import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** BigInt custom scalar type */
  BigInt: { input: number; output: number; }
  /** Date string custom scalar type, expects format: YYYY-MM-DD */
  DateString: { input: string; output: string; }
  /** Date custom scalar type */
  DateTime: { input: string; output: string; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: unknown; output: unknown; }
};

/** SNS接続を表します。 */
export type ActiveSnsConnections = {
  readonly __typename?: 'ActiveSnsConnections';
  /** Instagramの連携です。 */
  readonly instagram?: Maybe<InstagramConnection>;
  readonly tiktok?: Maybe<TikTokConnection>;
  readonly twitter?: Maybe<TwitterConnection>;
  readonly youtube?: Maybe<YouTubeConnection>;
};

/** 広告ガイドラインです。 */
export type AdGuideline = {
  readonly __typename?: 'AdGuideline';
  /** 同意したバージョンです。 */
  readonly agreedVersion?: Maybe<Scalars['DateTime']['output']>;
  /** 最新バージョンです。 */
  readonly latestVersion: Scalars['DateTime']['output'];
  /** 同意が必要かどうかです。 */
  readonly needAgree: Scalars['Boolean']['output'];
  /** 広告ガイドラインのURLです。 */
  readonly url: Scalars['String']['output'];
};

export type AdvAccountPerformanceReportTimeSeriesInput = {
  readonly endedAt: Scalars['DateString']['input'];
  readonly series: ReadonlyArray<MetricsFieldName>;
  readonly startedAt: Scalars['DateString']['input'];
};

/** 広告主ユーザーを表します。 */
export type Advertiser = {
  readonly __typename?: 'Advertiser';
  /** 広告主の広告ガイドライン同意を表します。 */
  readonly adGuideline?: Maybe<AdGuideline>;
  /** リテラシーアンケートに回答済みかどうかです。 */
  readonly answeredLiteracySurvey: Scalars['Boolean']['output'];
  /** 広告主が作成したキャンペーン数です。 */
  readonly campaignCount: Scalars['Int']['output'];
  /** 広告主が作成したキャンペーン一覧です。 */
  readonly campaigns: ReadonlyArray<Campaign>;
  /** 契約中のサブスクリプションをキャンセルできるかどうかです。 */
  readonly canCancelSubscription: Scalars['Boolean']['output'];
  /** 反社チェックに進んだかどうかです。 */
  readonly checkingAntiSocial: Scalars['Boolean']['output'];
  /** 広告会社の情報です。 */
  readonly company?: Maybe<Company>;
  /** 広告会社の統一IDです。 */
  readonly companyId?: Maybe<Scalars['String']['output']>;
  /** 店舗情報のテンプレート一覧です。 */
  readonly companyShopTemplates: ReadonlyArray<CampaignLocation>;
  /** 契約中のサブスクリプションの請求明細一覧です。 */
  readonly likesSubscriptionInvoiceDetails: ReadonlyArray<LikesSubscriptionInvoiceDetail>;
  /** LIKESサブスク一覧を返します。 */
  readonly likesSubscriptions: ReadonlyArray<LikesSubscription>;
  /** リテラシーアンケートの回答結果です。 */
  readonly literacySurveyAnswer?: Maybe<LiteracySurveyAnswer>;
  /** 広告主担当者の情報です。 */
  readonly member?: Maybe<Member>;
  /** 広告主担当者の統一IDです。 */
  readonly memberId: Scalars['String']['output'];
  /** 契約中のサブスクリプションを解約できるかどうかです。 */
  readonly mfkessaiDestination?: Maybe<MfkessaiDestination>;
  /** 広告主が作成したオファー数です。 */
  readonly offerCount: Scalars['Int']['output'];
  /** 広告主が作成したオファー一覧を返します。 */
  readonly offers: ReadonlyArray<Offer>;
  /** 定期公開中のキャンペーン一覧です。 */
  readonly regularlyPublishedCampaigns: ReadonlyArray<Campaign>;
  /** 契約中のサブスクリプションの請求明細一覧です。 */
  readonly ticketSubscriptionInvoiceDetails?: Maybe<ReadonlyArray<SubscriptionInvoiceDetail>>;
  /** 契約中のサブスクリプション一覧です。 */
  readonly ticketSubscriptions?: Maybe<ReadonlyArray<TicketSubscription>>;
};


/** 広告主ユーザーを表します。 */
export type AdvertiserCampaignCountArgs = {
  input: CampaignCountInput;
};


/** 広告主ユーザーを表します。 */
export type AdvertiserCampaignsArgs = {
  input?: InputMaybe<CampaignByAdvertiserInput>;
};


/** 広告主ユーザーを表します。 */
export type AdvertiserOfferCountArgs = {
  input: OfferCountInput;
};


/** 広告主ユーザーを表します。 */
export type AdvertiserOffersArgs = {
  input?: InputMaybe<OffersInput>;
};


/** 広告主ユーザーを表します。 */
export type AdvertiserTicketSubscriptionInvoiceDetailsArgs = {
  billingMonth: Scalars['DateTime']['input'];
};

export const AgeLimit = {
  /** 制限なし */
  NoLimit: 'NO_LIMIT',
  /** 20歳以上 */
  OverTwenties: 'OVER_TWENTIES'
} as const;

export type AgeLimit = typeof AgeLimit[keyof typeof AgeLimit];
/** 年齢層です。 */
export const AgeRange = {
  /** 20代 */
  From_20To_29: 'FROM_20_TO_29',
  /** 30代 */
  From_30To_39: 'FROM_30_TO_39',
  /** 40代 */
  From_40To_49: 'FROM_40_TO_49',
  /** 50代 */
  From_50To_59: 'FROM_50_TO_59',
  /** 60代以上 */
  Over_60: 'OVER_60',
  /** 10代以下 */
  Under_19: 'UNDER_19'
} as const;

export type AgeRange = typeof AgeRange[keyof typeof AgeRange];
/** ユーザーの年齢の割合です。 */
export type AgeRate = {
  readonly __typename?: 'AgeRate';
  /** 13歳から17歳の割合です。 */
  readonly from13To17: Scalars['Float']['output'];
  /** 18歳から24歳の割合です。 */
  readonly from18To24: Scalars['Float']['output'];
  /** 25歳から34歳の割合です。 */
  readonly from25To34: Scalars['Float']['output'];
  /** 35歳から44歳の割合です。 */
  readonly from35To44: Scalars['Float']['output'];
  /** 45歳から54歳の割合です。 */
  readonly from45To54: Scalars['Float']['output'];
  /** 55歳から64歳の割合です。 */
  readonly from55To64: Scalars['Float']['output'];
  /** 65歳以上の割合です。 */
  readonly over65: Scalars['Float']['output'];
};

/** Lv1: フォロワーの年齢の割合です。 */
export type AgeRateUnit = {
  readonly __typename?: 'AgeRateUnit';
  /** 年齢の割合です。 */
  readonly value?: Maybe<AgeRate>;
};

/** レポート集計間隔 */
export const AggregationInterval = {
  /** 全期間 */
  All: 'ALL',
  /** 日ごと */
  Daily: 'DAILY',
  /** 月ごと */
  Monthly: 'MONTHLY'
} as const;

export type AggregationInterval = typeof AggregationInterval[keyof typeof AggregationInterval];
/** レポート集計単位 */
export const AggregationLevel = {
  /** 広告アカウント単位 */
  AdvAccount: 'ADV_ACCOUNT',
  /** キャンペーン単位 */
  Campaign: 'CAMPAIGN',
  /** 投稿単位 */
  Post: 'POST'
} as const;

export type AggregationLevel = typeof AggregationLevel[keyof typeof AggregationLevel];
/** 回答した環境です。 */
export const AnswerEnvironment = {
  App: 'APP',
  Web: 'WEB'
} as const;

export type AnswerEnvironment = typeof AnswerEnvironment[keyof typeof AnswerEnvironment];
export type AnswerLiteracySurveyInput = {
  /** リテラシーアンケートの回答です。 */
  readonly answer: LiteracySurveyOption;
};

export type ApplySubscriptionByCodeInput = {
  /** プロモーションコードです。 */
  readonly code: Scalars['ID']['input'];
};

export type ApplySubscriptionInput = {
  /** サブスクリプションモデルのIDです。 */
  readonly subscriptionModelId: Scalars['ID']['input'];
};

export type ApproveCampaignEntryInput = {
  readonly id: Scalars['ID']['input'];
  readonly visitDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** 通報をオファーに割り当てる入力です。 */
export type AssignPenaltyToOfferInput = {
  /** 補足説明です。 */
  readonly body: Scalars['String']['input'];
  /** オファーのIDです。 */
  readonly offerId: Scalars['ID']['input'];
  /** 通報理由のIDです。 */
  readonly penaltyReasonId: Scalars['ID']['input'];
};

export type AvailableTransactionalSurveyInput = {
  readonly kind: SatisfactionSurveyKind;
};

/** Beginnerのカテゴリーを表します。 */
export type BeginnerCategory = Node & {
  readonly __typename?: 'BeginnerCategory';
  /** カテゴリーの説明です。 */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
  /** カテゴリーに属する記事です。 */
  readonly posts?: Maybe<ReadonlyArray<BeginnerPost>>;
  /** カテゴリーのタイトルです。 */
  readonly title: Scalars['String']['output'];
};


/** Beginnerのカテゴリーを表します。 */
export type BeginnerCategoryPostsArgs = {
  companySnsConnectionId?: InputMaybe<Scalars['ID']['input']>;
};

/** Beginnerの記事を表します。 */
export type BeginnerPost = Node & {
  readonly __typename?: 'BeginnerPost';
  /** 記事の本文です。 */
  readonly content: Scalars['String']['output'];
  /** 記事の説明です。 */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** 記事の作成が完了しているかどうかを表します。 */
  readonly done: Scalars['Boolean']['output'];
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
  /** 記事が対象とするSNSの種類です。 */
  readonly snsType: BeginnerPostSnsType;
  /** 記事のタイトルです。 */
  readonly title: Scalars['String']['output'];
};

/** SNSの種類です。 */
export const BeginnerPostSnsType = {
  /** Instagram */
  Instagram: 'INSTAGRAM'
} as const;

export type BeginnerPostSnsType = typeof BeginnerPostSnsType[keyof typeof BeginnerPostSnsType];
export type BillingReport = {
  readonly __typename?: 'BillingReport';
  /** 請求月 */
  readonly billingMonth: Scalars['DateTime']['output'];
  /** キャンペーンごとの立替費用詳細 */
  readonly campaignExpenseInvoiceDetails: ReadonlyArray<CampaignExpenseInvoiceDetail>;
  /** キャンペーンごとの請求詳細 */
  readonly campaignInvoiceDetails: ReadonlyArray<CampaignInvoiceDetail>;
  /** 確定済みのキャンペーン費用合計（税抜） */
  readonly campaignsFixedFee: Scalars['Int']['output'];
  /** 未確定のキャンペーン費用合計（税抜） */
  readonly campaignsUnsettledFee: Scalars['Int']['output'];
  /** 確定済みの立替金額合計 */
  readonly expenseFixedFee: Scalars['Int']['output'];
  /** 未確定の立替金額合計 */
  readonly expenseUnsettledFee: Scalars['Int']['output'];
  /** 採用課金が発生しているかどうか */
  readonly hasCampaignRecruitmentFee: Scalars['Boolean']['output'];
  /** 小計（税抜） */
  readonly subtotal: Scalars['Int']['output'];
  /** チケット購入履歴 */
  readonly ticketSubscriptionInvoiceDetails: ReadonlyArray<SubscriptionInvoiceDetail>;
  /** チケット費用合計（税抜） */
  readonly ticketsFee: Scalars['Int']['output'];
  /** 合計（税込） */
  readonly totalAmount: Scalars['Int']['output'];
  /** 消費税合計 */
  readonly totalTax: Scalars['Int']['output'];
};

export type BillingReportInput = {
  /** 請求月を指定します。 */
  readonly billingMonth: Scalars['DateTime']['input'];
};

/** キャンペーンを表します。 */
export type Campaign = Node & {
  readonly __typename?: 'Campaign';
  /** 年齢制限です。 */
  readonly ageLimit?: Maybe<AgeLimit>;
  /** キャンペーンが承認された日時です。 */
  readonly approvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** PRに関する注意事項です。 */
  readonly attention?: Maybe<Scalars['String']['output']>;
  /** 投稿報酬です。 */
  readonly basicGross?: Maybe<Scalars['Int']['output']>;
  /** 使用するオプションの文言指定です。 */
  readonly campaignRequirementOptionSpecifiedPrText?: Maybe<Scalars['String']['output']>;
  /** キャンペーンに設定されたオプションです。 */
  readonly campaignRequirementOptions: ReadonlyArray<CampaignRequirementOptions>;
  /** キャンペーンの審査結果 */
  readonly campaignReviewResults: ReadonlyArray<CampaignReviewResult>;
  /** SNSの種類です。 */
  readonly campaignSnsRequirements: ReadonlyArray<CampaignSnsRequirement>;
  /** キャンペーンを取り下げられるかどうかを表します。 */
  readonly canTakeBack: Scalars['Boolean']['output'];
  /** キャンペーンのカテゴリです。 */
  readonly category: CampaignCategory;
  /** 同伴者についてです。 */
  readonly companion: Companion;
  /** 広告主会社の統一IDです。 */
  readonly companyId: Scalars['ID']['output'];
  /**
   * 広告会社が選択したジャンルです。
   * @deprecated このフィールドは廃止され参照できなくなります
   */
  readonly companySelectGenre?: Maybe<Genre>;
  /**
   * 広告会社が選択した検索ジャンルです。
   * @deprecated このフィールドは廃止され参照できなくなります
   */
  readonly companySelectSearchGenre?: Maybe<SearchGenre>;
  /** 精算形式です。 */
  readonly costHandlingMethod?: Maybe<CampaignCostHandlingMethod>;
  /** キャンペーン画像のURLです。 */
  readonly coverImageUrls: ReadonlyArray<ImageUrl>;
  /** 作成日時です。 */
  readonly createdAt: Scalars['DateTime']['output'];
  /** 広告主が作成したキャンペーン数です。 */
  readonly deliveryFee?: Maybe<Scalars['Int']['output']>;
  /** 投稿希望言語です。 */
  readonly desiredLanguages: ReadonlyArray<LanguageType>;
  /** キャンペーンの応募締切日です。 */
  readonly desiredOfferDeadline?: Maybe<Scalars['DateTime']['output']>;
  /** 来店可能日時が編集可能かどうかです。 */
  readonly editableReservableSchedule: Scalars['Boolean']['output'];
  /** サブスクリプション更新予定情報の一覧です。 */
  readonly entries: CampaignEntryConnection;
  /** 応募状態ごとの件数を返します。 */
  readonly entriesCountByStatus: CampaignEntriesCount;
  /** 経費の証憑形式です。 */
  readonly expenseEvidenceType: ExpenseEvidenceType;
  /** キャンペーンにかかる費用を表します。 */
  readonly feeReport: CampaignFeeReport;
  /** キャンペーンのバージョンです。 */
  readonly formatVersion: FormatVersion;
  /** 募集するインフルエンサーの性別です。 */
  readonly gender: CampaignGender;
  /** 1採用するのにかかる金額（請求単価）です。ただし、採用課金は含まれていません。 */
  readonly gross?: Maybe<Scalars['Int']['output']>;
  /** ご案内です。 */
  readonly guidance?: Maybe<Scalars['String']['output']>;
  /** 広告会社側が調整可能な日程設定しているかを表します。 */
  readonly hasReservableSchedule: Scalars['Boolean']['output'];
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
  /** インフルエンサー負担率です。 */
  readonly influencerBurdenRate: Scalars['Int']['output'];
  /** このキャンペーンが採用中かどうかを表します。 */
  readonly isOffering: Scalars['Boolean']['output'];
  /** キャンペーンの店舗情報 */
  readonly location?: Maybe<CampaignLocation>;
  /** 同伴者の最大数です。 */
  readonly maxCompanionCount?: Maybe<Scalars['Int']['output']>;
  /** キャンペーン名です。 */
  readonly name: Scalars['String']['output'];
  /**
   * 最寄り駅です。
   * @deprecated 2024/03/19:shopNearestStationに移行するため廃止
   */
  readonly nearestStation?: Maybe<Scalars['String']['output']>;
  /** インフルエンサーを採用した際に自動で送付されるメッセージです。 */
  readonly offerAutoMessage?: Maybe<Scalars['String']['output']>;
  /** キャンペーンの終了日です。 */
  readonly offerEnded?: Maybe<Scalars['DateTime']['output']>;
  /** キャンペーンの開始日です。 */
  readonly offerStarted?: Maybe<Scalars['DateTime']['output']>;
  /** 応募の進捗状況ごとの件数を返します。 */
  readonly offerStateCount: OfferStateCount;
  /** あといくつの応募を採用できるかを表します。OpenLogiの在庫数、今までの採用数、採用数上限を考慮します。nullのときは無制限です。 */
  readonly offeringCapacity?: Maybe<Scalars['Int']['output']>;
  /** オファー一覧です。 */
  readonly offers?: Maybe<OfferConnection>;
  /** 採用数です。中止やキャンセルは含みません。 */
  readonly offersCount: Scalars['Int']['output'];
  /** オープンロジの在庫数です。アイテムが登録されていない場合、nullになります。 */
  readonly openlogiStockCount?: Maybe<Scalars['Int']['output']>;
  /** PR投稿のインサイトです */
  readonly prInsights?: Maybe<ReadonlyArray<PrInsight>>;
  /** 商材ターゲットの年齢層です。 */
  readonly prTargetAge?: Maybe<ReadonlyArray<PrTargetAge>>;
  /** 商材ターゲットの性別です。 */
  readonly prTargetGender?: Maybe<PrTargetGender>;
  /** プロジェクトの種類です。 */
  readonly projectType?: Maybe<ProjectType>;
  /** キャンペーンの応募時の質問です。 */
  readonly question?: Maybe<Scalars['String']['output']>;
  readonly regularlyPublishedCampaigns?: Maybe<RegularlyPublishedCampaign>;
  /** 広告会社側が調整可能な日程を表します。 */
  readonly reservableSchedules?: Maybe<ReadonlyArray<CampaignReservableSchedule>>;
  /** キャンペーンの予約可能な週間予定です。 */
  readonly reservableWeeklySchedule: ReadonlyArray<CampaignReservableWeeklySchedule>;
  /**
   * 日程調整機能、本人確認チケット機能の利用可否を表します
   * @deprecated 2024/02/08 廃止予定のため、scheduleTypeとuseIdentificationTicketを使用してください。
   */
  readonly reservation: Reservation;
  /**
   * インフルエンサーへの報酬です。
   * @deprecated 2025/2/4:広告主向けにrewardを見せない為廃止予定
   */
  readonly reward?: Maybe<Scalars['Int']['output']>;
  /** 日程調整機能の利用状況です */
  readonly scheduleType: CampaignScheduleType;
  /** サブジャンルから算出された検索ジャンル */
  readonly searchGenre?: Maybe<SearchGenre>;
  /** 選考上限です。 */
  readonly selectionMaxLimit?: Maybe<Scalars['Int']['output']>;
  /** キャンペーンが使用しているショップテンプレートのIDです。 */
  readonly shopTemplateId?: Maybe<Scalars['ID']['output']>;
  /** 提供サービスです。 */
  readonly sponsorService?: Maybe<Scalars['String']['output']>;
  /** 本来の提供価格（税抜）です。 */
  readonly sponsorServicePrice?: Maybe<Scalars['Int']['output']>;
  /** 本来の提供価格（税込）です。 */
  readonly sponsorServicePriceIntax?: Maybe<Scalars['Int']['output']>;
  /** キャンペーンの申請状態です。 */
  readonly status: CampaignStatus;
  /** キャンペーンのサブジャンルです。 */
  readonly subGenre: ReadonlyArray<Scalars['String']['output']>;
  /** キャンペーンの概要です。 */
  readonly summary?: Maybe<Scalars['String']['output']>;
  /**
   * キャンペーンのサムネイル画像のURLです。
   * @deprecated このフィールドは廃止されました。coverImageUrlを使用してください。
   */
  readonly thumbnailUrls: ReadonlyArray<Scalars['String']['output']>;
  /** 広告主サイトURLです。 */
  readonly url?: Maybe<Scalars['String']['output']>;
  /** 日程調整機能、本人確認チケット機能の利用可否を表します */
  readonly useIdentificationTicket: Scalars['Boolean']['output'];
  /** 来店日の一覧です。 */
  readonly visitScheduleOffers?: Maybe<ReadonlyArray<Offer>>;
  /** インフルエンサーにやってほしいことです。 */
  readonly wantInfluencer?: Maybe<Scalars['String']['output']>;
};


/** キャンペーンを表します。 */
export type CampaignEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  ageRange?: InputMaybe<AgeRange>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Gender>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderby?: InputMaybe<CampaignEntriesOrder>;
  pinned?: InputMaybe<Pinned>;
  status?: InputMaybe<CampaignEntryStatus>;
};


/** キャンペーンを表します。 */
export type CampaignOffersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** キャンペーンを表します。 */
export type CampaignReservableSchedulesArgs = {
  take?: InputMaybe<Scalars['Int']['input']>;
};


/** キャンペーンを表します。 */
export type CampaignVisitScheduleOffersArgs = {
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type CampaignByAdvertiserInput = {
  /** YouTubeを除外するかどうかです。 */
  readonly excludeYouTube?: InputMaybe<Scalars['Boolean']['input']>;
  /** キャンペーンのフォーマットバージョンです。 */
  readonly formatVersion?: InputMaybe<FormatVersion>;
  /** キャンペーンのフォーマットバージョンです。 */
  readonly formatVersions?: InputMaybe<ReadonlyArray<FormatVersion>>;
  /** キャンペーンのソート順です。 */
  readonly orderBy?: InputMaybe<CampaignOrder>;
  /** スキップする件数です。 */
  readonly skip?: InputMaybe<Scalars['Int']['input']>;
  /** SNSの種類です。 */
  readonly snsType?: InputMaybe<CampaignSnsRequirementSnsType>;
  /** キャンペーンのステータスです。 */
  readonly status?: InputMaybe<ReadonlyArray<CampaignStatus>>;
  /** 取得する件数です。 */
  readonly take?: InputMaybe<Scalars['Int']['input']>;
};

/** キャンペーンのカテゴリー（現地で体験 OR 自宅で体験）です。 */
export const CampaignCategory = {
  /** イベント */
  Event: 'EVENT',
  /** 自宅で体験 */
  Product: 'PRODUCT',
  /** 現地で体験 */
  Service: 'SERVICE'
} as const;

export type CampaignCategory = typeof CampaignCategory[keyof typeof CampaignCategory];
export const CampaignCostHandlingMethod = {
  /** 立替型 */
  ExpenseCampaign: 'ExpenseCampaign',
  /** 無償提供型 */
  NoChargeCampaign: 'NoChargeCampaign'
} as const;

export type CampaignCostHandlingMethod = typeof CampaignCostHandlingMethod[keyof typeof CampaignCostHandlingMethod];
export type CampaignCountInput = {
  /** キャンペーンのステータスです。 */
  readonly status?: InputMaybe<ReadonlyArray<CampaignStatus>>;
};

/** 応募状態ごとの件数を返します。 */
export type CampaignEntriesCount = {
  readonly __typename?: 'CampaignEntriesCount';
  /** APPLIEDの件数です。 */
  readonly APPLIED: Scalars['Int']['output'];
  /** APPROVEDの件数です。 */
  readonly APPROVED: Scalars['Int']['output'];
  /** BLOCKEDの件数です。 */
  readonly BLOCKED: Scalars['Int']['output'];
  /** DECLINEDの件数です。 */
  readonly DECLINED: Scalars['Int']['output'];
  /** ETCの件数です。 */
  readonly ETC: Scalars['Int']['output'];
};

export type CampaignEntriesOrder = {
  /** ソート順序です。 */
  readonly direction: OrderDirection;
  /** ソート項目です。 */
  readonly field: CampaignEntriesOrderField;
};

/** キャンペーンの応募一覧のソート項目です。 */
export const CampaignEntriesOrderField = {
  /** 応募日時です。 */
  CreatedAt: 'CREATED_AT',
  /** エンゲージメント予測値です。 */
  EngagementPrediction: 'ENGAGEMENT_PREDICTION',
  /** フォロワー数です。 */
  FollowerCount: 'FOLLOWER_COUNT',
  /** インプレッション予測値です。 */
  ImpressionPrediction: 'IMPRESSION_PREDICTION',
  /** リーチ予測値です。 */
  ReachPrediction: 'REACH_PREDICTION'
} as const;

export type CampaignEntriesOrderField = typeof CampaignEntriesOrderField[keyof typeof CampaignEntriesOrderField];
/** キャンペーンへの応募を表します。 */
export type CampaignEntry = Node & {
  readonly __typename?: 'CampaignEntry';
  /** 応募時の質問に対する回答です。 */
  readonly answer?: Maybe<Scalars['String']['output']>;
  /** 適用中のキャンペーンです。 */
  readonly campaign?: Maybe<Campaign>;
  /** 応募したキャンペーンの統一IDです。 */
  readonly campaignId: Scalars['ID']['output'];
  /** 来店の候補日です。 */
  readonly candidateSchedules: ReadonlyArray<CampaignEntryCandidateSchedule>;
  /** インフルエンサーが入力した同伴者人数です。 */
  readonly companionCount?: Maybe<Scalars['Int']['output']>;
  /** 作成日時です。 */
  readonly createdAt: Scalars['DateTime']['output'];
  /** エンゲージメント予測情報です。 */
  readonly engagementPrediction?: Maybe<CampaignEntryEngagementPrediction>;
  /** 応募の有効期限です。 */
  readonly expiredAt: Scalars['DateTime']['output'];
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
  /** インプレッション予測情報です。 */
  readonly impressionPrediction?: Maybe<CampaignEntryImpressionPrediction>;
  /** 応募中のインフルエンサー情報です。 */
  readonly influencer: Influencer;
  /** 応募したインフルエンサーの統一IDです。 */
  readonly influencerId: Scalars['ID']['output'];
  /** インサイト */
  readonly insight?: Maybe<InstagramInsight>;
  /** ピン留めの状態です。 */
  readonly pinned: Pinned;
  /** 応募時に選択した投稿言語 */
  readonly prPostLanguage?: Maybe<LanguageType>;
  /** リーチ予測情報です。 */
  readonly reachPrediction?: Maybe<CampaignEntryReachPrediction>;
  /** 応募時に使用したSNSアカウントの種類です。 */
  readonly snsType: Provider;
  /** 応募の状態です。 */
  readonly status: CampaignEntryStatus;
  /** 更新日時です。 */
  readonly updatedAt: Scalars['DateTime']['output'];
};

/** 来店の候補日を表します。 */
export type CampaignEntryCandidateSchedule = Node & {
  readonly __typename?: 'CampaignEntryCandidateSchedule';
  /** 候補日です。 */
  readonly candidateSchedule: Scalars['DateTime']['output'];
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
};

export type CampaignEntryConnection = {
  readonly __typename?: 'CampaignEntryConnection';
  readonly edges: ReadonlyArray<CampaignEntryEdge>;
  readonly nodes: ReadonlyArray<CampaignEntry>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

export type CampaignEntryEdge = {
  readonly __typename?: 'CampaignEntryEdge';
  readonly cursor: Scalars['String']['output'];
  readonly node: CampaignEntry;
};

/** エンゲージメント予測情報を表します。 */
export type CampaignEntryEngagementPrediction = {
  readonly __typename?: 'CampaignEntryEngagementPrediction';
  /** エンゲージメントのクラス分類です。 */
  readonly engagementClass?: Maybe<Scalars['Int']['output']>;
  /** エンゲージメント予測値です。 */
  readonly engagementPred?: Maybe<Scalars['Float']['output']>;
  /** エンゲージメント予測の下限です。 */
  readonly engagementPredLower?: Maybe<Scalars['Int']['output']>;
  /** エンゲージメント予測の上限です。 */
  readonly engagementPredUpper?: Maybe<Scalars['Int']['output']>;
};

/** インプレッション予測情報を表します。 */
export type CampaignEntryImpressionPrediction = {
  readonly __typename?: 'CampaignEntryImpressionPrediction';
  /** インプレッションのクラス分類です。 */
  readonly impressionClass?: Maybe<Scalars['Int']['output']>;
  /** インプレッション予測値です。 */
  readonly impressionPred?: Maybe<Scalars['Float']['output']>;
  /** インプレッション予測の下限です。 */
  readonly impressionPredLower?: Maybe<Scalars['Int']['output']>;
  /** インプレッション予測の上限です。 */
  readonly impressionPredUpper?: Maybe<Scalars['Int']['output']>;
};

/** リーチ予測情報を表します。 */
export type CampaignEntryReachPrediction = {
  readonly __typename?: 'CampaignEntryReachPrediction';
  /** リーチのクラス分類です。 */
  readonly reachClass?: Maybe<Scalars['Int']['output']>;
  /** リーチ予測値です。 */
  readonly reachPred?: Maybe<Scalars['Float']['output']>;
  /** リーチ予測の下限です。 */
  readonly reachPredLower?: Maybe<Scalars['Int']['output']>;
  /** リーチ予測の上限です。 */
  readonly reachPredUpper?: Maybe<Scalars['Int']['output']>;
};

/** キャンペーン応募の状態です。 */
export const CampaignEntryStatus = {
  /** 応募されてから承認されるまで */
  Applied: 'APPLIED',
  /** 承認された */
  Approved: 'APPROVED',
  /** ブロックされた */
  Blocked: 'BLOCKED',
  /** 不採用された */
  Declined: 'DECLINED',
  /** その他 */
  Etc: 'ETC'
} as const;

export type CampaignEntryStatus = typeof CampaignEntryStatus[keyof typeof CampaignEntryStatus];
export type CampaignExpenseInvoiceDetail = {
  readonly __typename?: 'CampaignExpenseInvoiceDetail';
  /** キャンペーン情報 */
  readonly campaign?: Maybe<Campaign>;
  /** 確定済みの立替費用詳細 */
  readonly expenseFixedFeeDetail: FixedExpenseFeeDetail;
  /** 未確定の立替費用詳細 */
  readonly expenseUnsettledFeeDetail: UnsettledExpenseFeeDetail;
};

/** キャンペーンにかかる費用の詳細を表します。 */
export type CampaignFeeDetail = {
  readonly __typename?: 'CampaignFeeDetail';
  /** 投稿報酬です。 */
  readonly postedReword: Scalars['Int']['output'];
  /** 採用課金です。 */
  readonly recruitmentFee: Scalars['Int']['output'];
};

/** キャンペーンにかかる費用を表します。 */
export type CampaignFeeReport = {
  readonly __typename?: 'CampaignFeeReport';
  /** 統一IDです。 */
  readonly campaignId: Scalars['ID']['output'];
  /** 完了報告済みの費用の内訳です。 */
  readonly fixedFeeDetail?: Maybe<CampaignFeeDetail>;
  /** 未完了報告の費用の内訳です。 */
  readonly unsettledFeeDetail?: Maybe<CampaignFeeDetail>;
};


/** キャンペーンにかかる費用を表します。 */
export type CampaignFeeReportFixedFeeDetailArgs = {
  input: CampaignFeeReportInput;
};


/** キャンペーンにかかる費用を表します。 */
export type CampaignFeeReportUnsettledFeeDetailArgs = {
  input: CampaignFeeReportInput;
};

export type CampaignFeeReportInput = {
  /** 対象の年月です。（日付はフィルタに影響しません。） */
  readonly reportMonth: Scalars['DateTime']['input'];
};

export const CampaignGender = {
  Man: 'MAN',
  NotKnown: 'NOT_KNOWN',
  Woman: 'WOMAN'
} as const;

export type CampaignGender = typeof CampaignGender[keyof typeof CampaignGender];
export type CampaignInvoiceDetail = {
  readonly __typename?: 'CampaignInvoiceDetail';
  /** キャンペーン情報 */
  readonly campaign?: Maybe<Campaign>;
  /** 確定済みの費用詳細 */
  readonly fixedFeeDetail: FixedFeeDetail;
  /** 未確定の費用詳細 */
  readonly unsettledFeeDetail: UnsettledFeeDetail;
};

/** キャンペーンの店舗・場所情報を表します */
export type CampaignLocation = Node & {
  readonly __typename?: 'CampaignLocation';
  /** 建物名・部屋番号 */
  readonly buildingName?: Maybe<Scalars['String']['output']>;
  /** 市区町村コード */
  readonly cityCode?: Maybe<Scalars['String']['output']>;
  /** 市区町村名 */
  readonly cityName?: Maybe<Scalars['String']['output']>;
  /** 作成日時 */
  readonly createdAt: Scalars['DateTime']['output'];
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
  /** 店舗名 */
  readonly name?: Maybe<Scalars['String']['output']>;
  /** 店舗の郵便番号 */
  readonly postalCode?: Maybe<Scalars['String']['output']>;
  /** 都道府県コード */
  readonly prefectureCode?: Maybe<Pref>;
  /** 最寄り駅コード */
  readonly stationCode?: Maybe<Scalars['String']['output']>;
  /** 最寄り駅 */
  readonly stationName?: Maybe<Scalars['String']['output']>;
  /** 番地・通り名 */
  readonly streetAddress?: Maybe<Scalars['String']['output']>;
  /** 電話番号 */
  readonly tel?: Maybe<Scalars['String']['output']>;
  /** 更新日時 */
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type CampaignNearestStation = {
  readonly __typename?: 'CampaignNearestStation';
  /** 駅コード */
  readonly code: Scalars['String']['output'];
  /** 駅名 */
  readonly name: Scalars['String']['output'];
};

export type CampaignNearestStationInput = {
  /** 店舗の最寄り駅名 */
  readonly stationName: Scalars['String']['input'];
};

/** キャンペーンのソート順です。 */
export type CampaignOrder = {
  /** ソート方向です。 */
  readonly direction: OrderDirection;
  /** ソート項目です。 */
  readonly field: CampaignOrderField;
};

/** キャンペーンのソート項目です。 */
export const CampaignOrderField = {
  /** 承認日時です。 */
  ApprovedAt: 'APPROVED_AT',
  /** キャンペーンの統一IDです。 */
  Id: 'ID'
} as const;

export type CampaignOrderField = typeof CampaignOrderField[keyof typeof CampaignOrderField];
export type CampaignPerformanceMetrics = {
  readonly __typename?: 'CampaignPerformanceMetrics';
  readonly advAccountId: Scalars['String']['output'];
  readonly campaign: Campaign;
  readonly campaignId: Scalars['String']['output'];
  readonly comments?: Maybe<Scalars['Float']['output']>;
  readonly endedAt: Scalars['DateString']['output'];
  readonly engagementRate?: Maybe<Scalars['Float']['output']>;
  readonly engagements?: Maybe<Scalars['Float']['output']>;
  readonly impressions?: Maybe<Scalars['Float']['output']>;
  readonly likes?: Maybe<Scalars['Float']['output']>;
  readonly playCounts?: Maybe<Scalars['Float']['output']>;
  readonly postCounts: Scalars['Float']['output'];
  readonly reaches?: Maybe<Scalars['Float']['output']>;
  readonly saves?: Maybe<Scalars['Float']['output']>;
  readonly shares?: Maybe<Scalars['Float']['output']>;
  readonly startedAt: Scalars['DateString']['output'];
};

export type CampaignPerformanceMetricsInput = {
  readonly endedAt: Scalars['DateString']['input'];
  readonly startedAt: Scalars['DateString']['input'];
};

export type CampaignPerformanceMetricsPage = {
  readonly __typename?: 'CampaignPerformanceMetricsPage';
  readonly nodes?: Maybe<ReadonlyArray<CampaignPerformanceMetrics>>;
  readonly totalCount: Scalars['Int']['output'];
};

export type CampaignPerformanceMetricsSummary = {
  readonly __typename?: 'CampaignPerformanceMetricsSummary';
  readonly comments?: Maybe<Scalars['Float']['output']>;
  readonly endedAt: Scalars['DateString']['output'];
  readonly engagementRate?: Maybe<Scalars['Float']['output']>;
  readonly engagements?: Maybe<Scalars['Float']['output']>;
  readonly impressions?: Maybe<Scalars['Float']['output']>;
  readonly likes?: Maybe<Scalars['Float']['output']>;
  readonly playCounts?: Maybe<Scalars['Float']['output']>;
  readonly postCounts?: Maybe<Scalars['Float']['output']>;
  readonly reaches?: Maybe<Scalars['Float']['output']>;
  readonly saves?: Maybe<Scalars['Float']['output']>;
  readonly shares?: Maybe<Scalars['Float']['output']>;
  readonly startedAt: Scalars['DateString']['output'];
};

export type CampaignPerformanceReportTimeSeriesInput = {
  readonly campaignId: Scalars['String']['input'];
  readonly endedAt: Scalars['DateString']['input'];
  readonly series: ReadonlyArray<MetricsFieldName>;
  readonly startedAt: Scalars['DateString']['input'];
};

export const CampaignRequirementOptions = {
  /** 投稿する写真の内容について指定が可能です（インフルエンサーとサービス（商品）を一緒に写してほしい）。 */
  CompositionInfluencerAndService: 'COMPOSITION_INFLUENCER_AND_SERVICE',
  /** 投稿する写真の内容について指定が可能です（商品単体で写してほしい）。 */
  CompositionProductOnly: 'COMPOSITION_PRODUCT_ONLY',
  /** 投稿する写真の内容について指定が可能です（実際に体験しているところを写してほしい）。 */
  CompositionUsageInContext: 'COMPOSITION_USAGE_IN_CONTEXT',
  /** 投稿前に内容をチェック・修正依頼を行うことが可能です。 */
  DraftCheck: 'DRAFT_CHECK',
  /** インフルエンサーの投稿物をInstagram以外で利用が可能です。 */
  SecondaryUse: 'SECONDARY_USE',
  /** 投稿するキャプションについて指定が可能です。 */
  SpecifiedPrText: 'SPECIFIED_PR_TEXT'
} as const;

export type CampaignRequirementOptions = typeof CampaignRequirementOptions[keyof typeof CampaignRequirementOptions];
/** 広告会社側が調整可能な日程を表します。 */
export type CampaignReservableSchedule = Node & {
  readonly __typename?: 'CampaignReservableSchedule';
  readonly createdAt: Scalars['DateTime']['output'];
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
  /** 調整可能な日時です。 */
  readonly possibleDatetime: Scalars['DateTime']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};

/** キャンペーンの予約可能な週間予定を表します。 */
export type CampaignReservableWeeklySchedule = Node & {
  readonly __typename?: 'CampaignReservableWeeklySchedule';
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
  /** 予約可能な日時です。 */
  readonly possibleMinutes: Scalars['Int']['output'];
  /** 予約可能な曜日です。 */
  readonly weekDay: WeekDay;
};

/** キャンペーンの審査項目の結果を表します。 */
export type CampaignReview = Node & {
  readonly __typename?: 'CampaignReview';
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
  /** 審査が承認されたかどうかです。 */
  readonly isChecked?: Maybe<Scalars['Boolean']['output']>;
  /** 審査項目です。 */
  readonly reviewTarget: ReviewTarget;
  /** 審査の差し戻し理由です。 */
  readonly sendBackReason: Scalars['String']['output'];
};

/** キャンペーンの審査難易度を表します。 */
export const CampaignReviewDifficulty = {
  /** 既存 */
  Approved: 'APPROVED',
  /** 新規 */
  New: 'NEW'
} as const;

export type CampaignReviewDifficulty = typeof CampaignReviewDifficulty[keyof typeof CampaignReviewDifficulty];
/** キャンペーン審査の結果を表します。 */
export type CampaignReviewResult = Node & {
  readonly __typename?: 'CampaignReviewResult';
  /** 審査項目の結果です。 */
  readonly campaignReviews: ReadonlyArray<CampaignReview>;
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
  /** 審査項目種別です。 */
  readonly reviewSection: ReviewSection;
};

/** キャンペーンの日程タイプ */
export const CampaignScheduleType = {
  /** 利用しない */
  NotUsed: 'NOT_USED',
  /** 日程確定式 */
  ReservableSchedule: 'RESERVABLE_SCHEDULE'
} as const;

export type CampaignScheduleType = typeof CampaignScheduleType[keyof typeof CampaignScheduleType];
export type CampaignShopLocations = {
  readonly __typename?: 'CampaignShopLocations';
  /** 市区町村名 */
  readonly cityName: Scalars['String']['output'];
  /** 都道府県コード */
  readonly prefectureCode: Pref;
  /** 市区町村コード */
  readonly shopCityCode: Scalars['String']['output'];
  /** 町域名 */
  readonly town: Scalars['String']['output'];
};

export type CampaignShopLocationsInput = {
  /** 郵便番号です */
  readonly postalCode: Scalars['String']['input'];
};

/** 募集するSNSの条件を表します。 */
export type CampaignSnsRequirement = Node & {
  readonly __typename?: 'CampaignSnsRequirement';
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
  /** 投稿のフッターです。 */
  readonly postFooter: Scalars['String']['output'];
  /** インフルエンサーの投稿に載せたいSNSアカウントです。 */
  readonly requestUrl?: Maybe<Scalars['String']['output']>;
  /** インフルエンサーの投稿に載せたいSNSアカウントのURLです。 */
  readonly snsPostRedirectUrl?: Maybe<Scalars['String']['output']>;
  /** SNSの投稿方法の一覧です。 */
  readonly snsPostTypeList: ReadonlyArray<CampaignSnsRequirementSnsPostType>;
  /** SNSの種類です。 */
  readonly snsType: CampaignSnsRequirementSnsType;
  /** 投稿に加えて欲しいタグ一覧（言語別） */
  readonly tagList: ReadonlyArray<CampaignSnsRequirementTag>;
};

/** SNSの投稿方法 */
export const CampaignSnsRequirementSnsPostType = {
  InstagramFeed: 'INSTAGRAM_FEED',
  InstagramReel: 'INSTAGRAM_REEL',
  /** ストーリーズ投稿（Instagram限定） */
  InstagramStories: 'INSTAGRAM_STORIES',
  /** 設定なし */
  NoSettings: 'NO_SETTINGS',
  /** 各種SNSのデフォルト方式 */
  SnsDefault: 'SNS_DEFAULT'
} as const;

export type CampaignSnsRequirementSnsPostType = typeof CampaignSnsRequirementSnsPostType[keyof typeof CampaignSnsRequirementSnsPostType];
/** SNSの種類 */
export const CampaignSnsRequirementSnsType = {
  /** Instagram */
  Instagram: 'INSTAGRAM',
  /** SNS情報が設定されていない */
  NoSettings: 'NO_SETTINGS',
  /** TikTok */
  Tiktok: 'TIKTOK',
  /** Twitter */
  Twitter: 'TWITTER',
  /** YouTubeのためのGoogle認証 */
  Youtube: 'YOUTUBE'
} as const;

export type CampaignSnsRequirementSnsType = typeof CampaignSnsRequirementSnsType[keyof typeof CampaignSnsRequirementSnsType];
/** 言語別のSNS投稿タグを表します。 */
export type CampaignSnsRequirementTag = Node & {
  readonly __typename?: 'CampaignSnsRequirementTag';
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
  /** 言語種別 */
  readonly languageType: LanguageType;
  /** タグ一覧 */
  readonly tags: ReadonlyArray<Scalars['String']['output']>;
};

export type CampaignSnsRequirementTagInput = {
  /** 言語種別 */
  readonly languageType: LanguageType;
  /** タグ一覧 */
  readonly tags: ReadonlyArray<Scalars['String']['input']>;
};

/** キャンペーンの申請状態です。 */
export const CampaignStatus = {
  /** 審査中 */
  ApprovalRequest: 'APPROVAL_REQUEST',
  /** 承認 */
  Approved: 'APPROVED',
  /** 否認 */
  Denial: 'DENIAL',
  /** 終了 */
  Finish: 'FINISH',
  /** 差し戻し中 */
  RevisionRequired: 'REVISION_REQUIRED'
} as const;

export type CampaignStatus = typeof CampaignStatus[keyof typeof CampaignStatus];
/** 解約になるタイミングです。 */
export const CancellationTiming = {
  /** 即時解約です。 */
  Immediate: 'IMMEDIATE',
  /** 最短の解約日をもって解約になります。 */
  MinCancellableDate: 'MIN_CANCELLABLE_DATE',
  /** 次回チケット発行日をもって解約になります。 */
  NextTicketIssueDate: 'NEXT_TICKET_ISSUE_DATE'
} as const;

export type CancellationTiming = typeof CancellationTiming[keyof typeof CancellationTiming];
export const Companion = {
  /** あり */
  Accompanying: 'ACCOMPANYING',
  /** なし */
  NoAccompanying: 'NO_ACCOMPANYING'
} as const;

export type Companion = typeof Companion[keyof typeof Companion];
/** 広告主の会社を表します。 */
export type Company = Node & {
  readonly __typename?: 'Company';
  /** 広告主担当者の一覧です。 */
  readonly adminMembers: ReadonlyArray<Member>;
  /** 有効なチケット一覧です。 */
  readonly availableTickets: ReadonlyArray<IssuedTicket>;
  /** キャンペーンの審査難易度です。 */
  readonly campaignReviewDifficulty: CampaignReviewDifficulty;
  /** 投稿報酬キャンペーンを作成できるかどうかを表します。 */
  readonly canCreateRewardCampaign: Scalars['Boolean']['output'];
  /** 会社名です。 */
  readonly companyName: Scalars['String']['output'];
  /** LINEグループ連携がされているかどうかです。 */
  readonly connectedLineGroup: Scalars['Boolean']['output'];
  /** 有効な支払い方法が登録されているかどうかです。 */
  readonly hasAvailablePaymentMethod: Scalars['Boolean']['output'];
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
  /** 発行済みチケット一覧です。 */
  readonly issuedTickets: IssuedTicketConnection;
  /** 広告主にLINE連携を求める必要があるかどうか。 */
  readonly needLineConnection: Scalars['Boolean']['output'];
  /** 通知メール一覧です。 */
  readonly notificationEmails: ReadonlyArray<CompanyNotificationEmail>;
  /** 支払い方法です。 */
  readonly paymentType: PaymentType;
  /** 代表者名です。 */
  readonly representativeName?: Maybe<Scalars['String']['output']>;
  /** 新規ユーザー向けの案内を表示するかどうかです。 */
  readonly showIntroduction: Scalars['Boolean']['output'];
  /** 広告主会社の連携先SNS情報を表します。 */
  readonly snsConnections: ReadonlyArray<CompanySnsConnection>;
  /** チケット移行同意日時です。 */
  readonly ticketMigrationAgreedAt?: Maybe<Scalars['DateTime']['output']>;
  /** 要対応オファーを取得します。 */
  readonly todoOffers?: Maybe<ReadonlyArray<TodoOffer>>;
  /** チュートリアルを表します。 */
  readonly tutorial: Tutorial;
};


/** 広告主の会社を表します。 */
export type CompanyAvailableTicketsArgs = {
  input?: InputMaybe<AvailableTicketsInputObject>;
};


/** 広告主の会社を表します。 */
export type CompanyIssuedTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** 広告主の会社を表します。 */
export type CompanySnsConnectionsArgs = {
  snsConnectId?: InputMaybe<Scalars['ID']['input']>;
};

/** 会社の通知メール情報を表します。 */
export type CompanyNotificationEmail = Node & {
  readonly __typename?: 'CompanyNotificationEmail';
  /** アクティベーション状態です。 */
  readonly activation: Scalars['Boolean']['output'];
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
  /** 通知メールアドレスです。 */
  readonly notificationEmail: Scalars['String']['output'];
  /** 認証期限です。 */
  readonly verificationDeadline: Scalars['DateTime']['output'];
};

/** 店舗情報のテンプレートを表します。 */
export type CompanyShopTemplate = Node & {
  readonly __typename?: 'CompanyShopTemplate';
  /** 店舗の住所 */
  readonly address1: Scalars['String']['output'];
  /** 店舗の住所（マンション名など） */
  readonly address2: Scalars['String']['output'];
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
  /** 店舗名 */
  readonly name: Scalars['String']['output'];
  /** 店舗の最寄駅 */
  readonly nearestStation: Scalars['String']['output'];
  /** 店舗の郵便番号 */
  readonly postalCode: Scalars['String']['output'];
  /** 店舗の都道府県 */
  readonly pref: Pref;
  /** 店舗の電話番号 */
  readonly tel: Scalars['String']['output'];
};

/** 広告主会社の連携先SNS情報を表します。 */
export type CompanySnsConnection = Node & {
  readonly __typename?: 'CompanySnsConnection';
  /** SNS連携開始日時です。 */
  readonly connectedAt: Scalars['DateTime']['output'];
  /** 広告主ユーザーのSNSアカウントのインサイト情報を表します。 */
  readonly dailyInstagramInsight?: Maybe<ReadonlyArray<DailyInstagramInsight>>;
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
  /** アカウントのプロフィール画像のURLです。 */
  readonly imageUrl?: Maybe<Scalars['String']['output']>;
  /** アカウント名です。 */
  readonly name: Scalars['String']['output'];
  /** アクセストークンの更新が必要かどうかを表します。 */
  readonly needTokenUpdate: Scalars['Boolean']['output'];
  /** 次回のアクセストークン更新日時です。 */
  readonly nextTokenUpdateAt: Scalars['DateTime']['output'];
  /** 連携するSNS種別です。 */
  readonly provider: CompanySnsConnectionProvider;
  /**
   * アクセストークンです。
   * @deprecated 2023/07/28 使用されていないため廃止する
   */
  readonly token: Scalars['String']['output'];
  /** 認証時のユーザーIDです。 */
  readonly uid: Scalars['String']['output'];
};


/** 広告主会社の連携先SNS情報を表します。 */
export type CompanySnsConnectionDailyInstagramInsightArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

/** そのSNSアカウントの種類を表します。 */
export const CompanySnsConnectionProvider = {
  /** Instagram */
  Instagram: 'INSTAGRAM',
  /** TikTok */
  Tiktok: 'TIKTOK',
  /** Twitter */
  Twitter: 'TWITTER',
  /** YouTube */
  Youtube: 'YOUTUBE'
} as const;

export type CompanySnsConnectionProvider = typeof CompanySnsConnectionProvider[keyof typeof CompanySnsConnectionProvider];
/** ユーザーが今までに完了したオファーの数を表します。 */
export const CompleteCountLevel = {
  /** 10以上です。 */
  Bronze: 'bronze',
  /** 50以上です。 */
  Gold: 'gold',
  /** 0以上です。 */
  Normal: 'normal',
  /** 30以上です。 */
  Silver: 'silver'
} as const;

export type CompleteCountLevel = typeof CompleteCountLevel[keyof typeof CompleteCountLevel];
export type CoverImageInput = {
  /** キャンペーン画像です。 */
  readonly image?: InputMaybe<Scalars['Upload']['input']>;
  /** キャンペーン画像のURLです。 */
  readonly imageUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCampaignCampaignReservableWeeklyScheduleInput = {
  /** 来店可能な時間帯です。分換算で表現します。 */
  readonly possibleMinutes: Scalars['Int']['input'];
  /** 来店可能な曜日です。 */
  readonly weekDay: WeekDay;
};

export type CreateCampaignInput = {
  /** 年齢制限です。 */
  readonly ageLimit: AgeLimit;
  /** 投稿報酬です。 */
  readonly basicGross: Scalars['Int']['input'];
  /** 建物名・部屋番号 */
  readonly buildingName?: InputMaybe<Scalars['String']['input']>;
  /** 使用するオプションの文言指定です。 */
  readonly campaignRequirementOptionSpecifiedPrText?: InputMaybe<Scalars['String']['input']>;
  /** 使用するオプションです。 */
  readonly campaignRequirementOptions: ReadonlyArray<CampaignRequirementOptions>;
  /** 来店可能な週間予定です。 */
  readonly campaignReservableWeeklySchedules: ReadonlyArray<CreateCampaignCampaignReservableWeeklyScheduleInput>;
  /** キャンペーンのカテゴリです。 */
  readonly category: CampaignCategory;
  /** 市区町村名 */
  readonly cityName?: InputMaybe<Scalars['String']['input']>;
  /** 精算形式です。 */
  readonly costHandlingMethod?: InputMaybe<CampaignCostHandlingMethod>;
  /** キャンペーンの画像です。 */
  readonly coverImages: ReadonlyArray<CoverImageInput>;
  /** 投稿希望言語です。 */
  readonly desiredLanguages: ReadonlyArray<LanguageType>;
  /** 経費の証憑形式です。 */
  readonly expenseEvidenceType?: InputMaybe<ExpenseEvidenceType>;
  /** ご案内です。 */
  readonly guidance: Scalars['String']['input'];
  /** インフルエンサー負担率です。 */
  readonly influencerBurdenRate: Scalars['Int']['input'];
  /** 同伴者の最大人数です。 */
  readonly maxCompanionCount: Scalars['Int']['input'];
  /** キャンペーンの名前です。 */
  readonly name: Scalars['String']['input'];
  /** 最寄り駅 */
  readonly nearestStationName?: InputMaybe<Scalars['String']['input']>;
  /** インフルエンサー採用時に相手に送られる自動メッセージ */
  readonly offerAutoMessage: Scalars['String']['input'];
  /** 募集開始日時です。 */
  readonly offerStarted?: InputMaybe<Scalars['DateTime']['input']>;
  /** 商材ターゲットの年齢層です。 */
  readonly prTargetAge: ReadonlyArray<PrTargetAge>;
  /** 商材ターゲットの性別です。 */
  readonly prTargetGender: PrTargetGender;
  /** キャンペーンの予約方法です。 */
  readonly scheduleType: CampaignScheduleType;
  /** キャンペーンのジャンルです。 */
  readonly searchGenre: SearchGenre;
  /** サブジャンルです。 */
  readonly searchSubGenreIds: ReadonlyArray<Scalars['BigInt']['input']>;
  /** 店舗名です。 */
  readonly shopName?: InputMaybe<Scalars['String']['input']>;
  /** 店舗の郵便番号です。 */
  readonly shopPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** 都道府県です。 */
  readonly shopPref?: InputMaybe<Pref>;
  readonly shopTel?: InputMaybe<Scalars['String']['input']>;
  /** 店舗テンプレートのIDです */
  readonly shopTemplateId?: InputMaybe<Scalars['BigInt']['input']>;
  /** 募集するSNSの条件です。 */
  readonly snsRequirements: ReadonlyArray<SnsRequirementPartialCreateCampaignInput>;
  /** 本来の提供価格（税込）です。 */
  readonly sponsorServicePriceIntax: Scalars['Int']['input'];
  /** 店舗の番地 */
  readonly streetAddress?: InputMaybe<Scalars['String']['input']>;
  /** 広告主サイトURLです。 */
  readonly url: Scalars['String']['input'];
  /** 定期公開設定を使用するかどうかです。 */
  readonly useRegularlyPublishedCampaign: Scalars['Boolean']['input'];
};

export type CreateCompanySnsConnectionInput = {
  /** プロフィール画像URLです。 */
  readonly imageUrl?: InputMaybe<Scalars['String']['input']>;
  /** アカウント名です。 */
  readonly name: Scalars['String']['input'];
  /** 次回トークン更新日時です。 */
  readonly nextTokenUpdateAt: Scalars['DateTime']['input'];
  /** 連携するSNS種別 */
  readonly provider: CompanySnsConnectionProvider;
  /** アクセストークンです。 */
  readonly token: Scalars['String']['input'];
  /** SNSのユーザーIDです。 */
  readonly uid: Scalars['String']['input'];
};

/** ダウンロードレポート作成リクエスト */
export type CreateDownloadReportInput = {
  /** レポート集計単位 */
  readonly aggregationLevel: AggregationLevel;
  /** レポート集計間隔 */
  readonly endedAt: Scalars['DateString']['input'];
  /** ダウンロードレポートのファイル形式 */
  readonly fileType: DownloadReportFileType;
  /** レポート集計間隔 */
  readonly interval: AggregationInterval;
  /** レポート集計間隔 */
  readonly startedAt: Scalars['DateString']['input'];
};

export type CreateMfkessaiCustomerDestinationInput = {
  /** 住所1 */
  readonly address1: Scalars['String']['input'];
  /** 住所2 */
  readonly address2?: InputMaybe<Scalars['String']['input']>;
  /** ccメール */
  readonly ccEmails?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** 部署 */
  readonly department?: InputMaybe<Scalars['String']['input']>;
  /** メールアドレス */
  readonly email: Scalars['String']['input'];
  /** 名前 */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** 名前カナ */
  readonly nameKana?: InputMaybe<Scalars['String']['input']>;
  /** 電話番号 */
  readonly tel: Scalars['String']['input'];
  /** 役職 */
  readonly title?: InputMaybe<Scalars['String']['input']>;
  /** 郵便番号 */
  readonly zipCode: Scalars['String']['input'];
};

export type CreateMfkessaiCustomerExaminationInput = {
  /** 事業内容 */
  readonly businessDescription?: InputMaybe<Scalars['String']['input']>;
  /** 事業所区分。不明な場合は空になります。 */
  readonly businessType?: InputMaybe<MfkessaiBusinessType>;
};

export type CreateMfkessaiCustomerInput = {
  readonly customerExamination: CreateMfkessaiCustomerExaminationInput;
  readonly destination: CreateMfkessaiCustomerDestinationInput;
};

/** 広告主ユーザーのSNSアカウントのインサイト情報を表します。 */
export type DailyInstagramInsight = {
  readonly __typename?: 'DailyInstagramInsight';
  /** PR投稿数です。 */
  readonly dailyPrPostCount: Scalars['Int']['output'];
  /** 集計日です。 */
  readonly date: Scalars['DateTime']['output'];
  /** フォロワー数です。 */
  readonly followerCount: Scalars['Int']['output'];
  /** プロフィールの閲覧数です。 */
  readonly profileViewCount: Scalars['Int']['output'];
  /** リーチ数です。 */
  readonly reachCount: Scalars['Int']['output'];
  /** サイトクリック数です。 */
  readonly siteClickCount: Scalars['Int']['output'];
};

export type DeleteCompanyNotificationEmailInput = {
  /** 統一IDです。 */
  readonly id: Scalars['ID']['input'];
};

export type DeleteCompanyShopTemplateInput = {
  /** 統一IDです */
  readonly id: Scalars['ID']['input'];
};

export type DisableRegularlyPublishedCampaignInput = {
  /** キャンペーンのIDです。 */
  readonly campaignId: Scalars['ID']['input'];
};

/** ダウンロードレポートを表します */
export type DownloadReport = Node & {
  readonly __typename?: 'DownloadReport';
  /** 作成日時 */
  readonly createdAt: Scalars['DateTime']['output'];
  /** ダウンロードURL */
  readonly downloadUrl?: Maybe<Scalars['String']['output']>;
  /** ダウンロードレポートのファイル形式 */
  readonly fileType: DownloadReportFileType;
  /** 統一IDです */
  readonly id: Scalars['ID']['output'];
  /** レポートのステータス */
  readonly status: DownloadReportStatus;
  /** レポートのタイトル */
  readonly title: Scalars['String']['output'];
};

/** ダウンロードレポートのファイル形式 */
export const DownloadReportFileType = {
  /** CSV */
  Csv: 'CSV',
  /** Excel */
  Excel: 'EXCEL'
} as const;

export type DownloadReportFileType = typeof DownloadReportFileType[keyof typeof DownloadReportFileType];
/** レポートのステータス */
export const DownloadReportStatus = {
  /** 作成済み */
  Created: 'CREATED',
  /** 削除済み */
  Deleted: 'DELETED',
  /** 失敗 */
  Error: 'ERROR',
  /** リクエスト受付済み、作成中 */
  Requested: 'REQUESTED'
} as const;

export type DownloadReportStatus = typeof DownloadReportStatus[keyof typeof DownloadReportStatus];
export type EnableRegularlyPublishedCampaignInput = {
  /** キャンペーンのIDです。 */
  readonly campaignId: Scalars['ID']['input'];
  /** 毎月の定期公開の実行日です。 */
  readonly executionDay?: InputMaybe<Scalars['Int']['input']>;
  /** 来店可能な曜日と時間帯の組み合わせです。 */
  readonly possibleWeekDayAndMinutes?: InputMaybe<ReadonlyArray<PossibleWeekDayAndMinutes>>;
};

export type EndCampaignOfferInput = {
  /** キャンペーンIDです。 */
  readonly campaignId: Scalars['ID']['input'];
  /** 募集を終了した理由です。 */
  readonly endedReason: Scalars['String']['input'];
};

export const ExpenseEvidenceType = {
  /** 証憑なし */
  NoEvidence: 'NO_EVIDENCE',
  /** 注文番号 */
  OrderNumber: 'ORDER_NUMBER',
  /** 領収書 */
  Receipt: 'RECEIPT'
} as const;

export type ExpenseEvidenceType = typeof ExpenseEvidenceType[keyof typeof ExpenseEvidenceType];
/** Lv2: 女性フォロワーの年齢の割合です。 */
export type FemaleAgeRateUnit = {
  readonly __typename?: 'FemaleAgeRateUnit';
  /** 年齢の割合です。 */
  readonly value?: Maybe<AgeRate>;
};

export type FixedExpenseFeeDetail = {
  readonly __typename?: 'FixedExpenseFeeDetail';
  /** 立替金額 */
  readonly expenseFee: Scalars['Int']['output'];
};

export type FixedFeeDetail = {
  readonly __typename?: 'FixedFeeDetail';
  /** 投稿報酬（税抜） */
  readonly postedReward: Scalars['Int']['output'];
  /** 採用課金（税抜） */
  readonly recruitmentFee: Scalars['Int']['output'];
  /** 採用課金（税込） */
  readonly recruitmentFeeWithTax: Scalars['Int']['output'];
  /** 立替金額、投稿報酬の消費税 */
  readonly totalTax: Scalars['Int']['output'];
};

export const FormatVersion = {
  V1Campaign: 'V1_CAMPAIGN',
  V2Campaign: 'V2_CAMPAIGN',
  V3Campaign: 'V3_CAMPAIGN',
  V4Campaign: 'V4_CAMPAIGN'
} as const;

export type FormatVersion = typeof FormatVersion[keyof typeof FormatVersion];
/** 性別です。 */
export const Gender = {
  /** 男性 */
  Man: 'MAN',
  /** その他 */
  Other: 'OTHER',
  /** 女性 */
  Woman: 'WOMAN'
} as const;

export type Gender = typeof Gender[keyof typeof Gender];
/** ユーザーの性別の割合です。 */
export type GenderRate = {
  readonly __typename?: 'GenderRate';
  /** 女性の割合です。 */
  readonly F: Scalars['Float']['output'];
  /** 男性の割合です。 */
  readonly M: Scalars['Float']['output'];
  /** その他のの割合です。 */
  readonly U: Scalars['Float']['output'];
};

/** Lv1: フォロワーの性別の割合です。 */
export type GenderRateUnit = {
  readonly __typename?: 'GenderRateUnit';
  /** 性別の割合です。 */
  readonly value?: Maybe<GenderRate>;
};

export const Genre = {
  /** アパレル */
  Apparel: 'APPAREL',
  /** ビューティー */
  Beauty: 'BEAUTY',
  /** グルメ */
  Gourmet: 'GOURMET',
  /** レジャー */
  Leisure: 'LEISURE',
  /** 通販 */
  OnlineStore: 'ONLINE_STORE',
  /** その他 */
  Other: 'OTHER',
  /** トラベル */
  Travel: 'TRAVEL'
} as const;

export type Genre = typeof Genre[keyof typeof Genre];
/** サムネイル画像のURLを表します。 */
export type ImageUrl = {
  readonly __typename?: 'ImageUrl';
  /** 中間サイズです。 */
  readonly medium: Scalars['String']['output'];
  /** オリジナルサイズです。 */
  readonly original: Scalars['String']['output'];
  /** 小さいサイズです。 */
  readonly small: Scalars['String']['output'];
};

/** Lv2: 過去1日間のインプレッション数です。 */
export type ImpressionsUnit = {
  readonly __typename?: 'ImpressionsUnit';
  /** 数値です。 */
  readonly value?: Maybe<Scalars['Int']['output']>;
};

/** インフルエンサーです。 */
export type Influencer = Node & {
  readonly __typename?: 'Influencer';
  /** インフルエンサーが登録しているSNSアカウントです。 */
  readonly activeSnsConnections: ActiveSnsConnections;
  /** 番地などです。 */
  readonly address1?: Maybe<Scalars['String']['output']>;
  /** マンション名などです。 */
  readonly address2?: Maybe<Scalars['String']['output']>;
  /** インフルエンサーの年齢です。 */
  readonly age?: Maybe<Scalars['Int']['output']>;
  /** 広告主がインフルエンサーを採用した回数です。 */
  readonly approvedCount: Scalars['Int']['output'];
  /** インフルエンサーの誕生日です。 */
  readonly birthday?: Maybe<Scalars['DateTime']['output']>;
  /** 市区町村です。 */
  readonly city?: Maybe<Scalars['String']['output']>;
  /** インフルエンサーの自己紹介です。 */
  readonly comment?: Maybe<Scalars['String']['output']>;
  /** インフルエンサーが完了したキャンペーン数です。 */
  readonly completeCountLevel: CompleteCountLevel;
  /** インフルエンサーの性別です */
  readonly gender: Gender;
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
  /** IDPのインフルエンサーIDです。 */
  readonly idpId?: Maybe<Scalars['String']['output']>;
  /** インフルエンサーのアイコンのURLです。 */
  readonly imageUrl?: Maybe<Scalars['String']['output']>;
  /** インフルエンサーの最新アクセス時間です */
  readonly latestAccessTime?: Maybe<Scalars['DateTime']['output']>;
  /** インフルエンサーの名前です。 */
  readonly name?: Maybe<Scalars['String']['output']>;
  /** 郵便番号です。 */
  readonly postalCode?: Maybe<Scalars['String']['output']>;
  /** 都道府県です。 */
  readonly pref?: Maybe<Pref>;
  /** インフルエンサーの本名です。 */
  readonly realName?: Maybe<Scalars['String']['output']>;
  /** インフルエンサーの本名（カナ）です。 */
  readonly realNameKana?: Maybe<Scalars['String']['output']>;
  /**
   * 発送先住所です。
   * @deprecated 24/06/24非推奨 address1,address2の使用を推奨します。
   */
  readonly shippingAddress?: Maybe<Scalars['String']['output']>;
  /** 電話番号です。 */
  readonly tel?: Maybe<Scalars['String']['output']>;
};

/** InstagramのSNS接続を表します。 */
export type InstagramConnection = SnsConnection & {
  readonly __typename?: 'InstagramConnection';
  /** Instagramのフォロワー数です。 */
  readonly followerCount: Scalars['Int']['output'];
  /** InstagramアイコンのURLです。 */
  readonly imageUrl?: Maybe<Scalars['String']['output']>;
  /** このInstagramの持ち主のインフルエンサーの統一Idです。 */
  readonly influencerId: Scalars['ID']['output'];
  /**
   * Instagramのインサイト情報です。
   * @deprecated CampaignEntry.insightに移動。
   */
  readonly insight?: Maybe<InstagramInsight>;
  /** SNS接続の状態です。 */
  readonly linked: Linked;
  /** Instagramのusernameです。 */
  readonly name: Scalars['String']['output'];
  /** Instagramの投稿数です。 */
  readonly postCount: Scalars['Int']['output'];
  /** InstagramのIDです。 */
  readonly uid: Scalars['String']['output'];
  readonly url: Scalars['String']['output'];
};

/** Instagramのインサイトを表します。 */
export type InstagramInsight = {
  readonly __typename?: 'InstagramInsight';
  /** Lv1: フォロワーの年齢の割合です。 */
  readonly ageRate: AgeRateUnit;
  /** Lv2: 女性フォロワーの年齢の割合です。 */
  readonly femaleAgeRate: FemaleAgeRateUnit;
  /** Lv1: フォロワーの性別の割合です。 */
  readonly genderRate: GenderRateUnit;
  /** Lv2: 過去1日間のインプレッション数です。 */
  readonly impressions: ImpressionsUnit;
  /** Lv2: 男性フォロワーの年齢の割合です。 */
  readonly maleAgeRate: MaleAgeRateUnit;
  /** Lv1: 直近25投稿のコメント数です。 */
  readonly postCommentCount: PostCommentCountUnit;
  /** Lv1: 直近25投稿のエンゲージメントです。 */
  readonly postEngagement: PostEngagementUnit;
  /** Lv2: 直近25投稿のインプレッション数です。 */
  readonly postImpressions: PostImpressionsUnit;
  /** Lv1: 直近25投稿のいいね数です。 */
  readonly postLikeCount: PostLikeCountUnit;
  /** Lv3: 直近25投稿のリーチ数です。 */
  readonly postReach: PostReachUnit;
  /** Lv2: 過去1日間のプロフィール表示回数です。 */
  readonly profileViews: ProfileViewsUnit;
  /** Lv3: 過去1日間のリーチ数です。 */
  readonly reach: ReachUnit;
  /** Lv3: 過去28日間のリーチ数です。 */
  readonly reach28: Reach28Unit;
};

/** 発行済みチケットを表します。 */
export type IssuedTicket = Node & {
  readonly __typename?: 'IssuedTicket';
  /** 適用中のキャンペーンです。 */
  readonly campaign?: Maybe<Campaign>;
  /** キャンセル日時 */
  readonly cancelAt?: Maybe<Scalars['DateTime']['output']>;
  /** チケットモデルのカテゴリです。 */
  readonly category: TicketModelCategory;
  /** 消化日時 */
  readonly consumedAt?: Maybe<Scalars['DateTime']['output']>;
  /** 発行日時 */
  readonly createdAt: Scalars['DateTime']['output'];
  /** 有効期限 */
  readonly expiredAt: Scalars['DateTime']['output'];
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
  /** チケット名です。 */
  readonly name: Scalars['String']['output'];
};

export type IssuedTicketConnection = {
  readonly __typename?: 'IssuedTicketConnection';
  readonly edges: ReadonlyArray<IssuedTicketEdge>;
  readonly nodes: ReadonlyArray<IssuedTicket>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

export type IssuedTicketEdge = {
  readonly __typename?: 'IssuedTicketEdge';
  readonly cursor: Scalars['String']['output'];
  readonly node: IssuedTicket;
};

export const LanguageType = {
  Chinese: 'CHINESE',
  English: 'ENGLISH',
  Japanese: 'JAPANESE'
} as const;

export type LanguageType = typeof LanguageType[keyof typeof LanguageType];
/** LIKESサブスクリプションを表します */
export type LikesSubscription = Node & {
  readonly __typename?: 'LikesSubscription';
  /** 最低更新回数で解約する為の期限 */
  readonly cancellableDaysBeforeMinimumUpdate: Scalars['Int']['output'];
  /** サブスク説明文 */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** 解約申請日時 */
  readonly endRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  /** 契約終了日 */
  readonly endedAt?: Maybe<Scalars['DateTime']['output']>;
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
  /** 最短解約可能日時 */
  readonly minCancellableDatetime: Scalars['DateTime']['output'];
  /** 最低更新回数です。 */
  readonly minimumUpdateCount: Scalars['Int']['output'];
  /** サブスク名称 */
  readonly name: Scalars['String']['output'];
  /** メモ */
  readonly publicMemo: Scalars['String']['output'];
  /** 契約開始日 */
  readonly startedAt: Scalars['DateTime']['output'];
};

/** 契約中のサブスクリプションの請求明細一覧です。 */
export type LikesSubscriptionInvoiceDetail = Node & {
  readonly __typename?: 'LikesSubscriptionInvoiceDetail';
  /** 請求日です。 */
  readonly billingDate: Scalars['DateTime']['output'];
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
  /** 品目名です。 */
  readonly name: Scalars['String']['output'];
  /** 支払い方法です。 */
  readonly paymentType: LikesSubscriptionInvoiceDetailPaymentType;
  /** 請求金額(税抜)です。 */
  readonly price: Scalars['Int']['output'];
  /** ステータスです。 */
  readonly status: LikesSubscriptionInvoiceDetailStatus;
  /** 消費税額です。 */
  readonly tax: Scalars['Int']['output'];
  /** 請求金額(税込)です。 */
  readonly taxIncludedPrice: Scalars['Int']['output'];
};

/** 支払い方法です。 */
export const LikesSubscriptionInvoiceDetailPaymentType = {
  CreditCard: 'CREDIT_CARD',
  Invoice: 'INVOICE',
  Mfkessai: 'MFKESSAI'
} as const;

export type LikesSubscriptionInvoiceDetailPaymentType = typeof LikesSubscriptionInvoiceDetailPaymentType[keyof typeof LikesSubscriptionInvoiceDetailPaymentType];
/** ステータスです。 */
export const LikesSubscriptionInvoiceDetailStatus = {
  /** キャンセル */
  Cancelled: 'CANCELLED',
  /** 完了 */
  Completed: 'COMPLETED',
  /** 請求失敗 */
  Failed: 'FAILED',
  /** 請求待ち */
  Waiting: 'WAITING'
} as const;

export type LikesSubscriptionInvoiceDetailStatus = typeof LikesSubscriptionInvoiceDetailStatus[keyof typeof LikesSubscriptionInvoiceDetailStatus];
/** そのSNSアカウントの接続状況です。 */
export const Linked = {
  AccountNotFound: 'ACCOUNT_NOT_FOUND',
  Approval: 'APPROVAL',
  ApprovalRequest: 'APPROVAL_REQUEST',
  Denial: 'DENIAL',
  Expulsion: 'EXPULSION',
  PrivateAccount: 'PRIVATE_ACCOUNT',
  SelfDenial: 'SELF_DENIAL'
} as const;

export type Linked = typeof Linked[keyof typeof Linked];
/** リテラシーアンケートの選択肢です。 */
export type LiteracySurvey = {
  readonly __typename?: 'LiteracySurvey';
  /** リテラシーアンケートの文言です。 */
  readonly label: Scalars['String']['output'];
  /** リテラシーアンケートの選択肢です。 */
  readonly literacySurveyOption: LiteracySurveyOption;
};

/** リテラシーアンケートの回答です。 */
export type LiteracySurveyAnswer = Node & {
  readonly __typename?: 'LiteracySurveyAnswer';
  /** リテラシーアンケートの回答です。 */
  readonly answer: LiteracySurveyOption;
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
};

/** リテラシーアンケートの選択肢です。 */
export const LiteracySurveyOption = {
  /** マーケティングにあまり詳しくなく、広告の数値指標（インプレッションやCPAなど）も見方がわからない。初歩的な内容からサポートが欲しい。 */
  Option1: 'OPTION1',
  /** 広告の基礎的な数値指標は理解しているが、広告専任の担当者がおらず、兼任のためそもそも広告を実施するリソースが不足している。 */
  Option2: 'OPTION2',
  /** 広告専任の担当者がいる、または兼任で広告実施はできるが、広告の効果測定や施策考案まで行うには十分とはいえない。 */
  Option3: 'OPTION3',
  /** 自社内に広告部署(3人以上)があり、施策を社内で考案できている。ターゲットとなる消費者像やインフルエンサー像も比較的明らかな方だ。 */
  Option4: 'OPTION4',
  /** プロダクトや広告の規模、広告予算が大きく、大手広告代理店に依頼することもある。条件が合えばトリドリに一任してもよい。 */
  Option5: 'OPTION5'
} as const;

export type LiteracySurveyOption = typeof LiteracySurveyOption[keyof typeof LiteracySurveyOption];
/** Lv2: 男性フォロワーの年齢の割合です。 */
export type MaleAgeRateUnit = {
  readonly __typename?: 'MaleAgeRateUnit';
  /** 年齢の割合です。 */
  readonly value?: Maybe<AgeRate>;
};

/** 広告主ユーザーを表します。 */
export type Member = Node & {
  readonly __typename?: 'Member';
  /** 広告主担当者のメールアドレスです。 */
  readonly email: Scalars['String']['output'];
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
};

/** インフルエンサーと広告会社のやり取りを表します。 */
export type Message = Node & {
  readonly __typename?: 'Message';
  /** 本文を返します。 */
  readonly body: Scalars['String']['output'];
  /** 作成日時を返します。 */
  readonly createdAt: Scalars['DateTime']['output'];
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
  /** 画像を返します。 */
  readonly image?: Maybe<Scalars['String']['output']>;
  /** 既読状態を返します。 */
  readonly readStatus: ReadStatus;
  /** 返信IDを返します。 */
  readonly replyUid?: Maybe<Scalars['String']['output']>;
  /** 送信元を返します。 */
  readonly sender: Sender;
};

/** レポートのメトリクス */
export const MetricsFieldName = {
  /** コメント */
  Comment: 'COMMENT',
  /** エンゲージメント */
  Engagement: 'ENGAGEMENT',
  /** エンゲージメント率 */
  EngagementRate: 'ENGAGEMENT_RATE',
  /** インプレッション */
  Impression: 'IMPRESSION',
  /** いいね */
  Like: 'LIKE',
  /** 再生回数 */
  PlayCount: 'PLAY_COUNT',
  /** 投稿数 */
  PostCount: 'POST_COUNT',
  /** リーチ */
  Reach: 'REACH',
  /** 保存 */
  Save: 'SAVE',
  /** シェア */
  Share: 'SHARE'
} as const;

export type MetricsFieldName = typeof MetricsFieldName[keyof typeof MetricsFieldName];
export type MetricsTrackingResult = {
  readonly __typename?: 'MetricsTrackingResult';
  readonly status: Scalars['String']['output'];
};

/** 事業所区分です。法人(corporate)または、個人(individual)で指定されます。 */
export const MfkessaiBusinessType = {
  /** 法人 */
  Corporate: 'CORPORATE',
  /** 個人 */
  Individual: 'INDIVIDUAL'
} as const;

export type MfkessaiBusinessType = typeof MfkessaiBusinessType[keyof typeof MfkessaiBusinessType];
/** MfkessaiのCustomerを表します。 */
export type MfkessaiCustomer = Node & {
  readonly __typename?: 'MfkessaiCustomer';
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
};

/** mfkessaiの請求先情報を表します。 */
export type MfkessaiDestination = {
  readonly __typename?: 'MfkessaiDestination';
  readonly address1?: Maybe<Scalars['String']['output']>;
  readonly address2?: Maybe<Scalars['String']['output']>;
  readonly ccEmails?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly createdAt?: Maybe<Scalars['String']['output']>;
  readonly customerId?: Maybe<Scalars['String']['output']>;
  readonly department?: Maybe<Scalars['String']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly nameKana?: Maybe<Scalars['String']['output']>;
  readonly tel?: Maybe<Scalars['String']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
  readonly uri?: Maybe<Scalars['String']['output']>;
  readonly zipCode?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  readonly __typename?: 'Mutation';
  /** 調整可能な日程を追加します。 */
  readonly addCampaignReservableSchedule?: Maybe<ReadonlyArray<Maybe<CampaignReservableSchedule>>>;
  readonly agreeAdGuideline: AdGuideline;
  /**
   * チケット制移行に同意します。
   * @deprecated 2023/05/24 必要ではなくなったため、廃止予定です。
   */
  readonly agreeTicketMigration?: Maybe<Scalars['DateTime']['output']>;
  readonly answerLiteracySurvey: LiteracySurveyAnswer;
  /** 満足度調査（リレーショナル）に回答します。 */
  readonly answerRelationalSurvey: RelationalSurveyAnswer;
  /** 満足度調査（リレーショナル）の理由を回答します。 */
  readonly answerRelationalSurveyReason: RelationalSurveyAnswer;
  /** 満足度調査（トランザクショナル）に回答します。 */
  readonly answerTransactionalSurvey: TransactionalSurveyAnswer;
  /** 満足度調査（トランザクショナル）の理由を回答します。 */
  readonly answerTransactionalSurveyReason: TransactionalSurveyAnswer;
  /** サブスクリプションを適用します。 */
  readonly applySubscription?: Maybe<TicketSubscription>;
  /** サブスクリプションを適用します。 */
  readonly applySubscriptionByCode?: Maybe<TicketSubscription>;
  /**
   * キャンペーンエントリーを承認します。
   * @deprecated 採用時の日程確定方式変更のため廃止予定
   */
  readonly approveCampaignEntry: CampaignEntry;
  /** キャンペーンエントリーを承認します。 */
  readonly approveCampaignEntryV2: CampaignEntry;
  /** 通報をオファーに割り当てます。 */
  readonly assignPenaltyToOffer: UserInfluencerPenaltyReport;
  /** キャンペーンエントリーをブロックします。 */
  readonly blockCampaignEntry: CampaignEntry;
  /** キャンペーンを作成します。 */
  readonly createCampaign: Campaign;
  /** 広告主会社の連携先SNS情報を登録します。 */
  readonly createCompanySnsConnection?: Maybe<CompanySnsConnection>;
  readonly createDownloadReport: DownloadReport;
  /**
   * MfkessaiのCustomerを作成します。
   * @deprecated 2023/07/24 使用されなくなったため、廃止予定です。
   */
  readonly createMfkessaiCustomer?: Maybe<MfkessaiCustomer>;
  /** 会社の通知メールを削除します。 */
  readonly deleteCompanyNotificationEmail?: Maybe<CompanyNotificationEmail>;
  /** companyShopTemplateを削除します。 */
  readonly deleteCompanyShopTemplateMut?: Maybe<CampaignLocation>;
  /** キャンペーンの定期公開を無効にします。 */
  readonly disableRegularlyPublishedCampaign: RegularlyPublishedCampaign;
  /** キャンペーンの定期公開を有効にします。 */
  readonly enableRegularlyPublishedCampaign: RegularlyPublishedCampaign;
  /** キャンペーンの募集を終了します。 */
  readonly endCampaignOffer: Campaign;
  readonly issueOneTimeLineAuthCode: Scalars['String']['output'];
  /** キャンペーンエントリーをピン留めします。 */
  readonly pinCampaignEntry: CampaignEntry;
  /** 会社の通知メールを仮登録します。 */
  readonly provisionallyRegisterCompanyNotificationEmail: ReadonlyArray<CompanyNotificationEmail>;
  /** 会社の通知メールのアクティベーションメールを再送信します。 */
  readonly reSendActivateCompanyNotificationEmail: CompanyNotificationEmail;
  /** 調整可能な日程を削除します。 */
  readonly removeCampaignReservableSchedule?: Maybe<ReadonlyArray<Maybe<CampaignReservableSchedule>>>;
  /** 広告主会社の連携先SNS情報を削除します。 */
  readonly removeCompanySnsConnection?: Maybe<Scalars['ID']['output']>;
  /** キャンペーンの情報を更新します。 */
  readonly requestApprovalCampaign: Campaign;
  /** LIKESサブスクリプションの解約予約をキャンセルします。 */
  readonly revokeLikesSubscriptionCancellation?: Maybe<LikesSubscription>;
  /** サブスクリプションの解約予約をキャンセルします。 */
  readonly revokeSubscriptionCancellation?: Maybe<TicketSubscription>;
  readonly savePredictedPrPostEngagementMetrics: MetricsTrackingResult;
  /** LIKESサブスクリプションの解約予約をします。 */
  readonly scheduleLikesSubscriptionCancellation?: Maybe<LikesSubscription>;
  /** サブスクリプションの解約予約をします。 */
  readonly scheduleSubscriptionCancellation?: Maybe<TicketSubscription>;
  /** キャンペーンの募集を取り下げます。 */
  readonly takeBackCampaign: Campaign;
  /** キャンペーンエントリーのピン留めを解除します。 */
  readonly unpinCampaignEntry: CampaignEntry;
  /** 広告主会社の連携先SNS情報を更新します。 */
  readonly updateAccessToken?: Maybe<CompanySnsConnection>;
  /** ビギナー記事の完了状態を更新します。 */
  readonly updateBeginnerPostStatus: BeginnerPost;
  /** キャンペーンの情報を更新します。 */
  readonly updateCampaign: Campaign;
  /** キャンペーンの予約可能な週間予定を更新します。 */
  readonly updateCampaignReservableWeeklySchedule: ReadonlyArray<CampaignReservableWeeklySchedule>;
};


export type MutationAddCampaignReservableScheduleArgs = {
  input: AddCampaignReservableScheduleInput;
};


export type MutationAnswerLiteracySurveyArgs = {
  input: AnswerLiteracySurveyInput;
};


export type MutationAnswerRelationalSurveyArgs = {
  input: AnswerRelationalSurveyInput;
};


export type MutationAnswerRelationalSurveyReasonArgs = {
  input: AnswerRelationalSurveyReasonInput;
};


export type MutationAnswerTransactionalSurveyArgs = {
  input: AnswerTransactionalSurveyInput;
};


export type MutationAnswerTransactionalSurveyReasonArgs = {
  input: AnswerTransactionalSurveyReasonInput;
};


export type MutationApplySubscriptionArgs = {
  input: ApplySubscriptionInput;
};


export type MutationApplySubscriptionByCodeArgs = {
  input: ApplySubscriptionByCodeInput;
};


export type MutationApproveCampaignEntryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationApproveCampaignEntryV2Args = {
  input: ApproveCampaignEntryInput;
};


export type MutationAssignPenaltyToOfferArgs = {
  input: AssignPenaltyToOfferInput;
};


export type MutationBlockCampaignEntryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreateCampaignArgs = {
  input: CreateCampaignInput;
};


export type MutationCreateCompanySnsConnectionArgs = {
  input: CreateCompanySnsConnectionInput;
};


export type MutationCreateDownloadReportArgs = {
  input: CreateDownloadReportInput;
};


export type MutationCreateMfkessaiCustomerArgs = {
  input: CreateMfkessaiCustomerInput;
};


export type MutationDeleteCompanyNotificationEmailArgs = {
  input: DeleteCompanyNotificationEmailInput;
};


export type MutationDeleteCompanyShopTemplateMutArgs = {
  input: DeleteCompanyShopTemplateInput;
};


export type MutationDisableRegularlyPublishedCampaignArgs = {
  input: DisableRegularlyPublishedCampaignInput;
};


export type MutationEnableRegularlyPublishedCampaignArgs = {
  input: EnableRegularlyPublishedCampaignInput;
};


export type MutationEndCampaignOfferArgs = {
  input: EndCampaignOfferInput;
};


export type MutationPinCampaignEntryArgs = {
  input: PinCampaignEntryInput;
};


export type MutationProvisionallyRegisterCompanyNotificationEmailArgs = {
  input: ProvisionallyRegisterCompanyNotificationEmailInput;
};


export type MutationReSendActivateCompanyNotificationEmailArgs = {
  input: ReSendActivateCompanyNotificationEmailInput;
};


export type MutationRemoveCampaignReservableScheduleArgs = {
  input: ReadonlyArray<RemoveCampaignReservableScheduleInput>;
};


export type MutationRemoveCompanySnsConnectionArgs = {
  input: RemoveCompanySnsConnectionInput;
};


export type MutationRequestApprovalCampaignArgs = {
  input: RequestApprovalCampaignInput;
};


export type MutationRevokeLikesSubscriptionCancellationArgs = {
  input: RevokeLikesSubscriptionCancellationInput;
};


export type MutationRevokeSubscriptionCancellationArgs = {
  input: RevokeSubscriptionCancellationInput;
};


export type MutationSavePredictedPrPostEngagementMetricsArgs = {
  input: SavePredictedPrPostEngagementInput;
};


export type MutationScheduleLikesSubscriptionCancellationArgs = {
  input: ScheduleLikesSubscriptionCancellationInput;
};


export type MutationScheduleSubscriptionCancellationArgs = {
  input: ScheduleSubscriptionCancellationInput;
};


export type MutationTakeBackCampaignArgs = {
  input: TakeBackCampaignInput;
};


export type MutationUnpinCampaignEntryArgs = {
  input: UnpinCampaignEntryInput;
};


export type MutationUpdateAccessTokenArgs = {
  input: UpdateAccessTokenInput;
};


export type MutationUpdateBeginnerPostStatusArgs = {
  input: UpdateBeginnerPostStatusInput;
};


export type MutationUpdateCampaignArgs = {
  input: UpdateCampaignInput;
};


export type MutationUpdateCampaignReservableWeeklyScheduleArgs = {
  input: UpdateCampaignReservableWeeklyScheduleInput;
};

export type Node = {
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
};

/** オファーを表します。 */
export type Offer = Node & {
  readonly __typename?: 'Offer';
  /** 承認日 */
  readonly approvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** キャンペーンを返します。 */
  readonly campaign?: Maybe<Campaign>;
  /** キャンペーンの応募情報を返します。 */
  readonly campaignEntry: CampaignEntry;
  /** PayJP支払いID */
  readonly chargeId?: Maybe<Scalars['String']['output']>;
  /**
   * プラットフォーム手数料
   * @deprecated 利用不可: 報酬金額が請求金額より大きい場合, 計算できないため
   */
  readonly collatechCommission: Scalars['Int']['output'];
  /** 広告主への請求単価 */
  readonly collatechGross: Scalars['Int']['output'];
  /** インフルエンサーへの支払金額 */
  readonly collatechNet: Scalars['Int']['output'];
  /** コメント数 */
  readonly commentCount: Scalars['Int']['output'];
  /** 作成日時 */
  readonly createdAt: Scalars['DateTime']['output'];
  /** 配送済みかどうか（発送の必要がなければnullになる） */
  readonly delivered?: Maybe<Scalars['Boolean']['output']>;
  /** 配送料 */
  readonly deliveryFee: Scalars['Int']['output'];
  /** ID */
  readonly id: Scalars['ID']['output'];
  /** インフルエンサーを返します。 */
  readonly influencer: Influencer;
  /** インフルエンサーと広告会社のやり取りを表します。 */
  readonly latestMessage?: Maybe<Message>;
  /** 最新のオファー状態遷移を返します。 */
  readonly latestTransition?: Maybe<OfferStateTransition>;
  /** いいね数 */
  readonly likeCount: Scalars['Int']['output'];
  /** 支払い方法 */
  readonly paymentType: OfferPaymentType;
  /** 完了報告文 */
  readonly reportContent?: Maybe<Scalars['String']['output']>;
  /** リツイート数 */
  readonly retweetCount: Scalars['Int']['output'];
  /** 書き直し依頼文 */
  readonly rewriteComment?: Maybe<Scalars['String']['output']>;
  /** オープンロジID */
  readonly shipmentId?: Maybe<Scalars['String']['output']>;
  /** 応募時に使用したSNSアカウントの種類です。 */
  readonly snsType: Provider;
  /** 消費税 */
  readonly tax: Scalars['Int']['output'];
  /** 更新日時 */
  readonly updatedAt: Scalars['DateTime']['output'];
  /** 完了報告の投稿URL */
  readonly url?: Maybe<Scalars['String']['output']>;
  /** 来店日 */
  readonly visitDate?: Maybe<Scalars['DateTime']['output']>;
};

export type OfferConnection = {
  readonly __typename?: 'OfferConnection';
  readonly edges: ReadonlyArray<OfferEdge>;
  readonly nodes: ReadonlyArray<Offer>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

export type OfferCountInput = {
  readonly filter?: InputMaybe<OffersFilterEnum>;
};

export type OfferEdge = {
  readonly __typename?: 'OfferEdge';
  readonly cursor: Scalars['String']['output'];
  readonly node: Offer;
};

/** オファーの支払いタイプを表します */
export const OfferPaymentType = {
  /** クレジットカード */
  CreditCard: 'CREDIT_CARD',
  /** クレジットカード */
  CreditCardGmopg: 'CREDIT_CARD_GMOPG',
  /** 自社請求書 */
  Invoice: 'INVOICE',
  /** マネーフォワードケッサイ */
  Mfkessai: 'MFKESSAI',
  /** 請求なし */
  NoCharge: 'NO_CHARGE'
} as const;

export type OfferPaymentType = typeof OfferPaymentType[keyof typeof OfferPaymentType];
/** キャンペーンの進捗状況ごとの件数を表します。 */
export type OfferStateCount = {
  readonly __typename?: 'OfferStateCount';
  /** 完了件数です。 */
  readonly completed: Scalars['Int']['output'];
  /** 応募件数です。 */
  readonly entry: Scalars['Int']['output'];
  /** 進行中の件数です。 */
  readonly working: Scalars['Int']['output'];
};

/** オファーの遷移 */
export type OfferStateTransition = Node & {
  readonly __typename?: 'OfferStateTransition';
  readonly action: OfferStateTransitionAction;
  /** 作成日時 */
  readonly createdAt: Scalars['DateTime']['output'];
  readonly deadline?: Maybe<Scalars['DateTime']['output']>;
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
  readonly state: OfferStateTransitionState;
  /** 更新日時 */
  readonly updatedAt: Scalars['DateTime']['output'];
};

/** オファーの最後に行った行動を表します */
export const OfferStateTransitionAction = {
  /** 広告主が取引キャンセルに同意した */
  AdvAcceptCancel: 'ADV_ACCEPT_CANCEL',
  /** 広告主がインフルエンサーを採用した */
  AdvAcceptEntry: 'ADV_ACCEPT_ENTRY',
  /** 広告主が完了報告を承認した */
  AdvAcceptReport: 'ADV_ACCEPT_REPORT',
  /** 広告主が日程を確定させた */
  AdvAcceptSchedule: 'ADV_ACCEPT_SCHEDULE',
  /** 広告主が日程提案をおまかせした */
  AdvAskSchedule: 'ADV_ASK_SCHEDULE',
  /** 広告主が取引キャンセルに同意しなかった */
  AdvDeclineCancel: 'ADV_DECLINE_CANCEL',
  /** 広告主がPR投稿の書き直しを依頼した */
  AdvDeclineReport: 'ADV_DECLINE_REPORT',
  /** 広告主が来店を報告した */
  AdvInformVisit: 'ADV_INFORM_VISIT',
  /** 広告主が日程を提案した */
  AdvProposeSchedule: 'ADV_PROPOSE_SCHEDULE',
  /** 広告主が採用を見送った */
  AdvRejectEntry: 'ADV_REJECT_ENTRY',
  /** 広告主が取引キャンセルを申請した */
  AdvRequestCancel: 'ADV_REQUEST_CANCEL',
  /** 広告主が日程調整のやり直しを提案した */
  AdvReschedule: 'ADV_RESCHEDULE',
  /** 広告主が取引キャンセルを取り下げた */
  AdvWithdrawCancel: 'ADV_WITHDRAW_CANCEL',
  /** 期限までに対応がなかったため取引の中断処理が行われた */
  BatchAbort: 'BATCH_ABORT',
  /** 期限までに対応がなかったため取引が自動でキャンセルされた */
  BatchAcceptCancel: 'BATCH_ACCEPT_CANCEL',
  /** 期限まで対応がなかったため完了報告が自動承認となりた */
  BatchAcceptReport: 'BATCH_ACCEPT_REPORT',
  /** 期限までに対応がなかったため自動で来店報告が行われた */
  BatchInformVisit: 'BATCH_INFORM_VISIT',
  /** インフルエンサーが取引キャンセルに同意した */
  InfluencerAcceptCancel: 'INFLUENCER_ACCEPT_CANCEL',
  /** インフルエンサーが日程を確定させた */
  InfluencerAcceptSchedule: 'INFLUENCER_ACCEPT_SCHEDULE',
  /** インフルエンサーが日程提案をおまかせした */
  InfluencerAskSchedule: 'INFLUENCER_ASK_SCHEDULE',
  /** インフルエンサーが取引キャンセルに同意しなかった */
  InfluencerDeclineCancel: 'INFLUENCER_DECLINE_CANCEL',
  /** インフルエンサーが完了報告を取り下げた */
  InfluencerDiscardReport: 'INFLUENCER_DISCARD_REPORT',
  /** インフルエンサーが来店を報告した */
  InfluencerInformVisit: 'INFLUENCER_INFORM_VISIT',
  /** インフルエンサーが日程を提案した */
  InfluencerProposeSchedule: 'INFLUENCER_PROPOSE_SCHEDULE',
  /** インフルエンサーが取引キャンセルを申請した */
  InfluencerRequestCancel: 'INFLUENCER_REQUEST_CANCEL',
  /** インフルエンサーが日程調整のやり直しを提案した */
  InfluencerReschedule: 'INFLUENCER_RESCHEDULE',
  /** インフルエンサーが完了報告を提出した（2回目の場合は再提出） */
  InfluencerSubmitReport: 'INFLUENCER_SUBMIT_REPORT',
  /** インフルエンサーが取引キャンセルを取り下げた */
  InfluencerWithdrawCancel: 'INFLUENCER_WITHDRAW_CANCEL',
  /** 運営事務局による中断処理が行われた */
  StaffAbort: 'STAFF_ABORT',
  /** 運営事務局が取引キャンセルを承認した */
  StaffAcceptCancel: 'STAFF_ACCEPT_CANCEL',
  /** 運営事務局が取引キャンセルに承認しなかった */
  StaffDeclineCancel: 'STAFF_DECLINE_CANCEL',
  /** 運営事務局による来店報告が行われた */
  StaffInformVisit: 'STAFF_INFORM_VISIT',
  /** 運営事務局による完了報告提出が行われた */
  StaffSubmitReport: 'STAFF_SUBMIT_REPORT'
} as const;

export type OfferStateTransitionAction = typeof OfferStateTransitionAction[keyof typeof OfferStateTransitionAction];
/** オファーの現在の状態を表します */
export const OfferStateTransitionState = {
  /** 中断 */
  Aborted: 'ABORTED',
  /** 広告主の完了報告承認・再承認待ち */
  AcceptingReport: 'ACCEPTING_REPORT',
  /** 広告主の取引キャンセル確認待ち */
  AdvConfirmingCancel: 'ADV_CONFIRMING_CANCEL',
  /** 広告主の日程調整待ち */
  AdvScheduling: 'ADV_SCHEDULING',
  /** 取引キャンセル済み */
  Canceled: 'CANCELED',
  /** 完了 */
  Completed: 'COMPLETED',
  /** インフルエンサーの来店待ち */
  ConfirmingVisit: 'CONFIRMING_VISIT',
  /** インフルエンサーの取引キャンセル確認待ち */
  InfluencerConfirmingCancel: 'INFLUENCER_CONFIRMING_CANCEL',
  /** インフルエンサーの日程調整待ち */
  InfluencerScheduling: 'INFLUENCER_SCHEDULING',
  /** 不採用 */
  Rejected: 'REJECTED',
  /** 運営事務局の取引キャンセル確認待ち */
  StaffConfirmingCancel: 'STAFF_CONFIRMING_CANCEL',
  /** インフルエンサーの完了報告提出・修正待ち */
  SubmittingReport: 'SUBMITTING_REPORT'
} as const;

export type OfferStateTransitionState = typeof OfferStateTransitionState[keyof typeof OfferStateTransitionState];
export const OffersFilterEnum = {
  /** 現在進行中のオファーです。 */
  Working: 'WORKING'
} as const;

export type OffersFilterEnum = typeof OffersFilterEnum[keyof typeof OffersFilterEnum];
export type OffersInput = {
  readonly filter?: InputMaybe<OffersFilterEnum>;
  readonly order?: InputMaybe<OffersOrderEnum>;
  readonly skip?: InputMaybe<Scalars['Int']['input']>;
  readonly take?: InputMaybe<Scalars['Int']['input']>;
};

export const OffersOrderEnum = {
  /** 最新の状態更新順に並び替えます。 */
  LatestActivity: 'LATEST_ACTIVITY'
} as const;

export type OffersOrderEnum = typeof OffersOrderEnum[keyof typeof OffersOrderEnum];
export type OffsetPaginationInput = {
  /** zero-based index of the current page. */
  readonly page?: InputMaybe<Scalars['Float']['input']>;
  /** number of items per page. */
  readonly pageSize?: InputMaybe<Scalars['Float']['input']>;
};

/** ソート順です。 */
export const OrderDirection = {
  /** 昇順です。 */
  Asc: 'ASC',
  /** 降順です。 */
  Desc: 'DESC'
} as const;

export type OrderDirection = typeof OrderDirection[keyof typeof OrderDirection];
export type PageInfo = {
  readonly __typename?: 'PageInfo';
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  readonly hasNextPage: Scalars['Boolean']['output'];
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** 支払い方法を表します。 */
export const PaymentType = {
  /** クレジットカード */
  CreditCard: 'CREDIT_CARD',
  /** クレジットカード */
  CreditCardGmopg: 'CREDIT_CARD_GMOPG',
  /** 請求書 */
  Invoice: 'INVOICE',
  /** MFKESSAI */
  Mfkessai: 'MFKESSAI'
} as const;

export type PaymentType = typeof PaymentType[keyof typeof PaymentType];
/** 通報理由を表します。 */
export type PenaltyReason = Node & {
  readonly __typename?: 'PenaltyReason';
  /** 通報理由のIDです。 */
  readonly id: Scalars['ID']['output'];
  /** 通報理由の名前です。 */
  readonly name: Scalars['String']['output'];
};

export type PerformanceMetricsOrder = {
  readonly direction: OrderDirection;
  readonly field: PerformanceMetricsOrderField;
};

/** パフォーマンス指標の並び順 */
export const PerformanceMetricsOrderField = {
  /** コメント */
  Comment: 'COMMENT',
  /** エンゲージメント */
  Engagement: 'ENGAGEMENT',
  /** エンゲージメント率 */
  EngagementRate: 'ENGAGEMENT_RATE',
  /** インプレッション */
  Impression: 'IMPRESSION',
  /** いいね */
  Like: 'LIKE',
  /** 再生回数 */
  PlayCount: 'PLAY_COUNT',
  /** 投稿数 */
  PostCount: 'POST_COUNT',
  /** リーチ */
  Reach: 'REACH',
  /** 保存 */
  Save: 'SAVE',
  /** シェア */
  Share: 'SHARE'
} as const;

export type PerformanceMetricsOrderField = typeof PerformanceMetricsOrderField[keyof typeof PerformanceMetricsOrderField];
export type PerformanceReportTimeSeries = {
  readonly __typename?: 'PerformanceReportTimeSeries';
  readonly name: MetricsFieldName;
  readonly value: ReadonlyArray<PerformanceReportTimeSeriesValue>;
};

export type PerformanceReportTimeSeriesValue = {
  readonly __typename?: 'PerformanceReportTimeSeriesValue';
  readonly date: Scalars['DateString']['output'];
  readonly value?: Maybe<Scalars['Float']['output']>;
};

export type PinCampaignEntryInput = {
  readonly id: Scalars['ID']['input'];
};

/** その応募がピンされているかを表します。 */
export const Pinned = {
  /** ピン留めされています。 */
  Pinned: 'PINNED',
  /** ピン留めされていません。 */
  Unpinned: 'UNPINNED'
} as const;

export type Pinned = typeof Pinned[keyof typeof Pinned];
/** プランを表します */
export type Plan = Node & {
  readonly __typename?: 'Plan';
  /**
   * 購入時の注意事項です。
   * @deprecated 2023/07/24 使用されなくなったため、廃止予定です。
   */
  readonly attention: Scalars['String']['output'];
  /** 作成日時 */
  readonly createdAt: Scalars['DateTime']['output'];
  /**
   * 次回に更新されるプランです。
   * @deprecated 2023/07/24 使用されなくなったため、廃止予定です。
   */
  readonly defaultNextPlan: Plan;
  /** 翌月更新するPlanのID */
  readonly defaultNextPlanId: Scalars['String']['output'];
  /**
   * 割引率
   * @deprecated 2023/07/24 使用されなくなったため、廃止予定です。
   */
  readonly discountRate: Scalars['Int']['output'];
  /** ジャンル */
  readonly genre: Genre;
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
  /** マーケで基本表示するプランかどうか */
  readonly isBasic: Scalars['Boolean']['output'];
  /** 採用課金かどうか */
  readonly isRecruitmentFeePlan: Scalars['Boolean']['output'];
  /** 自宅で体験かどうか */
  readonly isRemote: Scalars['Boolean']['output'];
  /** 特別プランかどうか */
  readonly isSpecialPlan: Scalars['Boolean']['output'];
  /** プランの名前 */
  readonly planName: Scalars['String']['output'];
  /** プランの月額 */
  readonly price: Scalars['Int']['output'];
  /** プランの適用期間 */
  readonly termType: TermType;
  /** 更新日時 */
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type PlanConnection = {
  readonly __typename?: 'PlanConnection';
  readonly edges: ReadonlyArray<PlanEdge>;
  readonly nodes: ReadonlyArray<Plan>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

export type PlanEdge = {
  readonly __typename?: 'PlanEdge';
  readonly cursor: Scalars['String']['output'];
  readonly node: Plan;
};

export type PossibleWeekDayAndMinutes = {
  /** 来店可能な時間帯を00:00からの分数で表します。 */
  readonly possibleMinutes: Scalars['Int']['input'];
  /** 来店可能な曜日です。 */
  readonly weekDay: WeekDay;
};

/** Lv1: 直近25投稿のコメント数です。 */
export type PostCommentCountUnit = {
  readonly __typename?: 'PostCommentCountUnit';
  /** 数値です。 */
  readonly value?: Maybe<Scalars['Int']['output']>;
};

/** Lv1: 直近25投稿のエンゲージメントです。 */
export type PostEngagementUnit = {
  readonly __typename?: 'PostEngagementUnit';
  /** 数値です。 */
  readonly value?: Maybe<Scalars['Int']['output']>;
};

/** Lv2: 直近25投稿のインプレッション数です。 */
export type PostImpressionsUnit = {
  readonly __typename?: 'PostImpressionsUnit';
  /** 数値です。 */
  readonly value?: Maybe<Scalars['Int']['output']>;
};

export type PostInfo = {
  readonly __typename?: 'PostInfo';
  /** 投稿画像のURL */
  readonly postThumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** 投稿のURL */
  readonly postUrl?: Maybe<Scalars['String']['output']>;
  /** 各種SNS側でのユーザー名 */
  readonly snsConnectName?: Maybe<Scalars['String']['output']>;
  /** 各種SNS側で発行されているユーザーID */
  readonly snsConnectUid?: Maybe<Scalars['String']['output']>;
  /** インフルエンサーID */
  readonly userInfluencerId?: Maybe<Scalars['String']['output']>;
  /** インフルエンサー名 */
  readonly userInfluencerName?: Maybe<Scalars['String']['output']>;
};

/** Lv1: 直近25投稿のいいね数です。 */
export type PostLikeCountUnit = {
  readonly __typename?: 'PostLikeCountUnit';
  /** 数値です。 */
  readonly value?: Maybe<Scalars['Int']['output']>;
};

export type PostPerformanceMetrics = {
  readonly __typename?: 'PostPerformanceMetrics';
  readonly advAccountId: Scalars['String']['output'];
  readonly campaign: Campaign;
  readonly campaignId: Scalars['String']['output'];
  readonly comments?: Maybe<Scalars['Float']['output']>;
  readonly endedAt: Scalars['DateString']['output'];
  readonly engagementRate?: Maybe<Scalars['Float']['output']>;
  readonly engagements?: Maybe<Scalars['Float']['output']>;
  readonly impressions?: Maybe<Scalars['Float']['output']>;
  readonly likes?: Maybe<Scalars['Float']['output']>;
  readonly offerId: Scalars['String']['output'];
  readonly playCounts?: Maybe<Scalars['Float']['output']>;
  readonly postInfo: PostInfo;
  readonly reaches?: Maybe<Scalars['Float']['output']>;
  readonly saves?: Maybe<Scalars['Float']['output']>;
  readonly shares?: Maybe<Scalars['Float']['output']>;
  readonly snsOriginalPostId: Scalars['String']['output'];
  readonly snsType: CampaignSnsRequirementSnsType;
  readonly startedAt: Scalars['DateString']['output'];
};

export type PostPerformanceMetricsInput = {
  readonly campaignId?: InputMaybe<Scalars['String']['input']>;
  readonly endedAt: Scalars['DateString']['input'];
  readonly startedAt: Scalars['DateString']['input'];
};

export type PostPerformanceMetricsPage = {
  readonly __typename?: 'PostPerformanceMetricsPage';
  readonly nodes?: Maybe<ReadonlyArray<PostPerformanceMetrics>>;
  readonly totalCount: Scalars['Int']['output'];
};

export type PostPerformanceMetricsSummary = {
  readonly __typename?: 'PostPerformanceMetricsSummary';
  readonly comments?: Maybe<Scalars['Float']['output']>;
  readonly endedAt: Scalars['DateString']['output'];
  readonly engagementRate?: Maybe<Scalars['Float']['output']>;
  readonly engagements?: Maybe<Scalars['Float']['output']>;
  readonly impressions?: Maybe<Scalars['Float']['output']>;
  readonly likes?: Maybe<Scalars['Float']['output']>;
  readonly playCounts?: Maybe<Scalars['Float']['output']>;
  readonly reaches?: Maybe<Scalars['Float']['output']>;
  readonly saves?: Maybe<Scalars['Float']['output']>;
  readonly shares?: Maybe<Scalars['Float']['output']>;
  readonly startedAt: Scalars['DateString']['output'];
};

/** Lv3: 直近25投稿のリーチ数です。 */
export type PostReachUnit = {
  readonly __typename?: 'PostReachUnit';
  /** 数値です。 */
  readonly value?: Maybe<Scalars['Int']['output']>;
};

/** PR投稿のインサイトです。 */
export type PrInsight = Node & {
  readonly __typename?: 'PrInsight';
  readonly aggregationTargetDate: Scalars['DateTime']['output'];
  readonly engagement?: Maybe<Scalars['Int']['output']>;
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
  readonly impression?: Maybe<Scalars['Int']['output']>;
  readonly like?: Maybe<Scalars['Int']['output']>;
  /** PR投稿数です。 */
  readonly postCount: Scalars['Int']['output'];
  readonly reach?: Maybe<Scalars['Int']['output']>;
};

export const PrTargetAge = {
  /** 17歳以下 */
  Age_17AndUnder: 'AGE_17_AND_UNDER',
  /** 18〜24歳 */
  Age_18To_24: 'AGE_18_TO_24',
  /** 25〜34歳 */
  Age_25To_34: 'AGE_25_TO_34',
  /** 35〜44歳 */
  Age_35To_44: 'AGE_35_TO_44',
  /** 45〜54歳 */
  Age_45To_54: 'AGE_45_TO_54',
  /** 55歳以上 */
  Age_55AndAbove: 'AGE_55_AND_ABOVE'
} as const;

export type PrTargetAge = typeof PrTargetAge[keyof typeof PrTargetAge];
export const PrTargetGender = {
  /** 女性 */
  Female: 'Female',
  /** 女性と男性 */
  FemaleAndMale: 'FemaleAndMale',
  /** 男性 */
  Male: 'Male',
  /** 指定なし */
  None: 'None'
} as const;

export type PrTargetGender = typeof PrTargetGender[keyof typeof PrTargetGender];
/** 都道府県を表します。 */
export const Pref = {
  /** 愛知県 */
  Aichi: 'AICHI',
  /** 秋田県 */
  Akita: 'AKITA',
  /** 青森県 */
  Aomori: 'AOMORI',
  /** 千葉県 */
  Chiba: 'CHIBA',
  /** 愛媛県 */
  Ehime: 'EHIME',
  /** 福井県 */
  Fukui: 'FUKUI',
  /** 福岡県 */
  Fukuoka: 'FUKUOKA',
  /** 福島県 */
  Fukushima: 'FUKUSHIMA',
  /** 岐阜県 */
  Gifu: 'GIFU',
  /** 群馬県 */
  Gunma: 'GUNMA',
  /** 広島県 */
  Hiroshima: 'HIROSHIMA',
  /** 北海道 */
  Hokkaido: 'HOKKAIDO',
  /** 兵庫県 */
  Hyogo: 'HYOGO',
  /** 茨城県 */
  Ibaraki: 'IBARAKI',
  /** 石川県 */
  Ishikawa: 'ISHIKAWA',
  /** 岩手県 */
  Iwate: 'IWATE',
  /** 香川県 */
  Kagawa: 'KAGAWA',
  /** 鹿児島県 */
  Kagoshima: 'KAGOSHIMA',
  /** 神奈川県 */
  Kanagawa: 'KANAGAWA',
  /** 高知県 */
  Kochi: 'KOCHI',
  /** 熊本県 */
  Kumamoto: 'KUMAMOTO',
  /** 京都府 */
  Kyoto: 'KYOTO',
  /** 三重県 */
  Mie: 'MIE',
  /** 宮城県 */
  Miyagi: 'MIYAGI',
  /** 宮崎県 */
  Miyazaki: 'MIYAZAKI',
  /** 長野県 */
  Nagano: 'NAGANO',
  /** 長崎県 */
  Nagasaki: 'NAGASAKI',
  /** 奈良県 */
  Nara: 'NARA',
  /** 新潟県 */
  Niigata: 'NIIGATA',
  /** 大分県 */
  Oita: 'OITA',
  /** 岡山県 */
  Okayama: 'OKAYAMA',
  /** 沖縄県 */
  Okinawa: 'OKINAWA',
  /** 大阪府 */
  Osaka: 'OSAKA',
  /** 佐賀県 */
  Saga: 'SAGA',
  /** 埼玉県 */
  Saitama: 'SAITAMA',
  /** 滋賀県 */
  Shiga: 'SHIGA',
  /** 島根県 */
  Shimane: 'SHIMANE',
  /** 静岡県 */
  Shizuoka: 'SHIZUOKA',
  /** 栃木県 */
  Tochigi: 'TOCHIGI',
  /** 徳島県 */
  Tokushima: 'TOKUSHIMA',
  /** 東京都 */
  Tokyo: 'TOKYO',
  /** 鳥取県 */
  Tottori: 'TOTTORI',
  /** 富山県 */
  Toyama: 'TOYAMA',
  /** 和歌山県 */
  Wakayama: 'WAKAYAMA',
  /** 山形県 */
  Yamagata: 'YAMAGATA',
  /** 山口県 */
  Yamaguchi: 'YAMAGUCHI',
  /** 山梨県 */
  Yamanashi: 'YAMANASHI'
} as const;

export type Pref = typeof Pref[keyof typeof Pref];
/** Lv2: 過去1日間のプロフィール表示回数です。 */
export type ProfileViewsUnit = {
  readonly __typename?: 'ProfileViewsUnit';
  /** 数値です。 */
  readonly value?: Maybe<Scalars['Int']['output']>;
};

/** キャンペーンの形式を表します。 */
export const ProjectType = {
  /**
   *     投稿報酬型のキャンペーンです。
   *     インフルエンサーに報酬が与えられます。
   *     21.04.27現在、必ずプランがついていません。
   */
  NoPlan: 'NO_PLAN',
  /**
   *     月額型のキャンペーンです。
   *     インフルエンサーに対する報酬がありません。
   *     21.04.27現在、必ずプランがついています。
   */
  WithPlan: 'WITH_PLAN'
} as const;

export type ProjectType = typeof ProjectType[keyof typeof ProjectType];
/** そのSNSアカウントの種類を表します。 */
export const Provider = {
  GoogleOauth2: 'GOOGLE_OAUTH2',
  Instagram: 'INSTAGRAM',
  Tiktok: 'TIKTOK',
  Twitter: 'TWITTER'
} as const;

export type Provider = typeof Provider[keyof typeof Provider];
export type ProvisionallyRegisterCompanyNotificationEmailInput = {
  /** メールアドレス一覧です。 */
  readonly emails: ReadonlyArray<Scalars['String']['input']>;
};

export type Query = {
  readonly __typename?: 'Query';
  readonly advAccountPerformanceReportTimeSeries: ReadonlyArray<PerformanceReportTimeSeries>;
  /** 満足度調査（リレーショナル）を取得します。 */
  readonly availableRelationalSurvey?: Maybe<RelationalSurvey>;
  /** 満足度調査（トランザクショナル）を取得します。 */
  readonly availableTransactionalSurvey?: Maybe<TransactionalSurvey>;
  readonly beginnerCategories: ReadonlyArray<BeginnerCategory>;
  /** 請求レポートを取得します。 */
  readonly billingReport: BillingReport;
  /** キャンペーンを返します。 */
  readonly campaign?: Maybe<Campaign>;
  /** キャンペーンエントリーを返します。 */
  readonly campaignEntry?: Maybe<CampaignEntry>;
  readonly campaignNearestStations: ReadonlyArray<CampaignNearestStation>;
  readonly campaignPerformanceMetrics: CampaignPerformanceMetricsPage;
  readonly campaignPerformanceMetricsSummary: CampaignPerformanceMetricsSummary;
  readonly campaignPerformanceReportTimeSeries: ReadonlyArray<PerformanceReportTimeSeries>;
  readonly campaignShopLocations: ReadonlyArray<CampaignShopLocations>;
  /** SNS連携情報を返します。 */
  readonly companySnsConnection: CompanySnsConnection;
  readonly downloadReports: ReadonlyArray<DownloadReport>;
  /** Facebookの短期アクセストークンを元に長期アクセストークンを返します。 */
  readonly facebookLongLiveAccessToken: Scalars['String']['output'];
  readonly literacySurveys: ReadonlyArray<LiteracySurvey>;
  /** 統一IDを使って、ノードをひとつ取得します。 */
  readonly node: Node;
  /** 統一IDを使って、ノードを複数取得します。 */
  readonly nodes: ReadonlyArray<Node>;
  /** オファーを返します。 */
  readonly offer: Offer;
  /** 通報理由一覧を取得します。 */
  readonly penaltyReasons: ReadonlyArray<PenaltyReason>;
  /**
   * プラン一覧を返します。
   * @deprecated 2023/07/24 使用されなくなったため、廃止予定です。
   */
  readonly plans: PlanConnection;
  readonly postPerformanceMetrics: PostPerformanceMetricsPage;
  readonly postPerformanceMetricsSummary: PostPerformanceMetricsSummary;
  /** すべてのジャンルとそのサブジャンルを取得します。 */
  readonly searchGenres: ReadonlyArray<SearchGenreModel>;
  /** プロモーションコードからサブスクリプションモデルを返します。 */
  readonly subscriptionModelByCode: SubscriptionModel;
  /** サブスクリプションモデル一覧を返します。 */
  readonly subscriptionModels: ReadonlyArray<SubscriptionModel>;
  /** 閲覧者の情報を返します。 */
  readonly viewer: Viewer;
  /** 閲覧者（広告主）の情報を返します。 */
  readonly viewerAsAdvertiser: Advertiser;
  /** 公開待機中のキャンペーン一覧を返します。 */
  readonly waitingPublishCampaigns: ReadonlyArray<Campaign>;
};


export type QueryAdvAccountPerformanceReportTimeSeriesArgs = {
  input: AdvAccountPerformanceReportTimeSeriesInput;
};


export type QueryAvailableTransactionalSurveyArgs = {
  input: AvailableTransactionalSurveyInput;
};


export type QueryBillingReportArgs = {
  input: BillingReportInput;
};


export type QueryCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCampaignEntryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCampaignNearestStationsArgs = {
  input: CampaignNearestStationInput;
};


export type QueryCampaignPerformanceMetricsArgs = {
  input: CampaignPerformanceMetricsInput;
  order?: InputMaybe<PerformanceMetricsOrder>;
  pagination: OffsetPaginationInput;
};


export type QueryCampaignPerformanceMetricsSummaryArgs = {
  input: CampaignPerformanceMetricsInput;
};


export type QueryCampaignPerformanceReportTimeSeriesArgs = {
  input: CampaignPerformanceReportTimeSeriesInput;
};


export type QueryCampaignShopLocationsArgs = {
  input: CampaignShopLocationsInput;
};


export type QueryCompanySnsConnectionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFacebookLongLiveAccessTokenArgs = {
  shortLiveAccessToken: Scalars['String']['input'];
};


export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNodesArgs = {
  ids: ReadonlyArray<Scalars['ID']['input']>;
};


export type QueryOfferArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPlansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPostPerformanceMetricsArgs = {
  input: PostPerformanceMetricsInput;
  order?: InputMaybe<PerformanceMetricsOrder>;
  pagination: OffsetPaginationInput;
};


export type QueryPostPerformanceMetricsSummaryArgs = {
  input: PostPerformanceMetricsInput;
};


export type QuerySubscriptionModelByCodeArgs = {
  code: Scalars['String']['input'];
};

export type ReSendActivateCompanyNotificationEmailInput = {
  /** 統一IDです。 */
  readonly id: Scalars['ID']['input'];
};

/** Lv3: 過去28日間のリーチ数です。 */
export type Reach28Unit = {
  readonly __typename?: 'Reach28Unit';
  /** 数値です。 */
  readonly value?: Maybe<Scalars['Int']['output']>;
};

/** Lv3: 過去1日間のリーチ数です。 */
export type ReachUnit = {
  readonly __typename?: 'ReachUnit';
  /** 数値です。 */
  readonly value?: Maybe<Scalars['Int']['output']>;
};

/** メッセージの既読ステータスを表します */
export const ReadStatus = {
  /** 広告主が既読の状態です */
  AdvRead: 'ADV_READ',
  /** 広告主とインフルエンサーの両方とも既読状態です */
  AllRead: 'ALL_READ',
  /** インフルエンサーが既読の状態です */
  InfluencerRead: 'INFLUENCER_READ',
  /** 広告主とインフルエンサーの両方とも未読の状態です */
  NoRead: 'NO_READ'
} as const;

export type ReadStatus = typeof ReadStatus[keyof typeof ReadStatus];
/** キャンペーンの定期公開に関する情報を表します。 */
export type RegularlyPublishedCampaign = Node & {
  readonly __typename?: 'RegularlyPublishedCampaign';
  /** 毎月の定期公開の実行日です。 */
  readonly executionDay?: Maybe<Scalars['Int']['output']>;
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
  /** 定期公開のログです。 */
  readonly logs?: Maybe<ReadonlyArray<RegularlyPublishedCampaignLog>>;
  /** 次回の定期公開実行日です。 */
  readonly nextExecutionDate?: Maybe<Scalars['DateTime']['output']>;
  /** コピー元のキャンペーンのIDです。 */
  readonly originalCampaignId: Scalars['BigInt']['output'];
  /** 定期公開の来店可能なスケジュールです。 */
  readonly reservableSchedules?: Maybe<ReadonlyArray<RegularlyPublishedCampaignReservableSchedule>>;
  /** 定期公開の状態です。 */
  readonly status: RegularlyPublishedCampaignStatus;
};

/** キャンペーン定期公開のログを表します。 */
export type RegularlyPublishedCampaignLog = Node & {
  readonly __typename?: 'RegularlyPublishedCampaignLog';
  /** コピー先のキャンペーンのIDです。 */
  readonly copiedCampaignId: Scalars['BigInt']['output'];
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
  /** コピー元のキャンペーンのIDです。 */
  readonly originalCampaignId: Scalars['BigInt']['output'];
  /** 定期公開のIDです。 */
  readonly regularlyPublishedCampaignId: Scalars['BigInt']['output'];
};

export type RegularlyPublishedCampaignReservableSchedule = {
  readonly __typename?: 'RegularlyPublishedCampaignReservableSchedule';
  /** 来店可能な時間帯です。00:00からの分数で表現します。 */
  readonly possibleMinutes: Scalars['Int']['output'];
  /** 定期公開のIDです。 */
  readonly regularlyPublishedCampaignId: Scalars['BigInt']['output'];
  /** 来店可能な曜日です。 */
  readonly weekDay: WeekDay;
};

/** 定期公開の状態です。 */
export const RegularlyPublishedCampaignStatus = {
  /** 無効 */
  Off: 'OFF',
  /** 有効 */
  On: 'ON'
} as const;

export type RegularlyPublishedCampaignStatus = typeof RegularlyPublishedCampaignStatus[keyof typeof RegularlyPublishedCampaignStatus];
/** 満足度調査（リレーショナル）を表します。 */
export type RelationalSurvey = Node & {
  readonly __typename?: 'RelationalSurvey';
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
};

/** 満足度調査の回答を表します。 */
export type RelationalSurveyAnswer = Node & {
  readonly __typename?: 'RelationalSurveyAnswer';
  /** 回答した環境です。 */
  readonly answerEnvironment: AnswerEnvironment;
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
  /** 理由です。 */
  readonly reason?: Maybe<Scalars['String']['output']>;
  /** 満足度です。(0〜10) */
  readonly score: Scalars['Int']['output'];
};

/** リレーショナルアンケートのバージョンです。 */
export const RelationalSurveyVersion = {
  /** NPSアンケートです */
  V1: 'V1',
  /** 満足度アンケートです */
  V2: 'V2'
} as const;

export type RelationalSurveyVersion = typeof RelationalSurveyVersion[keyof typeof RelationalSurveyVersion];
export type RemoveCompanySnsConnectionInput = {
  /** companySnsConnectionの統一IDです。  */
  readonly id: Scalars['ID']['input'];
};

export type RequestApprovalCampaignInput = {
  /** キャンペーンIDです。 */
  readonly id: Scalars['ID']['input'];
};

/** キャンペーンの予約タイプ */
export const Reservation = {
  /** 日程調整も本人確認チケットも利用します */
  Discuss: 'DISCUSS',
  /** 日程調整も本人確認チケットも利用しません */
  Other: 'OTHER',
  /** 日程調整のみ利用します */
  ScheduleOnly: 'SCHEDULE_ONLY',
  /** 本人確認チケットのみ利用します */
  TicketOnly: 'TICKET_ONLY'
} as const;

export type Reservation = typeof Reservation[keyof typeof Reservation];
export const ReviewSection = {
  /** キャンペーン情報 */
  Campaign: 'CAMPAIGN',
  /** その他 */
  Others: 'OTHERS',
  /** 来店可能日時 */
  ReservableSchedule: 'RESERVABLE_SCHEDULE'
} as const;

export type ReviewSection = typeof ReviewSection[keyof typeof ReviewSection];
export const ReviewTarget = {
  /** 募集するインフルエンサーの年齢制限が適切に設定されている */
  AgeLimit: 'AGE_LIMIT',
  /** PRに関する注意事項が設定されている */
  Attention: 'ATTENTION',
  /** キャンペーン名が魅力的な内容に設定されている */
  CampaignName: 'CAMPAIGN_NAME',
  /** 同伴者が設定されている */
  Companion: 'COMPANION',
  /** 1枚目がベストな画像になっている */
  CoverImages: 'COVER_IMAGES',
  /** 募集するインフルエンサーの性別が適切に設定されている */
  Gender: 'GENDER',
  /** 請求単価が設定されている */
  Gross: 'GROSS',
  /** ご案内が設定されている */
  Guidance: 'GUIDANCE',
  /** PRに関する注意事項が適切に設定されている */
  LegalAttention: 'LEGAL_ATTENTION',
  /** キャンペーン名が適切に設定されている */
  LegalCampaignName: 'LEGAL_CAMPAIGN_NAME',
  /** 1枚目がベストな画像になっている */
  LegalCoverImages: 'LEGAL_COVER_IMAGES',
  /** ご案内が設定されている */
  LegalGuidance: 'LEGAL_GUIDANCE',
  /** 自動応答メッセージが適切に設定されている */
  LegalOfferAutoMessage: 'LEGAL_OFFER_AUTO_MESSAGE',
  /** その他 */
  LegalOthers: 'LEGAL_OTHERS',
  /** 掲載を希望するアカウント・URLが適切に設定されている */
  LegalRequestUrl: 'LEGAL_REQUEST_URL',
  /** ストーリー投稿に貼るリンク先のURLが設定されている */
  LegalSnsPostRedirectUrl: 'LEGAL_SNS_POST_REDIRECT_URL',
  /** インフルエンサーの投稿に含める文章【文言指定オプション】が設定されている */
  LegalSpecifiedPrText: 'LEGAL_SPECIFIED_PR_TEXT',
  /** 提供サービスが適切に設定されている */
  LegalSponsorService: 'LEGAL_SPONSOR_SERVICE',
  /** 概要が適切に設定されている */
  LegalSummary: 'LEGAL_SUMMARY',
  /** 希望ハッシュタグが適切に設定されている */
  LegalTagList: 'LEGAL_TAG_LIST',
  /** インフルエンサーにやって欲しいことが適切に設定されている */
  LegalWantInfluencer: 'LEGAL_WANT_INFLUENCER',
  /** 最大同伴者数が設定されている */
  MaxCompanionCount: 'MAX_COMPANION_COUNT',
  /** 自動応答メッセージが設定されている */
  OfferAutoMessage: 'OFFER_AUTO_MESSAGE',
  /** 来店可能日時が適切に設定されている */
  Other: 'OTHER',
  /** 掲載を希望するアカウント・URLが設定されている */
  RequestUrl: 'REQUEST_URL',
  /** 来店可能日時が適切に設定されている */
  ReservableSchedules: 'RESERVABLE_SCHEDULES',
  /** 来店日の調整方法が設定されている */
  Reservations: 'RESERVATIONS',
  /** ジャンルが設定されている */
  SearchGenre: 'SEARCH_GENRE',
  /** サブジャンルが設定されている */
  SearchSubGenre: 'SEARCH_SUB_GENRE',
  /** 店舗住所が正しい */
  ShopAddress: 'SHOP_ADDRESS',
  /** ストーリー投稿に貼るリンク先のURLが設定されている */
  SnsPostRedirectUrl: 'SNS_POST_REDIRECT_URL',
  /** SNSへの投稿方法が設定されている */
  SnsPostType: 'SNS_POST_TYPE',
  /** インフルエンサーの投稿に含める文章【文言指定オプション】が設定されている */
  SpecifiedPrText: 'SPECIFIED_PR_TEXT',
  /** 提供サービスが設定されている */
  SponsorService: 'SPONSOR_SERVICE',
  /** 提供サービスの本来の価格(税抜)が設定されている */
  SponsorServicePrice: 'SPONSOR_SERVICE_PRICE',
  /** 概要が設定されている */
  Summary: 'SUMMARY',
  /** 希望ハッシュタグが設定されている */
  TagList: 'TAG_LIST',
  /** URLが正しい（リンク切れでない） */
  Url: 'URL',
  /** インフルエンサーにやって欲しいことが設定されている */
  WantInfluencer: 'WANT_INFLUENCER'
} as const;

export type ReviewTarget = typeof ReviewTarget[keyof typeof ReviewTarget];
export type RevokeLikesSubscriptionCancellationInput = {
  /** LIKESサブスクリプションのIDです。 */
  readonly likesSubscriptionId: Scalars['ID']['input'];
};

export type RevokeSubscriptionCancellationInput = {
  /** サブスクリプションのIDです。 */
  readonly subscriptionId: Scalars['ID']['input'];
};

/** 満足度調査の種別です。 */
export const SatisfactionSurveyKind = {
  /** ホーム */
  Home: 'HOME',
  /** inf応募一覧画面 */
  InfluencerEntryList: 'INFLUENCER_ENTRY_LIST',
  /** 完了報告一覧画面 */
  OfferCompletionList: 'OFFER_COMPLETION_LIST',
  /** やりとり詳細画面 */
  OfferTimeline: 'OFFER_TIMELINE',
  /** レポート */
  Report: 'REPORT',
  /** チケットの購入・契約 */
  SubscriptionContract: 'SUBSCRIPTION_CONTRACT'
} as const;

export type SatisfactionSurveyKind = typeof SatisfactionSurveyKind[keyof typeof SatisfactionSurveyKind];
export type SavePredictedPrPostEngagementInput = {
  readonly campaignEntryId: Scalars['ID']['input'];
  readonly engagementClass: Scalars['Int']['input'];
  readonly idpInfluencerId: Scalars['String']['input'];
  readonly predictionParamsJson: Scalars['String']['input'];
  readonly predictionResultJson: Scalars['String']['input'];
};

export type ScheduleLikesSubscriptionCancellationInput = {
  /** LIKESサブスクリプションのIDです。 */
  readonly likesSubscriptionId: Scalars['ID']['input'];
};

export type ScheduleSubscriptionCancellationInput = {
  /** サブスクリプションのIDです。 */
  readonly subscriptionId: Scalars['ID']['input'];
};

export const SearchGenre = {
  /** アパレル */
  Apparel: 'APPAREL',
  /** ビューティー */
  Beauty: 'BEAUTY',
  /** グルメ */
  Gourmet: 'GOURMET',
  /** レジャー */
  Leisure: 'LEISURE',
  /** ライフスタイル */
  Lifestyle: 'LIFESTYLE',
  /** トラベル */
  Travel: 'TRAVEL'
} as const;

export type SearchGenre = typeof SearchGenre[keyof typeof SearchGenre];
/** ジャンル */
export type SearchGenreModel = {
  readonly __typename?: 'SearchGenreModel';
  /** ジャンルID */
  readonly id: Scalars['ID']['output'];
  /** ジャンル名 */
  readonly name: Scalars['String']['output'];
  /** サブジャンル */
  readonly subGenres: ReadonlyArray<SearchSubGenreModel>;
};

/** サブジャンル */
export type SearchSubGenreModel = {
  readonly __typename?: 'SearchSubGenreModel';
  /** サブジャンルID */
  readonly id: Scalars['ID']['output'];
  /** サブジャンル名 */
  readonly name: Scalars['String']['output'];
};

/** メッセージの送り主を表します */
export const Sender = {
  /** 広告主 */
  Adv: 'ADV',
  /** インフルエンサー */
  Influencer: 'INFLUENCER',
  /** システム */
  System: 'SYSTEM'
} as const;

export type Sender = typeof Sender[keyof typeof Sender];
export type ShopCity = {
  readonly __typename?: 'ShopCity';
  /** 市区町村コード */
  readonly cityCode: Scalars['String']['output'];
  /** 市区町村名 */
  readonly name: Scalars['String']['output'];
  /** 町域名 */
  readonly town: Scalars['String']['output'];
};

export type ShopPrefecture = {
  readonly __typename?: 'ShopPrefecture';
  /** 都道府県名 */
  readonly prefecture: Scalars['String']['output'];
  /** 都道府県コード */
  readonly prefectureCode: Scalars['String']['output'];
};

export type SnsConnection = {
  readonly followerCount: Scalars['Int']['output'];
  readonly imageUrl?: Maybe<Scalars['String']['output']>;
  readonly linked: Linked;
  readonly name: Scalars['String']['output'];
  readonly postCount: Scalars['Int']['output'];
  readonly uid: Scalars['String']['output'];
};

export type SnsRequirementPartialCreateCampaignInput = {
  /** インフルエンサーの投稿に載せたいSNSアカウントです。 */
  readonly requestUrl: Scalars['String']['input'];
  /** ストーリーズ投稿の遷移先URLです。 */
  readonly snsPostRedirectUrl: Scalars['String']['input'];
  /** SNSの投稿形式です。 */
  readonly snsPostTypeList: ReadonlyArray<CampaignSnsRequirementSnsPostType>;
  /** 募集するSNSの種類です。 */
  readonly snsType: CampaignSnsRequirementSnsType;
  /** 投稿に加えて欲しいタグ一覧（言語別） */
  readonly tagList: ReadonlyArray<CampaignSnsRequirementTagInput>;
};

/** サブスクリプションの請求明細を表します。 */
export type SubscriptionInvoiceDetail = Node & {
  readonly __typename?: 'SubscriptionInvoiceDetail';
  /** 請求日です。 */
  readonly billingDate: Scalars['DateTime']['output'];
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
  /** 品目名です。 */
  readonly name: Scalars['String']['output'];
  /** 支払い方法です。 */
  readonly paymentType: SubscriptionInvoiceDetailPaymentType;
  /** 請求金額(税抜)です。 */
  readonly price: Scalars['Int']['output'];
  /** ステータスです。 */
  readonly status: SubscriptionInvoiceDetailStatus;
  /** 消費税額です。 */
  readonly tax: Scalars['Int']['output'];
  /** 請求金額(税込)です。 */
  readonly taxIncludedPrice: Scalars['Int']['output'];
  /** 請求したサブスクリプションです。 */
  readonly ticketSubscription: TicketSubscription;
};

/** 支払い方法を表します。 */
export const SubscriptionInvoiceDetailPaymentType = {
  /** クレジットカード */
  CreditCard: 'CREDIT_CARD',
  /** クレジットカード */
  CreditCardGmopg: 'CREDIT_CARD_GMOPG',
  /** 請求書 */
  Invoice: 'INVOICE',
  /** MFKESSAI */
  Mfkessai: 'MFKESSAI'
} as const;

export type SubscriptionInvoiceDetailPaymentType = typeof SubscriptionInvoiceDetailPaymentType[keyof typeof SubscriptionInvoiceDetailPaymentType];
/** ステータスです。 */
export const SubscriptionInvoiceDetailStatus = {
  /** キャンセル */
  Cancelled: 'CANCELLED',
  /** 完了 */
  Completed: 'COMPLETED',
  /** 請求失敗 */
  Failed: 'FAILED',
  /** 請求待ち */
  Waiting: 'WAITING'
} as const;

export type SubscriptionInvoiceDetailStatus = typeof SubscriptionInvoiceDetailStatus[keyof typeof SubscriptionInvoiceDetailStatus];
/** サブスクリプションモデルを表します。 */
export type SubscriptionModel = Node & {
  readonly __typename?: 'SubscriptionModel';
  /** サブスクリプションの説明です。 */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
  /** 付与チケット数（初回）です。 */
  readonly initialIssueTicketCount: Scalars['Int']['output'];
  /** 初回金額(税抜)です。 */
  readonly initialPrice: Scalars['Int']['output'];
  /** 初回発行されるチケットのIDです。 */
  readonly initialTicketModelId?: Maybe<Scalars['ID']['output']>;
  /** プロモーションでのみの提供するサブスクリプション */
  readonly isPromotionalSubscription: Scalars['Boolean']['output'];
  /** 付与チケット数（2ヶ月目以降）です。 */
  readonly issueTicketCount: Scalars['Int']['output'];
  /** 最低更新回数です。 */
  readonly minimumUpdateCount: Scalars['Int']['output'];
  /** サブスクリプションモデルの名前です。 */
  readonly name: Scalars['String']['output'];
  /** 金額(税抜)です。 */
  readonly price: Scalars['Int']['output'];
  /** 更新時に発行されるチケットIDです。 */
  readonly ticketModelId?: Maybe<Scalars['ID']['output']>;
};

/** サブスクリプションの更新予定を表します。 */
export type SubscriptionRenewal = Node & {
  readonly __typename?: 'SubscriptionRenewal';
  /**
   * 次の更新予定を作成したかどうかです。
   * @deprecated 2023/07/04 カラム削除予定のため使用不可
   */
  readonly createdNextRenewal: Scalars['Boolean']['output'];
  /**
   * 更新処理を試行したかどうかです。
   * @deprecated 2023/04/13 カラム削除のため使用不可
   */
  readonly doneProcessing: Scalars['Boolean']['output'];
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
  /** 更新予定日です。 */
  readonly renewalDate: Scalars['DateTime']['output'];
  /** サブスクリプションの請求明細です。 */
  readonly subscriptionInvoiceDetail?: Maybe<SubscriptionInvoiceDetail>;
};

export type SubscriptionRenewalConnection = {
  readonly __typename?: 'SubscriptionRenewalConnection';
  readonly edges: ReadonlyArray<SubscriptionRenewalEdge>;
  readonly nodes: ReadonlyArray<SubscriptionRenewal>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

export type SubscriptionRenewalEdge = {
  readonly __typename?: 'SubscriptionRenewalEdge';
  readonly cursor: Scalars['String']['output'];
  readonly node: SubscriptionRenewal;
};

export type SubscriptionRenewalOrder = {
  readonly direction: OrderDirection;
  readonly field: SubscriptionRenewalOrderField;
};

export const SubscriptionRenewalOrderField = {
  /** 更新日です。 */
  RenewalDate: 'RENEWAL_DATE'
} as const;

export type SubscriptionRenewalOrderField = typeof SubscriptionRenewalOrderField[keyof typeof SubscriptionRenewalOrderField];
export type TakeBackCampaignInput = {
  /** キャンペーンのIDです。 */
  readonly campaignId: Scalars['ID']['input'];
};

/** プランの適用期間 */
export const TermType = {
  /** ７日 */
  Day7: 'DAY7',
  /** １５日 */
  Day15: 'DAY15',
  /** ２０日 */
  Day20: 'DAY20',
  /** ４０日 */
  Day40: 'DAY40',
  /** １ヶ月 */
  Month1: 'MONTH1',
  /** ３ヶ月 */
  Month3: 'MONTH3',
  /** ６ヶ月 */
  Month6: 'MONTH6',
  /** １２ヶ月 */
  Month12: 'MONTH12',
  /** 期限なし */
  NoDeadline: 'NO_DEADLINE',
  /** 可変 */
  Variable: 'VARIABLE'
} as const;

export type TermType = typeof TermType[keyof typeof TermType];
/** チケットモデルのカテゴリです。 */
export const TicketModelCategory = {
  /** 現地で体験 */
  Locale: 'LOCALE',
  /** 自宅で体験 */
  Remote: 'REMOTE'
} as const;

export type TicketModelCategory = typeof TicketModelCategory[keyof typeof TicketModelCategory];
/** 適用中のサブスクリプションを表します。 */
export type TicketSubscription = Node & {
  readonly __typename?: 'TicketSubscription';
  /** 解約申請日時です。 */
  readonly cancellationRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  /** 解約になるタイミングです。 */
  readonly cancellationTiming: CancellationTiming;
  /** サブスクリプションの説明です。 */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** 終了日時です。 */
  readonly endedAt?: Maybe<Scalars['DateTime']['output']>;
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
  /** 次回の更新予定を表します。 */
  readonly latestSubscriptionRenewal: SubscriptionRenewal;
  /** 最短の解約可能日時です。(即日解約の場合は最新の更新日) */
  readonly minCancellableDatetime: Scalars['DateTime']['output'];
  /** 最小更新回数 */
  readonly minimumUpdateCount: Scalars['Int']['output'];
  /** サブスクリプション名です。 */
  readonly name: Scalars['String']['output'];
  /** 次回の請求金額(税抜)です。 */
  readonly nextBillingPrice?: Maybe<Scalars['Int']['output']>;
  /** 開始日時です。 */
  readonly startedAt: Scalars['DateTime']['output'];
  /** サブスクリプションモデルID */
  readonly subscriptionModelId: Scalars['BigInt']['output'];
  /** サブスクリプション更新予定情報の一覧です。 */
  readonly subscriptionRenewals: SubscriptionRenewalConnection;
};


/** 適用中のサブスクリプションを表します。 */
export type TicketSubscriptionSubscriptionRenewalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: SubscriptionRenewalOrder;
};

/** TikTokのSNS接続を表します。 */
export type TikTokConnection = SnsConnection & {
  readonly __typename?: 'TikTokConnection';
  /** TikTokのフォロワー数です。 */
  readonly followerCount: Scalars['Int']['output'];
  /** TikTokアイコンのURLです。 */
  readonly imageUrl?: Maybe<Scalars['String']['output']>;
  /** SNS接続の状態です。 */
  readonly linked: Linked;
  /** TikTokのユーザ名です。 */
  readonly name: Scalars['String']['output'];
  /** TikTokの投稿数です。 */
  readonly postCount: Scalars['Int']['output'];
  /** TikTokのIDです。 */
  readonly uid: Scalars['String']['output'];
  readonly url: Scalars['String']['output'];
};

/** 要対応オファーを表します。 */
export type TodoOffer = Node & {
  readonly __typename?: 'TodoOffer';
  /** 広告主ボールかどうかを表します。 */
  readonly hasCompanyTodo: Scalars['Boolean']['output'];
  /** 要対応マークがあるかどうかを表します。 */
  readonly hasReplyTodo: Scalars['Boolean']['output'];
  /** 未読メッセージがあるかどうかを表します。 */
  readonly hasUnreadMessage: Scalars['Boolean']['output'];
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
  /** オファーを表します。 */
  readonly offer: Offer;
};

/** 満足度調査（トランザクショナル）を表します。 */
export type TransactionalSurvey = Node & {
  readonly __typename?: 'TransactionalSurvey';
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
};

/** 満足度調査の回答を表します。 */
export type TransactionalSurveyAnswer = Node & {
  readonly __typename?: 'TransactionalSurveyAnswer';
  /** 回答した環境です。 */
  readonly answerEnvironment: AnswerEnvironment;
  /** 統一IDです。 */
  readonly id: Scalars['ID']['output'];
  /** 理由です。 */
  readonly reason?: Maybe<Scalars['String']['output']>;
  /** 満足度です。(0〜10) */
  readonly score: Scalars['Int']['output'];
};

/** チュートリアルを表します。 */
export type Tutorial = {
  readonly __typename?: 'Tutorial';
  /** BeginnerのDoneチェックがあるかです。 */
  readonly hasBeginnerDoneCheck: Scalars['Boolean']['output'];
  /** キャンペーンを一つでも持っているかです。 */
  readonly hasCampaign: Scalars['Boolean']['output'];
  /** Instagram連携をしているかです。 */
  readonly hasInstagramConnection: Scalars['Boolean']['output'];
  /** Instagramのウェブサイトリンクがあるかです。 */
  readonly hasInstagramWebsiteLink?: Maybe<Scalars['Boolean']['output']>;
  /** オファーがあるかです。 */
  readonly hasOffer: Scalars['Boolean']['output'];
  /**
   * プラン枠を一つでも買ったことがあるかです。
   * @deprecated hasTicketを参照してください。
   */
  readonly hasPlanSlot: Scalars['Boolean']['output'];
  /** チケットを一枚でも所持したことがあるかです。 */
  readonly hasTicket: Scalars['Boolean']['output'];
};

/** TwitterのSNS接続を表します。 */
export type TwitterConnection = SnsConnection & {
  readonly __typename?: 'TwitterConnection';
  /** Twitterのフォロワー数です。 */
  readonly followerCount: Scalars['Int']['output'];
  /** TwitterアイコンのURLです。 */
  readonly imageUrl?: Maybe<Scalars['String']['output']>;
  /** SNS接続の状態です。 */
  readonly linked: Linked;
  /** Twitterのscreen_nameです。 */
  readonly name: Scalars['String']['output'];
  /** Twitterのツイート数です。 */
  readonly postCount: Scalars['Int']['output'];
  /** TwitterのIDです。 */
  readonly uid: Scalars['String']['output'];
  /** TwitterのURLです。 */
  readonly url: Scalars['String']['output'];
};

export type UnpinCampaignEntryInput = {
  readonly id: Scalars['ID']['input'];
};

export type UnsettledExpenseFeeDetail = {
  readonly __typename?: 'UnsettledExpenseFeeDetail';
  /** 立替金額 */
  readonly expenseFee: Scalars['Int']['output'];
};

export type UnsettledFeeDetail = {
  readonly __typename?: 'UnsettledFeeDetail';
  /** 投稿報酬（税抜） */
  readonly postedReward: Scalars['Int']['output'];
  /** 採用課金（税抜） */
  readonly recruitmentFee: Scalars['Int']['output'];
  /** 採用課金（税込） */
  readonly recruitmentFeeWithTax: Scalars['Int']['output'];
  /** 立替金額、投稿報酬の消費税 */
  readonly totalTax: Scalars['Int']['output'];
};

export type UpdateAccessTokenInput = {
  /** companySnsConnectionの統一IDです。 */
  readonly id: Scalars['ID']['input'];
  /** 次回トークン更新日時です。 */
  readonly nextTokenUpdateAt: Scalars['DateTime']['input'];
  /** アクセストークンです。 */
  readonly token: Scalars['String']['input'];
};

export type UpdateBeginnerPostStatusInput = {
  readonly beginnerPostId: Scalars['ID']['input'];
  readonly companySnsConnectionId: Scalars['ID']['input'];
  readonly done: Scalars['Boolean']['input'];
};

export type UpdateCampaignInput = {
  /** 年齢制限です。 */
  readonly ageLimit?: InputMaybe<AgeLimit>;
  /** 注意事項 */
  readonly attention?: InputMaybe<Scalars['String']['input']>;
  /** 投稿報酬です。 */
  readonly basicGross?: InputMaybe<Scalars['Int']['input']>;
  /** 建物名・部屋番号 */
  readonly buildingName?: InputMaybe<Scalars['String']['input']>;
  /** 使用するオプションの文言指定です。 */
  readonly campaignRequirementOptionSpecifiedPrText?: InputMaybe<Scalars['String']['input']>;
  /** 使用するオプションです。 */
  readonly campaignRequirementOptions?: InputMaybe<ReadonlyArray<CampaignRequirementOptions>>;
  /** 市区町村名 */
  readonly cityName?: InputMaybe<Scalars['String']['input']>;
  /** 同行者の有無 */
  readonly companion?: InputMaybe<Companion>;
  /** キャンペーンの画像です。 */
  readonly coverImages?: InputMaybe<ReadonlyArray<CoverImageInput>>;
  /** 希望するインフルエンサーの性別です。 */
  readonly gender?: InputMaybe<CampaignGender>;
  /** 1採用するのにかかる金額（請求単価）です。ただし、採用課金は含まれていません。 */
  readonly gross?: InputMaybe<Scalars['Int']['input']>;
  /** ご案内です。 */
  readonly guidance?: InputMaybe<Scalars['String']['input']>;
  /** キャンペーンのIDです。 */
  readonly id: Scalars['ID']['input'];
  /** インフルエンサー負担率です。 */
  readonly influencerBurdenRate: Scalars['Int']['input'];
  /** 同伴者の最大人数です。 */
  readonly maxCompanionCount?: InputMaybe<Scalars['Int']['input']>;
  /** キャンペーンの名前です。 */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** 最寄り駅 */
  readonly nearestStationName?: InputMaybe<Scalars['String']['input']>;
  /** インフルエンサー採用時に相手に送られる自動メッセージ */
  readonly offerAutoMessage?: InputMaybe<Scalars['String']['input']>;
  /** 商材ターゲットの年齢層です。 */
  readonly prTargetAge?: InputMaybe<ReadonlyArray<PrTargetAge>>;
  /** 商材ターゲットの性別です。 */
  readonly prTargetGender?: InputMaybe<PrTargetGender>;
  /** サブジャンルです。 */
  readonly searchSubGenreIds?: InputMaybe<ReadonlyArray<Scalars['BigInt']['input']>>;
  /** 店舗名です。 */
  readonly shopName?: InputMaybe<Scalars['String']['input']>;
  /** 店舗の郵便番号です。 */
  readonly shopPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** 都道府県です。 */
  readonly shopPref?: InputMaybe<Pref>;
  readonly shopTel?: InputMaybe<Scalars['String']['input']>;
  /** 店舗テンプレートのIDです */
  readonly shopTemplateId?: InputMaybe<Scalars['BigInt']['input']>;
  /** 募集するSNSの条件です。 */
  readonly snsRequirements?: InputMaybe<ReadonlyArray<SnsRequirementPartialCreateCampaignInput>>;
  /** 提供サービスです。 */
  readonly sponsorService?: InputMaybe<Scalars['String']['input']>;
  /** 本来の提供価格（税込）です。 */
  readonly sponsorServicePriceIntax?: InputMaybe<Scalars['Int']['input']>;
  /** 店舗の番地 */
  readonly streetAddress?: InputMaybe<Scalars['String']['input']>;
  /** キャンペーンの概要です。 */
  readonly summary?: InputMaybe<Scalars['String']['input']>;
  /** 広告主サイトURLです。 */
  readonly url?: InputMaybe<Scalars['String']['input']>;
  /** インフルエンサーにやってほしいことです。 */
  readonly wantInfluencer?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCampaignReservableWeeklyScheduleInput = {
  readonly campaignId: Scalars['ID']['input'];
  readonly schedules: ReadonlyArray<UpdateCampaignReservableWeeklyScheduleSchedulesInput>;
};

export type UpdateCampaignReservableWeeklyScheduleSchedulesInput = {
  /** 来店可能な時間帯です。分換算で表現します。 */
  readonly possibleMinutes: Scalars['Int']['input'];
  /** 来店可能な曜日です。 */
  readonly weekDay: WeekDay;
};

export type UserInfluencerPenaltyReport = Node & {
  readonly __typename?: 'UserInfluencerPenaltyReport';
  readonly advAccountId?: Maybe<Scalars['ID']['output']>;
  readonly body: Scalars['String']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['ID']['output'];
  readonly kind: Scalars['Int']['output'];
  readonly offerId?: Maybe<Scalars['ID']['output']>;
  readonly penaltyReasonId?: Maybe<Scalars['ID']['output']>;
  readonly score?: Maybe<Scalars['Int']['output']>;
  readonly status: Scalars['Int']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly userInfluencerId: Scalars['ID']['output'];
};

export type Viewer = Advertiser;

/** 曜日 */
export const WeekDay = {
  /** 金曜日 */
  Friday: 'FRIDAY',
  /** 月曜日 */
  Monday: 'MONDAY',
  /** 土曜日 */
  Saturday: 'SATURDAY',
  /** 日曜日 */
  Sunday: 'SUNDAY',
  /** 木曜日 */
  Thursday: 'THURSDAY',
  /** 火曜日 */
  Tuesday: 'TUESDAY',
  /** 水曜日 */
  Wednesday: 'WEDNESDAY'
} as const;

export type WeekDay = typeof WeekDay[keyof typeof WeekDay];
/** YouTubeのSNS接続を表します。 */
export type YouTubeConnection = SnsConnection & {
  readonly __typename?: 'YouTubeConnection';
  /** YouTubeのフォロワー数です。 */
  readonly followerCount: Scalars['Int']['output'];
  /** YouTubeアイコンのURLです。 */
  readonly imageUrl?: Maybe<Scalars['String']['output']>;
  /** SNS接続の状態です。 */
  readonly linked: Linked;
  /** YouTubeのチャンネル名です。 */
  readonly name: Scalars['String']['output'];
  /** YouTubeの動画数です。 */
  readonly postCount: Scalars['Int']['output'];
  /** YouTubeのIDです。 */
  readonly uid: Scalars['String']['output'];
  readonly url: Scalars['String']['output'];
};

export type AddCampaignReservableScheduleInput = {
  readonly campaignId: Scalars['ID']['input'];
  /** 調整可能な日時です。 */
  readonly possibleDatetime: ReadonlyArray<Scalars['DateTime']['input']>;
};

export type AnswerRelationalSurveyInput = {
  /** 回答した環境です。 */
  readonly answerEnvironment: AnswerEnvironment;
  /** 満足度の回答理由です。 */
  readonly reason?: InputMaybe<Scalars['String']['input']>;
  /** 満足度調査のIDです。 */
  readonly relationalSurveyId: Scalars['ID']['input'];
  /** 満足度です。(0〜10) */
  readonly score: Scalars['Int']['input'];
  /** バージョンです。 */
  readonly version?: InputMaybe<RelationalSurveyVersion>;
};

export type AnswerRelationalSurveyReasonInput = {
  readonly id: Scalars['ID']['input'];
  /** 満足度の回答理由です。 */
  readonly reason: Scalars['String']['input'];
};

export type AnswerTransactionalSurveyInput = {
  /** 回答した環境です。 */
  readonly answerEnvironment: AnswerEnvironment;
  /** 満足度です。(0〜10) */
  readonly score: Scalars['Int']['input'];
  /** 満足度調査のIDです。 */
  readonly transactionalSurveyId: Scalars['ID']['input'];
};

export type AnswerTransactionalSurveyReasonInput = {
  readonly id: Scalars['ID']['input'];
  /** 理由です。 */
  readonly reason: Scalars['String']['input'];
};

export type AvailableTicketsInputObject = {
  readonly category: TicketModelCategory;
};

export type RemoveCampaignReservableScheduleInput = {
  readonly id: Scalars['ID']['input'];
};

export type AnswerLiteracySurveyMutationVariables = Exact<{
  input: AnswerLiteracySurveyInput;
}>;


export type AnswerLiteracySurveyMutation = { readonly __typename?: 'Mutation', readonly answerLiteracySurvey: { readonly __typename?: 'LiteracySurveyAnswer', readonly answer: LiteracySurveyOption } };

export type AnswerRelationalSurveyMutationVariables = Exact<{
  input: AnswerRelationalSurveyInput;
}>;


export type AnswerRelationalSurveyMutation = { readonly __typename?: 'Mutation', readonly answerRelationalSurvey: { readonly __typename?: 'RelationalSurveyAnswer', readonly id: string, readonly reason?: string | null, readonly score: number, readonly answerEnvironment: AnswerEnvironment } };

export type AnswerRelationalSurveyReasonMutationVariables = Exact<{
  input: AnswerRelationalSurveyReasonInput;
}>;


export type AnswerRelationalSurveyReasonMutation = { readonly __typename?: 'Mutation', readonly answerRelationalSurveyReason: { readonly __typename?: 'RelationalSurveyAnswer', readonly id: string, readonly reason?: string | null, readonly score: number, readonly answerEnvironment: AnswerEnvironment } };

export type AnswerTransactionalSurveyMutationVariables = Exact<{
  input: AnswerTransactionalSurveyInput;
}>;


export type AnswerTransactionalSurveyMutation = { readonly __typename?: 'Mutation', readonly answerTransactionalSurvey: { readonly __typename?: 'TransactionalSurveyAnswer', readonly id: string } };

export type AnswerTransactionalSurveyReasonMutationVariables = Exact<{
  input: AnswerTransactionalSurveyReasonInput;
}>;


export type AnswerTransactionalSurveyReasonMutation = { readonly __typename?: 'Mutation', readonly answerTransactionalSurveyReason: { readonly __typename?: 'TransactionalSurveyAnswer', readonly id: string } };

export type AnsweredLiteracySurveyQueryVariables = Exact<{ [key: string]: never; }>;


export type AnsweredLiteracySurveyQuery = { readonly __typename?: 'Query', readonly viewerAsAdvertiser: { readonly __typename?: 'Advertiser', readonly answeredLiteracySurvey: boolean } };

export type AvailableRelationalSurveyQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableRelationalSurveyQuery = { readonly __typename?: 'Query', readonly availableRelationalSurvey?: { readonly __typename?: 'RelationalSurvey', readonly id: string } | null };

export type AvailableTransactionalSurveyQueryVariables = Exact<{
  input: AvailableTransactionalSurveyInput;
}>;


export type AvailableTransactionalSurveyQuery = { readonly __typename?: 'Query', readonly availableTransactionalSurvey?: { readonly __typename?: 'TransactionalSurvey', readonly id: string } | null };

export type LiteracySurveysQueryVariables = Exact<{ [key: string]: never; }>;


export type LiteracySurveysQuery = { readonly __typename?: 'Query', readonly literacySurveys: ReadonlyArray<{ readonly __typename?: 'LiteracySurvey', readonly literacySurveyOption: LiteracySurveyOption, readonly label: string }> };

export type LiteracySurveyAnswerQueryVariables = Exact<{ [key: string]: never; }>;


export type LiteracySurveyAnswerQuery = { readonly __typename?: 'Query', readonly viewerAsAdvertiser: { readonly __typename?: 'Advertiser', readonly literacySurveyAnswer?: { readonly __typename?: 'LiteracySurveyAnswer', readonly answer: LiteracySurveyOption, readonly id: string } | null } };

export type AvailableTicketsQueryVariables = Exact<{
  input?: InputMaybe<AvailableTicketsInputObject>;
}>;


export type AvailableTicketsQuery = { readonly __typename?: 'Query', readonly viewer: { readonly __typename?: 'Advertiser', readonly companyId?: string | null, readonly company?: { readonly __typename?: 'Company', readonly id: string, readonly availableTickets: ReadonlyArray<{ readonly __typename?: 'IssuedTicket', readonly cancelAt?: string | null, readonly consumedAt?: string | null, readonly createdAt: string, readonly expiredAt: string, readonly id: string, readonly name: string, readonly category: TicketModelCategory, readonly campaign?: { readonly __typename?: 'Campaign', readonly id: string, readonly companyId: string, readonly name: string, readonly companySelectSearchGenre?: SearchGenre | null, readonly offerStarted?: string | null, readonly offerEnded?: string | null, readonly selectionMaxLimit?: number | null, readonly offersCount: number, readonly expenseEvidenceType: ExpenseEvidenceType, readonly thumbnailUrls: ReadonlyArray<string>, readonly question?: string | null, readonly gross?: number | null, readonly projectType?: ProjectType | null, readonly offeringCapacity?: number | null, readonly status: CampaignStatus, readonly scheduleType: CampaignScheduleType, readonly useIdentificationTicket: boolean, readonly category: CampaignCategory, readonly approvedAt?: string | null, readonly ageLimit?: AgeLimit | null, readonly sponsorServicePriceIntax?: number | null, readonly sponsorServicePrice?: number | null, readonly url?: string | null, readonly offerAutoMessage?: string | null, readonly attention?: string | null, readonly gender: CampaignGender, readonly sponsorService?: string | null, readonly summary?: string | null, readonly wantInfluencer?: string | null, readonly nearestStation?: string | null, readonly canTakeBack: boolean, readonly companion: Companion, readonly createdAt: string, readonly basicGross?: number | null, readonly campaignRequirementOptionSpecifiedPrText?: string | null, readonly campaignRequirementOptions: ReadonlyArray<CampaignRequirementOptions>, readonly guidance?: string | null, readonly maxCompanionCount?: number | null, readonly prTargetAge?: ReadonlyArray<PrTargetAge> | null, readonly prTargetGender?: PrTargetGender | null, readonly shopTemplateId?: string | null, readonly subGenre: ReadonlyArray<string>, readonly formatVersion: FormatVersion, readonly desiredLanguages: ReadonlyArray<LanguageType>, readonly costHandlingMethod?: CampaignCostHandlingMethod | null, readonly influencerBurdenRate: number, readonly campaignSnsRequirements: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirement', readonly id: string, readonly requestUrl?: string | null, readonly snsPostTypeList: ReadonlyArray<CampaignSnsRequirementSnsPostType>, readonly snsType: CampaignSnsRequirementSnsType, readonly snsPostRedirectUrl?: string | null, readonly postFooter: string, readonly tagList: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirementTag', readonly id: string, readonly languageType: LanguageType, readonly tags: ReadonlyArray<string> }> }>, readonly coverImageUrls: ReadonlyArray<{ readonly __typename?: 'ImageUrl', readonly original: string, readonly medium: string, readonly small: string }>, readonly regularlyPublishedCampaigns?: { readonly __typename?: 'RegularlyPublishedCampaign', readonly executionDay?: number | null, readonly status: RegularlyPublishedCampaignStatus } | null, readonly campaignReviewResults: ReadonlyArray<{ readonly __typename?: 'CampaignReviewResult', readonly id: string, readonly reviewSection: ReviewSection, readonly campaignReviews: ReadonlyArray<{ readonly __typename?: 'CampaignReview', readonly id: string, readonly isChecked?: boolean | null, readonly reviewTarget: ReviewTarget, readonly sendBackReason: string }> }>, readonly location?: { readonly __typename?: 'CampaignLocation', readonly id: string, readonly postalCode?: string | null, readonly prefectureCode?: Pref | null, readonly cityCode?: string | null, readonly cityName?: string | null, readonly streetAddress?: string | null, readonly buildingName?: string | null, readonly stationCode?: string | null, readonly stationName?: string | null, readonly name?: string | null, readonly tel?: string | null, readonly createdAt: string, readonly updatedAt: string } | null, readonly entriesCountByStatus: { readonly __typename?: 'CampaignEntriesCount', readonly APPLIED: number, readonly APPROVED: number, readonly DECLINED: number, readonly BLOCKED: number, readonly ETC: number }, readonly reservableWeeklySchedule: ReadonlyArray<{ readonly __typename?: 'CampaignReservableWeeklySchedule', readonly id: string, readonly possibleMinutes: number, readonly weekDay: WeekDay }> } | null }> } | null } };

export type IssuedTicketsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type IssuedTicketsQuery = { readonly __typename?: 'Query', readonly viewer: { readonly __typename?: 'Advertiser', readonly company?: { readonly __typename?: 'Company', readonly id: string, readonly issuedTickets: { readonly __typename?: 'IssuedTicketConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'IssuedTicketEdge', readonly cursor: string, readonly node: { readonly __typename?: 'IssuedTicket', readonly cancelAt?: string | null, readonly consumedAt?: string | null, readonly createdAt: string, readonly expiredAt: string, readonly id: string, readonly name: string, readonly category: TicketModelCategory, readonly campaign?: { readonly __typename?: 'Campaign', readonly id: string, readonly companyId: string, readonly name: string, readonly companySelectSearchGenre?: SearchGenre | null, readonly offerStarted?: string | null, readonly offerEnded?: string | null, readonly selectionMaxLimit?: number | null, readonly offersCount: number, readonly expenseEvidenceType: ExpenseEvidenceType, readonly thumbnailUrls: ReadonlyArray<string>, readonly question?: string | null, readonly gross?: number | null, readonly projectType?: ProjectType | null, readonly offeringCapacity?: number | null, readonly status: CampaignStatus, readonly scheduleType: CampaignScheduleType, readonly useIdentificationTicket: boolean, readonly category: CampaignCategory, readonly approvedAt?: string | null, readonly ageLimit?: AgeLimit | null, readonly sponsorServicePriceIntax?: number | null, readonly sponsorServicePrice?: number | null, readonly url?: string | null, readonly offerAutoMessage?: string | null, readonly attention?: string | null, readonly gender: CampaignGender, readonly sponsorService?: string | null, readonly summary?: string | null, readonly wantInfluencer?: string | null, readonly nearestStation?: string | null, readonly canTakeBack: boolean, readonly companion: Companion, readonly createdAt: string, readonly basicGross?: number | null, readonly campaignRequirementOptionSpecifiedPrText?: string | null, readonly campaignRequirementOptions: ReadonlyArray<CampaignRequirementOptions>, readonly guidance?: string | null, readonly maxCompanionCount?: number | null, readonly prTargetAge?: ReadonlyArray<PrTargetAge> | null, readonly prTargetGender?: PrTargetGender | null, readonly shopTemplateId?: string | null, readonly subGenre: ReadonlyArray<string>, readonly formatVersion: FormatVersion, readonly desiredLanguages: ReadonlyArray<LanguageType>, readonly costHandlingMethod?: CampaignCostHandlingMethod | null, readonly influencerBurdenRate: number, readonly campaignSnsRequirements: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirement', readonly id: string, readonly requestUrl?: string | null, readonly snsPostTypeList: ReadonlyArray<CampaignSnsRequirementSnsPostType>, readonly snsType: CampaignSnsRequirementSnsType, readonly snsPostRedirectUrl?: string | null, readonly postFooter: string, readonly tagList: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirementTag', readonly id: string, readonly languageType: LanguageType, readonly tags: ReadonlyArray<string> }> }>, readonly coverImageUrls: ReadonlyArray<{ readonly __typename?: 'ImageUrl', readonly original: string, readonly medium: string, readonly small: string }>, readonly regularlyPublishedCampaigns?: { readonly __typename?: 'RegularlyPublishedCampaign', readonly executionDay?: number | null, readonly status: RegularlyPublishedCampaignStatus } | null, readonly campaignReviewResults: ReadonlyArray<{ readonly __typename?: 'CampaignReviewResult', readonly id: string, readonly reviewSection: ReviewSection, readonly campaignReviews: ReadonlyArray<{ readonly __typename?: 'CampaignReview', readonly id: string, readonly isChecked?: boolean | null, readonly reviewTarget: ReviewTarget, readonly sendBackReason: string }> }>, readonly location?: { readonly __typename?: 'CampaignLocation', readonly id: string, readonly postalCode?: string | null, readonly prefectureCode?: Pref | null, readonly cityCode?: string | null, readonly cityName?: string | null, readonly streetAddress?: string | null, readonly buildingName?: string | null, readonly stationCode?: string | null, readonly stationName?: string | null, readonly name?: string | null, readonly tel?: string | null, readonly createdAt: string, readonly updatedAt: string } | null, readonly entriesCountByStatus: { readonly __typename?: 'CampaignEntriesCount', readonly APPLIED: number, readonly APPROVED: number, readonly DECLINED: number, readonly BLOCKED: number, readonly ETC: number }, readonly reservableWeeklySchedule: ReadonlyArray<{ readonly __typename?: 'CampaignReservableWeeklySchedule', readonly id: string, readonly possibleMinutes: number, readonly weekDay: WeekDay }> } | null } }>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly hasPreviousPage: boolean, readonly startCursor?: string | null, readonly endCursor?: string | null } } } | null } };

export type ActiveSnsConnectionsFragment = { readonly __typename?: 'ActiveSnsConnections', readonly twitter?: { readonly __typename?: 'TwitterConnection', readonly name: string, readonly uid: string, readonly followerCount: number, readonly imageUrl?: string | null, readonly postCount: number, readonly linked: Linked, readonly url: string } | null, readonly youtube?: { readonly __typename?: 'YouTubeConnection', readonly name: string, readonly uid: string, readonly imageUrl?: string | null, readonly followerCount: number, readonly linked: Linked, readonly postCount: number, readonly url: string } | null, readonly instagram?: { readonly __typename?: 'InstagramConnection', readonly name: string, readonly uid: string, readonly followerCount: number, readonly imageUrl?: string | null, readonly postCount: number, readonly linked: Linked, readonly url: string } | null, readonly tiktok?: { readonly __typename?: 'TikTokConnection', readonly name: string, readonly uid: string, readonly imageUrl?: string | null, readonly followerCount: number, readonly postCount: number, readonly linked: Linked, readonly url: string } | null };

export type AdGuidelineFragment = { readonly __typename?: 'AdGuideline', readonly agreedVersion?: string | null, readonly latestVersion: string, readonly needAgree: boolean, readonly url: string };

export type CampaignCostInfoFragment = { readonly __typename?: 'Campaign', readonly costHandlingMethod?: CampaignCostHandlingMethod | null, readonly influencerBurdenRate: number, readonly expenseEvidenceType: ExpenseEvidenceType };

export type CampaignEntriesInfoFragment = { readonly __typename?: 'Campaign', readonly id: string, readonly question?: string | null, readonly offeringCapacity?: number | null, readonly category: CampaignCategory, readonly scheduleType: CampaignScheduleType, readonly gross?: number | null, readonly sponsorServicePriceIntax?: number | null, readonly costHandlingMethod?: CampaignCostHandlingMethod | null, readonly influencerBurdenRate: number, readonly expenseEvidenceType: ExpenseEvidenceType, readonly entriesCountByStatus: { readonly __typename?: 'CampaignEntriesCount', readonly APPLIED: number, readonly APPROVED: number, readonly DECLINED: number, readonly BLOCKED: number, readonly ETC: number } };

export type CampaignEntryDetailFragment = { readonly __typename?: 'CampaignEntry', readonly id: string, readonly campaignId: string, readonly snsType: Provider, readonly pinned: Pinned, readonly status: CampaignEntryStatus, readonly createdAt: string, readonly updatedAt: string, readonly expiredAt: string, readonly answer?: string | null, readonly companionCount?: number | null, readonly prPostLanguage?: LanguageType | null, readonly campaign?: { readonly __typename?: 'Campaign', readonly id: string, readonly question?: string | null, readonly category: CampaignCategory } | null, readonly insight?: { readonly __typename?: 'InstagramInsight', readonly reach28: { readonly __typename?: 'Reach28Unit', readonly value?: number | null }, readonly impressions: { readonly __typename?: 'ImpressionsUnit', readonly value?: number | null }, readonly profileViews: { readonly __typename?: 'ProfileViewsUnit', readonly value?: number | null }, readonly reach: { readonly __typename?: 'ReachUnit', readonly value?: number | null }, readonly genderRate: { readonly __typename?: 'GenderRateUnit', readonly value?: { readonly __typename?: 'GenderRate', readonly M: number, readonly F: number, readonly U: number } | null }, readonly ageRate: { readonly __typename?: 'AgeRateUnit', readonly value?: { readonly __typename?: 'AgeRate', readonly from13To17: number, readonly from18To24: number, readonly from25To34: number, readonly from35To44: number, readonly from45To54: number, readonly from55To64: number, readonly over65: number } | null }, readonly maleAgeRate: { readonly __typename?: 'MaleAgeRateUnit', readonly value?: { readonly __typename?: 'AgeRate', readonly from13To17: number, readonly from18To24: number, readonly from25To34: number, readonly from35To44: number, readonly from45To54: number, readonly from55To64: number, readonly over65: number } | null }, readonly femaleAgeRate: { readonly __typename?: 'FemaleAgeRateUnit', readonly value?: { readonly __typename?: 'AgeRate', readonly from13To17: number, readonly from18To24: number, readonly from25To34: number, readonly from35To44: number, readonly from45To54: number, readonly from55To64: number, readonly over65: number } | null }, readonly postCommentCount: { readonly __typename?: 'PostCommentCountUnit', readonly value?: number | null }, readonly postLikeCount: { readonly __typename?: 'PostLikeCountUnit', readonly value?: number | null }, readonly postImpressions: { readonly __typename?: 'PostImpressionsUnit', readonly value?: number | null }, readonly postReach: { readonly __typename?: 'PostReachUnit', readonly value?: number | null }, readonly postEngagement: { readonly __typename?: 'PostEngagementUnit', readonly value?: number | null } } | null, readonly candidateSchedules: ReadonlyArray<{ readonly __typename?: 'CampaignEntryCandidateSchedule', readonly id: string, readonly candidateSchedule: string }>, readonly engagementPrediction?: { readonly __typename?: 'CampaignEntryEngagementPrediction', readonly engagementPredLower?: number | null, readonly engagementPredUpper?: number | null } | null, readonly reachPrediction?: { readonly __typename?: 'CampaignEntryReachPrediction', readonly reachPred?: number | null, readonly reachClass?: number | null, readonly reachPredLower?: number | null, readonly reachPredUpper?: number | null } | null, readonly impressionPrediction?: { readonly __typename?: 'CampaignEntryImpressionPrediction', readonly impressionPred?: number | null, readonly impressionClass?: number | null, readonly impressionPredLower?: number | null, readonly impressionPredUpper?: number | null } | null, readonly influencer: { readonly __typename?: 'Influencer', readonly comment?: string | null, readonly id: string, readonly idpId?: string | null, readonly name?: string | null, readonly gender: Gender, readonly birthday?: string | null, readonly imageUrl?: string | null, readonly age?: number | null, readonly latestAccessTime?: string | null, readonly completeCountLevel: CompleteCountLevel, readonly approvedCount: number, readonly activeSnsConnections: { readonly __typename?: 'ActiveSnsConnections', readonly twitter?: { readonly __typename?: 'TwitterConnection', readonly name: string, readonly uid: string, readonly followerCount: number, readonly imageUrl?: string | null, readonly postCount: number, readonly linked: Linked, readonly url: string } | null, readonly youtube?: { readonly __typename?: 'YouTubeConnection', readonly name: string, readonly uid: string, readonly imageUrl?: string | null, readonly followerCount: number, readonly linked: Linked, readonly postCount: number, readonly url: string } | null, readonly instagram?: { readonly __typename?: 'InstagramConnection', readonly name: string, readonly uid: string, readonly followerCount: number, readonly imageUrl?: string | null, readonly postCount: number, readonly linked: Linked, readonly url: string } | null, readonly tiktok?: { readonly __typename?: 'TikTokConnection', readonly name: string, readonly uid: string, readonly imageUrl?: string | null, readonly followerCount: number, readonly postCount: number, readonly linked: Linked, readonly url: string } | null } } };

export type CampaignFeeDetailFragment = { readonly __typename?: 'CampaignFeeDetail', readonly postedReword: number, readonly recruitmentFee: number };

export type CampaignLocationFragment = { readonly __typename?: 'CampaignLocation', readonly id: string, readonly postalCode?: string | null, readonly prefectureCode?: Pref | null, readonly cityCode?: string | null, readonly cityName?: string | null, readonly streetAddress?: string | null, readonly buildingName?: string | null, readonly stationCode?: string | null, readonly stationName?: string | null, readonly name?: string | null, readonly tel?: string | null, readonly createdAt: string, readonly updatedAt: string };

export type CampaignReservableScheduleFragment = { readonly __typename?: 'CampaignReservableSchedule', readonly id: string, readonly possibleDatetime: string };

export type CampaignReservableWeeklyScheduleFragment = { readonly __typename?: 'CampaignReservableWeeklySchedule', readonly id: string, readonly possibleMinutes: number, readonly weekDay: WeekDay };

export type CampaignReviewResultFragment = { readonly __typename?: 'CampaignReviewResult', readonly id: string, readonly reviewSection: ReviewSection, readonly campaignReviews: ReadonlyArray<{ readonly __typename?: 'CampaignReview', readonly id: string, readonly isChecked?: boolean | null, readonly reviewTarget: ReviewTarget, readonly sendBackReason: string }> };

export type CampaignReviewFragment = { readonly __typename?: 'CampaignReview', readonly id: string, readonly isChecked?: boolean | null, readonly reviewTarget: ReviewTarget, readonly sendBackReason: string };

export type CampaignSnsRequirementTagFragmentFragment = { readonly __typename?: 'CampaignSnsRequirementTag', readonly id: string, readonly languageType: LanguageType, readonly tags: ReadonlyArray<string> };

export type CampaignSnsRequirementFragment = { readonly __typename?: 'CampaignSnsRequirement', readonly id: string, readonly requestUrl?: string | null, readonly snsPostTypeList: ReadonlyArray<CampaignSnsRequirementSnsPostType>, readonly snsType: CampaignSnsRequirementSnsType, readonly snsPostRedirectUrl?: string | null, readonly postFooter: string, readonly tagList: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirementTag', readonly id: string, readonly languageType: LanguageType, readonly tags: ReadonlyArray<string> }> };

export type CampaignSummaryFragment = { readonly __typename?: 'Campaign', readonly id: string, readonly companyId: string, readonly name: string, readonly companySelectSearchGenre?: SearchGenre | null, readonly offerStarted?: string | null, readonly offerEnded?: string | null, readonly selectionMaxLimit?: number | null, readonly offersCount: number, readonly expenseEvidenceType: ExpenseEvidenceType, readonly thumbnailUrls: ReadonlyArray<string>, readonly question?: string | null, readonly gross?: number | null, readonly projectType?: ProjectType | null, readonly offeringCapacity?: number | null, readonly status: CampaignStatus, readonly scheduleType: CampaignScheduleType, readonly useIdentificationTicket: boolean, readonly category: CampaignCategory, readonly approvedAt?: string | null, readonly ageLimit?: AgeLimit | null, readonly sponsorServicePriceIntax?: number | null, readonly sponsorServicePrice?: number | null, readonly url?: string | null, readonly offerAutoMessage?: string | null, readonly attention?: string | null, readonly gender: CampaignGender, readonly sponsorService?: string | null, readonly summary?: string | null, readonly wantInfluencer?: string | null, readonly nearestStation?: string | null, readonly canTakeBack: boolean, readonly companion: Companion, readonly createdAt: string, readonly basicGross?: number | null, readonly campaignRequirementOptionSpecifiedPrText?: string | null, readonly campaignRequirementOptions: ReadonlyArray<CampaignRequirementOptions>, readonly guidance?: string | null, readonly maxCompanionCount?: number | null, readonly prTargetAge?: ReadonlyArray<PrTargetAge> | null, readonly prTargetGender?: PrTargetGender | null, readonly shopTemplateId?: string | null, readonly subGenre: ReadonlyArray<string>, readonly formatVersion: FormatVersion, readonly desiredLanguages: ReadonlyArray<LanguageType>, readonly costHandlingMethod?: CampaignCostHandlingMethod | null, readonly influencerBurdenRate: number, readonly campaignSnsRequirements: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirement', readonly id: string, readonly requestUrl?: string | null, readonly snsPostTypeList: ReadonlyArray<CampaignSnsRequirementSnsPostType>, readonly snsType: CampaignSnsRequirementSnsType, readonly snsPostRedirectUrl?: string | null, readonly postFooter: string, readonly tagList: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirementTag', readonly id: string, readonly languageType: LanguageType, readonly tags: ReadonlyArray<string> }> }>, readonly coverImageUrls: ReadonlyArray<{ readonly __typename?: 'ImageUrl', readonly original: string, readonly medium: string, readonly small: string }>, readonly regularlyPublishedCampaigns?: { readonly __typename?: 'RegularlyPublishedCampaign', readonly executionDay?: number | null, readonly status: RegularlyPublishedCampaignStatus } | null, readonly campaignReviewResults: ReadonlyArray<{ readonly __typename?: 'CampaignReviewResult', readonly id: string, readonly reviewSection: ReviewSection, readonly campaignReviews: ReadonlyArray<{ readonly __typename?: 'CampaignReview', readonly id: string, readonly isChecked?: boolean | null, readonly reviewTarget: ReviewTarget, readonly sendBackReason: string }> }>, readonly location?: { readonly __typename?: 'CampaignLocation', readonly id: string, readonly postalCode?: string | null, readonly prefectureCode?: Pref | null, readonly cityCode?: string | null, readonly cityName?: string | null, readonly streetAddress?: string | null, readonly buildingName?: string | null, readonly stationCode?: string | null, readonly stationName?: string | null, readonly name?: string | null, readonly tel?: string | null, readonly createdAt: string, readonly updatedAt: string } | null, readonly entriesCountByStatus: { readonly __typename?: 'CampaignEntriesCount', readonly APPLIED: number, readonly APPROVED: number, readonly DECLINED: number, readonly BLOCKED: number, readonly ETC: number }, readonly reservableWeeklySchedule: ReadonlyArray<{ readonly __typename?: 'CampaignReservableWeeklySchedule', readonly id: string, readonly possibleMinutes: number, readonly weekDay: WeekDay }> };

export type CampaignV4Fragment = { readonly __typename?: 'Campaign', readonly basicGross?: number | null, readonly campaignRequirementOptionSpecifiedPrText?: string | null, readonly campaignRequirementOptions: ReadonlyArray<CampaignRequirementOptions>, readonly guidance?: string | null, readonly maxCompanionCount?: number | null, readonly prTargetAge?: ReadonlyArray<PrTargetAge> | null, readonly prTargetGender?: PrTargetGender | null, readonly shopTemplateId?: string | null, readonly subGenre: ReadonlyArray<string>, readonly formatVersion: FormatVersion, readonly desiredLanguages: ReadonlyArray<LanguageType>, readonly costHandlingMethod?: CampaignCostHandlingMethod | null, readonly influencerBurdenRate: number, readonly expenseEvidenceType: ExpenseEvidenceType, readonly reservableWeeklySchedule: ReadonlyArray<{ readonly __typename?: 'CampaignReservableWeeklySchedule', readonly id: string, readonly possibleMinutes: number, readonly weekDay: WeekDay }> };

export type CompanyNotificationEmailFragment = { readonly __typename?: 'CompanyNotificationEmail', readonly id: string, readonly notificationEmail: string, readonly activation: boolean, readonly verificationDeadline: string };

export type CompanyShopTemplateFragment = { readonly __typename?: 'CampaignLocation', readonly streetAddress?: string | null, readonly buildingName?: string | null, readonly cityName?: string | null, readonly cityCode?: string | null, readonly id: string, readonly name?: string | null, readonly stationCode?: string | null, readonly stationName?: string | null, readonly postalCode?: string | null, readonly prefectureCode?: Pref | null, readonly tel?: string | null };

export type CopyCampaignFragment = { readonly __typename?: 'Campaign', readonly id: string, readonly companyId: string, readonly name: string, readonly question?: string | null, readonly gross?: number | null, readonly projectType?: ProjectType | null, readonly companySelectGenre?: Genre | null, readonly companySelectSearchGenre?: SearchGenre | null, readonly status: CampaignStatus, readonly category: CampaignCategory, readonly gender: CampaignGender, readonly scheduleType: CampaignScheduleType, readonly sponsorService?: string | null, readonly sponsorServicePrice?: number | null, readonly sponsorServicePriceIntax?: number | null, readonly summary?: string | null, readonly url?: string | null, readonly reservation: Reservation, readonly wantInfluencer?: string | null, readonly ageLimit?: AgeLimit | null, readonly offerEnded?: string | null, readonly useIdentificationTicket: boolean, readonly basicGross?: number | null, readonly campaignRequirementOptionSpecifiedPrText?: string | null, readonly campaignRequirementOptions: ReadonlyArray<CampaignRequirementOptions>, readonly guidance?: string | null, readonly maxCompanionCount?: number | null, readonly prTargetAge?: ReadonlyArray<PrTargetAge> | null, readonly prTargetGender?: PrTargetGender | null, readonly shopTemplateId?: string | null, readonly subGenre: ReadonlyArray<string>, readonly formatVersion: FormatVersion, readonly desiredLanguages: ReadonlyArray<LanguageType>, readonly costHandlingMethod?: CampaignCostHandlingMethod | null, readonly influencerBurdenRate: number, readonly expenseEvidenceType: ExpenseEvidenceType, readonly campaignSnsRequirements: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirement', readonly id: string, readonly requestUrl?: string | null, readonly snsPostTypeList: ReadonlyArray<CampaignSnsRequirementSnsPostType>, readonly snsType: CampaignSnsRequirementSnsType, readonly snsPostRedirectUrl?: string | null, readonly postFooter: string, readonly tagList: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirementTag', readonly id: string, readonly languageType: LanguageType, readonly tags: ReadonlyArray<string> }> }>, readonly coverImageUrls: ReadonlyArray<{ readonly __typename?: 'ImageUrl', readonly original: string }>, readonly regularlyPublishedCampaigns?: { readonly __typename?: 'RegularlyPublishedCampaign', readonly status: RegularlyPublishedCampaignStatus } | null, readonly location?: { readonly __typename?: 'CampaignLocation', readonly id: string, readonly postalCode?: string | null, readonly prefectureCode?: Pref | null, readonly cityCode?: string | null, readonly cityName?: string | null, readonly streetAddress?: string | null, readonly buildingName?: string | null, readonly stationCode?: string | null, readonly stationName?: string | null, readonly name?: string | null, readonly tel?: string | null, readonly createdAt: string, readonly updatedAt: string } | null, readonly reservableWeeklySchedule: ReadonlyArray<{ readonly __typename?: 'CampaignReservableWeeklySchedule', readonly id: string, readonly possibleMinutes: number, readonly weekDay: WeekDay }> };

export type EngagementPredictionFragment = { readonly __typename?: 'CampaignEntryEngagementPrediction', readonly engagementPredLower?: number | null, readonly engagementPredUpper?: number | null };

export type EntriesCountByStatusFragment = { readonly __typename?: 'Campaign', readonly entriesCountByStatus: { readonly __typename?: 'CampaignEntriesCount', readonly APPLIED: number, readonly APPROVED: number, readonly DECLINED: number, readonly BLOCKED: number, readonly ETC: number } };

export type CoverImageUrlsFragment = { readonly __typename?: 'ImageUrl', readonly original: string, readonly medium: string, readonly small: string };

export type ImpressionPredictionFragment = { readonly __typename?: 'CampaignEntryImpressionPrediction', readonly impressionPred?: number | null, readonly impressionClass?: number | null, readonly impressionPredLower?: number | null, readonly impressionPredUpper?: number | null };

export type InfluencerInfoFragment = { readonly __typename?: 'Influencer', readonly id: string, readonly idpId?: string | null, readonly name?: string | null, readonly gender: Gender, readonly birthday?: string | null, readonly imageUrl?: string | null, readonly age?: number | null, readonly latestAccessTime?: string | null, readonly completeCountLevel: CompleteCountLevel, readonly approvedCount: number };

export type InfluencerMailingInfoFragment = { readonly __typename?: 'Influencer', readonly name?: string | null, readonly realName?: string | null, readonly realNameKana?: string | null, readonly postalCode?: string | null, readonly pref?: Pref | null, readonly city?: string | null, readonly address1?: string | null, readonly address2?: string | null, readonly tel?: string | null };

export type IssuedTicketFragment = { readonly __typename?: 'IssuedTicket', readonly cancelAt?: string | null, readonly consumedAt?: string | null, readonly createdAt: string, readonly expiredAt: string, readonly id: string, readonly name: string, readonly category: TicketModelCategory, readonly campaign?: { readonly __typename?: 'Campaign', readonly id: string, readonly companyId: string, readonly name: string, readonly companySelectSearchGenre?: SearchGenre | null, readonly offerStarted?: string | null, readonly offerEnded?: string | null, readonly selectionMaxLimit?: number | null, readonly offersCount: number, readonly expenseEvidenceType: ExpenseEvidenceType, readonly thumbnailUrls: ReadonlyArray<string>, readonly question?: string | null, readonly gross?: number | null, readonly projectType?: ProjectType | null, readonly offeringCapacity?: number | null, readonly status: CampaignStatus, readonly scheduleType: CampaignScheduleType, readonly useIdentificationTicket: boolean, readonly category: CampaignCategory, readonly approvedAt?: string | null, readonly ageLimit?: AgeLimit | null, readonly sponsorServicePriceIntax?: number | null, readonly sponsorServicePrice?: number | null, readonly url?: string | null, readonly offerAutoMessage?: string | null, readonly attention?: string | null, readonly gender: CampaignGender, readonly sponsorService?: string | null, readonly summary?: string | null, readonly wantInfluencer?: string | null, readonly nearestStation?: string | null, readonly canTakeBack: boolean, readonly companion: Companion, readonly createdAt: string, readonly basicGross?: number | null, readonly campaignRequirementOptionSpecifiedPrText?: string | null, readonly campaignRequirementOptions: ReadonlyArray<CampaignRequirementOptions>, readonly guidance?: string | null, readonly maxCompanionCount?: number | null, readonly prTargetAge?: ReadonlyArray<PrTargetAge> | null, readonly prTargetGender?: PrTargetGender | null, readonly shopTemplateId?: string | null, readonly subGenre: ReadonlyArray<string>, readonly formatVersion: FormatVersion, readonly desiredLanguages: ReadonlyArray<LanguageType>, readonly costHandlingMethod?: CampaignCostHandlingMethod | null, readonly influencerBurdenRate: number, readonly campaignSnsRequirements: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirement', readonly id: string, readonly requestUrl?: string | null, readonly snsPostTypeList: ReadonlyArray<CampaignSnsRequirementSnsPostType>, readonly snsType: CampaignSnsRequirementSnsType, readonly snsPostRedirectUrl?: string | null, readonly postFooter: string, readonly tagList: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirementTag', readonly id: string, readonly languageType: LanguageType, readonly tags: ReadonlyArray<string> }> }>, readonly coverImageUrls: ReadonlyArray<{ readonly __typename?: 'ImageUrl', readonly original: string, readonly medium: string, readonly small: string }>, readonly regularlyPublishedCampaigns?: { readonly __typename?: 'RegularlyPublishedCampaign', readonly executionDay?: number | null, readonly status: RegularlyPublishedCampaignStatus } | null, readonly campaignReviewResults: ReadonlyArray<{ readonly __typename?: 'CampaignReviewResult', readonly id: string, readonly reviewSection: ReviewSection, readonly campaignReviews: ReadonlyArray<{ readonly __typename?: 'CampaignReview', readonly id: string, readonly isChecked?: boolean | null, readonly reviewTarget: ReviewTarget, readonly sendBackReason: string }> }>, readonly location?: { readonly __typename?: 'CampaignLocation', readonly id: string, readonly postalCode?: string | null, readonly prefectureCode?: Pref | null, readonly cityCode?: string | null, readonly cityName?: string | null, readonly streetAddress?: string | null, readonly buildingName?: string | null, readonly stationCode?: string | null, readonly stationName?: string | null, readonly name?: string | null, readonly tel?: string | null, readonly createdAt: string, readonly updatedAt: string } | null, readonly entriesCountByStatus: { readonly __typename?: 'CampaignEntriesCount', readonly APPLIED: number, readonly APPROVED: number, readonly DECLINED: number, readonly BLOCKED: number, readonly ETC: number }, readonly reservableWeeklySchedule: ReadonlyArray<{ readonly __typename?: 'CampaignReservableWeeklySchedule', readonly id: string, readonly possibleMinutes: number, readonly weekDay: WeekDay }> } | null };

export type OfferStateCountFragment = { readonly __typename?: 'OfferStateCount', readonly completed: number, readonly entry: number, readonly working: number };

export type PageInfoFragment = { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly hasPreviousPage: boolean, readonly startCursor?: string | null, readonly endCursor?: string | null };

export type UserInfluencerPenaltyReportFragment = { readonly __typename?: 'UserInfluencerPenaltyReport', readonly id: string, readonly advAccountId?: string | null, readonly body: string, readonly createdAt: string, readonly kind: number, readonly offerId?: string | null, readonly penaltyReasonId?: string | null, readonly score?: number | null, readonly status: number, readonly updatedAt: string, readonly userInfluencerId: string };

export type ReachPredictionFragment = { readonly __typename?: 'CampaignEntryReachPrediction', readonly reachPred?: number | null, readonly reachClass?: number | null, readonly reachPredLower?: number | null, readonly reachPredUpper?: number | null };

export type SnsConnectionInfoFragment = { readonly __typename?: 'CompanySnsConnection', readonly id: string, readonly name: string, readonly uid: string, readonly nextTokenUpdateAt: string, readonly provider: CompanySnsConnectionProvider, readonly imageUrl?: string | null, readonly needTokenUpdate: boolean };

export type SnsInsightFragment = { readonly __typename?: 'InstagramInsight', readonly reach28: { readonly __typename?: 'Reach28Unit', readonly value?: number | null }, readonly impressions: { readonly __typename?: 'ImpressionsUnit', readonly value?: number | null }, readonly profileViews: { readonly __typename?: 'ProfileViewsUnit', readonly value?: number | null }, readonly reach: { readonly __typename?: 'ReachUnit', readonly value?: number | null }, readonly genderRate: { readonly __typename?: 'GenderRateUnit', readonly value?: { readonly __typename?: 'GenderRate', readonly M: number, readonly F: number, readonly U: number } | null }, readonly ageRate: { readonly __typename?: 'AgeRateUnit', readonly value?: { readonly __typename?: 'AgeRate', readonly from13To17: number, readonly from18To24: number, readonly from25To34: number, readonly from35To44: number, readonly from45To54: number, readonly from55To64: number, readonly over65: number } | null }, readonly maleAgeRate: { readonly __typename?: 'MaleAgeRateUnit', readonly value?: { readonly __typename?: 'AgeRate', readonly from13To17: number, readonly from18To24: number, readonly from25To34: number, readonly from35To44: number, readonly from45To54: number, readonly from55To64: number, readonly over65: number } | null }, readonly femaleAgeRate: { readonly __typename?: 'FemaleAgeRateUnit', readonly value?: { readonly __typename?: 'AgeRate', readonly from13To17: number, readonly from18To24: number, readonly from25To34: number, readonly from35To44: number, readonly from45To54: number, readonly from55To64: number, readonly over65: number } | null }, readonly postCommentCount: { readonly __typename?: 'PostCommentCountUnit', readonly value?: number | null }, readonly postLikeCount: { readonly __typename?: 'PostLikeCountUnit', readonly value?: number | null }, readonly postImpressions: { readonly __typename?: 'PostImpressionsUnit', readonly value?: number | null }, readonly postReach: { readonly __typename?: 'PostReachUnit', readonly value?: number | null }, readonly postEngagement: { readonly __typename?: 'PostEngagementUnit', readonly value?: number | null } };

export type SubscriptionModelFragment = { readonly __typename?: 'SubscriptionModel', readonly id: string, readonly name: string, readonly description?: string | null, readonly initialPrice: number, readonly price: number, readonly initialIssueTicketCount: number, readonly issueTicketCount: number, readonly ticketModelId?: string | null };

export type TicketSubscriptionFragment = { readonly __typename?: 'TicketSubscription', readonly cancellationRequestedAt?: string | null, readonly description?: string | null, readonly endedAt?: string | null, readonly id: string, readonly name: string, readonly startedAt: string, readonly nextBillingPrice?: number | null, readonly minCancellableDatetime: string, readonly minimumUpdateCount: number, readonly cancellationTiming: CancellationTiming, readonly subscriptionModelId: number, readonly latestSubscriptionRenewal: { readonly __typename?: 'SubscriptionRenewal', readonly id: string, readonly renewalDate: string, readonly subscriptionInvoiceDetail?: { readonly __typename?: 'SubscriptionInvoiceDetail', readonly status: SubscriptionInvoiceDetailStatus } | null }, readonly subscriptionRenewals: { readonly __typename?: 'SubscriptionRenewalConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'SubscriptionRenewalEdge', readonly cursor: string, readonly node: { readonly __typename?: 'SubscriptionRenewal', readonly id: string, readonly renewalDate: string } }>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly hasPreviousPage: boolean, readonly startCursor?: string | null, readonly endCursor?: string | null } } };

export type WaitingCampaignsSummaryFragment = { readonly __typename?: 'Campaign', readonly id: string, readonly name: string, readonly status: CampaignStatus, readonly gross?: number | null, readonly offerStarted?: string | null, readonly offerEnded?: string | null, readonly coverImageUrls: ReadonlyArray<{ readonly __typename?: 'ImageUrl', readonly original: string, readonly medium: string, readonly small: string }>, readonly campaignSnsRequirements: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirement', readonly id: string, readonly requestUrl?: string | null, readonly snsPostTypeList: ReadonlyArray<CampaignSnsRequirementSnsPostType>, readonly snsType: CampaignSnsRequirementSnsType, readonly snsPostRedirectUrl?: string | null, readonly postFooter: string, readonly tagList: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirementTag', readonly id: string, readonly languageType: LanguageType, readonly tags: ReadonlyArray<string> }> }> };

export type BeginnerCategoryFragment = { readonly __typename?: 'BeginnerCategory', readonly id: string, readonly title: string, readonly description?: string | null };

export type BeginnerPostFragment = { readonly __typename?: 'BeginnerPost', readonly id: string, readonly snsType: BeginnerPostSnsType, readonly title: string, readonly description?: string | null, readonly content: string, readonly done: boolean };

export type UpdateBeginnerPostStatusMutationVariables = Exact<{
  input: UpdateBeginnerPostStatusInput;
}>;


export type UpdateBeginnerPostStatusMutation = { readonly __typename?: 'Mutation', readonly updateBeginnerPostStatus: { readonly __typename?: 'BeginnerPost', readonly id: string, readonly snsType: BeginnerPostSnsType, readonly title: string, readonly description?: string | null, readonly content: string, readonly done: boolean } };

export type BeginnerCategoriesQueryVariables = Exact<{
  companySnsConnectionId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type BeginnerCategoriesQuery = { readonly __typename?: 'Query', readonly beginnerCategories: ReadonlyArray<{ readonly __typename?: 'BeginnerCategory', readonly id: string, readonly title: string, readonly description?: string | null, readonly posts?: ReadonlyArray<{ readonly __typename?: 'BeginnerPost', readonly id: string, readonly snsType: BeginnerPostSnsType, readonly title: string, readonly description?: string | null, readonly content: string, readonly done: boolean }> | null }> };

export type AddCampaignReservableScheduleMutationVariables = Exact<{
  input: AddCampaignReservableScheduleInput;
}>;


export type AddCampaignReservableScheduleMutation = { readonly __typename?: 'Mutation', readonly addCampaignReservableSchedule?: ReadonlyArray<{ readonly __typename?: 'CampaignReservableSchedule', readonly id: string, readonly possibleDatetime: string } | null> | null };

export type CreateCampaignMutationVariables = Exact<{
  input: CreateCampaignInput;
}>;


export type CreateCampaignMutation = { readonly __typename?: 'Mutation', readonly createCampaign: { readonly __typename?: 'Campaign', readonly id: string } };

export type CreateDownloadReportMutationVariables = Exact<{
  input: CreateDownloadReportInput;
}>;


export type CreateDownloadReportMutation = { readonly __typename?: 'Mutation', readonly createDownloadReport: { readonly __typename?: 'DownloadReport', readonly createdAt: string, readonly downloadUrl?: string | null, readonly fileType: DownloadReportFileType, readonly id: string, readonly status: DownloadReportStatus, readonly title: string } };

export type EndCampaignOfferMutationVariables = Exact<{
  input: EndCampaignOfferInput;
}>;


export type EndCampaignOfferMutation = { readonly __typename?: 'Mutation', readonly endCampaignOffer: { readonly __typename?: 'Campaign', readonly id: string, readonly companyId: string, readonly name: string, readonly companySelectSearchGenre?: SearchGenre | null, readonly offerStarted?: string | null, readonly offerEnded?: string | null, readonly selectionMaxLimit?: number | null, readonly offersCount: number, readonly expenseEvidenceType: ExpenseEvidenceType, readonly thumbnailUrls: ReadonlyArray<string>, readonly question?: string | null, readonly gross?: number | null, readonly projectType?: ProjectType | null, readonly offeringCapacity?: number | null, readonly status: CampaignStatus, readonly scheduleType: CampaignScheduleType, readonly useIdentificationTicket: boolean, readonly category: CampaignCategory, readonly approvedAt?: string | null, readonly ageLimit?: AgeLimit | null, readonly sponsorServicePriceIntax?: number | null, readonly sponsorServicePrice?: number | null, readonly url?: string | null, readonly offerAutoMessage?: string | null, readonly attention?: string | null, readonly gender: CampaignGender, readonly sponsorService?: string | null, readonly summary?: string | null, readonly wantInfluencer?: string | null, readonly nearestStation?: string | null, readonly canTakeBack: boolean, readonly companion: Companion, readonly createdAt: string, readonly basicGross?: number | null, readonly campaignRequirementOptionSpecifiedPrText?: string | null, readonly campaignRequirementOptions: ReadonlyArray<CampaignRequirementOptions>, readonly guidance?: string | null, readonly maxCompanionCount?: number | null, readonly prTargetAge?: ReadonlyArray<PrTargetAge> | null, readonly prTargetGender?: PrTargetGender | null, readonly shopTemplateId?: string | null, readonly subGenre: ReadonlyArray<string>, readonly formatVersion: FormatVersion, readonly desiredLanguages: ReadonlyArray<LanguageType>, readonly costHandlingMethod?: CampaignCostHandlingMethod | null, readonly influencerBurdenRate: number, readonly campaignSnsRequirements: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirement', readonly id: string, readonly requestUrl?: string | null, readonly snsPostTypeList: ReadonlyArray<CampaignSnsRequirementSnsPostType>, readonly snsType: CampaignSnsRequirementSnsType, readonly snsPostRedirectUrl?: string | null, readonly postFooter: string, readonly tagList: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirementTag', readonly id: string, readonly languageType: LanguageType, readonly tags: ReadonlyArray<string> }> }>, readonly coverImageUrls: ReadonlyArray<{ readonly __typename?: 'ImageUrl', readonly original: string, readonly medium: string, readonly small: string }>, readonly regularlyPublishedCampaigns?: { readonly __typename?: 'RegularlyPublishedCampaign', readonly executionDay?: number | null, readonly status: RegularlyPublishedCampaignStatus } | null, readonly campaignReviewResults: ReadonlyArray<{ readonly __typename?: 'CampaignReviewResult', readonly id: string, readonly reviewSection: ReviewSection, readonly campaignReviews: ReadonlyArray<{ readonly __typename?: 'CampaignReview', readonly id: string, readonly isChecked?: boolean | null, readonly reviewTarget: ReviewTarget, readonly sendBackReason: string }> }>, readonly location?: { readonly __typename?: 'CampaignLocation', readonly id: string, readonly postalCode?: string | null, readonly prefectureCode?: Pref | null, readonly cityCode?: string | null, readonly cityName?: string | null, readonly streetAddress?: string | null, readonly buildingName?: string | null, readonly stationCode?: string | null, readonly stationName?: string | null, readonly name?: string | null, readonly tel?: string | null, readonly createdAt: string, readonly updatedAt: string } | null, readonly entriesCountByStatus: { readonly __typename?: 'CampaignEntriesCount', readonly APPLIED: number, readonly APPROVED: number, readonly DECLINED: number, readonly BLOCKED: number, readonly ETC: number }, readonly reservableWeeklySchedule: ReadonlyArray<{ readonly __typename?: 'CampaignReservableWeeklySchedule', readonly id: string, readonly possibleMinutes: number, readonly weekDay: WeekDay }> } };

export type RemoveCampaignReservableScheduleMutationVariables = Exact<{
  input: ReadonlyArray<RemoveCampaignReservableScheduleInput> | RemoveCampaignReservableScheduleInput;
}>;


export type RemoveCampaignReservableScheduleMutation = { readonly __typename?: 'Mutation', readonly removeCampaignReservableSchedule?: ReadonlyArray<{ readonly __typename?: 'CampaignReservableSchedule', readonly id: string, readonly possibleDatetime: string } | null> | null };

export type RequestApprovalCampaignMutationVariables = Exact<{
  input: RequestApprovalCampaignInput;
}>;


export type RequestApprovalCampaignMutation = { readonly __typename?: 'Mutation', readonly requestApprovalCampaign: { readonly __typename?: 'Campaign', readonly id: string, readonly companyId: string, readonly name: string, readonly companySelectSearchGenre?: SearchGenre | null, readonly offerStarted?: string | null, readonly offerEnded?: string | null, readonly selectionMaxLimit?: number | null, readonly offersCount: number, readonly expenseEvidenceType: ExpenseEvidenceType, readonly thumbnailUrls: ReadonlyArray<string>, readonly question?: string | null, readonly gross?: number | null, readonly projectType?: ProjectType | null, readonly offeringCapacity?: number | null, readonly status: CampaignStatus, readonly scheduleType: CampaignScheduleType, readonly useIdentificationTicket: boolean, readonly category: CampaignCategory, readonly approvedAt?: string | null, readonly ageLimit?: AgeLimit | null, readonly sponsorServicePriceIntax?: number | null, readonly sponsorServicePrice?: number | null, readonly url?: string | null, readonly offerAutoMessage?: string | null, readonly attention?: string | null, readonly gender: CampaignGender, readonly sponsorService?: string | null, readonly summary?: string | null, readonly wantInfluencer?: string | null, readonly nearestStation?: string | null, readonly canTakeBack: boolean, readonly companion: Companion, readonly createdAt: string, readonly basicGross?: number | null, readonly campaignRequirementOptionSpecifiedPrText?: string | null, readonly campaignRequirementOptions: ReadonlyArray<CampaignRequirementOptions>, readonly guidance?: string | null, readonly maxCompanionCount?: number | null, readonly prTargetAge?: ReadonlyArray<PrTargetAge> | null, readonly prTargetGender?: PrTargetGender | null, readonly shopTemplateId?: string | null, readonly subGenre: ReadonlyArray<string>, readonly formatVersion: FormatVersion, readonly desiredLanguages: ReadonlyArray<LanguageType>, readonly costHandlingMethod?: CampaignCostHandlingMethod | null, readonly influencerBurdenRate: number, readonly campaignSnsRequirements: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirement', readonly id: string, readonly requestUrl?: string | null, readonly snsPostTypeList: ReadonlyArray<CampaignSnsRequirementSnsPostType>, readonly snsType: CampaignSnsRequirementSnsType, readonly snsPostRedirectUrl?: string | null, readonly postFooter: string, readonly tagList: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirementTag', readonly id: string, readonly languageType: LanguageType, readonly tags: ReadonlyArray<string> }> }>, readonly coverImageUrls: ReadonlyArray<{ readonly __typename?: 'ImageUrl', readonly original: string, readonly medium: string, readonly small: string }>, readonly regularlyPublishedCampaigns?: { readonly __typename?: 'RegularlyPublishedCampaign', readonly executionDay?: number | null, readonly status: RegularlyPublishedCampaignStatus } | null, readonly campaignReviewResults: ReadonlyArray<{ readonly __typename?: 'CampaignReviewResult', readonly id: string, readonly reviewSection: ReviewSection, readonly campaignReviews: ReadonlyArray<{ readonly __typename?: 'CampaignReview', readonly id: string, readonly isChecked?: boolean | null, readonly reviewTarget: ReviewTarget, readonly sendBackReason: string }> }>, readonly location?: { readonly __typename?: 'CampaignLocation', readonly id: string, readonly postalCode?: string | null, readonly prefectureCode?: Pref | null, readonly cityCode?: string | null, readonly cityName?: string | null, readonly streetAddress?: string | null, readonly buildingName?: string | null, readonly stationCode?: string | null, readonly stationName?: string | null, readonly name?: string | null, readonly tel?: string | null, readonly createdAt: string, readonly updatedAt: string } | null, readonly entriesCountByStatus: { readonly __typename?: 'CampaignEntriesCount', readonly APPLIED: number, readonly APPROVED: number, readonly DECLINED: number, readonly BLOCKED: number, readonly ETC: number }, readonly reservableWeeklySchedule: ReadonlyArray<{ readonly __typename?: 'CampaignReservableWeeklySchedule', readonly id: string, readonly possibleMinutes: number, readonly weekDay: WeekDay }> } };

export type TakeBackCampaignMutationVariables = Exact<{
  input: TakeBackCampaignInput;
}>;


export type TakeBackCampaignMutation = { readonly __typename?: 'Mutation', readonly takeBackCampaign: { readonly __typename?: 'Campaign', readonly id: string, readonly companyId: string, readonly name: string, readonly companySelectSearchGenre?: SearchGenre | null, readonly offerStarted?: string | null, readonly offerEnded?: string | null, readonly selectionMaxLimit?: number | null, readonly offersCount: number, readonly expenseEvidenceType: ExpenseEvidenceType, readonly thumbnailUrls: ReadonlyArray<string>, readonly question?: string | null, readonly gross?: number | null, readonly projectType?: ProjectType | null, readonly offeringCapacity?: number | null, readonly status: CampaignStatus, readonly scheduleType: CampaignScheduleType, readonly useIdentificationTicket: boolean, readonly category: CampaignCategory, readonly approvedAt?: string | null, readonly ageLimit?: AgeLimit | null, readonly sponsorServicePriceIntax?: number | null, readonly sponsorServicePrice?: number | null, readonly url?: string | null, readonly offerAutoMessage?: string | null, readonly attention?: string | null, readonly gender: CampaignGender, readonly sponsorService?: string | null, readonly summary?: string | null, readonly wantInfluencer?: string | null, readonly nearestStation?: string | null, readonly canTakeBack: boolean, readonly companion: Companion, readonly createdAt: string, readonly basicGross?: number | null, readonly campaignRequirementOptionSpecifiedPrText?: string | null, readonly campaignRequirementOptions: ReadonlyArray<CampaignRequirementOptions>, readonly guidance?: string | null, readonly maxCompanionCount?: number | null, readonly prTargetAge?: ReadonlyArray<PrTargetAge> | null, readonly prTargetGender?: PrTargetGender | null, readonly shopTemplateId?: string | null, readonly subGenre: ReadonlyArray<string>, readonly formatVersion: FormatVersion, readonly desiredLanguages: ReadonlyArray<LanguageType>, readonly costHandlingMethod?: CampaignCostHandlingMethod | null, readonly influencerBurdenRate: number, readonly campaignSnsRequirements: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirement', readonly id: string, readonly requestUrl?: string | null, readonly snsPostTypeList: ReadonlyArray<CampaignSnsRequirementSnsPostType>, readonly snsType: CampaignSnsRequirementSnsType, readonly snsPostRedirectUrl?: string | null, readonly postFooter: string, readonly tagList: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirementTag', readonly id: string, readonly languageType: LanguageType, readonly tags: ReadonlyArray<string> }> }>, readonly coverImageUrls: ReadonlyArray<{ readonly __typename?: 'ImageUrl', readonly original: string, readonly medium: string, readonly small: string }>, readonly regularlyPublishedCampaigns?: { readonly __typename?: 'RegularlyPublishedCampaign', readonly executionDay?: number | null, readonly status: RegularlyPublishedCampaignStatus } | null, readonly campaignReviewResults: ReadonlyArray<{ readonly __typename?: 'CampaignReviewResult', readonly id: string, readonly reviewSection: ReviewSection, readonly campaignReviews: ReadonlyArray<{ readonly __typename?: 'CampaignReview', readonly id: string, readonly isChecked?: boolean | null, readonly reviewTarget: ReviewTarget, readonly sendBackReason: string }> }>, readonly location?: { readonly __typename?: 'CampaignLocation', readonly id: string, readonly postalCode?: string | null, readonly prefectureCode?: Pref | null, readonly cityCode?: string | null, readonly cityName?: string | null, readonly streetAddress?: string | null, readonly buildingName?: string | null, readonly stationCode?: string | null, readonly stationName?: string | null, readonly name?: string | null, readonly tel?: string | null, readonly createdAt: string, readonly updatedAt: string } | null, readonly entriesCountByStatus: { readonly __typename?: 'CampaignEntriesCount', readonly APPLIED: number, readonly APPROVED: number, readonly DECLINED: number, readonly BLOCKED: number, readonly ETC: number }, readonly reservableWeeklySchedule: ReadonlyArray<{ readonly __typename?: 'CampaignReservableWeeklySchedule', readonly id: string, readonly possibleMinutes: number, readonly weekDay: WeekDay }> } };

export type UpdateCampaignMutationVariables = Exact<{
  input: UpdateCampaignInput;
}>;


export type UpdateCampaignMutation = { readonly __typename?: 'Mutation', readonly updateCampaign: { readonly __typename?: 'Campaign', readonly id: string, readonly companyId: string, readonly name: string, readonly companySelectSearchGenre?: SearchGenre | null, readonly offerStarted?: string | null, readonly offerEnded?: string | null, readonly selectionMaxLimit?: number | null, readonly offersCount: number, readonly expenseEvidenceType: ExpenseEvidenceType, readonly thumbnailUrls: ReadonlyArray<string>, readonly question?: string | null, readonly gross?: number | null, readonly projectType?: ProjectType | null, readonly offeringCapacity?: number | null, readonly status: CampaignStatus, readonly scheduleType: CampaignScheduleType, readonly useIdentificationTicket: boolean, readonly category: CampaignCategory, readonly approvedAt?: string | null, readonly ageLimit?: AgeLimit | null, readonly sponsorServicePriceIntax?: number | null, readonly sponsorServicePrice?: number | null, readonly url?: string | null, readonly offerAutoMessage?: string | null, readonly attention?: string | null, readonly gender: CampaignGender, readonly sponsorService?: string | null, readonly summary?: string | null, readonly wantInfluencer?: string | null, readonly nearestStation?: string | null, readonly canTakeBack: boolean, readonly companion: Companion, readonly createdAt: string, readonly basicGross?: number | null, readonly campaignRequirementOptionSpecifiedPrText?: string | null, readonly campaignRequirementOptions: ReadonlyArray<CampaignRequirementOptions>, readonly guidance?: string | null, readonly maxCompanionCount?: number | null, readonly prTargetAge?: ReadonlyArray<PrTargetAge> | null, readonly prTargetGender?: PrTargetGender | null, readonly shopTemplateId?: string | null, readonly subGenre: ReadonlyArray<string>, readonly formatVersion: FormatVersion, readonly desiredLanguages: ReadonlyArray<LanguageType>, readonly costHandlingMethod?: CampaignCostHandlingMethod | null, readonly influencerBurdenRate: number, readonly campaignSnsRequirements: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirement', readonly id: string, readonly requestUrl?: string | null, readonly snsPostTypeList: ReadonlyArray<CampaignSnsRequirementSnsPostType>, readonly snsType: CampaignSnsRequirementSnsType, readonly snsPostRedirectUrl?: string | null, readonly postFooter: string, readonly tagList: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirementTag', readonly id: string, readonly languageType: LanguageType, readonly tags: ReadonlyArray<string> }> }>, readonly coverImageUrls: ReadonlyArray<{ readonly __typename?: 'ImageUrl', readonly original: string, readonly medium: string, readonly small: string }>, readonly regularlyPublishedCampaigns?: { readonly __typename?: 'RegularlyPublishedCampaign', readonly executionDay?: number | null, readonly status: RegularlyPublishedCampaignStatus } | null, readonly campaignReviewResults: ReadonlyArray<{ readonly __typename?: 'CampaignReviewResult', readonly id: string, readonly reviewSection: ReviewSection, readonly campaignReviews: ReadonlyArray<{ readonly __typename?: 'CampaignReview', readonly id: string, readonly isChecked?: boolean | null, readonly reviewTarget: ReviewTarget, readonly sendBackReason: string }> }>, readonly location?: { readonly __typename?: 'CampaignLocation', readonly id: string, readonly postalCode?: string | null, readonly prefectureCode?: Pref | null, readonly cityCode?: string | null, readonly cityName?: string | null, readonly streetAddress?: string | null, readonly buildingName?: string | null, readonly stationCode?: string | null, readonly stationName?: string | null, readonly name?: string | null, readonly tel?: string | null, readonly createdAt: string, readonly updatedAt: string } | null, readonly entriesCountByStatus: { readonly __typename?: 'CampaignEntriesCount', readonly APPLIED: number, readonly APPROVED: number, readonly DECLINED: number, readonly BLOCKED: number, readonly ETC: number }, readonly reservableWeeklySchedule: ReadonlyArray<{ readonly __typename?: 'CampaignReservableWeeklySchedule', readonly id: string, readonly possibleMinutes: number, readonly weekDay: WeekDay }> } };

export type UpdateCampaignReservableWeeklyScheduleMutationVariables = Exact<{
  input: UpdateCampaignReservableWeeklyScheduleInput;
}>;


export type UpdateCampaignReservableWeeklyScheduleMutation = { readonly __typename?: 'Mutation', readonly updateCampaignReservableWeeklySchedule: ReadonlyArray<{ readonly __typename?: 'CampaignReservableWeeklySchedule', readonly id: string }> };

export type CampaignQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CampaignQuery = { readonly __typename?: 'Query', readonly campaign?: { readonly __typename?: 'Campaign', readonly id: string, readonly companyId: string, readonly name: string, readonly companySelectSearchGenre?: SearchGenre | null, readonly offerStarted?: string | null, readonly offerEnded?: string | null, readonly selectionMaxLimit?: number | null, readonly offersCount: number, readonly expenseEvidenceType: ExpenseEvidenceType, readonly thumbnailUrls: ReadonlyArray<string>, readonly question?: string | null, readonly gross?: number | null, readonly projectType?: ProjectType | null, readonly offeringCapacity?: number | null, readonly status: CampaignStatus, readonly scheduleType: CampaignScheduleType, readonly useIdentificationTicket: boolean, readonly category: CampaignCategory, readonly approvedAt?: string | null, readonly ageLimit?: AgeLimit | null, readonly sponsorServicePriceIntax?: number | null, readonly sponsorServicePrice?: number | null, readonly url?: string | null, readonly offerAutoMessage?: string | null, readonly attention?: string | null, readonly gender: CampaignGender, readonly sponsorService?: string | null, readonly summary?: string | null, readonly wantInfluencer?: string | null, readonly nearestStation?: string | null, readonly canTakeBack: boolean, readonly companion: Companion, readonly createdAt: string, readonly basicGross?: number | null, readonly campaignRequirementOptionSpecifiedPrText?: string | null, readonly campaignRequirementOptions: ReadonlyArray<CampaignRequirementOptions>, readonly guidance?: string | null, readonly maxCompanionCount?: number | null, readonly prTargetAge?: ReadonlyArray<PrTargetAge> | null, readonly prTargetGender?: PrTargetGender | null, readonly shopTemplateId?: string | null, readonly subGenre: ReadonlyArray<string>, readonly formatVersion: FormatVersion, readonly desiredLanguages: ReadonlyArray<LanguageType>, readonly costHandlingMethod?: CampaignCostHandlingMethod | null, readonly influencerBurdenRate: number, readonly campaignReviewResults: ReadonlyArray<{ readonly __typename?: 'CampaignReviewResult', readonly id: string, readonly reviewSection: ReviewSection, readonly campaignReviews: ReadonlyArray<{ readonly __typename?: 'CampaignReview', readonly id: string, readonly isChecked?: boolean | null, readonly reviewTarget: ReviewTarget, readonly sendBackReason: string }> }>, readonly campaignSnsRequirements: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirement', readonly id: string, readonly requestUrl?: string | null, readonly snsPostTypeList: ReadonlyArray<CampaignSnsRequirementSnsPostType>, readonly snsType: CampaignSnsRequirementSnsType, readonly snsPostRedirectUrl?: string | null, readonly postFooter: string, readonly tagList: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirementTag', readonly id: string, readonly languageType: LanguageType, readonly tags: ReadonlyArray<string> }> }>, readonly coverImageUrls: ReadonlyArray<{ readonly __typename?: 'ImageUrl', readonly original: string, readonly medium: string, readonly small: string }>, readonly regularlyPublishedCampaigns?: { readonly __typename?: 'RegularlyPublishedCampaign', readonly executionDay?: number | null, readonly status: RegularlyPublishedCampaignStatus } | null, readonly location?: { readonly __typename?: 'CampaignLocation', readonly id: string, readonly postalCode?: string | null, readonly prefectureCode?: Pref | null, readonly cityCode?: string | null, readonly cityName?: string | null, readonly streetAddress?: string | null, readonly buildingName?: string | null, readonly stationCode?: string | null, readonly stationName?: string | null, readonly name?: string | null, readonly tel?: string | null, readonly createdAt: string, readonly updatedAt: string } | null, readonly entriesCountByStatus: { readonly __typename?: 'CampaignEntriesCount', readonly APPLIED: number, readonly APPROVED: number, readonly DECLINED: number, readonly BLOCKED: number, readonly ETC: number }, readonly reservableWeeklySchedule: ReadonlyArray<{ readonly __typename?: 'CampaignReservableWeeklySchedule', readonly id: string, readonly possibleMinutes: number, readonly weekDay: WeekDay }> } | null };

export type CampaignInfoQueryVariables = Exact<{
  nodeId: Scalars['ID']['input'];
}>;


export type CampaignInfoQuery = { readonly __typename?: 'Query', readonly node: { readonly __typename?: 'BeginnerCategory' } | { readonly __typename?: 'BeginnerPost' } | { readonly __typename?: 'Campaign', readonly id: string, readonly companyId: string, readonly name: string, readonly companySelectSearchGenre?: SearchGenre | null, readonly offerStarted?: string | null, readonly offerEnded?: string | null, readonly selectionMaxLimit?: number | null, readonly offersCount: number, readonly expenseEvidenceType: ExpenseEvidenceType, readonly thumbnailUrls: ReadonlyArray<string>, readonly question?: string | null, readonly gross?: number | null, readonly projectType?: ProjectType | null, readonly offeringCapacity?: number | null, readonly status: CampaignStatus, readonly scheduleType: CampaignScheduleType, readonly useIdentificationTicket: boolean, readonly category: CampaignCategory, readonly approvedAt?: string | null, readonly ageLimit?: AgeLimit | null, readonly sponsorServicePriceIntax?: number | null, readonly sponsorServicePrice?: number | null, readonly url?: string | null, readonly offerAutoMessage?: string | null, readonly attention?: string | null, readonly gender: CampaignGender, readonly sponsorService?: string | null, readonly summary?: string | null, readonly wantInfluencer?: string | null, readonly nearestStation?: string | null, readonly canTakeBack: boolean, readonly companion: Companion, readonly createdAt: string, readonly basicGross?: number | null, readonly campaignRequirementOptionSpecifiedPrText?: string | null, readonly campaignRequirementOptions: ReadonlyArray<CampaignRequirementOptions>, readonly guidance?: string | null, readonly maxCompanionCount?: number | null, readonly prTargetAge?: ReadonlyArray<PrTargetAge> | null, readonly prTargetGender?: PrTargetGender | null, readonly shopTemplateId?: string | null, readonly subGenre: ReadonlyArray<string>, readonly formatVersion: FormatVersion, readonly desiredLanguages: ReadonlyArray<LanguageType>, readonly costHandlingMethod?: CampaignCostHandlingMethod | null, readonly influencerBurdenRate: number, readonly reservableSchedules?: ReadonlyArray<{ readonly __typename?: 'CampaignReservableSchedule', readonly id: string, readonly possibleDatetime: string }> | null, readonly campaignSnsRequirements: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirement', readonly id: string, readonly requestUrl?: string | null, readonly snsPostTypeList: ReadonlyArray<CampaignSnsRequirementSnsPostType>, readonly snsType: CampaignSnsRequirementSnsType, readonly snsPostRedirectUrl?: string | null, readonly postFooter: string, readonly tagList: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirementTag', readonly id: string, readonly languageType: LanguageType, readonly tags: ReadonlyArray<string> }> }>, readonly coverImageUrls: ReadonlyArray<{ readonly __typename?: 'ImageUrl', readonly original: string, readonly medium: string, readonly small: string }>, readonly regularlyPublishedCampaigns?: { readonly __typename?: 'RegularlyPublishedCampaign', readonly executionDay?: number | null, readonly status: RegularlyPublishedCampaignStatus } | null, readonly campaignReviewResults: ReadonlyArray<{ readonly __typename?: 'CampaignReviewResult', readonly id: string, readonly reviewSection: ReviewSection, readonly campaignReviews: ReadonlyArray<{ readonly __typename?: 'CampaignReview', readonly id: string, readonly isChecked?: boolean | null, readonly reviewTarget: ReviewTarget, readonly sendBackReason: string }> }>, readonly location?: { readonly __typename?: 'CampaignLocation', readonly id: string, readonly postalCode?: string | null, readonly prefectureCode?: Pref | null, readonly cityCode?: string | null, readonly cityName?: string | null, readonly streetAddress?: string | null, readonly buildingName?: string | null, readonly stationCode?: string | null, readonly stationName?: string | null, readonly name?: string | null, readonly tel?: string | null, readonly createdAt: string, readonly updatedAt: string } | null, readonly entriesCountByStatus: { readonly __typename?: 'CampaignEntriesCount', readonly APPLIED: number, readonly APPROVED: number, readonly DECLINED: number, readonly BLOCKED: number, readonly ETC: number }, readonly reservableWeeklySchedule: ReadonlyArray<{ readonly __typename?: 'CampaignReservableWeeklySchedule', readonly id: string, readonly possibleMinutes: number, readonly weekDay: WeekDay }> } | { readonly __typename?: 'CampaignEntry' } | { readonly __typename?: 'CampaignEntryCandidateSchedule' } | { readonly __typename?: 'CampaignLocation' } | { readonly __typename?: 'CampaignReservableSchedule' } | { readonly __typename?: 'CampaignReservableWeeklySchedule' } | { readonly __typename?: 'CampaignReview' } | { readonly __typename?: 'CampaignReviewResult' } | { readonly __typename?: 'CampaignSnsRequirement' } | { readonly __typename?: 'CampaignSnsRequirementTag' } | { readonly __typename?: 'Company' } | { readonly __typename?: 'CompanyNotificationEmail' } | { readonly __typename?: 'CompanyShopTemplate' } | { readonly __typename?: 'CompanySnsConnection' } | { readonly __typename?: 'DownloadReport' } | { readonly __typename?: 'Influencer' } | { readonly __typename?: 'IssuedTicket' } | { readonly __typename?: 'LikesSubscription' } | { readonly __typename?: 'LikesSubscriptionInvoiceDetail' } | { readonly __typename?: 'LiteracySurveyAnswer' } | { readonly __typename?: 'Member' } | { readonly __typename?: 'Message' } | { readonly __typename?: 'MfkessaiCustomer' } | { readonly __typename?: 'Offer' } | { readonly __typename?: 'OfferStateTransition' } | { readonly __typename?: 'PenaltyReason' } | { readonly __typename?: 'Plan' } | { readonly __typename?: 'PrInsight' } | { readonly __typename?: 'RegularlyPublishedCampaign' } | { readonly __typename?: 'RegularlyPublishedCampaignLog' } | { readonly __typename?: 'RelationalSurvey' } | { readonly __typename?: 'RelationalSurveyAnswer' } | { readonly __typename?: 'SubscriptionInvoiceDetail' } | { readonly __typename?: 'SubscriptionModel' } | { readonly __typename?: 'SubscriptionRenewal' } | { readonly __typename?: 'TicketSubscription' } | { readonly __typename?: 'TodoOffer' } | { readonly __typename?: 'TransactionalSurvey' } | { readonly __typename?: 'TransactionalSurveyAnswer' } | { readonly __typename?: 'UserInfluencerPenaltyReport' } };

export type CampaignListQueryVariables = Exact<{
  input?: InputMaybe<CampaignByAdvertiserInput>;
  campaignCountInput: CampaignCountInput;
}>;


export type CampaignListQuery = { readonly __typename?: 'Query', readonly viewer: { readonly __typename?: 'Advertiser', readonly campaignCount: number, readonly campaigns: ReadonlyArray<{ readonly __typename?: 'Campaign', readonly id: string, readonly name: string, readonly status: CampaignStatus, readonly offerStarted?: string | null, readonly offerEnded?: string | null, readonly gross?: number | null, readonly scheduleType: CampaignScheduleType, readonly hasReservableSchedule: boolean, readonly formatVersion: FormatVersion, readonly costHandlingMethod?: CampaignCostHandlingMethod | null, readonly influencerBurdenRate: number, readonly expenseEvidenceType: ExpenseEvidenceType, readonly coverImageUrls: ReadonlyArray<{ readonly __typename?: 'ImageUrl', readonly original: string, readonly medium: string, readonly small: string }>, readonly campaignSnsRequirements: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirement', readonly id: string, readonly requestUrl?: string | null, readonly snsPostTypeList: ReadonlyArray<CampaignSnsRequirementSnsPostType>, readonly snsType: CampaignSnsRequirementSnsType, readonly snsPostRedirectUrl?: string | null, readonly postFooter: string, readonly tagList: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirementTag', readonly id: string, readonly languageType: LanguageType, readonly tags: ReadonlyArray<string> }> }>, readonly offerStateCount: { readonly __typename?: 'OfferStateCount', readonly completed: number, readonly entry: number, readonly working: number }, readonly regularlyPublishedCampaigns?: { readonly __typename?: 'RegularlyPublishedCampaign', readonly status: RegularlyPublishedCampaignStatus, readonly executionDay?: number | null } | null }> } };

export type CampaignMailingQueryVariables = Exact<{
  nodeId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type CampaignMailingQuery = { readonly __typename?: 'Query', readonly node: { readonly __typename?: 'BeginnerCategory' } | { readonly __typename?: 'BeginnerPost' } | { readonly __typename?: 'Campaign', readonly offers?: { readonly __typename?: 'OfferConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'OfferEdge', readonly node: { readonly __typename?: 'Offer', readonly snsType: Provider, readonly id: string, readonly delivered?: boolean | null, readonly latestTransition?: { readonly __typename?: 'OfferStateTransition', readonly state: OfferStateTransitionState } | null, readonly influencer: { readonly __typename?: 'Influencer', readonly name?: string | null, readonly realName?: string | null, readonly realNameKana?: string | null, readonly postalCode?: string | null, readonly pref?: Pref | null, readonly city?: string | null, readonly address1?: string | null, readonly address2?: string | null, readonly tel?: string | null, readonly activeSnsConnections: { readonly __typename?: 'ActiveSnsConnections', readonly twitter?: { readonly __typename?: 'TwitterConnection', readonly name: string, readonly uid: string, readonly followerCount: number, readonly imageUrl?: string | null, readonly postCount: number, readonly linked: Linked, readonly url: string } | null, readonly youtube?: { readonly __typename?: 'YouTubeConnection', readonly name: string, readonly uid: string, readonly imageUrl?: string | null, readonly followerCount: number, readonly linked: Linked, readonly postCount: number, readonly url: string } | null, readonly instagram?: { readonly __typename?: 'InstagramConnection', readonly name: string, readonly uid: string, readonly followerCount: number, readonly imageUrl?: string | null, readonly postCount: number, readonly linked: Linked, readonly url: string } | null, readonly tiktok?: { readonly __typename?: 'TikTokConnection', readonly name: string, readonly uid: string, readonly imageUrl?: string | null, readonly followerCount: number, readonly postCount: number, readonly linked: Linked, readonly url: string } | null } } } }>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null } } | null } | { readonly __typename?: 'CampaignEntry' } | { readonly __typename?: 'CampaignEntryCandidateSchedule' } | { readonly __typename?: 'CampaignLocation' } | { readonly __typename?: 'CampaignReservableSchedule' } | { readonly __typename?: 'CampaignReservableWeeklySchedule' } | { readonly __typename?: 'CampaignReview' } | { readonly __typename?: 'CampaignReviewResult' } | { readonly __typename?: 'CampaignSnsRequirement' } | { readonly __typename?: 'CampaignSnsRequirementTag' } | { readonly __typename?: 'Company' } | { readonly __typename?: 'CompanyNotificationEmail' } | { readonly __typename?: 'CompanyShopTemplate' } | { readonly __typename?: 'CompanySnsConnection' } | { readonly __typename?: 'DownloadReport' } | { readonly __typename?: 'Influencer' } | { readonly __typename?: 'IssuedTicket' } | { readonly __typename?: 'LikesSubscription' } | { readonly __typename?: 'LikesSubscriptionInvoiceDetail' } | { readonly __typename?: 'LiteracySurveyAnswer' } | { readonly __typename?: 'Member' } | { readonly __typename?: 'Message' } | { readonly __typename?: 'MfkessaiCustomer' } | { readonly __typename?: 'Offer' } | { readonly __typename?: 'OfferStateTransition' } | { readonly __typename?: 'PenaltyReason' } | { readonly __typename?: 'Plan' } | { readonly __typename?: 'PrInsight' } | { readonly __typename?: 'RegularlyPublishedCampaign' } | { readonly __typename?: 'RegularlyPublishedCampaignLog' } | { readonly __typename?: 'RelationalSurvey' } | { readonly __typename?: 'RelationalSurveyAnswer' } | { readonly __typename?: 'SubscriptionInvoiceDetail' } | { readonly __typename?: 'SubscriptionModel' } | { readonly __typename?: 'SubscriptionRenewal' } | { readonly __typename?: 'TicketSubscription' } | { readonly __typename?: 'TodoOffer' } | { readonly __typename?: 'TransactionalSurvey' } | { readonly __typename?: 'TransactionalSurveyAnswer' } | { readonly __typename?: 'UserInfluencerPenaltyReport' } };

export type CampaignNameQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignNameQuery = { readonly __typename?: 'Query', readonly campaign?: { readonly __typename?: 'Campaign', readonly id: string, readonly name: string } | null };

export type CampaignNearestStationsQueryVariables = Exact<{
  input: CampaignNearestStationInput;
}>;


export type CampaignNearestStationsQuery = { readonly __typename?: 'Query', readonly campaignNearestStations: ReadonlyArray<{ readonly __typename?: 'CampaignNearestStation', readonly code: string, readonly name: string }> };

export type CampaignOfferMailingQueryVariables = Exact<{
  nodeId: Scalars['ID']['input'];
}>;


export type CampaignOfferMailingQuery = { readonly __typename?: 'Query', readonly node: { readonly __typename?: 'BeginnerCategory' } | { readonly __typename?: 'BeginnerPost' } | { readonly __typename?: 'Campaign' } | { readonly __typename?: 'CampaignEntry' } | { readonly __typename?: 'CampaignEntryCandidateSchedule' } | { readonly __typename?: 'CampaignLocation' } | { readonly __typename?: 'CampaignReservableSchedule' } | { readonly __typename?: 'CampaignReservableWeeklySchedule' } | { readonly __typename?: 'CampaignReview' } | { readonly __typename?: 'CampaignReviewResult' } | { readonly __typename?: 'CampaignSnsRequirement' } | { readonly __typename?: 'CampaignSnsRequirementTag' } | { readonly __typename?: 'Company' } | { readonly __typename?: 'CompanyNotificationEmail' } | { readonly __typename?: 'CompanyShopTemplate' } | { readonly __typename?: 'CompanySnsConnection' } | { readonly __typename?: 'DownloadReport' } | { readonly __typename?: 'Influencer' } | { readonly __typename?: 'IssuedTicket' } | { readonly __typename?: 'LikesSubscription' } | { readonly __typename?: 'LikesSubscriptionInvoiceDetail' } | { readonly __typename?: 'LiteracySurveyAnswer' } | { readonly __typename?: 'Member' } | { readonly __typename?: 'Message' } | { readonly __typename?: 'MfkessaiCustomer' } | { readonly __typename?: 'Offer', readonly influencer: { readonly __typename?: 'Influencer', readonly name?: string | null, readonly realName?: string | null, readonly realNameKana?: string | null, readonly postalCode?: string | null, readonly pref?: Pref | null, readonly city?: string | null, readonly address1?: string | null, readonly address2?: string | null, readonly tel?: string | null } } | { readonly __typename?: 'OfferStateTransition' } | { readonly __typename?: 'PenaltyReason' } | { readonly __typename?: 'Plan' } | { readonly __typename?: 'PrInsight' } | { readonly __typename?: 'RegularlyPublishedCampaign' } | { readonly __typename?: 'RegularlyPublishedCampaignLog' } | { readonly __typename?: 'RelationalSurvey' } | { readonly __typename?: 'RelationalSurveyAnswer' } | { readonly __typename?: 'SubscriptionInvoiceDetail' } | { readonly __typename?: 'SubscriptionModel' } | { readonly __typename?: 'SubscriptionRenewal' } | { readonly __typename?: 'TicketSubscription' } | { readonly __typename?: 'TodoOffer' } | { readonly __typename?: 'TransactionalSurvey' } | { readonly __typename?: 'TransactionalSurveyAnswer' } | { readonly __typename?: 'UserInfluencerPenaltyReport' } };

export type CampaignReviewResultQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CampaignReviewResultQuery = { readonly __typename?: 'Query', readonly campaign?: { readonly __typename?: 'Campaign', readonly campaignReviewResults: ReadonlyArray<{ readonly __typename?: 'CampaignReviewResult', readonly id: string, readonly reviewSection: ReviewSection, readonly campaignReviews: ReadonlyArray<{ readonly __typename?: 'CampaignReview', readonly id: string, readonly isChecked?: boolean | null, readonly reviewTarget: ReviewTarget, readonly sendBackReason: string }> }> } | null };

export type CampaignSchedulesQueryVariables = Exact<{
  nodeId: Scalars['ID']['input'];
}>;


export type CampaignSchedulesQuery = { readonly __typename?: 'Query', readonly node: { readonly __typename?: 'BeginnerCategory' } | { readonly __typename?: 'BeginnerPost' } | { readonly __typename?: 'Campaign', readonly id: string, readonly visitScheduleOffers?: ReadonlyArray<{ readonly __typename?: 'Offer', readonly id: string, readonly visitDate?: string | null, readonly snsType: Provider, readonly influencer: { readonly __typename?: 'Influencer', readonly id: string, readonly name?: string | null, readonly imageUrl?: string | null, readonly age?: number | null, readonly gender: Gender, readonly activeSnsConnections: { readonly __typename?: 'ActiveSnsConnections', readonly twitter?: { readonly __typename?: 'TwitterConnection', readonly name: string, readonly uid: string, readonly followerCount: number, readonly imageUrl?: string | null, readonly postCount: number, readonly linked: Linked, readonly url: string } | null, readonly youtube?: { readonly __typename?: 'YouTubeConnection', readonly name: string, readonly uid: string, readonly imageUrl?: string | null, readonly followerCount: number, readonly linked: Linked, readonly postCount: number, readonly url: string } | null, readonly instagram?: { readonly __typename?: 'InstagramConnection', readonly name: string, readonly uid: string, readonly followerCount: number, readonly imageUrl?: string | null, readonly postCount: number, readonly linked: Linked, readonly url: string } | null, readonly tiktok?: { readonly __typename?: 'TikTokConnection', readonly name: string, readonly uid: string, readonly imageUrl?: string | null, readonly followerCount: number, readonly postCount: number, readonly linked: Linked, readonly url: string } | null } } }> | null } | { readonly __typename?: 'CampaignEntry' } | { readonly __typename?: 'CampaignEntryCandidateSchedule' } | { readonly __typename?: 'CampaignLocation' } | { readonly __typename?: 'CampaignReservableSchedule' } | { readonly __typename?: 'CampaignReservableWeeklySchedule' } | { readonly __typename?: 'CampaignReview' } | { readonly __typename?: 'CampaignReviewResult' } | { readonly __typename?: 'CampaignSnsRequirement' } | { readonly __typename?: 'CampaignSnsRequirementTag' } | { readonly __typename?: 'Company' } | { readonly __typename?: 'CompanyNotificationEmail' } | { readonly __typename?: 'CompanyShopTemplate' } | { readonly __typename?: 'CompanySnsConnection' } | { readonly __typename?: 'DownloadReport' } | { readonly __typename?: 'Influencer' } | { readonly __typename?: 'IssuedTicket' } | { readonly __typename?: 'LikesSubscription' } | { readonly __typename?: 'LikesSubscriptionInvoiceDetail' } | { readonly __typename?: 'LiteracySurveyAnswer' } | { readonly __typename?: 'Member' } | { readonly __typename?: 'Message' } | { readonly __typename?: 'MfkessaiCustomer' } | { readonly __typename?: 'Offer' } | { readonly __typename?: 'OfferStateTransition' } | { readonly __typename?: 'PenaltyReason' } | { readonly __typename?: 'Plan' } | { readonly __typename?: 'PrInsight' } | { readonly __typename?: 'RegularlyPublishedCampaign' } | { readonly __typename?: 'RegularlyPublishedCampaignLog' } | { readonly __typename?: 'RelationalSurvey' } | { readonly __typename?: 'RelationalSurveyAnswer' } | { readonly __typename?: 'SubscriptionInvoiceDetail' } | { readonly __typename?: 'SubscriptionModel' } | { readonly __typename?: 'SubscriptionRenewal' } | { readonly __typename?: 'TicketSubscription' } | { readonly __typename?: 'TodoOffer' } | { readonly __typename?: 'TransactionalSurvey' } | { readonly __typename?: 'TransactionalSurveyAnswer' } | { readonly __typename?: 'UserInfluencerPenaltyReport' } };

export type CampaignShopLocationsQueryVariables = Exact<{
  input: CampaignShopLocationsInput;
}>;


export type CampaignShopLocationsQuery = { readonly __typename?: 'Query', readonly campaignShopLocations: ReadonlyArray<{ readonly __typename?: 'CampaignShopLocations', readonly prefectureCode: Pref, readonly shopCityCode: string, readonly cityName: string, readonly town: string }> };

export type CampaignWithSchedulesQueryVariables = Exact<{
  nodeId: Scalars['ID']['input'];
}>;


export type CampaignWithSchedulesQuery = { readonly __typename?: 'Query', readonly node: { readonly __typename?: 'BeginnerCategory' } | { readonly __typename?: 'BeginnerPost' } | { readonly __typename?: 'Campaign', readonly editableReservableSchedule: boolean, readonly id: string, readonly companyId: string, readonly name: string, readonly companySelectSearchGenre?: SearchGenre | null, readonly offerStarted?: string | null, readonly offerEnded?: string | null, readonly selectionMaxLimit?: number | null, readonly offersCount: number, readonly expenseEvidenceType: ExpenseEvidenceType, readonly thumbnailUrls: ReadonlyArray<string>, readonly question?: string | null, readonly gross?: number | null, readonly projectType?: ProjectType | null, readonly offeringCapacity?: number | null, readonly status: CampaignStatus, readonly scheduleType: CampaignScheduleType, readonly useIdentificationTicket: boolean, readonly category: CampaignCategory, readonly approvedAt?: string | null, readonly ageLimit?: AgeLimit | null, readonly sponsorServicePriceIntax?: number | null, readonly sponsorServicePrice?: number | null, readonly url?: string | null, readonly offerAutoMessage?: string | null, readonly attention?: string | null, readonly gender: CampaignGender, readonly sponsorService?: string | null, readonly summary?: string | null, readonly wantInfluencer?: string | null, readonly nearestStation?: string | null, readonly canTakeBack: boolean, readonly companion: Companion, readonly createdAt: string, readonly basicGross?: number | null, readonly campaignRequirementOptionSpecifiedPrText?: string | null, readonly campaignRequirementOptions: ReadonlyArray<CampaignRequirementOptions>, readonly guidance?: string | null, readonly maxCompanionCount?: number | null, readonly prTargetAge?: ReadonlyArray<PrTargetAge> | null, readonly prTargetGender?: PrTargetGender | null, readonly shopTemplateId?: string | null, readonly subGenre: ReadonlyArray<string>, readonly formatVersion: FormatVersion, readonly desiredLanguages: ReadonlyArray<LanguageType>, readonly costHandlingMethod?: CampaignCostHandlingMethod | null, readonly influencerBurdenRate: number, readonly reservableWeeklySchedule: ReadonlyArray<{ readonly __typename?: 'CampaignReservableWeeklySchedule', readonly id: string, readonly possibleMinutes: number, readonly weekDay: WeekDay }>, readonly reservableSchedules?: ReadonlyArray<{ readonly __typename?: 'CampaignReservableSchedule', readonly id: string, readonly possibleDatetime: string }> | null, readonly campaignSnsRequirements: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirement', readonly id: string, readonly requestUrl?: string | null, readonly snsPostTypeList: ReadonlyArray<CampaignSnsRequirementSnsPostType>, readonly snsType: CampaignSnsRequirementSnsType, readonly snsPostRedirectUrl?: string | null, readonly postFooter: string, readonly tagList: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirementTag', readonly id: string, readonly languageType: LanguageType, readonly tags: ReadonlyArray<string> }> }>, readonly coverImageUrls: ReadonlyArray<{ readonly __typename?: 'ImageUrl', readonly original: string, readonly medium: string, readonly small: string }>, readonly regularlyPublishedCampaigns?: { readonly __typename?: 'RegularlyPublishedCampaign', readonly executionDay?: number | null, readonly status: RegularlyPublishedCampaignStatus } | null, readonly campaignReviewResults: ReadonlyArray<{ readonly __typename?: 'CampaignReviewResult', readonly id: string, readonly reviewSection: ReviewSection, readonly campaignReviews: ReadonlyArray<{ readonly __typename?: 'CampaignReview', readonly id: string, readonly isChecked?: boolean | null, readonly reviewTarget: ReviewTarget, readonly sendBackReason: string }> }>, readonly location?: { readonly __typename?: 'CampaignLocation', readonly id: string, readonly postalCode?: string | null, readonly prefectureCode?: Pref | null, readonly cityCode?: string | null, readonly cityName?: string | null, readonly streetAddress?: string | null, readonly buildingName?: string | null, readonly stationCode?: string | null, readonly stationName?: string | null, readonly name?: string | null, readonly tel?: string | null, readonly createdAt: string, readonly updatedAt: string } | null, readonly entriesCountByStatus: { readonly __typename?: 'CampaignEntriesCount', readonly APPLIED: number, readonly APPROVED: number, readonly DECLINED: number, readonly BLOCKED: number, readonly ETC: number } } | { readonly __typename?: 'CampaignEntry' } | { readonly __typename?: 'CampaignEntryCandidateSchedule' } | { readonly __typename?: 'CampaignLocation' } | { readonly __typename?: 'CampaignReservableSchedule' } | { readonly __typename?: 'CampaignReservableWeeklySchedule' } | { readonly __typename?: 'CampaignReview' } | { readonly __typename?: 'CampaignReviewResult' } | { readonly __typename?: 'CampaignSnsRequirement' } | { readonly __typename?: 'CampaignSnsRequirementTag' } | { readonly __typename?: 'Company' } | { readonly __typename?: 'CompanyNotificationEmail' } | { readonly __typename?: 'CompanyShopTemplate' } | { readonly __typename?: 'CompanySnsConnection' } | { readonly __typename?: 'DownloadReport' } | { readonly __typename?: 'Influencer' } | { readonly __typename?: 'IssuedTicket' } | { readonly __typename?: 'LikesSubscription' } | { readonly __typename?: 'LikesSubscriptionInvoiceDetail' } | { readonly __typename?: 'LiteracySurveyAnswer' } | { readonly __typename?: 'Member' } | { readonly __typename?: 'Message' } | { readonly __typename?: 'MfkessaiCustomer' } | { readonly __typename?: 'Offer' } | { readonly __typename?: 'OfferStateTransition' } | { readonly __typename?: 'PenaltyReason' } | { readonly __typename?: 'Plan' } | { readonly __typename?: 'PrInsight' } | { readonly __typename?: 'RegularlyPublishedCampaign' } | { readonly __typename?: 'RegularlyPublishedCampaignLog' } | { readonly __typename?: 'RelationalSurvey' } | { readonly __typename?: 'RelationalSurveyAnswer' } | { readonly __typename?: 'SubscriptionInvoiceDetail' } | { readonly __typename?: 'SubscriptionModel' } | { readonly __typename?: 'SubscriptionRenewal' } | { readonly __typename?: 'TicketSubscription' } | { readonly __typename?: 'TodoOffer' } | { readonly __typename?: 'TransactionalSurvey' } | { readonly __typename?: 'TransactionalSurveyAnswer' } | { readonly __typename?: 'UserInfluencerPenaltyReport' } };

export type DownloadReportsQueryVariables = Exact<{ [key: string]: never; }>;


export type DownloadReportsQuery = { readonly __typename?: 'Query', readonly downloadReports: ReadonlyArray<{ readonly __typename?: 'DownloadReport', readonly createdAt: string, readonly downloadUrl?: string | null, readonly fileType: DownloadReportFileType, readonly id: string, readonly status: DownloadReportStatus, readonly title: string }> };

export type SearchGenresQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchGenresQuery = { readonly __typename?: 'Query', readonly searchGenres: ReadonlyArray<{ readonly __typename?: 'SearchGenreModel', readonly id: string, readonly name: string, readonly subGenres: ReadonlyArray<{ readonly __typename?: 'SearchSubGenreModel', readonly id: string, readonly name: string }> }> };

export type OfferMailingQueryVariables = Exact<{
  offerId: Scalars['ID']['input'];
}>;


export type OfferMailingQuery = { readonly __typename?: 'Query', readonly offer: { readonly __typename?: 'Offer', readonly influencer: { readonly __typename?: 'Influencer', readonly name?: string | null, readonly realName?: string | null, readonly realNameKana?: string | null, readonly postalCode?: string | null, readonly pref?: Pref | null, readonly city?: string | null, readonly address1?: string | null, readonly address2?: string | null, readonly tel?: string | null } } };

export type RegularlyPublishedCampaignListQueryVariables = Exact<{ [key: string]: never; }>;


export type RegularlyPublishedCampaignListQuery = { readonly __typename?: 'Query', readonly viewer: { readonly __typename?: 'Advertiser', readonly regularlyPublishedCampaigns: ReadonlyArray<{ readonly __typename?: 'Campaign', readonly id: string, readonly name: string, readonly status: CampaignStatus, readonly offerStarted?: string | null, readonly offerEnded?: string | null, readonly gross?: number | null, readonly costHandlingMethod?: CampaignCostHandlingMethod | null, readonly influencerBurdenRate: number, readonly expenseEvidenceType: ExpenseEvidenceType, readonly coverImageUrls: ReadonlyArray<{ readonly __typename?: 'ImageUrl', readonly original: string, readonly medium: string, readonly small: string }>, readonly campaignSnsRequirements: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirement', readonly id: string, readonly requestUrl?: string | null, readonly snsPostTypeList: ReadonlyArray<CampaignSnsRequirementSnsPostType>, readonly snsType: CampaignSnsRequirementSnsType, readonly snsPostRedirectUrl?: string | null, readonly postFooter: string, readonly tagList: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirementTag', readonly id: string, readonly languageType: LanguageType, readonly tags: ReadonlyArray<string> }> }>, readonly offerStateCount: { readonly __typename?: 'OfferStateCount', readonly completed: number, readonly entry: number, readonly working: number }, readonly regularlyPublishedCampaigns?: { readonly __typename?: 'RegularlyPublishedCampaign', readonly id: string, readonly status: RegularlyPublishedCampaignStatus, readonly executionDay?: number | null, readonly nextExecutionDate?: string | null } | null }> } };

export type WaitingCampaignListQueryVariables = Exact<{
  input?: InputMaybe<CampaignByAdvertiserInput>;
}>;


export type WaitingCampaignListQuery = { readonly __typename?: 'Query', readonly viewer: { readonly __typename?: 'Advertiser', readonly campaigns: ReadonlyArray<{ readonly __typename?: 'Campaign', readonly id: string, readonly name: string, readonly status: CampaignStatus, readonly gross?: number | null, readonly offerStarted?: string | null, readonly offerEnded?: string | null, readonly coverImageUrls: ReadonlyArray<{ readonly __typename?: 'ImageUrl', readonly original: string, readonly medium: string, readonly small: string }>, readonly campaignSnsRequirements: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirement', readonly id: string, readonly requestUrl?: string | null, readonly snsPostTypeList: ReadonlyArray<CampaignSnsRequirementSnsPostType>, readonly snsType: CampaignSnsRequirementSnsType, readonly snsPostRedirectUrl?: string | null, readonly postFooter: string, readonly tagList: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirementTag', readonly id: string, readonly languageType: LanguageType, readonly tags: ReadonlyArray<string> }> }> }> } };

export type WaitingPublishCampaignsQueryVariables = Exact<{ [key: string]: never; }>;


export type WaitingPublishCampaignsQuery = { readonly __typename?: 'Query', readonly waitingPublishCampaigns: ReadonlyArray<{ readonly __typename?: 'Campaign', readonly id: string, readonly name: string, readonly status: CampaignStatus, readonly gross?: number | null, readonly offerStarted?: string | null, readonly offerEnded?: string | null, readonly coverImageUrls: ReadonlyArray<{ readonly __typename?: 'ImageUrl', readonly original: string, readonly medium: string, readonly small: string }>, readonly campaignSnsRequirements: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirement', readonly id: string, readonly requestUrl?: string | null, readonly snsPostTypeList: ReadonlyArray<CampaignSnsRequirementSnsPostType>, readonly snsType: CampaignSnsRequirementSnsType, readonly snsPostRedirectUrl?: string | null, readonly postFooter: string, readonly tagList: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirementTag', readonly id: string, readonly languageType: LanguageType, readonly tags: ReadonlyArray<string> }> }> }> };

export type CheckingAntiSocialQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckingAntiSocialQuery = { readonly __typename?: 'Query', readonly viewerAsAdvertiser: { readonly __typename?: 'Advertiser', readonly checkingAntiSocial: boolean } };

export type ApproveCampaignEntryMutationVariables = Exact<{
  input: ApproveCampaignEntryInput;
}>;


export type ApproveCampaignEntryMutation = { readonly __typename?: 'Mutation', readonly approveCampaignEntryV2: { readonly __typename?: 'CampaignEntry', readonly id: string, readonly status: CampaignEntryStatus, readonly campaign?: { readonly __typename?: 'Campaign', readonly id: string, readonly name: string, readonly offeringCapacity?: number | null, readonly offersCount: number, readonly entriesCountByStatus: { readonly __typename?: 'CampaignEntriesCount', readonly APPLIED: number, readonly APPROVED: number, readonly DECLINED: number, readonly BLOCKED: number, readonly ETC: number } } | null } };

export type BlockCampaignEntryMutationVariables = Exact<{
  blockCampaignEntryId: Scalars['ID']['input'];
}>;


export type BlockCampaignEntryMutation = { readonly __typename?: 'Mutation', readonly blockCampaignEntry: { readonly __typename?: 'CampaignEntry', readonly id: string, readonly status: CampaignEntryStatus, readonly campaign?: { readonly __typename?: 'Campaign', readonly id: string, readonly entriesCountByStatus: { readonly __typename?: 'CampaignEntriesCount', readonly APPLIED: number, readonly APPROVED: number, readonly DECLINED: number, readonly BLOCKED: number, readonly ETC: number } } | null } };

export type PinCampaignEntryMutationVariables = Exact<{
  input: PinCampaignEntryInput;
}>;


export type PinCampaignEntryMutation = { readonly __typename?: 'Mutation', readonly pinCampaignEntry: { readonly __typename?: 'CampaignEntry', readonly id: string, readonly pinned: Pinned } };

export type UnpinCampaignEntryMutationVariables = Exact<{
  input: UnpinCampaignEntryInput;
}>;


export type UnpinCampaignEntryMutation = { readonly __typename?: 'Mutation', readonly unpinCampaignEntry: { readonly __typename?: 'CampaignEntry', readonly id: string, readonly pinned: Pinned } };

export type CampaignEntriesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  pinned?: InputMaybe<Pinned>;
  gender?: InputMaybe<Gender>;
  ageRange?: InputMaybe<AgeRange>;
  orderby: CampaignEntriesOrder;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CampaignEntriesQuery = { readonly __typename?: 'Query', readonly campaign?: { readonly __typename?: 'Campaign', readonly id: string, readonly question?: string | null, readonly entries: { readonly __typename?: 'CampaignEntryConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CampaignEntryEdge', readonly node: { readonly __typename?: 'CampaignEntry', readonly id: string, readonly campaignId: string, readonly snsType: Provider, readonly pinned: Pinned, readonly status: CampaignEntryStatus, readonly createdAt: string, readonly updatedAt: string, readonly expiredAt: string, readonly answer?: string | null, readonly companionCount?: number | null, readonly prPostLanguage?: LanguageType | null, readonly campaign?: { readonly __typename?: 'Campaign', readonly id: string, readonly question?: string | null, readonly category: CampaignCategory } | null, readonly insight?: { readonly __typename?: 'InstagramInsight', readonly reach28: { readonly __typename?: 'Reach28Unit', readonly value?: number | null }, readonly impressions: { readonly __typename?: 'ImpressionsUnit', readonly value?: number | null }, readonly profileViews: { readonly __typename?: 'ProfileViewsUnit', readonly value?: number | null }, readonly reach: { readonly __typename?: 'ReachUnit', readonly value?: number | null }, readonly genderRate: { readonly __typename?: 'GenderRateUnit', readonly value?: { readonly __typename?: 'GenderRate', readonly M: number, readonly F: number, readonly U: number } | null }, readonly ageRate: { readonly __typename?: 'AgeRateUnit', readonly value?: { readonly __typename?: 'AgeRate', readonly from13To17: number, readonly from18To24: number, readonly from25To34: number, readonly from35To44: number, readonly from45To54: number, readonly from55To64: number, readonly over65: number } | null }, readonly maleAgeRate: { readonly __typename?: 'MaleAgeRateUnit', readonly value?: { readonly __typename?: 'AgeRate', readonly from13To17: number, readonly from18To24: number, readonly from25To34: number, readonly from35To44: number, readonly from45To54: number, readonly from55To64: number, readonly over65: number } | null }, readonly femaleAgeRate: { readonly __typename?: 'FemaleAgeRateUnit', readonly value?: { readonly __typename?: 'AgeRate', readonly from13To17: number, readonly from18To24: number, readonly from25To34: number, readonly from35To44: number, readonly from45To54: number, readonly from55To64: number, readonly over65: number } | null }, readonly postCommentCount: { readonly __typename?: 'PostCommentCountUnit', readonly value?: number | null }, readonly postLikeCount: { readonly __typename?: 'PostLikeCountUnit', readonly value?: number | null }, readonly postImpressions: { readonly __typename?: 'PostImpressionsUnit', readonly value?: number | null }, readonly postReach: { readonly __typename?: 'PostReachUnit', readonly value?: number | null }, readonly postEngagement: { readonly __typename?: 'PostEngagementUnit', readonly value?: number | null } } | null, readonly candidateSchedules: ReadonlyArray<{ readonly __typename?: 'CampaignEntryCandidateSchedule', readonly id: string, readonly candidateSchedule: string }>, readonly engagementPrediction?: { readonly __typename?: 'CampaignEntryEngagementPrediction', readonly engagementPredLower?: number | null, readonly engagementPredUpper?: number | null } | null, readonly reachPrediction?: { readonly __typename?: 'CampaignEntryReachPrediction', readonly reachPred?: number | null, readonly reachClass?: number | null, readonly reachPredLower?: number | null, readonly reachPredUpper?: number | null } | null, readonly impressionPrediction?: { readonly __typename?: 'CampaignEntryImpressionPrediction', readonly impressionPred?: number | null, readonly impressionClass?: number | null, readonly impressionPredLower?: number | null, readonly impressionPredUpper?: number | null } | null, readonly influencer: { readonly __typename?: 'Influencer', readonly comment?: string | null, readonly id: string, readonly idpId?: string | null, readonly name?: string | null, readonly gender: Gender, readonly birthday?: string | null, readonly imageUrl?: string | null, readonly age?: number | null, readonly latestAccessTime?: string | null, readonly completeCountLevel: CompleteCountLevel, readonly approvedCount: number, readonly activeSnsConnections: { readonly __typename?: 'ActiveSnsConnections', readonly twitter?: { readonly __typename?: 'TwitterConnection', readonly name: string, readonly uid: string, readonly followerCount: number, readonly imageUrl?: string | null, readonly postCount: number, readonly linked: Linked, readonly url: string } | null, readonly youtube?: { readonly __typename?: 'YouTubeConnection', readonly name: string, readonly uid: string, readonly imageUrl?: string | null, readonly followerCount: number, readonly linked: Linked, readonly postCount: number, readonly url: string } | null, readonly instagram?: { readonly __typename?: 'InstagramConnection', readonly name: string, readonly uid: string, readonly followerCount: number, readonly imageUrl?: string | null, readonly postCount: number, readonly linked: Linked, readonly url: string } | null, readonly tiktok?: { readonly __typename?: 'TikTokConnection', readonly name: string, readonly uid: string, readonly imageUrl?: string | null, readonly followerCount: number, readonly postCount: number, readonly linked: Linked, readonly url: string } | null } } } }>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly hasPreviousPage: boolean, readonly startCursor?: string | null, readonly endCursor?: string | null } }, readonly entriesCountByStatus: { readonly __typename?: 'CampaignEntriesCount', readonly APPLIED: number, readonly APPROVED: number, readonly DECLINED: number, readonly BLOCKED: number, readonly ETC: number } } | null };

export type CampaignEntryQueryVariables = Exact<{
  nodeId: Scalars['ID']['input'];
}>;


export type CampaignEntryQuery = { readonly __typename?: 'Query', readonly node: { readonly __typename?: 'BeginnerCategory' } | { readonly __typename?: 'BeginnerPost' } | { readonly __typename?: 'Campaign' } | { readonly __typename?: 'CampaignEntry', readonly id: string, readonly campaignId: string, readonly snsType: Provider, readonly pinned: Pinned, readonly status: CampaignEntryStatus, readonly createdAt: string, readonly updatedAt: string, readonly expiredAt: string, readonly answer?: string | null, readonly companionCount?: number | null, readonly prPostLanguage?: LanguageType | null, readonly campaign?: { readonly __typename?: 'Campaign', readonly id: string, readonly question?: string | null, readonly category: CampaignCategory, readonly companyId: string, readonly name: string, readonly companySelectSearchGenre?: SearchGenre | null, readonly offerStarted?: string | null, readonly offerEnded?: string | null, readonly selectionMaxLimit?: number | null, readonly offersCount: number, readonly expenseEvidenceType: ExpenseEvidenceType, readonly thumbnailUrls: ReadonlyArray<string>, readonly gross?: number | null, readonly projectType?: ProjectType | null, readonly offeringCapacity?: number | null, readonly status: CampaignStatus, readonly scheduleType: CampaignScheduleType, readonly useIdentificationTicket: boolean, readonly approvedAt?: string | null, readonly ageLimit?: AgeLimit | null, readonly sponsorServicePriceIntax?: number | null, readonly sponsorServicePrice?: number | null, readonly url?: string | null, readonly offerAutoMessage?: string | null, readonly attention?: string | null, readonly gender: CampaignGender, readonly sponsorService?: string | null, readonly summary?: string | null, readonly wantInfluencer?: string | null, readonly nearestStation?: string | null, readonly canTakeBack: boolean, readonly companion: Companion, readonly createdAt: string, readonly basicGross?: number | null, readonly campaignRequirementOptionSpecifiedPrText?: string | null, readonly campaignRequirementOptions: ReadonlyArray<CampaignRequirementOptions>, readonly guidance?: string | null, readonly maxCompanionCount?: number | null, readonly prTargetAge?: ReadonlyArray<PrTargetAge> | null, readonly prTargetGender?: PrTargetGender | null, readonly shopTemplateId?: string | null, readonly subGenre: ReadonlyArray<string>, readonly formatVersion: FormatVersion, readonly desiredLanguages: ReadonlyArray<LanguageType>, readonly costHandlingMethod?: CampaignCostHandlingMethod | null, readonly influencerBurdenRate: number, readonly campaignSnsRequirements: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirement', readonly id: string, readonly requestUrl?: string | null, readonly snsPostTypeList: ReadonlyArray<CampaignSnsRequirementSnsPostType>, readonly snsType: CampaignSnsRequirementSnsType, readonly snsPostRedirectUrl?: string | null, readonly postFooter: string, readonly tagList: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirementTag', readonly id: string, readonly languageType: LanguageType, readonly tags: ReadonlyArray<string> }> }>, readonly coverImageUrls: ReadonlyArray<{ readonly __typename?: 'ImageUrl', readonly original: string, readonly medium: string, readonly small: string }>, readonly regularlyPublishedCampaigns?: { readonly __typename?: 'RegularlyPublishedCampaign', readonly executionDay?: number | null, readonly status: RegularlyPublishedCampaignStatus } | null, readonly campaignReviewResults: ReadonlyArray<{ readonly __typename?: 'CampaignReviewResult', readonly id: string, readonly reviewSection: ReviewSection, readonly campaignReviews: ReadonlyArray<{ readonly __typename?: 'CampaignReview', readonly id: string, readonly isChecked?: boolean | null, readonly reviewTarget: ReviewTarget, readonly sendBackReason: string }> }>, readonly location?: { readonly __typename?: 'CampaignLocation', readonly id: string, readonly postalCode?: string | null, readonly prefectureCode?: Pref | null, readonly cityCode?: string | null, readonly cityName?: string | null, readonly streetAddress?: string | null, readonly buildingName?: string | null, readonly stationCode?: string | null, readonly stationName?: string | null, readonly name?: string | null, readonly tel?: string | null, readonly createdAt: string, readonly updatedAt: string } | null, readonly entriesCountByStatus: { readonly __typename?: 'CampaignEntriesCount', readonly APPLIED: number, readonly APPROVED: number, readonly DECLINED: number, readonly BLOCKED: number, readonly ETC: number }, readonly reservableWeeklySchedule: ReadonlyArray<{ readonly __typename?: 'CampaignReservableWeeklySchedule', readonly id: string, readonly possibleMinutes: number, readonly weekDay: WeekDay }> } | null, readonly insight?: { readonly __typename?: 'InstagramInsight', readonly reach28: { readonly __typename?: 'Reach28Unit', readonly value?: number | null }, readonly impressions: { readonly __typename?: 'ImpressionsUnit', readonly value?: number | null }, readonly profileViews: { readonly __typename?: 'ProfileViewsUnit', readonly value?: number | null }, readonly reach: { readonly __typename?: 'ReachUnit', readonly value?: number | null }, readonly genderRate: { readonly __typename?: 'GenderRateUnit', readonly value?: { readonly __typename?: 'GenderRate', readonly M: number, readonly F: number, readonly U: number } | null }, readonly ageRate: { readonly __typename?: 'AgeRateUnit', readonly value?: { readonly __typename?: 'AgeRate', readonly from13To17: number, readonly from18To24: number, readonly from25To34: number, readonly from35To44: number, readonly from45To54: number, readonly from55To64: number, readonly over65: number } | null }, readonly maleAgeRate: { readonly __typename?: 'MaleAgeRateUnit', readonly value?: { readonly __typename?: 'AgeRate', readonly from13To17: number, readonly from18To24: number, readonly from25To34: number, readonly from35To44: number, readonly from45To54: number, readonly from55To64: number, readonly over65: number } | null }, readonly femaleAgeRate: { readonly __typename?: 'FemaleAgeRateUnit', readonly value?: { readonly __typename?: 'AgeRate', readonly from13To17: number, readonly from18To24: number, readonly from25To34: number, readonly from35To44: number, readonly from45To54: number, readonly from55To64: number, readonly over65: number } | null }, readonly postCommentCount: { readonly __typename?: 'PostCommentCountUnit', readonly value?: number | null }, readonly postLikeCount: { readonly __typename?: 'PostLikeCountUnit', readonly value?: number | null }, readonly postImpressions: { readonly __typename?: 'PostImpressionsUnit', readonly value?: number | null }, readonly postReach: { readonly __typename?: 'PostReachUnit', readonly value?: number | null }, readonly postEngagement: { readonly __typename?: 'PostEngagementUnit', readonly value?: number | null } } | null, readonly candidateSchedules: ReadonlyArray<{ readonly __typename?: 'CampaignEntryCandidateSchedule', readonly id: string, readonly candidateSchedule: string }>, readonly engagementPrediction?: { readonly __typename?: 'CampaignEntryEngagementPrediction', readonly engagementPredLower?: number | null, readonly engagementPredUpper?: number | null } | null, readonly reachPrediction?: { readonly __typename?: 'CampaignEntryReachPrediction', readonly reachPred?: number | null, readonly reachClass?: number | null, readonly reachPredLower?: number | null, readonly reachPredUpper?: number | null } | null, readonly impressionPrediction?: { readonly __typename?: 'CampaignEntryImpressionPrediction', readonly impressionPred?: number | null, readonly impressionClass?: number | null, readonly impressionPredLower?: number | null, readonly impressionPredUpper?: number | null } | null, readonly influencer: { readonly __typename?: 'Influencer', readonly comment?: string | null, readonly id: string, readonly idpId?: string | null, readonly name?: string | null, readonly gender: Gender, readonly birthday?: string | null, readonly imageUrl?: string | null, readonly age?: number | null, readonly latestAccessTime?: string | null, readonly completeCountLevel: CompleteCountLevel, readonly approvedCount: number, readonly activeSnsConnections: { readonly __typename?: 'ActiveSnsConnections', readonly twitter?: { readonly __typename?: 'TwitterConnection', readonly name: string, readonly uid: string, readonly followerCount: number, readonly imageUrl?: string | null, readonly postCount: number, readonly linked: Linked, readonly url: string } | null, readonly youtube?: { readonly __typename?: 'YouTubeConnection', readonly name: string, readonly uid: string, readonly imageUrl?: string | null, readonly followerCount: number, readonly linked: Linked, readonly postCount: number, readonly url: string } | null, readonly instagram?: { readonly __typename?: 'InstagramConnection', readonly name: string, readonly uid: string, readonly followerCount: number, readonly imageUrl?: string | null, readonly postCount: number, readonly linked: Linked, readonly url: string } | null, readonly tiktok?: { readonly __typename?: 'TikTokConnection', readonly name: string, readonly uid: string, readonly imageUrl?: string | null, readonly followerCount: number, readonly postCount: number, readonly linked: Linked, readonly url: string } | null } } } | { readonly __typename?: 'CampaignEntryCandidateSchedule' } | { readonly __typename?: 'CampaignLocation' } | { readonly __typename?: 'CampaignReservableSchedule' } | { readonly __typename?: 'CampaignReservableWeeklySchedule' } | { readonly __typename?: 'CampaignReview' } | { readonly __typename?: 'CampaignReviewResult' } | { readonly __typename?: 'CampaignSnsRequirement' } | { readonly __typename?: 'CampaignSnsRequirementTag' } | { readonly __typename?: 'Company' } | { readonly __typename?: 'CompanyNotificationEmail' } | { readonly __typename?: 'CompanyShopTemplate' } | { readonly __typename?: 'CompanySnsConnection' } | { readonly __typename?: 'DownloadReport' } | { readonly __typename?: 'Influencer' } | { readonly __typename?: 'IssuedTicket' } | { readonly __typename?: 'LikesSubscription' } | { readonly __typename?: 'LikesSubscriptionInvoiceDetail' } | { readonly __typename?: 'LiteracySurveyAnswer' } | { readonly __typename?: 'Member' } | { readonly __typename?: 'Message' } | { readonly __typename?: 'MfkessaiCustomer' } | { readonly __typename?: 'Offer' } | { readonly __typename?: 'OfferStateTransition' } | { readonly __typename?: 'PenaltyReason' } | { readonly __typename?: 'Plan' } | { readonly __typename?: 'PrInsight' } | { readonly __typename?: 'RegularlyPublishedCampaign' } | { readonly __typename?: 'RegularlyPublishedCampaignLog' } | { readonly __typename?: 'RelationalSurvey' } | { readonly __typename?: 'RelationalSurveyAnswer' } | { readonly __typename?: 'SubscriptionInvoiceDetail' } | { readonly __typename?: 'SubscriptionModel' } | { readonly __typename?: 'SubscriptionRenewal' } | { readonly __typename?: 'TicketSubscription' } | { readonly __typename?: 'TodoOffer' } | { readonly __typename?: 'TransactionalSurvey' } | { readonly __typename?: 'TransactionalSurveyAnswer' } | { readonly __typename?: 'UserInfluencerPenaltyReport' } };

export type OfferCampaignEntryQueryVariables = Exact<{
  nodeId: Scalars['ID']['input'];
}>;


export type OfferCampaignEntryQuery = { readonly __typename?: 'Query', readonly node: { readonly __typename?: 'BeginnerCategory' } | { readonly __typename?: 'BeginnerPost' } | { readonly __typename?: 'Campaign' } | { readonly __typename?: 'CampaignEntry' } | { readonly __typename?: 'CampaignEntryCandidateSchedule' } | { readonly __typename?: 'CampaignLocation' } | { readonly __typename?: 'CampaignReservableSchedule' } | { readonly __typename?: 'CampaignReservableWeeklySchedule' } | { readonly __typename?: 'CampaignReview' } | { readonly __typename?: 'CampaignReviewResult' } | { readonly __typename?: 'CampaignSnsRequirement' } | { readonly __typename?: 'CampaignSnsRequirementTag' } | { readonly __typename?: 'Company' } | { readonly __typename?: 'CompanyNotificationEmail' } | { readonly __typename?: 'CompanyShopTemplate' } | { readonly __typename?: 'CompanySnsConnection' } | { readonly __typename?: 'DownloadReport' } | { readonly __typename?: 'Influencer' } | { readonly __typename?: 'IssuedTicket' } | { readonly __typename?: 'LikesSubscription' } | { readonly __typename?: 'LikesSubscriptionInvoiceDetail' } | { readonly __typename?: 'LiteracySurveyAnswer' } | { readonly __typename?: 'Member' } | { readonly __typename?: 'Message' } | { readonly __typename?: 'MfkessaiCustomer' } | { readonly __typename?: 'Offer', readonly id: string, readonly campaignEntry: { readonly __typename?: 'CampaignEntry', readonly id: string, readonly companionCount?: number | null, readonly answer?: string | null, readonly prPostLanguage?: LanguageType | null, readonly campaign?: { readonly __typename?: 'Campaign', readonly id: string, readonly question?: string | null, readonly category: CampaignCategory } | null } } | { readonly __typename?: 'OfferStateTransition' } | { readonly __typename?: 'PenaltyReason' } | { readonly __typename?: 'Plan' } | { readonly __typename?: 'PrInsight' } | { readonly __typename?: 'RegularlyPublishedCampaign' } | { readonly __typename?: 'RegularlyPublishedCampaignLog' } | { readonly __typename?: 'RelationalSurvey' } | { readonly __typename?: 'RelationalSurveyAnswer' } | { readonly __typename?: 'SubscriptionInvoiceDetail' } | { readonly __typename?: 'SubscriptionModel' } | { readonly __typename?: 'SubscriptionRenewal' } | { readonly __typename?: 'TicketSubscription' } | { readonly __typename?: 'TodoOffer' } | { readonly __typename?: 'TransactionalSurvey' } | { readonly __typename?: 'TransactionalSurveyAnswer' } | { readonly __typename?: 'UserInfluencerPenaltyReport' } };

export type AdvAccountPerformanceReportTimeSeriesQueryVariables = Exact<{
  input: AdvAccountPerformanceReportTimeSeriesInput;
}>;


export type AdvAccountPerformanceReportTimeSeriesQuery = { readonly __typename?: 'Query', readonly advAccountPerformanceReportTimeSeries: ReadonlyArray<{ readonly __typename?: 'PerformanceReportTimeSeries', readonly name: MetricsFieldName, readonly value: ReadonlyArray<{ readonly __typename?: 'PerformanceReportTimeSeriesValue', readonly date: string, readonly value?: number | null }> }> };

export type CampaignPerformanceMetricsQueryVariables = Exact<{
  pagination: OffsetPaginationInput;
  order?: InputMaybe<PerformanceMetricsOrder>;
  input: CampaignPerformanceMetricsInput;
}>;


export type CampaignPerformanceMetricsQuery = { readonly __typename?: 'Query', readonly campaignPerformanceMetrics: { readonly __typename?: 'CampaignPerformanceMetricsPage', readonly totalCount: number, readonly nodes?: ReadonlyArray<{ readonly __typename?: 'CampaignPerformanceMetrics', readonly advAccountId: string, readonly campaignId: string, readonly impressions?: number | null, readonly reaches?: number | null, readonly engagements?: number | null, readonly engagementRate?: number | null, readonly likes?: number | null, readonly comments?: number | null, readonly saves?: number | null, readonly shares?: number | null, readonly postCounts: number, readonly startedAt: string, readonly endedAt: string, readonly campaign: { readonly __typename?: 'Campaign', readonly id: string, readonly name: string, readonly thumbnailUrls: ReadonlyArray<string> } }> | null } };

export type CampaignPerformanceMetricsSummaryQueryVariables = Exact<{
  input: CampaignPerformanceMetricsInput;
}>;


export type CampaignPerformanceMetricsSummaryQuery = { readonly __typename?: 'Query', readonly campaignPerformanceMetricsSummary: { readonly __typename?: 'CampaignPerformanceMetricsSummary', readonly impressions?: number | null, readonly reaches?: number | null, readonly engagements?: number | null, readonly engagementRate?: number | null, readonly likes?: number | null, readonly comments?: number | null, readonly saves?: number | null, readonly shares?: number | null, readonly postCounts?: number | null, readonly startedAt: string, readonly endedAt: string } };

export type CampaignPerformanceReportTimeSeriesQueryVariables = Exact<{
  input: CampaignPerformanceReportTimeSeriesInput;
}>;


export type CampaignPerformanceReportTimeSeriesQuery = { readonly __typename?: 'Query', readonly campaignPerformanceReportTimeSeries: ReadonlyArray<{ readonly __typename?: 'PerformanceReportTimeSeries', readonly name: MetricsFieldName, readonly value: ReadonlyArray<{ readonly __typename?: 'PerformanceReportTimeSeriesValue', readonly date: string, readonly value?: number | null }> }> };

export type PostPerformanceMetricsQueryVariables = Exact<{
  pagination: OffsetPaginationInput;
  order?: InputMaybe<PerformanceMetricsOrder>;
  input: PostPerformanceMetricsInput;
}>;


export type PostPerformanceMetricsQuery = { readonly __typename?: 'Query', readonly postPerformanceMetrics: { readonly __typename?: 'PostPerformanceMetricsPage', readonly totalCount: number, readonly nodes?: ReadonlyArray<{ readonly __typename?: 'PostPerformanceMetrics', readonly snsType: CampaignSnsRequirementSnsType, readonly snsOriginalPostId: string, readonly advAccountId: string, readonly campaignId: string, readonly offerId: string, readonly impressions?: number | null, readonly reaches?: number | null, readonly engagements?: number | null, readonly engagementRate?: number | null, readonly likes?: number | null, readonly comments?: number | null, readonly saves?: number | null, readonly shares?: number | null, readonly startedAt: string, readonly endedAt: string, readonly postInfo: { readonly __typename?: 'PostInfo', readonly postUrl?: string | null, readonly postThumbnailUrl?: string | null, readonly userInfluencerId?: string | null, readonly userInfluencerName?: string | null, readonly snsConnectUid?: string | null, readonly snsConnectName?: string | null }, readonly campaign: { readonly __typename?: 'Campaign', readonly id: string, readonly name: string, readonly thumbnailUrls: ReadonlyArray<string> } }> | null } };

export type PostPerformanceMetricsSummaryQueryVariables = Exact<{
  input: PostPerformanceMetricsInput;
}>;


export type PostPerformanceMetricsSummaryQuery = { readonly __typename?: 'Query', readonly postPerformanceMetricsSummary: { readonly __typename?: 'PostPerformanceMetricsSummary', readonly impressions?: number | null, readonly reaches?: number | null, readonly engagements?: number | null, readonly engagementRate?: number | null, readonly likes?: number | null, readonly comments?: number | null, readonly saves?: number | null, readonly shares?: number | null, readonly startedAt: string, readonly endedAt: string } };

export type DeleteCompanyNotificationEmailMutationVariables = Exact<{
  input: DeleteCompanyNotificationEmailInput;
}>;


export type DeleteCompanyNotificationEmailMutation = { readonly __typename?: 'Mutation', readonly deleteCompanyNotificationEmail?: { readonly __typename?: 'CompanyNotificationEmail', readonly id: string, readonly notificationEmail: string, readonly activation: boolean } | null };

export type ProvisionallyRegisterCompanyNotificationEmailMutationVariables = Exact<{
  input: ProvisionallyRegisterCompanyNotificationEmailInput;
}>;


export type ProvisionallyRegisterCompanyNotificationEmailMutation = { readonly __typename?: 'Mutation', readonly provisionallyRegisterCompanyNotificationEmail: ReadonlyArray<{ readonly __typename?: 'CompanyNotificationEmail', readonly id: string, readonly notificationEmail: string, readonly activation: boolean, readonly verificationDeadline: string }> };

export type ReSendActivateCompanyNotificationEmailMutationVariables = Exact<{
  input: ReSendActivateCompanyNotificationEmailInput;
}>;


export type ReSendActivateCompanyNotificationEmailMutation = { readonly __typename?: 'Mutation', readonly reSendActivateCompanyNotificationEmail: { readonly __typename?: 'CompanyNotificationEmail', readonly id: string, readonly notificationEmail: string, readonly activation: boolean } };

export type CompanyNotificationEmailsQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyNotificationEmailsQuery = { readonly __typename?: 'Query', readonly viewer: { readonly __typename?: 'Advertiser', readonly company?: { readonly __typename?: 'Company', readonly adminMembers: ReadonlyArray<{ readonly __typename?: 'Member', readonly id: string, readonly email: string }>, readonly notificationEmails: ReadonlyArray<{ readonly __typename?: 'CompanyNotificationEmail', readonly id: string, readonly notificationEmail: string, readonly activation: boolean, readonly verificationDeadline: string }> } | null } };

export type SavePredictedPrPostEngagementMetricsMutationVariables = Exact<{
  input: SavePredictedPrPostEngagementInput;
}>;


export type SavePredictedPrPostEngagementMetricsMutation = { readonly __typename?: 'Mutation', readonly savePredictedPrPostEngagementMetrics: { readonly __typename?: 'MetricsTrackingResult', readonly status: string } };

export type InvoiceQueryVariables = Exact<{
  billingMonth: Scalars['DateTime']['input'];
}>;


export type InvoiceQuery = { readonly __typename?: 'Query', readonly viewer: { readonly __typename?: 'Advertiser', readonly campaigns: ReadonlyArray<{ readonly __typename?: 'Campaign', readonly id: string, readonly name: string, readonly gross?: number | null, readonly offerStarted?: string | null, readonly offerEnded?: string | null, readonly coverImageUrls: ReadonlyArray<{ readonly __typename?: 'ImageUrl', readonly original: string, readonly small: string, readonly medium: string }>, readonly campaignSnsRequirements: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirement', readonly id: string, readonly snsType: CampaignSnsRequirementSnsType, readonly postFooter: string, readonly requestUrl?: string | null, readonly tagList: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirementTag', readonly id: string, readonly languageType: LanguageType, readonly tags: ReadonlyArray<string> }> }>, readonly feeReport: { readonly __typename?: 'CampaignFeeReport', readonly campaignId: string, readonly fixedFeeDetail?: { readonly __typename?: 'CampaignFeeDetail', readonly postedReword: number, readonly recruitmentFee: number } | null, readonly unsettledFeeDetail?: { readonly __typename?: 'CampaignFeeDetail', readonly postedReword: number, readonly recruitmentFee: number } | null } }>, readonly ticketSubscriptionInvoiceDetails?: ReadonlyArray<{ readonly __typename?: 'SubscriptionInvoiceDetail', readonly name: string, readonly billingDate: string, readonly price: number, readonly ticketSubscription: { readonly __typename?: 'TicketSubscription', readonly cancellationRequestedAt?: string | null, readonly description?: string | null, readonly endedAt?: string | null, readonly id: string, readonly name: string, readonly startedAt: string, readonly nextBillingPrice?: number | null, readonly minCancellableDatetime: string, readonly minimumUpdateCount: number, readonly cancellationTiming: CancellationTiming, readonly subscriptionModelId: number, readonly latestSubscriptionRenewal: { readonly __typename?: 'SubscriptionRenewal', readonly id: string, readonly renewalDate: string, readonly subscriptionInvoiceDetail?: { readonly __typename?: 'SubscriptionInvoiceDetail', readonly status: SubscriptionInvoiceDetailStatus } | null }, readonly subscriptionRenewals: { readonly __typename?: 'SubscriptionRenewalConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'SubscriptionRenewalEdge', readonly cursor: string, readonly node: { readonly __typename?: 'SubscriptionRenewal', readonly id: string, readonly renewalDate: string } }>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly hasPreviousPage: boolean, readonly startCursor?: string | null, readonly endCursor?: string | null } } } }> | null } };

export type IssueOneTimeLineAuthCodeMutationVariables = Exact<{ [key: string]: never; }>;


export type IssueOneTimeLineAuthCodeMutation = { readonly __typename?: 'Mutation', readonly issueOneTimeLineAuthCode: string };

export type CreateMfkessaiCustomerMutationVariables = Exact<{
  input: CreateMfkessaiCustomerInput;
}>;


export type CreateMfkessaiCustomerMutation = { readonly __typename?: 'Mutation', readonly createMfkessaiCustomer?: { readonly __typename?: 'MfkessaiCustomer', readonly id: string } | null };

export type MfkessaiDestinationQueryVariables = Exact<{ [key: string]: never; }>;


export type MfkessaiDestinationQuery = { readonly __typename?: 'Query', readonly viewer: { readonly __typename?: 'Advertiser', readonly mfkessaiDestination?: { readonly __typename?: 'MfkessaiDestination', readonly address1?: string | null, readonly address2?: string | null, readonly ccEmails?: ReadonlyArray<string> | null, readonly createdAt?: string | null, readonly customerId?: string | null, readonly department?: string | null, readonly email?: string | null, readonly id?: string | null, readonly name?: string | null, readonly nameKana?: string | null, readonly tel?: string | null, readonly title?: string | null, readonly uri?: string | null, readonly zipCode?: string | null } | null } };

export type OfferListQueryVariables = Exact<{
  input?: InputMaybe<OffersInput>;
  countInput: OfferCountInput;
}>;


export type OfferListQuery = { readonly __typename?: 'Query', readonly viewer: { readonly __typename?: 'Advertiser', readonly offerCount: number, readonly offers: ReadonlyArray<{ readonly __typename?: 'Offer', readonly id: string, readonly delivered?: boolean | null, readonly campaign?: { readonly __typename?: 'Campaign', readonly id: string, readonly name: string, readonly coverImageUrls: ReadonlyArray<{ readonly __typename?: 'ImageUrl', readonly original: string, readonly medium: string, readonly small: string }> } | null, readonly latestMessage?: { readonly __typename?: 'Message', readonly body: string, readonly sender: Sender, readonly createdAt: string } | null, readonly latestTransition?: { readonly __typename?: 'OfferStateTransition', readonly action: OfferStateTransitionAction, readonly createdAt: string, readonly deadline?: string | null } | null, readonly influencer: { readonly __typename?: 'Influencer', readonly id: string, readonly name?: string | null, readonly imageUrl?: string | null, readonly birthday?: string | null, readonly gender: Gender } }> } };

export type OfferListOfferFragment = { readonly __typename?: 'Offer', readonly id: string, readonly delivered?: boolean | null, readonly campaign?: { readonly __typename?: 'Campaign', readonly id: string, readonly name: string, readonly coverImageUrls: ReadonlyArray<{ readonly __typename?: 'ImageUrl', readonly original: string, readonly medium: string, readonly small: string }> } | null, readonly latestMessage?: { readonly __typename?: 'Message', readonly body: string, readonly sender: Sender, readonly createdAt: string } | null, readonly latestTransition?: { readonly __typename?: 'OfferStateTransition', readonly action: OfferStateTransitionAction, readonly createdAt: string, readonly deadline?: string | null } | null, readonly influencer: { readonly __typename?: 'Influencer', readonly id: string, readonly name?: string | null, readonly imageUrl?: string | null, readonly birthday?: string | null, readonly gender: Gender } };

export type OfferListCampaignFragment = { readonly __typename?: 'Campaign', readonly id: string, readonly name: string, readonly coverImageUrls: ReadonlyArray<{ readonly __typename?: 'ImageUrl', readonly original: string, readonly medium: string, readonly small: string }> };

export type AssignPenaltyToOfferMutationVariables = Exact<{
  input: AssignPenaltyToOfferInput;
}>;


export type AssignPenaltyToOfferMutation = { readonly __typename?: 'Mutation', readonly assignPenaltyToOffer: { readonly __typename?: 'UserInfluencerPenaltyReport', readonly id: string, readonly advAccountId?: string | null, readonly body: string, readonly createdAt: string, readonly kind: number, readonly offerId?: string | null, readonly penaltyReasonId?: string | null, readonly score?: number | null, readonly status: number, readonly updatedAt: string, readonly userInfluencerId: string } };

export type PenaltyReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type PenaltyReasonsQuery = { readonly __typename?: 'Query', readonly penaltyReasons: ReadonlyArray<{ readonly __typename?: 'PenaltyReason', readonly id: string, readonly name: string }> };

export type BillingReportQueryVariables = Exact<{
  input: BillingReportInput;
}>;


export type BillingReportQuery = { readonly __typename?: 'Query', readonly billingReport: { readonly __typename?: 'BillingReport', readonly billingMonth: string, readonly campaignsFixedFee: number, readonly campaignsUnsettledFee: number, readonly hasCampaignRecruitmentFee: boolean, readonly subtotal: number, readonly ticketsFee: number, readonly totalAmount: number, readonly totalTax: number, readonly expenseFixedFee: number, readonly expenseUnsettledFee: number, readonly campaignInvoiceDetails: ReadonlyArray<{ readonly __typename?: 'CampaignInvoiceDetail', readonly campaign?: { readonly __typename?: 'Campaign', readonly id: string, readonly name: string, readonly gross?: number | null, readonly offerStarted?: string | null, readonly offerEnded?: string | null, readonly coverImageUrls: ReadonlyArray<{ readonly __typename?: 'ImageUrl', readonly original: string, readonly small: string, readonly medium: string }>, readonly campaignSnsRequirements: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirement', readonly id: string, readonly snsType: CampaignSnsRequirementSnsType, readonly postFooter: string, readonly requestUrl?: string | null, readonly tagList: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirementTag', readonly id: string, readonly languageType: LanguageType, readonly tags: ReadonlyArray<string> }> }> } | null, readonly fixedFeeDetail: { readonly __typename?: 'FixedFeeDetail', readonly postedReward: number, readonly recruitmentFee: number, readonly recruitmentFeeWithTax: number, readonly totalTax: number }, readonly unsettledFeeDetail: { readonly __typename?: 'UnsettledFeeDetail', readonly postedReward: number, readonly recruitmentFee: number, readonly recruitmentFeeWithTax: number, readonly totalTax: number } }>, readonly campaignExpenseInvoiceDetails: ReadonlyArray<{ readonly __typename?: 'CampaignExpenseInvoiceDetail', readonly campaign?: { readonly __typename?: 'Campaign', readonly id: string, readonly name: string, readonly gross?: number | null, readonly offerStarted?: string | null, readonly offerEnded?: string | null, readonly coverImageUrls: ReadonlyArray<{ readonly __typename?: 'ImageUrl', readonly original: string, readonly small: string, readonly medium: string }>, readonly campaignSnsRequirements: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirement', readonly id: string, readonly snsType: CampaignSnsRequirementSnsType, readonly snsPostTypeList: ReadonlyArray<CampaignSnsRequirementSnsPostType>, readonly postFooter: string, readonly requestUrl?: string | null, readonly tagList: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirementTag', readonly id: string, readonly languageType: LanguageType, readonly tags: ReadonlyArray<string> }> }> } | null, readonly expenseFixedFeeDetail: { readonly __typename?: 'FixedExpenseFeeDetail', readonly expenseFee: number }, readonly expenseUnsettledFeeDetail: { readonly __typename?: 'UnsettledExpenseFeeDetail', readonly expenseFee: number } }>, readonly ticketSubscriptionInvoiceDetails: ReadonlyArray<{ readonly __typename?: 'SubscriptionInvoiceDetail', readonly id: string, readonly billingDate: string, readonly name: string, readonly paymentType: SubscriptionInvoiceDetailPaymentType, readonly price: number, readonly status: SubscriptionInvoiceDetailStatus, readonly tax: number, readonly taxIncludedPrice: number, readonly ticketSubscription: { readonly __typename?: 'TicketSubscription', readonly cancellationRequestedAt?: string | null, readonly description?: string | null, readonly endedAt?: string | null, readonly id: string, readonly name: string, readonly startedAt: string, readonly nextBillingPrice?: number | null, readonly minCancellableDatetime: string, readonly minimumUpdateCount: number, readonly cancellationTiming: CancellationTiming, readonly subscriptionModelId: number, readonly latestSubscriptionRenewal: { readonly __typename?: 'SubscriptionRenewal', readonly id: string, readonly renewalDate: string, readonly subscriptionInvoiceDetail?: { readonly __typename?: 'SubscriptionInvoiceDetail', readonly status: SubscriptionInvoiceDetailStatus } | null }, readonly subscriptionRenewals: { readonly __typename?: 'SubscriptionRenewalConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'SubscriptionRenewalEdge', readonly cursor: string, readonly node: { readonly __typename?: 'SubscriptionRenewal', readonly id: string, readonly renewalDate: string } }>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly hasPreviousPage: boolean, readonly startCursor?: string | null, readonly endCursor?: string | null } } } }> } };

export type DisableRegularlyPublishedCampaignMutationVariables = Exact<{
  input: DisableRegularlyPublishedCampaignInput;
}>;


export type DisableRegularlyPublishedCampaignMutation = { readonly __typename?: 'Mutation', readonly disableRegularlyPublishedCampaign: { readonly __typename?: 'RegularlyPublishedCampaign', readonly id: string } };

export type EnableRegularlyPublishedCampaignMutationVariables = Exact<{
  input: EnableRegularlyPublishedCampaignInput;
}>;


export type EnableRegularlyPublishedCampaignMutation = { readonly __typename?: 'Mutation', readonly enableRegularlyPublishedCampaign: { readonly __typename?: 'RegularlyPublishedCampaign', readonly id: string } };

export type CreateCompanySnsConnectionMutationVariables = Exact<{
  input: CreateCompanySnsConnectionInput;
}>;


export type CreateCompanySnsConnectionMutation = { readonly __typename?: 'Mutation', readonly createCompanySnsConnection?: { readonly __typename?: 'CompanySnsConnection', readonly id: string, readonly name: string, readonly uid: string, readonly nextTokenUpdateAt: string, readonly provider: CompanySnsConnectionProvider, readonly imageUrl?: string | null, readonly needTokenUpdate: boolean } | null };

export type RemoveCompanySnsConnectionMutationVariables = Exact<{
  input: RemoveCompanySnsConnectionInput;
}>;


export type RemoveCompanySnsConnectionMutation = { readonly __typename?: 'Mutation', readonly removeCompanySnsConnection?: string | null };

export type UpdateAccessTokenMutationVariables = Exact<{
  input: UpdateAccessTokenInput;
}>;


export type UpdateAccessTokenMutation = { readonly __typename?: 'Mutation', readonly updateAccessToken?: { readonly __typename?: 'CompanySnsConnection', readonly id: string, readonly name: string, readonly uid: string, readonly nextTokenUpdateAt: string, readonly provider: CompanySnsConnectionProvider, readonly imageUrl?: string | null, readonly needTokenUpdate: boolean } | null };

export type GetLongLiveAccessTokenQueryVariables = Exact<{
  shortLiveAccessToken: Scalars['String']['input'];
}>;


export type GetLongLiveAccessTokenQuery = { readonly __typename?: 'Query', readonly facebookLongLiveAccessToken: string };

export type ApplySubscriptionMutationVariables = Exact<{
  input: ApplySubscriptionInput;
}>;


export type ApplySubscriptionMutation = { readonly __typename?: 'Mutation', readonly applySubscription?: { readonly __typename?: 'TicketSubscription', readonly cancellationRequestedAt?: string | null, readonly description?: string | null, readonly endedAt?: string | null, readonly id: string, readonly name: string, readonly startedAt: string, readonly nextBillingPrice?: number | null, readonly minCancellableDatetime: string, readonly minimumUpdateCount: number, readonly cancellationTiming: CancellationTiming, readonly subscriptionModelId: number, readonly latestSubscriptionRenewal: { readonly __typename?: 'SubscriptionRenewal', readonly id: string, readonly renewalDate: string, readonly subscriptionInvoiceDetail?: { readonly __typename?: 'SubscriptionInvoiceDetail', readonly status: SubscriptionInvoiceDetailStatus } | null }, readonly subscriptionRenewals: { readonly __typename?: 'SubscriptionRenewalConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'SubscriptionRenewalEdge', readonly cursor: string, readonly node: { readonly __typename?: 'SubscriptionRenewal', readonly id: string, readonly renewalDate: string } }>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly hasPreviousPage: boolean, readonly startCursor?: string | null, readonly endCursor?: string | null } } } | null };

export type ApplySubscriptionByCodeMutationVariables = Exact<{
  input: ApplySubscriptionByCodeInput;
}>;


export type ApplySubscriptionByCodeMutation = { readonly __typename?: 'Mutation', readonly applySubscriptionByCode?: { readonly __typename?: 'TicketSubscription', readonly id: string } | null };

export type RevokeSubscriptionCancellationMutationVariables = Exact<{
  input: RevokeSubscriptionCancellationInput;
}>;


export type RevokeSubscriptionCancellationMutation = { readonly __typename?: 'Mutation', readonly revokeSubscriptionCancellation?: { readonly __typename?: 'TicketSubscription', readonly cancellationRequestedAt?: string | null, readonly description?: string | null, readonly endedAt?: string | null, readonly id: string, readonly name: string, readonly startedAt: string, readonly nextBillingPrice?: number | null, readonly minCancellableDatetime: string, readonly minimumUpdateCount: number, readonly cancellationTiming: CancellationTiming, readonly subscriptionModelId: number, readonly latestSubscriptionRenewal: { readonly __typename?: 'SubscriptionRenewal', readonly id: string, readonly renewalDate: string, readonly subscriptionInvoiceDetail?: { readonly __typename?: 'SubscriptionInvoiceDetail', readonly status: SubscriptionInvoiceDetailStatus } | null }, readonly subscriptionRenewals: { readonly __typename?: 'SubscriptionRenewalConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'SubscriptionRenewalEdge', readonly cursor: string, readonly node: { readonly __typename?: 'SubscriptionRenewal', readonly id: string, readonly renewalDate: string } }>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly hasPreviousPage: boolean, readonly startCursor?: string | null, readonly endCursor?: string | null } } } | null };

export type ScheduleSubscriptionCancellationMutationVariables = Exact<{
  input: ScheduleSubscriptionCancellationInput;
}>;


export type ScheduleSubscriptionCancellationMutation = { readonly __typename?: 'Mutation', readonly scheduleSubscriptionCancellation?: { readonly __typename?: 'TicketSubscription', readonly cancellationRequestedAt?: string | null, readonly description?: string | null, readonly endedAt?: string | null, readonly id: string, readonly name: string, readonly startedAt: string, readonly nextBillingPrice?: number | null, readonly minCancellableDatetime: string, readonly minimumUpdateCount: number, readonly cancellationTiming: CancellationTiming, readonly subscriptionModelId: number, readonly latestSubscriptionRenewal: { readonly __typename?: 'SubscriptionRenewal', readonly id: string, readonly renewalDate: string, readonly subscriptionInvoiceDetail?: { readonly __typename?: 'SubscriptionInvoiceDetail', readonly status: SubscriptionInvoiceDetailStatus } | null }, readonly subscriptionRenewals: { readonly __typename?: 'SubscriptionRenewalConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'SubscriptionRenewalEdge', readonly cursor: string, readonly node: { readonly __typename?: 'SubscriptionRenewal', readonly id: string, readonly renewalDate: string } }>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly hasPreviousPage: boolean, readonly startCursor?: string | null, readonly endCursor?: string | null } } } | null };

export type SubscriptionModelByCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type SubscriptionModelByCodeQuery = { readonly __typename?: 'Query', readonly subscriptionModelByCode: { readonly __typename?: 'SubscriptionModel', readonly id: string, readonly name: string, readonly description?: string | null, readonly initialPrice: number, readonly price: number, readonly initialIssueTicketCount: number, readonly issueTicketCount: number, readonly ticketModelId?: string | null } };

export type TicketSubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type TicketSubscriptionsQuery = { readonly __typename?: 'Query', readonly viewer: { readonly __typename?: 'Advertiser', readonly canCancelSubscription: boolean, readonly ticketSubscriptions?: ReadonlyArray<{ readonly __typename?: 'TicketSubscription', readonly cancellationRequestedAt?: string | null, readonly description?: string | null, readonly endedAt?: string | null, readonly id: string, readonly name: string, readonly startedAt: string, readonly nextBillingPrice?: number | null, readonly minCancellableDatetime: string, readonly minimumUpdateCount: number, readonly cancellationTiming: CancellationTiming, readonly subscriptionModelId: number, readonly latestSubscriptionRenewal: { readonly __typename?: 'SubscriptionRenewal', readonly id: string, readonly renewalDate: string, readonly subscriptionInvoiceDetail?: { readonly __typename?: 'SubscriptionInvoiceDetail', readonly status: SubscriptionInvoiceDetailStatus } | null }, readonly subscriptionRenewals: { readonly __typename?: 'SubscriptionRenewalConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'SubscriptionRenewalEdge', readonly cursor: string, readonly node: { readonly __typename?: 'SubscriptionRenewal', readonly id: string, readonly renewalDate: string } }>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly hasPreviousPage: boolean, readonly startCursor?: string | null, readonly endCursor?: string | null } } }> | null } };

export type SubscriptionModelsQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionModelsQuery = { readonly __typename?: 'Query', readonly subscriptionModels: ReadonlyArray<{ readonly __typename?: 'SubscriptionModel', readonly id: string, readonly name: string, readonly description?: string | null, readonly initialPrice: number, readonly price: number, readonly initialIssueTicketCount: number, readonly issueTicketCount: number, readonly ticketModelId?: string | null }> };

export type InstagramInsightFragment = { readonly __typename?: 'DailyInstagramInsight', readonly date: string, readonly followerCount: number, readonly siteClickCount: number, readonly profileViewCount: number, readonly reachCount: number, readonly dailyPrPostCount: number };

export type AgreeAdGuidelineMutationVariables = Exact<{ [key: string]: never; }>;


export type AgreeAdGuidelineMutation = { readonly __typename?: 'Mutation', readonly agreeAdGuideline: { readonly __typename?: 'AdGuideline', readonly agreedVersion?: string | null, readonly latestVersion: string, readonly needAgree: boolean, readonly url: string } };

export type DeleteCompanyShopTemplateMutationVariables = Exact<{
  input: DeleteCompanyShopTemplateInput;
}>;


export type DeleteCompanyShopTemplateMutation = { readonly __typename?: 'Mutation', readonly deleteCompanyShopTemplateMut?: { readonly __typename?: 'CampaignLocation', readonly streetAddress?: string | null, readonly buildingName?: string | null, readonly cityName?: string | null, readonly cityCode?: string | null, readonly id: string, readonly name?: string | null, readonly stationCode?: string | null, readonly stationName?: string | null, readonly postalCode?: string | null, readonly prefectureCode?: Pref | null, readonly tel?: string | null } | null };

export type AvailableAndRevisionCampaignsQueryVariables = Exact<{
  orderBy?: CampaignOrder;
  excludeYouTube?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AvailableAndRevisionCampaignsQuery = { readonly __typename?: 'Query', readonly viewer: { readonly __typename?: 'Advertiser', readonly availableCampaigns: ReadonlyArray<{ readonly __typename?: 'Campaign', readonly id: string, readonly companyId: string, readonly name: string, readonly question?: string | null, readonly gross?: number | null, readonly projectType?: ProjectType | null, readonly companySelectGenre?: Genre | null, readonly companySelectSearchGenre?: SearchGenre | null, readonly status: CampaignStatus, readonly category: CampaignCategory, readonly gender: CampaignGender, readonly scheduleType: CampaignScheduleType, readonly sponsorService?: string | null, readonly sponsorServicePrice?: number | null, readonly sponsorServicePriceIntax?: number | null, readonly summary?: string | null, readonly url?: string | null, readonly reservation: Reservation, readonly wantInfluencer?: string | null, readonly ageLimit?: AgeLimit | null, readonly offerEnded?: string | null, readonly useIdentificationTicket: boolean, readonly basicGross?: number | null, readonly campaignRequirementOptionSpecifiedPrText?: string | null, readonly campaignRequirementOptions: ReadonlyArray<CampaignRequirementOptions>, readonly guidance?: string | null, readonly maxCompanionCount?: number | null, readonly prTargetAge?: ReadonlyArray<PrTargetAge> | null, readonly prTargetGender?: PrTargetGender | null, readonly shopTemplateId?: string | null, readonly subGenre: ReadonlyArray<string>, readonly formatVersion: FormatVersion, readonly desiredLanguages: ReadonlyArray<LanguageType>, readonly costHandlingMethod?: CampaignCostHandlingMethod | null, readonly influencerBurdenRate: number, readonly expenseEvidenceType: ExpenseEvidenceType, readonly campaignSnsRequirements: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirement', readonly id: string, readonly requestUrl?: string | null, readonly snsPostTypeList: ReadonlyArray<CampaignSnsRequirementSnsPostType>, readonly snsType: CampaignSnsRequirementSnsType, readonly snsPostRedirectUrl?: string | null, readonly postFooter: string, readonly tagList: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirementTag', readonly id: string, readonly languageType: LanguageType, readonly tags: ReadonlyArray<string> }> }>, readonly coverImageUrls: ReadonlyArray<{ readonly __typename?: 'ImageUrl', readonly original: string }>, readonly regularlyPublishedCampaigns?: { readonly __typename?: 'RegularlyPublishedCampaign', readonly status: RegularlyPublishedCampaignStatus } | null, readonly location?: { readonly __typename?: 'CampaignLocation', readonly id: string, readonly postalCode?: string | null, readonly prefectureCode?: Pref | null, readonly cityCode?: string | null, readonly cityName?: string | null, readonly streetAddress?: string | null, readonly buildingName?: string | null, readonly stationCode?: string | null, readonly stationName?: string | null, readonly name?: string | null, readonly tel?: string | null, readonly createdAt: string, readonly updatedAt: string } | null, readonly reservableWeeklySchedule: ReadonlyArray<{ readonly __typename?: 'CampaignReservableWeeklySchedule', readonly id: string, readonly possibleMinutes: number, readonly weekDay: WeekDay }> }>, readonly revisionCampaigns: ReadonlyArray<{ readonly __typename?: 'Campaign', readonly id: string, readonly companyId: string, readonly name: string, readonly question?: string | null, readonly gross?: number | null, readonly projectType?: ProjectType | null, readonly companySelectGenre?: Genre | null, readonly companySelectSearchGenre?: SearchGenre | null, readonly status: CampaignStatus, readonly category: CampaignCategory, readonly gender: CampaignGender, readonly scheduleType: CampaignScheduleType, readonly sponsorService?: string | null, readonly sponsorServicePrice?: number | null, readonly sponsorServicePriceIntax?: number | null, readonly summary?: string | null, readonly url?: string | null, readonly reservation: Reservation, readonly wantInfluencer?: string | null, readonly ageLimit?: AgeLimit | null, readonly offerEnded?: string | null, readonly useIdentificationTicket: boolean, readonly basicGross?: number | null, readonly campaignRequirementOptionSpecifiedPrText?: string | null, readonly campaignRequirementOptions: ReadonlyArray<CampaignRequirementOptions>, readonly guidance?: string | null, readonly maxCompanionCount?: number | null, readonly prTargetAge?: ReadonlyArray<PrTargetAge> | null, readonly prTargetGender?: PrTargetGender | null, readonly shopTemplateId?: string | null, readonly subGenre: ReadonlyArray<string>, readonly formatVersion: FormatVersion, readonly desiredLanguages: ReadonlyArray<LanguageType>, readonly costHandlingMethod?: CampaignCostHandlingMethod | null, readonly influencerBurdenRate: number, readonly expenseEvidenceType: ExpenseEvidenceType, readonly campaignSnsRequirements: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirement', readonly id: string, readonly requestUrl?: string | null, readonly snsPostTypeList: ReadonlyArray<CampaignSnsRequirementSnsPostType>, readonly snsType: CampaignSnsRequirementSnsType, readonly snsPostRedirectUrl?: string | null, readonly postFooter: string, readonly tagList: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirementTag', readonly id: string, readonly languageType: LanguageType, readonly tags: ReadonlyArray<string> }> }>, readonly coverImageUrls: ReadonlyArray<{ readonly __typename?: 'ImageUrl', readonly original: string }>, readonly regularlyPublishedCampaigns?: { readonly __typename?: 'RegularlyPublishedCampaign', readonly status: RegularlyPublishedCampaignStatus } | null, readonly location?: { readonly __typename?: 'CampaignLocation', readonly id: string, readonly postalCode?: string | null, readonly prefectureCode?: Pref | null, readonly cityCode?: string | null, readonly cityName?: string | null, readonly streetAddress?: string | null, readonly buildingName?: string | null, readonly stationCode?: string | null, readonly stationName?: string | null, readonly name?: string | null, readonly tel?: string | null, readonly createdAt: string, readonly updatedAt: string } | null, readonly reservableWeeklySchedule: ReadonlyArray<{ readonly __typename?: 'CampaignReservableWeeklySchedule', readonly id: string, readonly possibleMinutes: number, readonly weekDay: WeekDay }> }>, readonly company?: { readonly __typename?: 'Company', readonly id: string, readonly availableTickets: ReadonlyArray<{ readonly __typename?: 'IssuedTicket', readonly cancelAt?: string | null, readonly consumedAt?: string | null, readonly createdAt: string, readonly expiredAt: string, readonly id: string, readonly name: string, readonly category: TicketModelCategory, readonly campaign?: { readonly __typename?: 'Campaign', readonly id: string, readonly companyId: string, readonly name: string, readonly companySelectSearchGenre?: SearchGenre | null, readonly offerStarted?: string | null, readonly offerEnded?: string | null, readonly selectionMaxLimit?: number | null, readonly offersCount: number, readonly expenseEvidenceType: ExpenseEvidenceType, readonly thumbnailUrls: ReadonlyArray<string>, readonly question?: string | null, readonly gross?: number | null, readonly projectType?: ProjectType | null, readonly offeringCapacity?: number | null, readonly status: CampaignStatus, readonly scheduleType: CampaignScheduleType, readonly useIdentificationTicket: boolean, readonly category: CampaignCategory, readonly approvedAt?: string | null, readonly ageLimit?: AgeLimit | null, readonly sponsorServicePriceIntax?: number | null, readonly sponsorServicePrice?: number | null, readonly url?: string | null, readonly offerAutoMessage?: string | null, readonly attention?: string | null, readonly gender: CampaignGender, readonly sponsorService?: string | null, readonly summary?: string | null, readonly wantInfluencer?: string | null, readonly nearestStation?: string | null, readonly canTakeBack: boolean, readonly companion: Companion, readonly createdAt: string, readonly basicGross?: number | null, readonly campaignRequirementOptionSpecifiedPrText?: string | null, readonly campaignRequirementOptions: ReadonlyArray<CampaignRequirementOptions>, readonly guidance?: string | null, readonly maxCompanionCount?: number | null, readonly prTargetAge?: ReadonlyArray<PrTargetAge> | null, readonly prTargetGender?: PrTargetGender | null, readonly shopTemplateId?: string | null, readonly subGenre: ReadonlyArray<string>, readonly formatVersion: FormatVersion, readonly desiredLanguages: ReadonlyArray<LanguageType>, readonly costHandlingMethod?: CampaignCostHandlingMethod | null, readonly influencerBurdenRate: number, readonly campaignSnsRequirements: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirement', readonly id: string, readonly requestUrl?: string | null, readonly snsPostTypeList: ReadonlyArray<CampaignSnsRequirementSnsPostType>, readonly snsType: CampaignSnsRequirementSnsType, readonly snsPostRedirectUrl?: string | null, readonly postFooter: string, readonly tagList: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirementTag', readonly id: string, readonly languageType: LanguageType, readonly tags: ReadonlyArray<string> }> }>, readonly coverImageUrls: ReadonlyArray<{ readonly __typename?: 'ImageUrl', readonly original: string, readonly medium: string, readonly small: string }>, readonly regularlyPublishedCampaigns?: { readonly __typename?: 'RegularlyPublishedCampaign', readonly executionDay?: number | null, readonly status: RegularlyPublishedCampaignStatus } | null, readonly campaignReviewResults: ReadonlyArray<{ readonly __typename?: 'CampaignReviewResult', readonly id: string, readonly reviewSection: ReviewSection, readonly campaignReviews: ReadonlyArray<{ readonly __typename?: 'CampaignReview', readonly id: string, readonly isChecked?: boolean | null, readonly reviewTarget: ReviewTarget, readonly sendBackReason: string }> }>, readonly location?: { readonly __typename?: 'CampaignLocation', readonly id: string, readonly postalCode?: string | null, readonly prefectureCode?: Pref | null, readonly cityCode?: string | null, readonly cityName?: string | null, readonly streetAddress?: string | null, readonly buildingName?: string | null, readonly stationCode?: string | null, readonly stationName?: string | null, readonly name?: string | null, readonly tel?: string | null, readonly createdAt: string, readonly updatedAt: string } | null, readonly entriesCountByStatus: { readonly __typename?: 'CampaignEntriesCount', readonly APPLIED: number, readonly APPROVED: number, readonly DECLINED: number, readonly BLOCKED: number, readonly ETC: number }, readonly reservableWeeklySchedule: ReadonlyArray<{ readonly __typename?: 'CampaignReservableWeeklySchedule', readonly id: string, readonly possibleMinutes: number, readonly weekDay: WeekDay }> } | null }> } | null } };

export type CampaignEntriesNewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderby?: CampaignEntriesOrder;
  pinned?: InputMaybe<Pinned>;
  gender?: InputMaybe<Gender>;
  ageRange?: InputMaybe<AgeRange>;
}>;


export type CampaignEntriesNewQuery = { readonly __typename?: 'Query', readonly campaign?: { readonly __typename?: 'Campaign', readonly id: string, readonly companyId: string, readonly name: string, readonly companySelectSearchGenre?: SearchGenre | null, readonly offerStarted?: string | null, readonly offerEnded?: string | null, readonly selectionMaxLimit?: number | null, readonly offersCount: number, readonly expenseEvidenceType: ExpenseEvidenceType, readonly thumbnailUrls: ReadonlyArray<string>, readonly question?: string | null, readonly gross?: number | null, readonly projectType?: ProjectType | null, readonly offeringCapacity?: number | null, readonly status: CampaignStatus, readonly scheduleType: CampaignScheduleType, readonly useIdentificationTicket: boolean, readonly category: CampaignCategory, readonly approvedAt?: string | null, readonly ageLimit?: AgeLimit | null, readonly sponsorServicePriceIntax?: number | null, readonly sponsorServicePrice?: number | null, readonly url?: string | null, readonly offerAutoMessage?: string | null, readonly attention?: string | null, readonly gender: CampaignGender, readonly sponsorService?: string | null, readonly summary?: string | null, readonly wantInfluencer?: string | null, readonly nearestStation?: string | null, readonly canTakeBack: boolean, readonly companion: Companion, readonly createdAt: string, readonly basicGross?: number | null, readonly campaignRequirementOptionSpecifiedPrText?: string | null, readonly campaignRequirementOptions: ReadonlyArray<CampaignRequirementOptions>, readonly guidance?: string | null, readonly maxCompanionCount?: number | null, readonly prTargetAge?: ReadonlyArray<PrTargetAge> | null, readonly prTargetGender?: PrTargetGender | null, readonly shopTemplateId?: string | null, readonly subGenre: ReadonlyArray<string>, readonly formatVersion: FormatVersion, readonly desiredLanguages: ReadonlyArray<LanguageType>, readonly costHandlingMethod?: CampaignCostHandlingMethod | null, readonly influencerBurdenRate: number, readonly entries: { readonly __typename?: 'CampaignEntryConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CampaignEntryEdge', readonly node: { readonly __typename?: 'CampaignEntry', readonly id: string, readonly campaignId: string, readonly snsType: Provider, readonly pinned: Pinned, readonly status: CampaignEntryStatus, readonly createdAt: string, readonly updatedAt: string, readonly expiredAt: string, readonly answer?: string | null, readonly companionCount?: number | null, readonly prPostLanguage?: LanguageType | null, readonly campaign?: { readonly __typename?: 'Campaign', readonly id: string, readonly question?: string | null, readonly category: CampaignCategory } | null, readonly insight?: { readonly __typename?: 'InstagramInsight', readonly reach28: { readonly __typename?: 'Reach28Unit', readonly value?: number | null }, readonly impressions: { readonly __typename?: 'ImpressionsUnit', readonly value?: number | null }, readonly profileViews: { readonly __typename?: 'ProfileViewsUnit', readonly value?: number | null }, readonly reach: { readonly __typename?: 'ReachUnit', readonly value?: number | null }, readonly genderRate: { readonly __typename?: 'GenderRateUnit', readonly value?: { readonly __typename?: 'GenderRate', readonly M: number, readonly F: number, readonly U: number } | null }, readonly ageRate: { readonly __typename?: 'AgeRateUnit', readonly value?: { readonly __typename?: 'AgeRate', readonly from13To17: number, readonly from18To24: number, readonly from25To34: number, readonly from35To44: number, readonly from45To54: number, readonly from55To64: number, readonly over65: number } | null }, readonly maleAgeRate: { readonly __typename?: 'MaleAgeRateUnit', readonly value?: { readonly __typename?: 'AgeRate', readonly from13To17: number, readonly from18To24: number, readonly from25To34: number, readonly from35To44: number, readonly from45To54: number, readonly from55To64: number, readonly over65: number } | null }, readonly femaleAgeRate: { readonly __typename?: 'FemaleAgeRateUnit', readonly value?: { readonly __typename?: 'AgeRate', readonly from13To17: number, readonly from18To24: number, readonly from25To34: number, readonly from35To44: number, readonly from45To54: number, readonly from55To64: number, readonly over65: number } | null }, readonly postCommentCount: { readonly __typename?: 'PostCommentCountUnit', readonly value?: number | null }, readonly postLikeCount: { readonly __typename?: 'PostLikeCountUnit', readonly value?: number | null }, readonly postImpressions: { readonly __typename?: 'PostImpressionsUnit', readonly value?: number | null }, readonly postReach: { readonly __typename?: 'PostReachUnit', readonly value?: number | null }, readonly postEngagement: { readonly __typename?: 'PostEngagementUnit', readonly value?: number | null } } | null, readonly candidateSchedules: ReadonlyArray<{ readonly __typename?: 'CampaignEntryCandidateSchedule', readonly id: string, readonly candidateSchedule: string }>, readonly engagementPrediction?: { readonly __typename?: 'CampaignEntryEngagementPrediction', readonly engagementPredLower?: number | null, readonly engagementPredUpper?: number | null } | null, readonly reachPrediction?: { readonly __typename?: 'CampaignEntryReachPrediction', readonly reachPred?: number | null, readonly reachClass?: number | null, readonly reachPredLower?: number | null, readonly reachPredUpper?: number | null } | null, readonly impressionPrediction?: { readonly __typename?: 'CampaignEntryImpressionPrediction', readonly impressionPred?: number | null, readonly impressionClass?: number | null, readonly impressionPredLower?: number | null, readonly impressionPredUpper?: number | null } | null, readonly influencer: { readonly __typename?: 'Influencer', readonly comment?: string | null, readonly id: string, readonly idpId?: string | null, readonly name?: string | null, readonly gender: Gender, readonly birthday?: string | null, readonly imageUrl?: string | null, readonly age?: number | null, readonly latestAccessTime?: string | null, readonly completeCountLevel: CompleteCountLevel, readonly approvedCount: number, readonly activeSnsConnections: { readonly __typename?: 'ActiveSnsConnections', readonly twitter?: { readonly __typename?: 'TwitterConnection', readonly name: string, readonly uid: string, readonly followerCount: number, readonly imageUrl?: string | null, readonly postCount: number, readonly linked: Linked, readonly url: string } | null, readonly youtube?: { readonly __typename?: 'YouTubeConnection', readonly name: string, readonly uid: string, readonly imageUrl?: string | null, readonly followerCount: number, readonly linked: Linked, readonly postCount: number, readonly url: string } | null, readonly instagram?: { readonly __typename?: 'InstagramConnection', readonly name: string, readonly uid: string, readonly followerCount: number, readonly imageUrl?: string | null, readonly postCount: number, readonly linked: Linked, readonly url: string } | null, readonly tiktok?: { readonly __typename?: 'TikTokConnection', readonly name: string, readonly uid: string, readonly imageUrl?: string | null, readonly followerCount: number, readonly postCount: number, readonly linked: Linked, readonly url: string } | null } } } }>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly hasPreviousPage: boolean, readonly startCursor?: string | null, readonly endCursor?: string | null } }, readonly campaignSnsRequirements: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirement', readonly id: string, readonly requestUrl?: string | null, readonly snsPostTypeList: ReadonlyArray<CampaignSnsRequirementSnsPostType>, readonly snsType: CampaignSnsRequirementSnsType, readonly snsPostRedirectUrl?: string | null, readonly postFooter: string, readonly tagList: ReadonlyArray<{ readonly __typename?: 'CampaignSnsRequirementTag', readonly id: string, readonly languageType: LanguageType, readonly tags: ReadonlyArray<string> }> }>, readonly coverImageUrls: ReadonlyArray<{ readonly __typename?: 'ImageUrl', readonly original: string, readonly medium: string, readonly small: string }>, readonly regularlyPublishedCampaigns?: { readonly __typename?: 'RegularlyPublishedCampaign', readonly executionDay?: number | null, readonly status: RegularlyPublishedCampaignStatus } | null, readonly campaignReviewResults: ReadonlyArray<{ readonly __typename?: 'CampaignReviewResult', readonly id: string, readonly reviewSection: ReviewSection, readonly campaignReviews: ReadonlyArray<{ readonly __typename?: 'CampaignReview', readonly id: string, readonly isChecked?: boolean | null, readonly reviewTarget: ReviewTarget, readonly sendBackReason: string }> }>, readonly location?: { readonly __typename?: 'CampaignLocation', readonly id: string, readonly postalCode?: string | null, readonly prefectureCode?: Pref | null, readonly cityCode?: string | null, readonly cityName?: string | null, readonly streetAddress?: string | null, readonly buildingName?: string | null, readonly stationCode?: string | null, readonly stationName?: string | null, readonly name?: string | null, readonly tel?: string | null, readonly createdAt: string, readonly updatedAt: string } | null, readonly entriesCountByStatus: { readonly __typename?: 'CampaignEntriesCount', readonly APPLIED: number, readonly APPROVED: number, readonly DECLINED: number, readonly BLOCKED: number, readonly ETC: number }, readonly reservableWeeklySchedule: ReadonlyArray<{ readonly __typename?: 'CampaignReservableWeeklySchedule', readonly id: string, readonly possibleMinutes: number, readonly weekDay: WeekDay }> } | null };

export type ConnectedLineGroupQueryVariables = Exact<{ [key: string]: never; }>;


export type ConnectedLineGroupQuery = { readonly __typename?: 'Query', readonly viewer: { readonly __typename?: 'Advertiser', readonly company?: { readonly __typename?: 'Company', readonly connectedLineGroup: boolean } | null } };

export type DailyInsightQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  snsConnectId: Scalars['ID']['input'];
}>;


export type DailyInsightQuery = { readonly __typename?: 'Query', readonly viewer: { readonly __typename?: 'Advertiser', readonly company?: { readonly __typename?: 'Company', readonly snsConnections: ReadonlyArray<{ readonly __typename?: 'CompanySnsConnection', readonly id: string, readonly connectedAt: string, readonly dailyInstagramInsight?: ReadonlyArray<{ readonly __typename?: 'DailyInstagramInsight', readonly date: string, readonly followerCount: number, readonly siteClickCount: number, readonly profileViewCount: number, readonly reachCount: number, readonly dailyPrPostCount: number }> | null }> } | null } };

export type CompanyShopTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyShopTemplatesQuery = { readonly __typename?: 'Query', readonly viewer: { readonly __typename?: 'Advertiser', readonly companyShopTemplates: ReadonlyArray<{ readonly __typename?: 'CampaignLocation', readonly streetAddress?: string | null, readonly buildingName?: string | null, readonly cityName?: string | null, readonly cityCode?: string | null, readonly id: string, readonly name?: string | null, readonly stationCode?: string | null, readonly stationName?: string | null, readonly postalCode?: string | null, readonly prefectureCode?: Pref | null, readonly tel?: string | null }> } };

export type TodoOffersQueryVariables = Exact<{ [key: string]: never; }>;


export type TodoOffersQuery = { readonly __typename?: 'Query', readonly viewer: { readonly __typename?: 'Advertiser', readonly company?: { readonly __typename?: 'Company', readonly id: string, readonly todoOffers?: ReadonlyArray<{ readonly __typename?: 'TodoOffer', readonly id: string, readonly hasCompanyTodo: boolean, readonly hasReplyTodo: boolean, readonly hasUnreadMessage: boolean, readonly offer: { readonly __typename?: 'Offer', readonly id: string, readonly snsType: Provider, readonly delivered?: boolean | null, readonly influencer: { readonly __typename?: 'Influencer', readonly id: string, readonly name?: string | null, readonly imageUrl?: string | null, readonly birthday?: string | null, readonly gender: Gender, readonly activeSnsConnections: { readonly __typename?: 'ActiveSnsConnections', readonly twitter?: { readonly __typename?: 'TwitterConnection', readonly name: string, readonly uid: string, readonly followerCount: number, readonly imageUrl?: string | null, readonly postCount: number, readonly linked: Linked, readonly url: string } | null, readonly youtube?: { readonly __typename?: 'YouTubeConnection', readonly name: string, readonly uid: string, readonly imageUrl?: string | null, readonly followerCount: number, readonly linked: Linked, readonly postCount: number, readonly url: string } | null, readonly instagram?: { readonly __typename?: 'InstagramConnection', readonly name: string, readonly uid: string, readonly followerCount: number, readonly imageUrl?: string | null, readonly postCount: number, readonly linked: Linked, readonly url: string } | null, readonly tiktok?: { readonly __typename?: 'TikTokConnection', readonly name: string, readonly uid: string, readonly imageUrl?: string | null, readonly followerCount: number, readonly postCount: number, readonly linked: Linked, readonly url: string } | null } }, readonly latestMessage?: { readonly __typename?: 'Message', readonly id: string, readonly body: string, readonly readStatus: ReadStatus, readonly sender: Sender, readonly createdAt: string } | null, readonly latestTransition?: { readonly __typename?: 'OfferStateTransition', readonly id: string, readonly action: OfferStateTransitionAction, readonly createdAt: string, readonly deadline?: string | null } | null, readonly campaign?: { readonly __typename?: 'Campaign', readonly id: string, readonly name: string, readonly thumbnailUrls: ReadonlyArray<string>, readonly costHandlingMethod?: CampaignCostHandlingMethod | null, readonly influencerBurdenRate: number, readonly expenseEvidenceType: ExpenseEvidenceType, readonly coverImageUrls: ReadonlyArray<{ readonly __typename?: 'ImageUrl', readonly original: string, readonly medium: string, readonly small: string }> } | null } }> | null } | null } };

export type TodoOfferTodosFragment = { readonly __typename?: 'TodoOffer', readonly id: string, readonly hasCompanyTodo: boolean, readonly hasReplyTodo: boolean, readonly hasUnreadMessage: boolean };

export type TutorialQueryVariables = Exact<{ [key: string]: never; }>;


export type TutorialQuery = { readonly __typename?: 'Query', readonly viewer: { readonly __typename?: 'Advertiser', readonly company?: { readonly __typename?: 'Company', readonly id: string, readonly tutorial: { readonly __typename?: 'Tutorial', readonly hasBeginnerDoneCheck: boolean, readonly hasCampaign: boolean, readonly hasInstagramConnection: boolean, readonly hasInstagramWebsiteLink?: boolean | null, readonly hasOffer: boolean, readonly hasTicket: boolean } } | null } };

export type ViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerQuery = { readonly __typename?: 'Query', readonly viewer: { readonly __typename?: 'Advertiser', readonly adGuideline?: { readonly __typename?: 'AdGuideline', readonly agreedVersion?: string | null, readonly latestVersion: string, readonly needAgree: boolean, readonly url: string } | null, readonly company?: { readonly __typename?: 'Company', readonly id: string, readonly paymentType: PaymentType, readonly canCreateRewardCampaign: boolean, readonly showIntroduction: boolean, readonly connectedLineGroup: boolean, readonly needLineConnection: boolean, readonly snsConnections: ReadonlyArray<{ readonly __typename?: 'CompanySnsConnection', readonly id: string, readonly name: string, readonly uid: string, readonly nextTokenUpdateAt: string, readonly provider: CompanySnsConnectionProvider, readonly imageUrl?: string | null, readonly needTokenUpdate: boolean }> } | null } };

export const AdGuidelineFragmentDoc = gql`
    fragment AdGuideline on AdGuideline {
  agreedVersion
  latestVersion
  needAgree
  url
}
    `;
export const CampaignCostInfoFragmentDoc = gql`
    fragment CampaignCostInfo on Campaign {
  costHandlingMethod
  influencerBurdenRate
  expenseEvidenceType
}
    `;
export const EntriesCountByStatusFragmentDoc = gql`
    fragment EntriesCountByStatus on Campaign {
  entriesCountByStatus {
    APPLIED
    APPROVED
    DECLINED
    BLOCKED
    ETC
  }
}
    `;
export const CampaignEntriesInfoFragmentDoc = gql`
    fragment CampaignEntriesInfo on Campaign {
  id
  question
  offeringCapacity
  category
  scheduleType
  ...CampaignCostInfo
  gross
  sponsorServicePriceIntax
  ...EntriesCountByStatus
}
    ${CampaignCostInfoFragmentDoc}
${EntriesCountByStatusFragmentDoc}`;
export const SnsInsightFragmentDoc = gql`
    fragment SnsInsight on InstagramInsight {
  reach28 {
    value
  }
  impressions {
    value
  }
  profileViews {
    value
  }
  reach {
    value
  }
  genderRate {
    value {
      M
      F
      U
    }
  }
  ageRate {
    value {
      from13To17
      from18To24
      from25To34
      from35To44
      from45To54
      from55To64
      over65
    }
  }
  maleAgeRate {
    value {
      from13To17
      from18To24
      from25To34
      from35To44
      from45To54
      from55To64
      over65
    }
  }
  femaleAgeRate {
    value {
      from13To17
      from18To24
      from25To34
      from35To44
      from45To54
      from55To64
      over65
    }
  }
  postCommentCount {
    value
  }
  postLikeCount {
    value
  }
  postImpressions {
    value
  }
  postReach {
    value
  }
  postEngagement {
    value
  }
}
    `;
export const EngagementPredictionFragmentDoc = gql`
    fragment EngagementPrediction on CampaignEntryEngagementPrediction {
  engagementPredLower
  engagementPredUpper
}
    `;
export const ReachPredictionFragmentDoc = gql`
    fragment ReachPrediction on CampaignEntryReachPrediction {
  reachPred
  reachClass
  reachPredLower
  reachPredUpper
}
    `;
export const ImpressionPredictionFragmentDoc = gql`
    fragment ImpressionPrediction on CampaignEntryImpressionPrediction {
  impressionPred
  impressionClass
  impressionPredLower
  impressionPredUpper
}
    `;
export const InfluencerInfoFragmentDoc = gql`
    fragment InfluencerInfo on Influencer {
  id
  idpId
  name
  gender
  birthday
  imageUrl
  age
  latestAccessTime
  completeCountLevel
  approvedCount
}
    `;
export const ActiveSnsConnectionsFragmentDoc = gql`
    fragment ActiveSnsConnections on ActiveSnsConnections {
  twitter {
    name
    uid
    followerCount
    imageUrl
    postCount
    linked
    url
  }
  youtube {
    name
    uid
    imageUrl
    followerCount
    linked
    postCount
    url
  }
  instagram {
    name
    uid
    followerCount
    imageUrl
    postCount
    linked
    url
  }
  tiktok {
    name
    uid
    imageUrl
    followerCount
    postCount
    linked
    url
  }
}
    `;
export const CampaignEntryDetailFragmentDoc = gql`
    fragment CampaignEntryDetail on CampaignEntry {
  id
  campaignId
  snsType
  pinned
  status
  createdAt
  updatedAt
  expiredAt
  answer
  campaign {
    id
    question
    category
  }
  insight {
    ...SnsInsight
  }
  candidateSchedules {
    id
    candidateSchedule
  }
  companionCount
  prPostLanguage
  engagementPrediction {
    ...EngagementPrediction
  }
  reachPrediction {
    ...ReachPrediction
  }
  impressionPrediction {
    ...ImpressionPrediction
  }
  influencer {
    ...InfluencerInfo
    comment
    activeSnsConnections {
      ...ActiveSnsConnections
    }
  }
}
    ${SnsInsightFragmentDoc}
${EngagementPredictionFragmentDoc}
${ReachPredictionFragmentDoc}
${ImpressionPredictionFragmentDoc}
${InfluencerInfoFragmentDoc}
${ActiveSnsConnectionsFragmentDoc}`;
export const CampaignFeeDetailFragmentDoc = gql`
    fragment CampaignFeeDetail on CampaignFeeDetail {
  postedReword
  recruitmentFee
}
    `;
export const CampaignReservableScheduleFragmentDoc = gql`
    fragment CampaignReservableSchedule on CampaignReservableSchedule {
  id
  possibleDatetime
}
    `;
export const CompanyNotificationEmailFragmentDoc = gql`
    fragment CompanyNotificationEmail on CompanyNotificationEmail {
  id
  notificationEmail
  activation
  verificationDeadline
}
    `;
export const CompanyShopTemplateFragmentDoc = gql`
    fragment CompanyShopTemplate on CampaignLocation {
  streetAddress
  buildingName
  cityName
  cityCode
  id
  name
  stationCode
  stationName
  postalCode
  prefectureCode
  tel
}
    `;
export const CampaignSnsRequirementTagFragmentFragmentDoc = gql`
    fragment CampaignSnsRequirementTagFragment on CampaignSnsRequirementTag {
  id
  languageType
  tags
}
    `;
export const CampaignSnsRequirementFragmentDoc = gql`
    fragment CampaignSnsRequirement on CampaignSnsRequirement {
  id
  requestUrl
  snsPostTypeList
  snsType
  snsPostRedirectUrl
  tagList {
    ...CampaignSnsRequirementTagFragment
  }
  postFooter
}
    ${CampaignSnsRequirementTagFragmentFragmentDoc}`;
export const CampaignLocationFragmentDoc = gql`
    fragment CampaignLocation on CampaignLocation {
  id
  postalCode
  prefectureCode
  cityCode
  cityName
  streetAddress
  buildingName
  stationCode
  stationName
  name
  tel
  createdAt
  updatedAt
}
    `;
export const CampaignReservableWeeklyScheduleFragmentDoc = gql`
    fragment CampaignReservableWeeklySchedule on CampaignReservableWeeklySchedule {
  id
  possibleMinutes
  weekDay
}
    `;
export const CampaignV4FragmentDoc = gql`
    fragment CampaignV4 on Campaign {
  basicGross
  campaignRequirementOptionSpecifiedPrText
  campaignRequirementOptions
  guidance
  maxCompanionCount
  prTargetAge
  prTargetGender
  shopTemplateId
  subGenre
  formatVersion
  reservableWeeklySchedule {
    ...CampaignReservableWeeklySchedule
  }
  ...CampaignCostInfo
  desiredLanguages
}
    ${CampaignReservableWeeklyScheduleFragmentDoc}
${CampaignCostInfoFragmentDoc}`;
export const CopyCampaignFragmentDoc = gql`
    fragment CopyCampaign on Campaign {
  id
  companyId
  name
  campaignSnsRequirements {
    ...CampaignSnsRequirement
  }
  question
  gross
  projectType
  companySelectGenre
  companySelectSearchGenre
  status
  category
  gender
  scheduleType
  sponsorService
  sponsorServicePrice
  sponsorServicePriceIntax
  summary
  url
  reservation
  coverImageUrls {
    original
  }
  wantInfluencer
  regularlyPublishedCampaigns {
    status
  }
  ageLimit
  offerEnded
  useIdentificationTicket
  location {
    ...CampaignLocation
  }
  ...CampaignV4
}
    ${CampaignSnsRequirementFragmentDoc}
${CampaignLocationFragmentDoc}
${CampaignV4FragmentDoc}`;
export const InfluencerMailingInfoFragmentDoc = gql`
    fragment InfluencerMailingInfo on Influencer {
  name
  realName
  realNameKana
  postalCode
  pref
  city
  address1
  address2
  tel
}
    `;
export const CoverImageUrlsFragmentDoc = gql`
    fragment CoverImageUrls on ImageUrl {
  original
  medium
  small
}
    `;
export const CampaignReviewFragmentDoc = gql`
    fragment CampaignReview on CampaignReview {
  id
  isChecked
  reviewTarget
  sendBackReason
}
    `;
export const CampaignReviewResultFragmentDoc = gql`
    fragment CampaignReviewResult on CampaignReviewResult {
  campaignReviews {
    ...CampaignReview
  }
  id
  reviewSection
}
    ${CampaignReviewFragmentDoc}`;
export const CampaignSummaryFragmentDoc = gql`
    fragment CampaignSummary on Campaign {
  id
  companyId
  name
  companySelectSearchGenre
  offerStarted
  offerEnded
  selectionMaxLimit
  offersCount
  ...EntriesCountByStatus
  expenseEvidenceType
  thumbnailUrls
  question
  gross
  projectType
  offeringCapacity
  status
  scheduleType
  useIdentificationTicket
  campaignSnsRequirements {
    ...CampaignSnsRequirement
  }
  category
  approvedAt
  ageLimit
  sponsorServicePriceIntax
  sponsorServicePrice
  url
  offerAutoMessage
  attention
  gender
  sponsorService
  summary
  wantInfluencer
  coverImageUrls {
    ...CoverImageUrls
  }
  wantInfluencer
  nearestStation
  regularlyPublishedCampaigns {
    executionDay
    status
  }
  canTakeBack
  companion
  createdAt
  campaignReviewResults {
    ...CampaignReviewResult
  }
  location {
    ...CampaignLocation
  }
  ...CampaignV4
}
    ${EntriesCountByStatusFragmentDoc}
${CampaignSnsRequirementFragmentDoc}
${CoverImageUrlsFragmentDoc}
${CampaignReviewResultFragmentDoc}
${CampaignLocationFragmentDoc}
${CampaignV4FragmentDoc}`;
export const IssuedTicketFragmentDoc = gql`
    fragment IssuedTicket on IssuedTicket {
  cancelAt
  consumedAt
  createdAt
  expiredAt
  id
  name
  campaign {
    ...CampaignSummary
  }
  category
}
    ${CampaignSummaryFragmentDoc}`;
export const OfferStateCountFragmentDoc = gql`
    fragment OfferStateCount on OfferStateCount {
  completed
  entry
  working
}
    `;
export const UserInfluencerPenaltyReportFragmentDoc = gql`
    fragment UserInfluencerPenaltyReport on UserInfluencerPenaltyReport {
  id
  advAccountId
  body
  createdAt
  kind
  offerId
  penaltyReasonId
  score
  status
  updatedAt
  userInfluencerId
}
    `;
export const SnsConnectionInfoFragmentDoc = gql`
    fragment SnsConnectionInfo on CompanySnsConnection {
  id
  name
  uid
  nextTokenUpdateAt
  provider
  imageUrl
  needTokenUpdate
}
    `;
export const SubscriptionModelFragmentDoc = gql`
    fragment SubscriptionModel on SubscriptionModel {
  id
  name
  description
  initialPrice
  price
  initialIssueTicketCount
  issueTicketCount
  ticketModelId
}
    `;
export const PageInfoFragmentDoc = gql`
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
    `;
export const TicketSubscriptionFragmentDoc = gql`
    fragment TicketSubscription on TicketSubscription {
  cancellationRequestedAt
  description
  endedAt
  id
  latestSubscriptionRenewal {
    subscriptionInvoiceDetail {
      status
    }
    id
    renewalDate
  }
  name
  startedAt
  nextBillingPrice
  minCancellableDatetime
  minimumUpdateCount
  cancellationTiming
  subscriptionModelId
  subscriptionRenewals(first: 2) {
    edges {
      cursor
      node {
        id
        renewalDate
      }
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    ${PageInfoFragmentDoc}`;
export const WaitingCampaignsSummaryFragmentDoc = gql`
    fragment WaitingCampaignsSummary on Campaign {
  id
  name
  status
  coverImageUrls {
    ...CoverImageUrls
  }
  campaignSnsRequirements {
    ...CampaignSnsRequirement
  }
  gross
  offerStarted
  offerEnded
}
    ${CoverImageUrlsFragmentDoc}
${CampaignSnsRequirementFragmentDoc}`;
export const BeginnerCategoryFragmentDoc = gql`
    fragment BeginnerCategory on BeginnerCategory {
  id
  title
  description
}
    `;
export const BeginnerPostFragmentDoc = gql`
    fragment BeginnerPost on BeginnerPost {
  id
  snsType
  title
  description
  content
  done
}
    `;
export const OfferListCampaignFragmentDoc = gql`
    fragment OfferList_Campaign on Campaign {
  id
  name
  coverImageUrls {
    ...CoverImageUrls
  }
}
    ${CoverImageUrlsFragmentDoc}`;
export const OfferListOfferFragmentDoc = gql`
    fragment OfferList_Offer on Offer {
  id
  delivered
  campaign {
    ...OfferList_Campaign
  }
  latestMessage {
    body
    sender
    createdAt
  }
  latestTransition {
    action
    createdAt
    deadline
  }
  influencer {
    id
    name
    imageUrl
    birthday
    gender
  }
}
    ${OfferListCampaignFragmentDoc}`;
export const InstagramInsightFragmentDoc = gql`
    fragment InstagramInsight on DailyInstagramInsight {
  date
  followerCount
  siteClickCount
  profileViewCount
  reachCount
  dailyPrPostCount
}
    `;
export const TodoOfferTodosFragmentDoc = gql`
    fragment TodoOffer_Todos on TodoOffer {
  id
  hasCompanyTodo
  hasReplyTodo
  hasUnreadMessage
}
    `;
export const AnswerLiteracySurveyDocument = gql`
    mutation AnswerLiteracySurvey($input: AnswerLiteracySurveyInput!) {
  answerLiteracySurvey(input: $input) {
    answer
  }
}
    `;
export type AnswerLiteracySurveyMutationFn = Apollo.MutationFunction<AnswerLiteracySurveyMutation, AnswerLiteracySurveyMutationVariables>;

/**
 * __useAnswerLiteracySurveyMutation__
 *
 * To run a mutation, you first call `useAnswerLiteracySurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerLiteracySurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerLiteracySurveyMutation, { data, loading, error }] = useAnswerLiteracySurveyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnswerLiteracySurveyMutation(baseOptions?: Apollo.MutationHookOptions<AnswerLiteracySurveyMutation, AnswerLiteracySurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnswerLiteracySurveyMutation, AnswerLiteracySurveyMutationVariables>(AnswerLiteracySurveyDocument, options);
      }
export type AnswerLiteracySurveyMutationHookResult = ReturnType<typeof useAnswerLiteracySurveyMutation>;
export type AnswerLiteracySurveyMutationResult = Apollo.MutationResult<AnswerLiteracySurveyMutation>;
export type AnswerLiteracySurveyMutationOptions = Apollo.BaseMutationOptions<AnswerLiteracySurveyMutation, AnswerLiteracySurveyMutationVariables>;
export const AnswerRelationalSurveyDocument = gql`
    mutation AnswerRelationalSurvey($input: answerRelationalSurveyInput!) {
  answerRelationalSurvey(input: $input) {
    id
    reason
    score
    answerEnvironment
  }
}
    `;
export type AnswerRelationalSurveyMutationFn = Apollo.MutationFunction<AnswerRelationalSurveyMutation, AnswerRelationalSurveyMutationVariables>;

/**
 * __useAnswerRelationalSurveyMutation__
 *
 * To run a mutation, you first call `useAnswerRelationalSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerRelationalSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerRelationalSurveyMutation, { data, loading, error }] = useAnswerRelationalSurveyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnswerRelationalSurveyMutation(baseOptions?: Apollo.MutationHookOptions<AnswerRelationalSurveyMutation, AnswerRelationalSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnswerRelationalSurveyMutation, AnswerRelationalSurveyMutationVariables>(AnswerRelationalSurveyDocument, options);
      }
export type AnswerRelationalSurveyMutationHookResult = ReturnType<typeof useAnswerRelationalSurveyMutation>;
export type AnswerRelationalSurveyMutationResult = Apollo.MutationResult<AnswerRelationalSurveyMutation>;
export type AnswerRelationalSurveyMutationOptions = Apollo.BaseMutationOptions<AnswerRelationalSurveyMutation, AnswerRelationalSurveyMutationVariables>;
export const AnswerRelationalSurveyReasonDocument = gql`
    mutation AnswerRelationalSurveyReason($input: answerRelationalSurveyReasonInput!) {
  answerRelationalSurveyReason(input: $input) {
    id
    reason
    score
    answerEnvironment
  }
}
    `;
export type AnswerRelationalSurveyReasonMutationFn = Apollo.MutationFunction<AnswerRelationalSurveyReasonMutation, AnswerRelationalSurveyReasonMutationVariables>;

/**
 * __useAnswerRelationalSurveyReasonMutation__
 *
 * To run a mutation, you first call `useAnswerRelationalSurveyReasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerRelationalSurveyReasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerRelationalSurveyReasonMutation, { data, loading, error }] = useAnswerRelationalSurveyReasonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnswerRelationalSurveyReasonMutation(baseOptions?: Apollo.MutationHookOptions<AnswerRelationalSurveyReasonMutation, AnswerRelationalSurveyReasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnswerRelationalSurveyReasonMutation, AnswerRelationalSurveyReasonMutationVariables>(AnswerRelationalSurveyReasonDocument, options);
      }
export type AnswerRelationalSurveyReasonMutationHookResult = ReturnType<typeof useAnswerRelationalSurveyReasonMutation>;
export type AnswerRelationalSurveyReasonMutationResult = Apollo.MutationResult<AnswerRelationalSurveyReasonMutation>;
export type AnswerRelationalSurveyReasonMutationOptions = Apollo.BaseMutationOptions<AnswerRelationalSurveyReasonMutation, AnswerRelationalSurveyReasonMutationVariables>;
export const AnswerTransactionalSurveyDocument = gql`
    mutation AnswerTransactionalSurvey($input: answerTransactionalSurveyInput!) {
  answerTransactionalSurvey(input: $input) {
    id
  }
}
    `;
export type AnswerTransactionalSurveyMutationFn = Apollo.MutationFunction<AnswerTransactionalSurveyMutation, AnswerTransactionalSurveyMutationVariables>;

/**
 * __useAnswerTransactionalSurveyMutation__
 *
 * To run a mutation, you first call `useAnswerTransactionalSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerTransactionalSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerTransactionalSurveyMutation, { data, loading, error }] = useAnswerTransactionalSurveyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnswerTransactionalSurveyMutation(baseOptions?: Apollo.MutationHookOptions<AnswerTransactionalSurveyMutation, AnswerTransactionalSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnswerTransactionalSurveyMutation, AnswerTransactionalSurveyMutationVariables>(AnswerTransactionalSurveyDocument, options);
      }
export type AnswerTransactionalSurveyMutationHookResult = ReturnType<typeof useAnswerTransactionalSurveyMutation>;
export type AnswerTransactionalSurveyMutationResult = Apollo.MutationResult<AnswerTransactionalSurveyMutation>;
export type AnswerTransactionalSurveyMutationOptions = Apollo.BaseMutationOptions<AnswerTransactionalSurveyMutation, AnswerTransactionalSurveyMutationVariables>;
export const AnswerTransactionalSurveyReasonDocument = gql`
    mutation AnswerTransactionalSurveyReason($input: answerTransactionalSurveyReasonInput!) {
  answerTransactionalSurveyReason(input: $input) {
    id
  }
}
    `;
export type AnswerTransactionalSurveyReasonMutationFn = Apollo.MutationFunction<AnswerTransactionalSurveyReasonMutation, AnswerTransactionalSurveyReasonMutationVariables>;

/**
 * __useAnswerTransactionalSurveyReasonMutation__
 *
 * To run a mutation, you first call `useAnswerTransactionalSurveyReasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerTransactionalSurveyReasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerTransactionalSurveyReasonMutation, { data, loading, error }] = useAnswerTransactionalSurveyReasonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnswerTransactionalSurveyReasonMutation(baseOptions?: Apollo.MutationHookOptions<AnswerTransactionalSurveyReasonMutation, AnswerTransactionalSurveyReasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnswerTransactionalSurveyReasonMutation, AnswerTransactionalSurveyReasonMutationVariables>(AnswerTransactionalSurveyReasonDocument, options);
      }
export type AnswerTransactionalSurveyReasonMutationHookResult = ReturnType<typeof useAnswerTransactionalSurveyReasonMutation>;
export type AnswerTransactionalSurveyReasonMutationResult = Apollo.MutationResult<AnswerTransactionalSurveyReasonMutation>;
export type AnswerTransactionalSurveyReasonMutationOptions = Apollo.BaseMutationOptions<AnswerTransactionalSurveyReasonMutation, AnswerTransactionalSurveyReasonMutationVariables>;
export const AnsweredLiteracySurveyDocument = gql`
    query AnsweredLiteracySurvey {
  viewerAsAdvertiser {
    answeredLiteracySurvey
  }
}
    `;

/**
 * __useAnsweredLiteracySurveyQuery__
 *
 * To run a query within a React component, call `useAnsweredLiteracySurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnsweredLiteracySurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnsweredLiteracySurveyQuery({
 *   variables: {
 *   },
 * });
 */
export function useAnsweredLiteracySurveyQuery(baseOptions?: Apollo.QueryHookOptions<AnsweredLiteracySurveyQuery, AnsweredLiteracySurveyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnsweredLiteracySurveyQuery, AnsweredLiteracySurveyQueryVariables>(AnsweredLiteracySurveyDocument, options);
      }
export function useAnsweredLiteracySurveyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnsweredLiteracySurveyQuery, AnsweredLiteracySurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnsweredLiteracySurveyQuery, AnsweredLiteracySurveyQueryVariables>(AnsweredLiteracySurveyDocument, options);
        }
export function useAnsweredLiteracySurveySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnsweredLiteracySurveyQuery, AnsweredLiteracySurveyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnsweredLiteracySurveyQuery, AnsweredLiteracySurveyQueryVariables>(AnsweredLiteracySurveyDocument, options);
        }
export type AnsweredLiteracySurveyQueryHookResult = ReturnType<typeof useAnsweredLiteracySurveyQuery>;
export type AnsweredLiteracySurveyLazyQueryHookResult = ReturnType<typeof useAnsweredLiteracySurveyLazyQuery>;
export type AnsweredLiteracySurveySuspenseQueryHookResult = ReturnType<typeof useAnsweredLiteracySurveySuspenseQuery>;
export type AnsweredLiteracySurveyQueryResult = Apollo.QueryResult<AnsweredLiteracySurveyQuery, AnsweredLiteracySurveyQueryVariables>;
export const AvailableRelationalSurveyDocument = gql`
    query AvailableRelationalSurvey {
  availableRelationalSurvey {
    id
  }
}
    `;

/**
 * __useAvailableRelationalSurveyQuery__
 *
 * To run a query within a React component, call `useAvailableRelationalSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableRelationalSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableRelationalSurveyQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableRelationalSurveyQuery(baseOptions?: Apollo.QueryHookOptions<AvailableRelationalSurveyQuery, AvailableRelationalSurveyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableRelationalSurveyQuery, AvailableRelationalSurveyQueryVariables>(AvailableRelationalSurveyDocument, options);
      }
export function useAvailableRelationalSurveyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableRelationalSurveyQuery, AvailableRelationalSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableRelationalSurveyQuery, AvailableRelationalSurveyQueryVariables>(AvailableRelationalSurveyDocument, options);
        }
export function useAvailableRelationalSurveySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailableRelationalSurveyQuery, AvailableRelationalSurveyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailableRelationalSurveyQuery, AvailableRelationalSurveyQueryVariables>(AvailableRelationalSurveyDocument, options);
        }
export type AvailableRelationalSurveyQueryHookResult = ReturnType<typeof useAvailableRelationalSurveyQuery>;
export type AvailableRelationalSurveyLazyQueryHookResult = ReturnType<typeof useAvailableRelationalSurveyLazyQuery>;
export type AvailableRelationalSurveySuspenseQueryHookResult = ReturnType<typeof useAvailableRelationalSurveySuspenseQuery>;
export type AvailableRelationalSurveyQueryResult = Apollo.QueryResult<AvailableRelationalSurveyQuery, AvailableRelationalSurveyQueryVariables>;
export const AvailableTransactionalSurveyDocument = gql`
    query AvailableTransactionalSurvey($input: AvailableTransactionalSurveyInput!) {
  availableTransactionalSurvey(input: $input) {
    id
  }
}
    `;

/**
 * __useAvailableTransactionalSurveyQuery__
 *
 * To run a query within a React component, call `useAvailableTransactionalSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableTransactionalSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableTransactionalSurveyQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAvailableTransactionalSurveyQuery(baseOptions: Apollo.QueryHookOptions<AvailableTransactionalSurveyQuery, AvailableTransactionalSurveyQueryVariables> & ({ variables: AvailableTransactionalSurveyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableTransactionalSurveyQuery, AvailableTransactionalSurveyQueryVariables>(AvailableTransactionalSurveyDocument, options);
      }
export function useAvailableTransactionalSurveyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableTransactionalSurveyQuery, AvailableTransactionalSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableTransactionalSurveyQuery, AvailableTransactionalSurveyQueryVariables>(AvailableTransactionalSurveyDocument, options);
        }
export function useAvailableTransactionalSurveySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailableTransactionalSurveyQuery, AvailableTransactionalSurveyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailableTransactionalSurveyQuery, AvailableTransactionalSurveyQueryVariables>(AvailableTransactionalSurveyDocument, options);
        }
export type AvailableTransactionalSurveyQueryHookResult = ReturnType<typeof useAvailableTransactionalSurveyQuery>;
export type AvailableTransactionalSurveyLazyQueryHookResult = ReturnType<typeof useAvailableTransactionalSurveyLazyQuery>;
export type AvailableTransactionalSurveySuspenseQueryHookResult = ReturnType<typeof useAvailableTransactionalSurveySuspenseQuery>;
export type AvailableTransactionalSurveyQueryResult = Apollo.QueryResult<AvailableTransactionalSurveyQuery, AvailableTransactionalSurveyQueryVariables>;
export const LiteracySurveysDocument = gql`
    query LiteracySurveys {
  literacySurveys {
    literacySurveyOption
    label
  }
}
    `;

/**
 * __useLiteracySurveysQuery__
 *
 * To run a query within a React component, call `useLiteracySurveysQuery` and pass it any options that fit your needs.
 * When your component renders, `useLiteracySurveysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiteracySurveysQuery({
 *   variables: {
 *   },
 * });
 */
export function useLiteracySurveysQuery(baseOptions?: Apollo.QueryHookOptions<LiteracySurveysQuery, LiteracySurveysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LiteracySurveysQuery, LiteracySurveysQueryVariables>(LiteracySurveysDocument, options);
      }
export function useLiteracySurveysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LiteracySurveysQuery, LiteracySurveysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LiteracySurveysQuery, LiteracySurveysQueryVariables>(LiteracySurveysDocument, options);
        }
export function useLiteracySurveysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LiteracySurveysQuery, LiteracySurveysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LiteracySurveysQuery, LiteracySurveysQueryVariables>(LiteracySurveysDocument, options);
        }
export type LiteracySurveysQueryHookResult = ReturnType<typeof useLiteracySurveysQuery>;
export type LiteracySurveysLazyQueryHookResult = ReturnType<typeof useLiteracySurveysLazyQuery>;
export type LiteracySurveysSuspenseQueryHookResult = ReturnType<typeof useLiteracySurveysSuspenseQuery>;
export type LiteracySurveysQueryResult = Apollo.QueryResult<LiteracySurveysQuery, LiteracySurveysQueryVariables>;
export const LiteracySurveyAnswerDocument = gql`
    query LiteracySurveyAnswer {
  viewerAsAdvertiser {
    literacySurveyAnswer {
      answer
      id
    }
  }
}
    `;

/**
 * __useLiteracySurveyAnswerQuery__
 *
 * To run a query within a React component, call `useLiteracySurveyAnswerQuery` and pass it any options that fit your needs.
 * When your component renders, `useLiteracySurveyAnswerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiteracySurveyAnswerQuery({
 *   variables: {
 *   },
 * });
 */
export function useLiteracySurveyAnswerQuery(baseOptions?: Apollo.QueryHookOptions<LiteracySurveyAnswerQuery, LiteracySurveyAnswerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LiteracySurveyAnswerQuery, LiteracySurveyAnswerQueryVariables>(LiteracySurveyAnswerDocument, options);
      }
export function useLiteracySurveyAnswerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LiteracySurveyAnswerQuery, LiteracySurveyAnswerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LiteracySurveyAnswerQuery, LiteracySurveyAnswerQueryVariables>(LiteracySurveyAnswerDocument, options);
        }
export function useLiteracySurveyAnswerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LiteracySurveyAnswerQuery, LiteracySurveyAnswerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LiteracySurveyAnswerQuery, LiteracySurveyAnswerQueryVariables>(LiteracySurveyAnswerDocument, options);
        }
export type LiteracySurveyAnswerQueryHookResult = ReturnType<typeof useLiteracySurveyAnswerQuery>;
export type LiteracySurveyAnswerLazyQueryHookResult = ReturnType<typeof useLiteracySurveyAnswerLazyQuery>;
export type LiteracySurveyAnswerSuspenseQueryHookResult = ReturnType<typeof useLiteracySurveyAnswerSuspenseQuery>;
export type LiteracySurveyAnswerQueryResult = Apollo.QueryResult<LiteracySurveyAnswerQuery, LiteracySurveyAnswerQueryVariables>;
export const AvailableTicketsDocument = gql`
    query AvailableTickets($input: availableTicketsInputObject) {
  viewer: viewerAsAdvertiser {
    ... on Advertiser {
      companyId
      company {
        id
        availableTickets(input: $input) {
          ...IssuedTicket
        }
      }
    }
  }
}
    ${IssuedTicketFragmentDoc}`;

/**
 * __useAvailableTicketsQuery__
 *
 * To run a query within a React component, call `useAvailableTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableTicketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableTicketsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAvailableTicketsQuery(baseOptions?: Apollo.QueryHookOptions<AvailableTicketsQuery, AvailableTicketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableTicketsQuery, AvailableTicketsQueryVariables>(AvailableTicketsDocument, options);
      }
export function useAvailableTicketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableTicketsQuery, AvailableTicketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableTicketsQuery, AvailableTicketsQueryVariables>(AvailableTicketsDocument, options);
        }
export function useAvailableTicketsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailableTicketsQuery, AvailableTicketsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailableTicketsQuery, AvailableTicketsQueryVariables>(AvailableTicketsDocument, options);
        }
export type AvailableTicketsQueryHookResult = ReturnType<typeof useAvailableTicketsQuery>;
export type AvailableTicketsLazyQueryHookResult = ReturnType<typeof useAvailableTicketsLazyQuery>;
export type AvailableTicketsSuspenseQueryHookResult = ReturnType<typeof useAvailableTicketsSuspenseQuery>;
export type AvailableTicketsQueryResult = Apollo.QueryResult<AvailableTicketsQuery, AvailableTicketsQueryVariables>;
export const IssuedTicketsDocument = gql`
    query IssuedTickets($first: Int = 10, $after: String, $before: String, $last: Int) {
  viewer: viewerAsAdvertiser {
    ... on Advertiser {
      company {
        id
        issuedTickets(first: $first, after: $after, before: $before, last: $last) {
          edges {
            node {
              ...IssuedTicket
            }
            cursor
          }
          pageInfo {
            ...PageInfo
          }
          totalCount
        }
      }
    }
  }
}
    ${IssuedTicketFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useIssuedTicketsQuery__
 *
 * To run a query within a React component, call `useIssuedTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIssuedTicketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIssuedTicketsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useIssuedTicketsQuery(baseOptions?: Apollo.QueryHookOptions<IssuedTicketsQuery, IssuedTicketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IssuedTicketsQuery, IssuedTicketsQueryVariables>(IssuedTicketsDocument, options);
      }
export function useIssuedTicketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IssuedTicketsQuery, IssuedTicketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IssuedTicketsQuery, IssuedTicketsQueryVariables>(IssuedTicketsDocument, options);
        }
export function useIssuedTicketsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IssuedTicketsQuery, IssuedTicketsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IssuedTicketsQuery, IssuedTicketsQueryVariables>(IssuedTicketsDocument, options);
        }
export type IssuedTicketsQueryHookResult = ReturnType<typeof useIssuedTicketsQuery>;
export type IssuedTicketsLazyQueryHookResult = ReturnType<typeof useIssuedTicketsLazyQuery>;
export type IssuedTicketsSuspenseQueryHookResult = ReturnType<typeof useIssuedTicketsSuspenseQuery>;
export type IssuedTicketsQueryResult = Apollo.QueryResult<IssuedTicketsQuery, IssuedTicketsQueryVariables>;
export const UpdateBeginnerPostStatusDocument = gql`
    mutation UpdateBeginnerPostStatus($input: UpdateBeginnerPostStatusInput!) {
  updateBeginnerPostStatus(input: $input) {
    ...BeginnerPost
  }
}
    ${BeginnerPostFragmentDoc}`;
export type UpdateBeginnerPostStatusMutationFn = Apollo.MutationFunction<UpdateBeginnerPostStatusMutation, UpdateBeginnerPostStatusMutationVariables>;

/**
 * __useUpdateBeginnerPostStatusMutation__
 *
 * To run a mutation, you first call `useUpdateBeginnerPostStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBeginnerPostStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBeginnerPostStatusMutation, { data, loading, error }] = useUpdateBeginnerPostStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBeginnerPostStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBeginnerPostStatusMutation, UpdateBeginnerPostStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBeginnerPostStatusMutation, UpdateBeginnerPostStatusMutationVariables>(UpdateBeginnerPostStatusDocument, options);
      }
export type UpdateBeginnerPostStatusMutationHookResult = ReturnType<typeof useUpdateBeginnerPostStatusMutation>;
export type UpdateBeginnerPostStatusMutationResult = Apollo.MutationResult<UpdateBeginnerPostStatusMutation>;
export type UpdateBeginnerPostStatusMutationOptions = Apollo.BaseMutationOptions<UpdateBeginnerPostStatusMutation, UpdateBeginnerPostStatusMutationVariables>;
export const BeginnerCategoriesDocument = gql`
    query BeginnerCategories($companySnsConnectionId: ID) {
  beginnerCategories {
    ...BeginnerCategory
    posts(companySnsConnectionId: $companySnsConnectionId) {
      ...BeginnerPost
    }
  }
}
    ${BeginnerCategoryFragmentDoc}
${BeginnerPostFragmentDoc}`;

/**
 * __useBeginnerCategoriesQuery__
 *
 * To run a query within a React component, call `useBeginnerCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBeginnerCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBeginnerCategoriesQuery({
 *   variables: {
 *      companySnsConnectionId: // value for 'companySnsConnectionId'
 *   },
 * });
 */
export function useBeginnerCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<BeginnerCategoriesQuery, BeginnerCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BeginnerCategoriesQuery, BeginnerCategoriesQueryVariables>(BeginnerCategoriesDocument, options);
      }
export function useBeginnerCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BeginnerCategoriesQuery, BeginnerCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BeginnerCategoriesQuery, BeginnerCategoriesQueryVariables>(BeginnerCategoriesDocument, options);
        }
export function useBeginnerCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BeginnerCategoriesQuery, BeginnerCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BeginnerCategoriesQuery, BeginnerCategoriesQueryVariables>(BeginnerCategoriesDocument, options);
        }
export type BeginnerCategoriesQueryHookResult = ReturnType<typeof useBeginnerCategoriesQuery>;
export type BeginnerCategoriesLazyQueryHookResult = ReturnType<typeof useBeginnerCategoriesLazyQuery>;
export type BeginnerCategoriesSuspenseQueryHookResult = ReturnType<typeof useBeginnerCategoriesSuspenseQuery>;
export type BeginnerCategoriesQueryResult = Apollo.QueryResult<BeginnerCategoriesQuery, BeginnerCategoriesQueryVariables>;
export const AddCampaignReservableScheduleDocument = gql`
    mutation AddCampaignReservableSchedule($input: addCampaignReservableScheduleInput!) {
  addCampaignReservableSchedule(input: $input) {
    id
    possibleDatetime
  }
}
    `;
export type AddCampaignReservableScheduleMutationFn = Apollo.MutationFunction<AddCampaignReservableScheduleMutation, AddCampaignReservableScheduleMutationVariables>;

/**
 * __useAddCampaignReservableScheduleMutation__
 *
 * To run a mutation, you first call `useAddCampaignReservableScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCampaignReservableScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCampaignReservableScheduleMutation, { data, loading, error }] = useAddCampaignReservableScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCampaignReservableScheduleMutation(baseOptions?: Apollo.MutationHookOptions<AddCampaignReservableScheduleMutation, AddCampaignReservableScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCampaignReservableScheduleMutation, AddCampaignReservableScheduleMutationVariables>(AddCampaignReservableScheduleDocument, options);
      }
export type AddCampaignReservableScheduleMutationHookResult = ReturnType<typeof useAddCampaignReservableScheduleMutation>;
export type AddCampaignReservableScheduleMutationResult = Apollo.MutationResult<AddCampaignReservableScheduleMutation>;
export type AddCampaignReservableScheduleMutationOptions = Apollo.BaseMutationOptions<AddCampaignReservableScheduleMutation, AddCampaignReservableScheduleMutationVariables>;
export const CreateCampaignDocument = gql`
    mutation createCampaign($input: CreateCampaignInput!) {
  createCampaign(input: $input) {
    id
  }
}
    `;
export type CreateCampaignMutationFn = Apollo.MutationFunction<CreateCampaignMutation, CreateCampaignMutationVariables>;

/**
 * __useCreateCampaignMutation__
 *
 * To run a mutation, you first call `useCreateCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampaignMutation, { data, loading, error }] = useCreateCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCampaignMutation(baseOptions?: Apollo.MutationHookOptions<CreateCampaignMutation, CreateCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCampaignMutation, CreateCampaignMutationVariables>(CreateCampaignDocument, options);
      }
export type CreateCampaignMutationHookResult = ReturnType<typeof useCreateCampaignMutation>;
export type CreateCampaignMutationResult = Apollo.MutationResult<CreateCampaignMutation>;
export type CreateCampaignMutationOptions = Apollo.BaseMutationOptions<CreateCampaignMutation, CreateCampaignMutationVariables>;
export const CreateDownloadReportDocument = gql`
    mutation CreateDownloadReport($input: CreateDownloadReportInput!) {
  createDownloadReport(input: $input) {
    createdAt
    downloadUrl
    fileType
    id
    status
    title
  }
}
    `;
export type CreateDownloadReportMutationFn = Apollo.MutationFunction<CreateDownloadReportMutation, CreateDownloadReportMutationVariables>;

/**
 * __useCreateDownloadReportMutation__
 *
 * To run a mutation, you first call `useCreateDownloadReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDownloadReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDownloadReportMutation, { data, loading, error }] = useCreateDownloadReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDownloadReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateDownloadReportMutation, CreateDownloadReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDownloadReportMutation, CreateDownloadReportMutationVariables>(CreateDownloadReportDocument, options);
      }
export type CreateDownloadReportMutationHookResult = ReturnType<typeof useCreateDownloadReportMutation>;
export type CreateDownloadReportMutationResult = Apollo.MutationResult<CreateDownloadReportMutation>;
export type CreateDownloadReportMutationOptions = Apollo.BaseMutationOptions<CreateDownloadReportMutation, CreateDownloadReportMutationVariables>;
export const EndCampaignOfferDocument = gql`
    mutation endCampaignOffer($input: EndCampaignOfferInput!) {
  endCampaignOffer(input: $input) {
    ...CampaignSummary
  }
}
    ${CampaignSummaryFragmentDoc}`;
export type EndCampaignOfferMutationFn = Apollo.MutationFunction<EndCampaignOfferMutation, EndCampaignOfferMutationVariables>;

/**
 * __useEndCampaignOfferMutation__
 *
 * To run a mutation, you first call `useEndCampaignOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndCampaignOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endCampaignOfferMutation, { data, loading, error }] = useEndCampaignOfferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEndCampaignOfferMutation(baseOptions?: Apollo.MutationHookOptions<EndCampaignOfferMutation, EndCampaignOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EndCampaignOfferMutation, EndCampaignOfferMutationVariables>(EndCampaignOfferDocument, options);
      }
export type EndCampaignOfferMutationHookResult = ReturnType<typeof useEndCampaignOfferMutation>;
export type EndCampaignOfferMutationResult = Apollo.MutationResult<EndCampaignOfferMutation>;
export type EndCampaignOfferMutationOptions = Apollo.BaseMutationOptions<EndCampaignOfferMutation, EndCampaignOfferMutationVariables>;
export const RemoveCampaignReservableScheduleDocument = gql`
    mutation RemoveCampaignReservableSchedule($input: [removeCampaignReservableScheduleInput!]!) {
  removeCampaignReservableSchedule(input: $input) {
    id
    possibleDatetime
  }
}
    `;
export type RemoveCampaignReservableScheduleMutationFn = Apollo.MutationFunction<RemoveCampaignReservableScheduleMutation, RemoveCampaignReservableScheduleMutationVariables>;

/**
 * __useRemoveCampaignReservableScheduleMutation__
 *
 * To run a mutation, you first call `useRemoveCampaignReservableScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCampaignReservableScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCampaignReservableScheduleMutation, { data, loading, error }] = useRemoveCampaignReservableScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveCampaignReservableScheduleMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCampaignReservableScheduleMutation, RemoveCampaignReservableScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCampaignReservableScheduleMutation, RemoveCampaignReservableScheduleMutationVariables>(RemoveCampaignReservableScheduleDocument, options);
      }
export type RemoveCampaignReservableScheduleMutationHookResult = ReturnType<typeof useRemoveCampaignReservableScheduleMutation>;
export type RemoveCampaignReservableScheduleMutationResult = Apollo.MutationResult<RemoveCampaignReservableScheduleMutation>;
export type RemoveCampaignReservableScheduleMutationOptions = Apollo.BaseMutationOptions<RemoveCampaignReservableScheduleMutation, RemoveCampaignReservableScheduleMutationVariables>;
export const RequestApprovalCampaignDocument = gql`
    mutation requestApprovalCampaign($input: RequestApprovalCampaignInput!) {
  requestApprovalCampaign(input: $input) {
    ...CampaignSummary
  }
}
    ${CampaignSummaryFragmentDoc}`;
export type RequestApprovalCampaignMutationFn = Apollo.MutationFunction<RequestApprovalCampaignMutation, RequestApprovalCampaignMutationVariables>;

/**
 * __useRequestApprovalCampaignMutation__
 *
 * To run a mutation, you first call `useRequestApprovalCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestApprovalCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestApprovalCampaignMutation, { data, loading, error }] = useRequestApprovalCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestApprovalCampaignMutation(baseOptions?: Apollo.MutationHookOptions<RequestApprovalCampaignMutation, RequestApprovalCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestApprovalCampaignMutation, RequestApprovalCampaignMutationVariables>(RequestApprovalCampaignDocument, options);
      }
export type RequestApprovalCampaignMutationHookResult = ReturnType<typeof useRequestApprovalCampaignMutation>;
export type RequestApprovalCampaignMutationResult = Apollo.MutationResult<RequestApprovalCampaignMutation>;
export type RequestApprovalCampaignMutationOptions = Apollo.BaseMutationOptions<RequestApprovalCampaignMutation, RequestApprovalCampaignMutationVariables>;
export const TakeBackCampaignDocument = gql`
    mutation TakeBackCampaign($input: TakeBackCampaignInput!) {
  takeBackCampaign(input: $input) {
    ...CampaignSummary
  }
}
    ${CampaignSummaryFragmentDoc}`;
export type TakeBackCampaignMutationFn = Apollo.MutationFunction<TakeBackCampaignMutation, TakeBackCampaignMutationVariables>;

/**
 * __useTakeBackCampaignMutation__
 *
 * To run a mutation, you first call `useTakeBackCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTakeBackCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [takeBackCampaignMutation, { data, loading, error }] = useTakeBackCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTakeBackCampaignMutation(baseOptions?: Apollo.MutationHookOptions<TakeBackCampaignMutation, TakeBackCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TakeBackCampaignMutation, TakeBackCampaignMutationVariables>(TakeBackCampaignDocument, options);
      }
export type TakeBackCampaignMutationHookResult = ReturnType<typeof useTakeBackCampaignMutation>;
export type TakeBackCampaignMutationResult = Apollo.MutationResult<TakeBackCampaignMutation>;
export type TakeBackCampaignMutationOptions = Apollo.BaseMutationOptions<TakeBackCampaignMutation, TakeBackCampaignMutationVariables>;
export const UpdateCampaignDocument = gql`
    mutation UpdateCampaign($input: UpdateCampaignInput!) {
  updateCampaign(input: $input) {
    ...CampaignSummary
  }
}
    ${CampaignSummaryFragmentDoc}`;
export type UpdateCampaignMutationFn = Apollo.MutationFunction<UpdateCampaignMutation, UpdateCampaignMutationVariables>;

/**
 * __useUpdateCampaignMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignMutation, { data, loading, error }] = useUpdateCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCampaignMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampaignMutation, UpdateCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampaignMutation, UpdateCampaignMutationVariables>(UpdateCampaignDocument, options);
      }
export type UpdateCampaignMutationHookResult = ReturnType<typeof useUpdateCampaignMutation>;
export type UpdateCampaignMutationResult = Apollo.MutationResult<UpdateCampaignMutation>;
export type UpdateCampaignMutationOptions = Apollo.BaseMutationOptions<UpdateCampaignMutation, UpdateCampaignMutationVariables>;
export const UpdateCampaignReservableWeeklyScheduleDocument = gql`
    mutation UpdateCampaignReservableWeeklySchedule($input: UpdateCampaignReservableWeeklyScheduleInput!) {
  updateCampaignReservableWeeklySchedule(input: $input) {
    id
  }
}
    `;
export type UpdateCampaignReservableWeeklyScheduleMutationFn = Apollo.MutationFunction<UpdateCampaignReservableWeeklyScheduleMutation, UpdateCampaignReservableWeeklyScheduleMutationVariables>;

/**
 * __useUpdateCampaignReservableWeeklyScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignReservableWeeklyScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignReservableWeeklyScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignReservableWeeklyScheduleMutation, { data, loading, error }] = useUpdateCampaignReservableWeeklyScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCampaignReservableWeeklyScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampaignReservableWeeklyScheduleMutation, UpdateCampaignReservableWeeklyScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampaignReservableWeeklyScheduleMutation, UpdateCampaignReservableWeeklyScheduleMutationVariables>(UpdateCampaignReservableWeeklyScheduleDocument, options);
      }
export type UpdateCampaignReservableWeeklyScheduleMutationHookResult = ReturnType<typeof useUpdateCampaignReservableWeeklyScheduleMutation>;
export type UpdateCampaignReservableWeeklyScheduleMutationResult = Apollo.MutationResult<UpdateCampaignReservableWeeklyScheduleMutation>;
export type UpdateCampaignReservableWeeklyScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateCampaignReservableWeeklyScheduleMutation, UpdateCampaignReservableWeeklyScheduleMutationVariables>;
export const CampaignDocument = gql`
    query Campaign($id: ID!) {
  campaign(id: $id) {
    ...CampaignSummary
    campaignReviewResults {
      ...CampaignReviewResult
    }
  }
}
    ${CampaignSummaryFragmentDoc}
${CampaignReviewResultFragmentDoc}`;

/**
 * __useCampaignQuery__
 *
 * To run a query within a React component, call `useCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCampaignQuery(baseOptions: Apollo.QueryHookOptions<CampaignQuery, CampaignQueryVariables> & ({ variables: CampaignQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignQuery, CampaignQueryVariables>(CampaignDocument, options);
      }
export function useCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignQuery, CampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignQuery, CampaignQueryVariables>(CampaignDocument, options);
        }
export function useCampaignSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignQuery, CampaignQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignQuery, CampaignQueryVariables>(CampaignDocument, options);
        }
export type CampaignQueryHookResult = ReturnType<typeof useCampaignQuery>;
export type CampaignLazyQueryHookResult = ReturnType<typeof useCampaignLazyQuery>;
export type CampaignSuspenseQueryHookResult = ReturnType<typeof useCampaignSuspenseQuery>;
export type CampaignQueryResult = Apollo.QueryResult<CampaignQuery, CampaignQueryVariables>;
export const CampaignInfoDocument = gql`
    query CampaignInfo($nodeId: ID!) {
  node(id: $nodeId) {
    ... on Campaign {
      ...CampaignSummary
      reservableSchedules(take: 1) {
        ...CampaignReservableSchedule
      }
    }
  }
}
    ${CampaignSummaryFragmentDoc}
${CampaignReservableScheduleFragmentDoc}`;

/**
 * __useCampaignInfoQuery__
 *
 * To run a query within a React component, call `useCampaignInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignInfoQuery({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useCampaignInfoQuery(baseOptions: Apollo.QueryHookOptions<CampaignInfoQuery, CampaignInfoQueryVariables> & ({ variables: CampaignInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignInfoQuery, CampaignInfoQueryVariables>(CampaignInfoDocument, options);
      }
export function useCampaignInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignInfoQuery, CampaignInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignInfoQuery, CampaignInfoQueryVariables>(CampaignInfoDocument, options);
        }
export function useCampaignInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignInfoQuery, CampaignInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignInfoQuery, CampaignInfoQueryVariables>(CampaignInfoDocument, options);
        }
export type CampaignInfoQueryHookResult = ReturnType<typeof useCampaignInfoQuery>;
export type CampaignInfoLazyQueryHookResult = ReturnType<typeof useCampaignInfoLazyQuery>;
export type CampaignInfoSuspenseQueryHookResult = ReturnType<typeof useCampaignInfoSuspenseQuery>;
export type CampaignInfoQueryResult = Apollo.QueryResult<CampaignInfoQuery, CampaignInfoQueryVariables>;
export const CampaignListDocument = gql`
    query CampaignList($input: CampaignByAdvertiserInput, $campaignCountInput: CampaignCountInput!) {
  viewer: viewerAsAdvertiser {
    ... on Advertiser {
      campaignCount(input: $campaignCountInput)
      campaigns(input: $input) {
        id
        name
        status
        offerStarted
        offerEnded
        coverImageUrls {
          ...CoverImageUrls
        }
        gross
        scheduleType
        hasReservableSchedule
        campaignSnsRequirements {
          ...CampaignSnsRequirement
        }
        offerStateCount {
          ...OfferStateCount
        }
        regularlyPublishedCampaigns {
          status
          executionDay
        }
        ...CampaignCostInfo
        formatVersion
      }
    }
  }
}
    ${CoverImageUrlsFragmentDoc}
${CampaignSnsRequirementFragmentDoc}
${OfferStateCountFragmentDoc}
${CampaignCostInfoFragmentDoc}`;

/**
 * __useCampaignListQuery__
 *
 * To run a query within a React component, call `useCampaignListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignListQuery({
 *   variables: {
 *      input: // value for 'input'
 *      campaignCountInput: // value for 'campaignCountInput'
 *   },
 * });
 */
export function useCampaignListQuery(baseOptions: Apollo.QueryHookOptions<CampaignListQuery, CampaignListQueryVariables> & ({ variables: CampaignListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignListQuery, CampaignListQueryVariables>(CampaignListDocument, options);
      }
export function useCampaignListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignListQuery, CampaignListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignListQuery, CampaignListQueryVariables>(CampaignListDocument, options);
        }
export function useCampaignListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignListQuery, CampaignListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignListQuery, CampaignListQueryVariables>(CampaignListDocument, options);
        }
export type CampaignListQueryHookResult = ReturnType<typeof useCampaignListQuery>;
export type CampaignListLazyQueryHookResult = ReturnType<typeof useCampaignListLazyQuery>;
export type CampaignListSuspenseQueryHookResult = ReturnType<typeof useCampaignListSuspenseQuery>;
export type CampaignListQueryResult = Apollo.QueryResult<CampaignListQuery, CampaignListQueryVariables>;
export const CampaignMailingDocument = gql`
    query CampaignMailing($nodeId: ID!, $first: Int, $cursor: String) {
  node(id: $nodeId) {
    ... on Campaign {
      offers(first: $first, after: $cursor) {
        edges {
          node {
            snsType
            latestTransition {
              state
            }
            influencer {
              ...InfluencerMailingInfo
              activeSnsConnections {
                ...ActiveSnsConnections
              }
            }
            id
            delivered
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
}
    ${InfluencerMailingInfoFragmentDoc}
${ActiveSnsConnectionsFragmentDoc}`;

/**
 * __useCampaignMailingQuery__
 *
 * To run a query within a React component, call `useCampaignMailingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignMailingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignMailingQuery({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useCampaignMailingQuery(baseOptions: Apollo.QueryHookOptions<CampaignMailingQuery, CampaignMailingQueryVariables> & ({ variables: CampaignMailingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignMailingQuery, CampaignMailingQueryVariables>(CampaignMailingDocument, options);
      }
export function useCampaignMailingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignMailingQuery, CampaignMailingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignMailingQuery, CampaignMailingQueryVariables>(CampaignMailingDocument, options);
        }
export function useCampaignMailingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignMailingQuery, CampaignMailingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignMailingQuery, CampaignMailingQueryVariables>(CampaignMailingDocument, options);
        }
export type CampaignMailingQueryHookResult = ReturnType<typeof useCampaignMailingQuery>;
export type CampaignMailingLazyQueryHookResult = ReturnType<typeof useCampaignMailingLazyQuery>;
export type CampaignMailingSuspenseQueryHookResult = ReturnType<typeof useCampaignMailingSuspenseQuery>;
export type CampaignMailingQueryResult = Apollo.QueryResult<CampaignMailingQuery, CampaignMailingQueryVariables>;
export const CampaignNameDocument = gql`
    query CampaignName($campaignId: ID!) {
  campaign(id: $campaignId) {
    id
    name
  }
}
    `;

/**
 * __useCampaignNameQuery__
 *
 * To run a query within a React component, call `useCampaignNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignNameQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignNameQuery(baseOptions: Apollo.QueryHookOptions<CampaignNameQuery, CampaignNameQueryVariables> & ({ variables: CampaignNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignNameQuery, CampaignNameQueryVariables>(CampaignNameDocument, options);
      }
export function useCampaignNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignNameQuery, CampaignNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignNameQuery, CampaignNameQueryVariables>(CampaignNameDocument, options);
        }
export function useCampaignNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignNameQuery, CampaignNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignNameQuery, CampaignNameQueryVariables>(CampaignNameDocument, options);
        }
export type CampaignNameQueryHookResult = ReturnType<typeof useCampaignNameQuery>;
export type CampaignNameLazyQueryHookResult = ReturnType<typeof useCampaignNameLazyQuery>;
export type CampaignNameSuspenseQueryHookResult = ReturnType<typeof useCampaignNameSuspenseQuery>;
export type CampaignNameQueryResult = Apollo.QueryResult<CampaignNameQuery, CampaignNameQueryVariables>;
export const CampaignNearestStationsDocument = gql`
    query CampaignNearestStations($input: CampaignNearestStationInput!) {
  campaignNearestStations(input: $input) {
    code
    name
  }
}
    `;

/**
 * __useCampaignNearestStationsQuery__
 *
 * To run a query within a React component, call `useCampaignNearestStationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignNearestStationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignNearestStationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCampaignNearestStationsQuery(baseOptions: Apollo.QueryHookOptions<CampaignNearestStationsQuery, CampaignNearestStationsQueryVariables> & ({ variables: CampaignNearestStationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignNearestStationsQuery, CampaignNearestStationsQueryVariables>(CampaignNearestStationsDocument, options);
      }
export function useCampaignNearestStationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignNearestStationsQuery, CampaignNearestStationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignNearestStationsQuery, CampaignNearestStationsQueryVariables>(CampaignNearestStationsDocument, options);
        }
export function useCampaignNearestStationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignNearestStationsQuery, CampaignNearestStationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignNearestStationsQuery, CampaignNearestStationsQueryVariables>(CampaignNearestStationsDocument, options);
        }
export type CampaignNearestStationsQueryHookResult = ReturnType<typeof useCampaignNearestStationsQuery>;
export type CampaignNearestStationsLazyQueryHookResult = ReturnType<typeof useCampaignNearestStationsLazyQuery>;
export type CampaignNearestStationsSuspenseQueryHookResult = ReturnType<typeof useCampaignNearestStationsSuspenseQuery>;
export type CampaignNearestStationsQueryResult = Apollo.QueryResult<CampaignNearestStationsQuery, CampaignNearestStationsQueryVariables>;
export const CampaignOfferMailingDocument = gql`
    query CampaignOfferMailing($nodeId: ID!) {
  node(id: $nodeId) {
    ... on Offer {
      influencer {
        ...InfluencerMailingInfo
      }
    }
  }
}
    ${InfluencerMailingInfoFragmentDoc}`;

/**
 * __useCampaignOfferMailingQuery__
 *
 * To run a query within a React component, call `useCampaignOfferMailingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignOfferMailingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignOfferMailingQuery({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useCampaignOfferMailingQuery(baseOptions: Apollo.QueryHookOptions<CampaignOfferMailingQuery, CampaignOfferMailingQueryVariables> & ({ variables: CampaignOfferMailingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignOfferMailingQuery, CampaignOfferMailingQueryVariables>(CampaignOfferMailingDocument, options);
      }
export function useCampaignOfferMailingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignOfferMailingQuery, CampaignOfferMailingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignOfferMailingQuery, CampaignOfferMailingQueryVariables>(CampaignOfferMailingDocument, options);
        }
export function useCampaignOfferMailingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignOfferMailingQuery, CampaignOfferMailingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignOfferMailingQuery, CampaignOfferMailingQueryVariables>(CampaignOfferMailingDocument, options);
        }
export type CampaignOfferMailingQueryHookResult = ReturnType<typeof useCampaignOfferMailingQuery>;
export type CampaignOfferMailingLazyQueryHookResult = ReturnType<typeof useCampaignOfferMailingLazyQuery>;
export type CampaignOfferMailingSuspenseQueryHookResult = ReturnType<typeof useCampaignOfferMailingSuspenseQuery>;
export type CampaignOfferMailingQueryResult = Apollo.QueryResult<CampaignOfferMailingQuery, CampaignOfferMailingQueryVariables>;
export const CampaignReviewResultDocument = gql`
    query CampaignReviewResult($id: ID!) {
  campaign(id: $id) {
    campaignReviewResults {
      ...CampaignReviewResult
    }
  }
}
    ${CampaignReviewResultFragmentDoc}`;

/**
 * __useCampaignReviewResultQuery__
 *
 * To run a query within a React component, call `useCampaignReviewResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignReviewResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignReviewResultQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCampaignReviewResultQuery(baseOptions: Apollo.QueryHookOptions<CampaignReviewResultQuery, CampaignReviewResultQueryVariables> & ({ variables: CampaignReviewResultQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignReviewResultQuery, CampaignReviewResultQueryVariables>(CampaignReviewResultDocument, options);
      }
export function useCampaignReviewResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignReviewResultQuery, CampaignReviewResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignReviewResultQuery, CampaignReviewResultQueryVariables>(CampaignReviewResultDocument, options);
        }
export function useCampaignReviewResultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignReviewResultQuery, CampaignReviewResultQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignReviewResultQuery, CampaignReviewResultQueryVariables>(CampaignReviewResultDocument, options);
        }
export type CampaignReviewResultQueryHookResult = ReturnType<typeof useCampaignReviewResultQuery>;
export type CampaignReviewResultLazyQueryHookResult = ReturnType<typeof useCampaignReviewResultLazyQuery>;
export type CampaignReviewResultSuspenseQueryHookResult = ReturnType<typeof useCampaignReviewResultSuspenseQuery>;
export type CampaignReviewResultQueryResult = Apollo.QueryResult<CampaignReviewResultQuery, CampaignReviewResultQueryVariables>;
export const CampaignSchedulesDocument = gql`
    query CampaignSchedules($nodeId: ID!) {
  node(id: $nodeId) {
    ... on Campaign {
      id
      visitScheduleOffers {
        id
        visitDate
        snsType
        influencer {
          id
          name
          imageUrl
          age
          gender
          activeSnsConnections {
            ...ActiveSnsConnections
          }
        }
      }
    }
  }
}
    ${ActiveSnsConnectionsFragmentDoc}`;

/**
 * __useCampaignSchedulesQuery__
 *
 * To run a query within a React component, call `useCampaignSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignSchedulesQuery({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useCampaignSchedulesQuery(baseOptions: Apollo.QueryHookOptions<CampaignSchedulesQuery, CampaignSchedulesQueryVariables> & ({ variables: CampaignSchedulesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignSchedulesQuery, CampaignSchedulesQueryVariables>(CampaignSchedulesDocument, options);
      }
export function useCampaignSchedulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignSchedulesQuery, CampaignSchedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignSchedulesQuery, CampaignSchedulesQueryVariables>(CampaignSchedulesDocument, options);
        }
export function useCampaignSchedulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignSchedulesQuery, CampaignSchedulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignSchedulesQuery, CampaignSchedulesQueryVariables>(CampaignSchedulesDocument, options);
        }
export type CampaignSchedulesQueryHookResult = ReturnType<typeof useCampaignSchedulesQuery>;
export type CampaignSchedulesLazyQueryHookResult = ReturnType<typeof useCampaignSchedulesLazyQuery>;
export type CampaignSchedulesSuspenseQueryHookResult = ReturnType<typeof useCampaignSchedulesSuspenseQuery>;
export type CampaignSchedulesQueryResult = Apollo.QueryResult<CampaignSchedulesQuery, CampaignSchedulesQueryVariables>;
export const CampaignShopLocationsDocument = gql`
    query CampaignShopLocations($input: CampaignShopLocationsInput!) {
  campaignShopLocations(input: $input) {
    prefectureCode
    shopCityCode
    cityName
    town
  }
}
    `;

/**
 * __useCampaignShopLocationsQuery__
 *
 * To run a query within a React component, call `useCampaignShopLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignShopLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignShopLocationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCampaignShopLocationsQuery(baseOptions: Apollo.QueryHookOptions<CampaignShopLocationsQuery, CampaignShopLocationsQueryVariables> & ({ variables: CampaignShopLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignShopLocationsQuery, CampaignShopLocationsQueryVariables>(CampaignShopLocationsDocument, options);
      }
export function useCampaignShopLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignShopLocationsQuery, CampaignShopLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignShopLocationsQuery, CampaignShopLocationsQueryVariables>(CampaignShopLocationsDocument, options);
        }
export function useCampaignShopLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignShopLocationsQuery, CampaignShopLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignShopLocationsQuery, CampaignShopLocationsQueryVariables>(CampaignShopLocationsDocument, options);
        }
export type CampaignShopLocationsQueryHookResult = ReturnType<typeof useCampaignShopLocationsQuery>;
export type CampaignShopLocationsLazyQueryHookResult = ReturnType<typeof useCampaignShopLocationsLazyQuery>;
export type CampaignShopLocationsSuspenseQueryHookResult = ReturnType<typeof useCampaignShopLocationsSuspenseQuery>;
export type CampaignShopLocationsQueryResult = Apollo.QueryResult<CampaignShopLocationsQuery, CampaignShopLocationsQueryVariables>;
export const CampaignWithSchedulesDocument = gql`
    query CampaignWithSchedules($nodeId: ID!) {
  node(id: $nodeId) {
    ... on Campaign {
      ...CampaignSummary
      editableReservableSchedule
      reservableWeeklySchedule {
        ...CampaignReservableWeeklySchedule
      }
      reservableSchedules {
        ...CampaignReservableSchedule
      }
    }
  }
}
    ${CampaignSummaryFragmentDoc}
${CampaignReservableWeeklyScheduleFragmentDoc}
${CampaignReservableScheduleFragmentDoc}`;

/**
 * __useCampaignWithSchedulesQuery__
 *
 * To run a query within a React component, call `useCampaignWithSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignWithSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignWithSchedulesQuery({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useCampaignWithSchedulesQuery(baseOptions: Apollo.QueryHookOptions<CampaignWithSchedulesQuery, CampaignWithSchedulesQueryVariables> & ({ variables: CampaignWithSchedulesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignWithSchedulesQuery, CampaignWithSchedulesQueryVariables>(CampaignWithSchedulesDocument, options);
      }
export function useCampaignWithSchedulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignWithSchedulesQuery, CampaignWithSchedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignWithSchedulesQuery, CampaignWithSchedulesQueryVariables>(CampaignWithSchedulesDocument, options);
        }
export function useCampaignWithSchedulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignWithSchedulesQuery, CampaignWithSchedulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignWithSchedulesQuery, CampaignWithSchedulesQueryVariables>(CampaignWithSchedulesDocument, options);
        }
export type CampaignWithSchedulesQueryHookResult = ReturnType<typeof useCampaignWithSchedulesQuery>;
export type CampaignWithSchedulesLazyQueryHookResult = ReturnType<typeof useCampaignWithSchedulesLazyQuery>;
export type CampaignWithSchedulesSuspenseQueryHookResult = ReturnType<typeof useCampaignWithSchedulesSuspenseQuery>;
export type CampaignWithSchedulesQueryResult = Apollo.QueryResult<CampaignWithSchedulesQuery, CampaignWithSchedulesQueryVariables>;
export const DownloadReportsDocument = gql`
    query DownloadReports {
  downloadReports {
    createdAt
    downloadUrl
    fileType
    id
    status
    title
  }
}
    `;

/**
 * __useDownloadReportsQuery__
 *
 * To run a query within a React component, call `useDownloadReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadReportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDownloadReportsQuery(baseOptions?: Apollo.QueryHookOptions<DownloadReportsQuery, DownloadReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadReportsQuery, DownloadReportsQueryVariables>(DownloadReportsDocument, options);
      }
export function useDownloadReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadReportsQuery, DownloadReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadReportsQuery, DownloadReportsQueryVariables>(DownloadReportsDocument, options);
        }
export function useDownloadReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadReportsQuery, DownloadReportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadReportsQuery, DownloadReportsQueryVariables>(DownloadReportsDocument, options);
        }
export type DownloadReportsQueryHookResult = ReturnType<typeof useDownloadReportsQuery>;
export type DownloadReportsLazyQueryHookResult = ReturnType<typeof useDownloadReportsLazyQuery>;
export type DownloadReportsSuspenseQueryHookResult = ReturnType<typeof useDownloadReportsSuspenseQuery>;
export type DownloadReportsQueryResult = Apollo.QueryResult<DownloadReportsQuery, DownloadReportsQueryVariables>;
export const SearchGenresDocument = gql`
    query SearchGenres {
  searchGenres {
    id
    name
    subGenres {
      id
      name
    }
  }
}
    `;

/**
 * __useSearchGenresQuery__
 *
 * To run a query within a React component, call `useSearchGenresQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchGenresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchGenresQuery({
 *   variables: {
 *   },
 * });
 */
export function useSearchGenresQuery(baseOptions?: Apollo.QueryHookOptions<SearchGenresQuery, SearchGenresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchGenresQuery, SearchGenresQueryVariables>(SearchGenresDocument, options);
      }
export function useSearchGenresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchGenresQuery, SearchGenresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchGenresQuery, SearchGenresQueryVariables>(SearchGenresDocument, options);
        }
export function useSearchGenresSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchGenresQuery, SearchGenresQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchGenresQuery, SearchGenresQueryVariables>(SearchGenresDocument, options);
        }
export type SearchGenresQueryHookResult = ReturnType<typeof useSearchGenresQuery>;
export type SearchGenresLazyQueryHookResult = ReturnType<typeof useSearchGenresLazyQuery>;
export type SearchGenresSuspenseQueryHookResult = ReturnType<typeof useSearchGenresSuspenseQuery>;
export type SearchGenresQueryResult = Apollo.QueryResult<SearchGenresQuery, SearchGenresQueryVariables>;
export const OfferMailingDocument = gql`
    query OfferMailing($offerId: ID!) {
  offer(id: $offerId) {
    influencer {
      ...InfluencerMailingInfo
    }
  }
}
    ${InfluencerMailingInfoFragmentDoc}`;

/**
 * __useOfferMailingQuery__
 *
 * To run a query within a React component, call `useOfferMailingQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferMailingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferMailingQuery({
 *   variables: {
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useOfferMailingQuery(baseOptions: Apollo.QueryHookOptions<OfferMailingQuery, OfferMailingQueryVariables> & ({ variables: OfferMailingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OfferMailingQuery, OfferMailingQueryVariables>(OfferMailingDocument, options);
      }
export function useOfferMailingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OfferMailingQuery, OfferMailingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OfferMailingQuery, OfferMailingQueryVariables>(OfferMailingDocument, options);
        }
export function useOfferMailingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OfferMailingQuery, OfferMailingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OfferMailingQuery, OfferMailingQueryVariables>(OfferMailingDocument, options);
        }
export type OfferMailingQueryHookResult = ReturnType<typeof useOfferMailingQuery>;
export type OfferMailingLazyQueryHookResult = ReturnType<typeof useOfferMailingLazyQuery>;
export type OfferMailingSuspenseQueryHookResult = ReturnType<typeof useOfferMailingSuspenseQuery>;
export type OfferMailingQueryResult = Apollo.QueryResult<OfferMailingQuery, OfferMailingQueryVariables>;
export const RegularlyPublishedCampaignListDocument = gql`
    query RegularlyPublishedCampaignList {
  viewer: viewerAsAdvertiser {
    regularlyPublishedCampaigns {
      id
      name
      status
      offerStarted
      offerEnded
      coverImageUrls {
        ...CoverImageUrls
      }
      gross
      campaignSnsRequirements {
        ...CampaignSnsRequirement
      }
      offerStateCount {
        ...OfferStateCount
      }
      regularlyPublishedCampaigns {
        id
        status
        executionDay
        nextExecutionDate
      }
      ...CampaignCostInfo
    }
  }
}
    ${CoverImageUrlsFragmentDoc}
${CampaignSnsRequirementFragmentDoc}
${OfferStateCountFragmentDoc}
${CampaignCostInfoFragmentDoc}`;

/**
 * __useRegularlyPublishedCampaignListQuery__
 *
 * To run a query within a React component, call `useRegularlyPublishedCampaignListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegularlyPublishedCampaignListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegularlyPublishedCampaignListQuery({
 *   variables: {
 *   },
 * });
 */
export function useRegularlyPublishedCampaignListQuery(baseOptions?: Apollo.QueryHookOptions<RegularlyPublishedCampaignListQuery, RegularlyPublishedCampaignListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegularlyPublishedCampaignListQuery, RegularlyPublishedCampaignListQueryVariables>(RegularlyPublishedCampaignListDocument, options);
      }
export function useRegularlyPublishedCampaignListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegularlyPublishedCampaignListQuery, RegularlyPublishedCampaignListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegularlyPublishedCampaignListQuery, RegularlyPublishedCampaignListQueryVariables>(RegularlyPublishedCampaignListDocument, options);
        }
export function useRegularlyPublishedCampaignListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RegularlyPublishedCampaignListQuery, RegularlyPublishedCampaignListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RegularlyPublishedCampaignListQuery, RegularlyPublishedCampaignListQueryVariables>(RegularlyPublishedCampaignListDocument, options);
        }
export type RegularlyPublishedCampaignListQueryHookResult = ReturnType<typeof useRegularlyPublishedCampaignListQuery>;
export type RegularlyPublishedCampaignListLazyQueryHookResult = ReturnType<typeof useRegularlyPublishedCampaignListLazyQuery>;
export type RegularlyPublishedCampaignListSuspenseQueryHookResult = ReturnType<typeof useRegularlyPublishedCampaignListSuspenseQuery>;
export type RegularlyPublishedCampaignListQueryResult = Apollo.QueryResult<RegularlyPublishedCampaignListQuery, RegularlyPublishedCampaignListQueryVariables>;
export const WaitingCampaignListDocument = gql`
    query WaitingCampaignList($input: CampaignByAdvertiserInput) {
  viewer: viewerAsAdvertiser {
    ... on Advertiser {
      campaigns(input: $input) {
        ...WaitingCampaignsSummary
      }
    }
  }
}
    ${WaitingCampaignsSummaryFragmentDoc}`;

/**
 * __useWaitingCampaignListQuery__
 *
 * To run a query within a React component, call `useWaitingCampaignListQuery` and pass it any options that fit your needs.
 * When your component renders, `useWaitingCampaignListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWaitingCampaignListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWaitingCampaignListQuery(baseOptions?: Apollo.QueryHookOptions<WaitingCampaignListQuery, WaitingCampaignListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WaitingCampaignListQuery, WaitingCampaignListQueryVariables>(WaitingCampaignListDocument, options);
      }
export function useWaitingCampaignListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WaitingCampaignListQuery, WaitingCampaignListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WaitingCampaignListQuery, WaitingCampaignListQueryVariables>(WaitingCampaignListDocument, options);
        }
export function useWaitingCampaignListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WaitingCampaignListQuery, WaitingCampaignListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WaitingCampaignListQuery, WaitingCampaignListQueryVariables>(WaitingCampaignListDocument, options);
        }
export type WaitingCampaignListQueryHookResult = ReturnType<typeof useWaitingCampaignListQuery>;
export type WaitingCampaignListLazyQueryHookResult = ReturnType<typeof useWaitingCampaignListLazyQuery>;
export type WaitingCampaignListSuspenseQueryHookResult = ReturnType<typeof useWaitingCampaignListSuspenseQuery>;
export type WaitingCampaignListQueryResult = Apollo.QueryResult<WaitingCampaignListQuery, WaitingCampaignListQueryVariables>;
export const WaitingPublishCampaignsDocument = gql`
    query WaitingPublishCampaigns {
  waitingPublishCampaigns {
    ...WaitingCampaignsSummary
  }
}
    ${WaitingCampaignsSummaryFragmentDoc}`;

/**
 * __useWaitingPublishCampaignsQuery__
 *
 * To run a query within a React component, call `useWaitingPublishCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWaitingPublishCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWaitingPublishCampaignsQuery({
 *   variables: {
 *   },
 * });
 */
export function useWaitingPublishCampaignsQuery(baseOptions?: Apollo.QueryHookOptions<WaitingPublishCampaignsQuery, WaitingPublishCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WaitingPublishCampaignsQuery, WaitingPublishCampaignsQueryVariables>(WaitingPublishCampaignsDocument, options);
      }
export function useWaitingPublishCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WaitingPublishCampaignsQuery, WaitingPublishCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WaitingPublishCampaignsQuery, WaitingPublishCampaignsQueryVariables>(WaitingPublishCampaignsDocument, options);
        }
export function useWaitingPublishCampaignsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WaitingPublishCampaignsQuery, WaitingPublishCampaignsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WaitingPublishCampaignsQuery, WaitingPublishCampaignsQueryVariables>(WaitingPublishCampaignsDocument, options);
        }
export type WaitingPublishCampaignsQueryHookResult = ReturnType<typeof useWaitingPublishCampaignsQuery>;
export type WaitingPublishCampaignsLazyQueryHookResult = ReturnType<typeof useWaitingPublishCampaignsLazyQuery>;
export type WaitingPublishCampaignsSuspenseQueryHookResult = ReturnType<typeof useWaitingPublishCampaignsSuspenseQuery>;
export type WaitingPublishCampaignsQueryResult = Apollo.QueryResult<WaitingPublishCampaignsQuery, WaitingPublishCampaignsQueryVariables>;
export const CheckingAntiSocialDocument = gql`
    query checkingAntiSocial {
  viewerAsAdvertiser {
    checkingAntiSocial
  }
}
    `;

/**
 * __useCheckingAntiSocialQuery__
 *
 * To run a query within a React component, call `useCheckingAntiSocialQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckingAntiSocialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckingAntiSocialQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckingAntiSocialQuery(baseOptions?: Apollo.QueryHookOptions<CheckingAntiSocialQuery, CheckingAntiSocialQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckingAntiSocialQuery, CheckingAntiSocialQueryVariables>(CheckingAntiSocialDocument, options);
      }
export function useCheckingAntiSocialLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckingAntiSocialQuery, CheckingAntiSocialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckingAntiSocialQuery, CheckingAntiSocialQueryVariables>(CheckingAntiSocialDocument, options);
        }
export function useCheckingAntiSocialSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckingAntiSocialQuery, CheckingAntiSocialQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckingAntiSocialQuery, CheckingAntiSocialQueryVariables>(CheckingAntiSocialDocument, options);
        }
export type CheckingAntiSocialQueryHookResult = ReturnType<typeof useCheckingAntiSocialQuery>;
export type CheckingAntiSocialLazyQueryHookResult = ReturnType<typeof useCheckingAntiSocialLazyQuery>;
export type CheckingAntiSocialSuspenseQueryHookResult = ReturnType<typeof useCheckingAntiSocialSuspenseQuery>;
export type CheckingAntiSocialQueryResult = Apollo.QueryResult<CheckingAntiSocialQuery, CheckingAntiSocialQueryVariables>;
export const ApproveCampaignEntryDocument = gql`
    mutation ApproveCampaignEntry($input: ApproveCampaignEntryInput!) {
  approveCampaignEntryV2(input: $input) {
    id
    status
    campaign {
      id
      name
      offeringCapacity
      offersCount
      ...EntriesCountByStatus
    }
  }
}
    ${EntriesCountByStatusFragmentDoc}`;
export type ApproveCampaignEntryMutationFn = Apollo.MutationFunction<ApproveCampaignEntryMutation, ApproveCampaignEntryMutationVariables>;

/**
 * __useApproveCampaignEntryMutation__
 *
 * To run a mutation, you first call `useApproveCampaignEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveCampaignEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveCampaignEntryMutation, { data, loading, error }] = useApproveCampaignEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveCampaignEntryMutation(baseOptions?: Apollo.MutationHookOptions<ApproveCampaignEntryMutation, ApproveCampaignEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveCampaignEntryMutation, ApproveCampaignEntryMutationVariables>(ApproveCampaignEntryDocument, options);
      }
export type ApproveCampaignEntryMutationHookResult = ReturnType<typeof useApproveCampaignEntryMutation>;
export type ApproveCampaignEntryMutationResult = Apollo.MutationResult<ApproveCampaignEntryMutation>;
export type ApproveCampaignEntryMutationOptions = Apollo.BaseMutationOptions<ApproveCampaignEntryMutation, ApproveCampaignEntryMutationVariables>;
export const BlockCampaignEntryDocument = gql`
    mutation BlockCampaignEntry($blockCampaignEntryId: ID!) {
  blockCampaignEntry(id: $blockCampaignEntryId) {
    id
    status
    campaign {
      id
      ...EntriesCountByStatus
    }
  }
}
    ${EntriesCountByStatusFragmentDoc}`;
export type BlockCampaignEntryMutationFn = Apollo.MutationFunction<BlockCampaignEntryMutation, BlockCampaignEntryMutationVariables>;

/**
 * __useBlockCampaignEntryMutation__
 *
 * To run a mutation, you first call `useBlockCampaignEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockCampaignEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockCampaignEntryMutation, { data, loading, error }] = useBlockCampaignEntryMutation({
 *   variables: {
 *      blockCampaignEntryId: // value for 'blockCampaignEntryId'
 *   },
 * });
 */
export function useBlockCampaignEntryMutation(baseOptions?: Apollo.MutationHookOptions<BlockCampaignEntryMutation, BlockCampaignEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BlockCampaignEntryMutation, BlockCampaignEntryMutationVariables>(BlockCampaignEntryDocument, options);
      }
export type BlockCampaignEntryMutationHookResult = ReturnType<typeof useBlockCampaignEntryMutation>;
export type BlockCampaignEntryMutationResult = Apollo.MutationResult<BlockCampaignEntryMutation>;
export type BlockCampaignEntryMutationOptions = Apollo.BaseMutationOptions<BlockCampaignEntryMutation, BlockCampaignEntryMutationVariables>;
export const PinCampaignEntryDocument = gql`
    mutation PinCampaignEntry($input: PinCampaignEntryInput!) {
  pinCampaignEntry(input: $input) {
    id
    pinned
  }
}
    `;
export type PinCampaignEntryMutationFn = Apollo.MutationFunction<PinCampaignEntryMutation, PinCampaignEntryMutationVariables>;

/**
 * __usePinCampaignEntryMutation__
 *
 * To run a mutation, you first call `usePinCampaignEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePinCampaignEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pinCampaignEntryMutation, { data, loading, error }] = usePinCampaignEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePinCampaignEntryMutation(baseOptions?: Apollo.MutationHookOptions<PinCampaignEntryMutation, PinCampaignEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PinCampaignEntryMutation, PinCampaignEntryMutationVariables>(PinCampaignEntryDocument, options);
      }
export type PinCampaignEntryMutationHookResult = ReturnType<typeof usePinCampaignEntryMutation>;
export type PinCampaignEntryMutationResult = Apollo.MutationResult<PinCampaignEntryMutation>;
export type PinCampaignEntryMutationOptions = Apollo.BaseMutationOptions<PinCampaignEntryMutation, PinCampaignEntryMutationVariables>;
export const UnpinCampaignEntryDocument = gql`
    mutation UnpinCampaignEntry($input: UnpinCampaignEntryInput!) {
  unpinCampaignEntry(input: $input) {
    id
    pinned
  }
}
    `;
export type UnpinCampaignEntryMutationFn = Apollo.MutationFunction<UnpinCampaignEntryMutation, UnpinCampaignEntryMutationVariables>;

/**
 * __useUnpinCampaignEntryMutation__
 *
 * To run a mutation, you first call `useUnpinCampaignEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpinCampaignEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpinCampaignEntryMutation, { data, loading, error }] = useUnpinCampaignEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnpinCampaignEntryMutation(baseOptions?: Apollo.MutationHookOptions<UnpinCampaignEntryMutation, UnpinCampaignEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnpinCampaignEntryMutation, UnpinCampaignEntryMutationVariables>(UnpinCampaignEntryDocument, options);
      }
export type UnpinCampaignEntryMutationHookResult = ReturnType<typeof useUnpinCampaignEntryMutation>;
export type UnpinCampaignEntryMutationResult = Apollo.MutationResult<UnpinCampaignEntryMutation>;
export type UnpinCampaignEntryMutationOptions = Apollo.BaseMutationOptions<UnpinCampaignEntryMutation, UnpinCampaignEntryMutationVariables>;
export const CampaignEntriesDocument = gql`
    query CampaignEntries($id: ID!, $first: Int = 12, $pinned: Pinned, $gender: Gender, $ageRange: AgeRange, $orderby: CampaignEntriesOrder!, $offset: Int = 0) {
  campaign(id: $id) {
    id
    ...EntriesCountByStatus
    question
    entries(
      first: $first
      offset: $offset
      pinned: $pinned
      orderby: $orderby
      gender: $gender
      ageRange: $ageRange
    ) {
      edges {
        node {
          ...CampaignEntryDetail
        }
      }
      pageInfo {
        ...PageInfo
      }
      totalCount
    }
  }
}
    ${EntriesCountByStatusFragmentDoc}
${CampaignEntryDetailFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useCampaignEntriesQuery__
 *
 * To run a query within a React component, call `useCampaignEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignEntriesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      pinned: // value for 'pinned'
 *      gender: // value for 'gender'
 *      ageRange: // value for 'ageRange'
 *      orderby: // value for 'orderby'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useCampaignEntriesQuery(baseOptions: Apollo.QueryHookOptions<CampaignEntriesQuery, CampaignEntriesQueryVariables> & ({ variables: CampaignEntriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignEntriesQuery, CampaignEntriesQueryVariables>(CampaignEntriesDocument, options);
      }
export function useCampaignEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignEntriesQuery, CampaignEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignEntriesQuery, CampaignEntriesQueryVariables>(CampaignEntriesDocument, options);
        }
export function useCampaignEntriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignEntriesQuery, CampaignEntriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignEntriesQuery, CampaignEntriesQueryVariables>(CampaignEntriesDocument, options);
        }
export type CampaignEntriesQueryHookResult = ReturnType<typeof useCampaignEntriesQuery>;
export type CampaignEntriesLazyQueryHookResult = ReturnType<typeof useCampaignEntriesLazyQuery>;
export type CampaignEntriesSuspenseQueryHookResult = ReturnType<typeof useCampaignEntriesSuspenseQuery>;
export type CampaignEntriesQueryResult = Apollo.QueryResult<CampaignEntriesQuery, CampaignEntriesQueryVariables>;
export const CampaignEntryDocument = gql`
    query CampaignEntry($nodeId: ID!) {
  node(id: $nodeId) {
    ... on CampaignEntry {
      ...CampaignEntryDetail
      campaign {
        ...CampaignSummary
      }
    }
  }
}
    ${CampaignEntryDetailFragmentDoc}
${CampaignSummaryFragmentDoc}`;

/**
 * __useCampaignEntryQuery__
 *
 * To run a query within a React component, call `useCampaignEntryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignEntryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignEntryQuery({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useCampaignEntryQuery(baseOptions: Apollo.QueryHookOptions<CampaignEntryQuery, CampaignEntryQueryVariables> & ({ variables: CampaignEntryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignEntryQuery, CampaignEntryQueryVariables>(CampaignEntryDocument, options);
      }
export function useCampaignEntryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignEntryQuery, CampaignEntryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignEntryQuery, CampaignEntryQueryVariables>(CampaignEntryDocument, options);
        }
export function useCampaignEntrySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignEntryQuery, CampaignEntryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignEntryQuery, CampaignEntryQueryVariables>(CampaignEntryDocument, options);
        }
export type CampaignEntryQueryHookResult = ReturnType<typeof useCampaignEntryQuery>;
export type CampaignEntryLazyQueryHookResult = ReturnType<typeof useCampaignEntryLazyQuery>;
export type CampaignEntrySuspenseQueryHookResult = ReturnType<typeof useCampaignEntrySuspenseQuery>;
export type CampaignEntryQueryResult = Apollo.QueryResult<CampaignEntryQuery, CampaignEntryQueryVariables>;
export const OfferCampaignEntryDocument = gql`
    query OfferCampaignEntry($nodeId: ID!) {
  node(id: $nodeId) {
    ... on Offer {
      id
      campaignEntry {
        id
        companionCount
        answer
        prPostLanguage
        campaign {
          id
          question
          category
        }
      }
    }
  }
}
    `;

/**
 * __useOfferCampaignEntryQuery__
 *
 * To run a query within a React component, call `useOfferCampaignEntryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferCampaignEntryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferCampaignEntryQuery({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useOfferCampaignEntryQuery(baseOptions: Apollo.QueryHookOptions<OfferCampaignEntryQuery, OfferCampaignEntryQueryVariables> & ({ variables: OfferCampaignEntryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OfferCampaignEntryQuery, OfferCampaignEntryQueryVariables>(OfferCampaignEntryDocument, options);
      }
export function useOfferCampaignEntryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OfferCampaignEntryQuery, OfferCampaignEntryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OfferCampaignEntryQuery, OfferCampaignEntryQueryVariables>(OfferCampaignEntryDocument, options);
        }
export function useOfferCampaignEntrySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OfferCampaignEntryQuery, OfferCampaignEntryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OfferCampaignEntryQuery, OfferCampaignEntryQueryVariables>(OfferCampaignEntryDocument, options);
        }
export type OfferCampaignEntryQueryHookResult = ReturnType<typeof useOfferCampaignEntryQuery>;
export type OfferCampaignEntryLazyQueryHookResult = ReturnType<typeof useOfferCampaignEntryLazyQuery>;
export type OfferCampaignEntrySuspenseQueryHookResult = ReturnType<typeof useOfferCampaignEntrySuspenseQuery>;
export type OfferCampaignEntryQueryResult = Apollo.QueryResult<OfferCampaignEntryQuery, OfferCampaignEntryQueryVariables>;
export const AdvAccountPerformanceReportTimeSeriesDocument = gql`
    query AdvAccountPerformanceReportTimeSeries($input: AdvAccountPerformanceReportTimeSeriesInput!) {
  advAccountPerformanceReportTimeSeries(input: $input) {
    name
    value {
      date
      value
    }
  }
}
    `;

/**
 * __useAdvAccountPerformanceReportTimeSeriesQuery__
 *
 * To run a query within a React component, call `useAdvAccountPerformanceReportTimeSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdvAccountPerformanceReportTimeSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdvAccountPerformanceReportTimeSeriesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdvAccountPerformanceReportTimeSeriesQuery(baseOptions: Apollo.QueryHookOptions<AdvAccountPerformanceReportTimeSeriesQuery, AdvAccountPerformanceReportTimeSeriesQueryVariables> & ({ variables: AdvAccountPerformanceReportTimeSeriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdvAccountPerformanceReportTimeSeriesQuery, AdvAccountPerformanceReportTimeSeriesQueryVariables>(AdvAccountPerformanceReportTimeSeriesDocument, options);
      }
export function useAdvAccountPerformanceReportTimeSeriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdvAccountPerformanceReportTimeSeriesQuery, AdvAccountPerformanceReportTimeSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdvAccountPerformanceReportTimeSeriesQuery, AdvAccountPerformanceReportTimeSeriesQueryVariables>(AdvAccountPerformanceReportTimeSeriesDocument, options);
        }
export function useAdvAccountPerformanceReportTimeSeriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdvAccountPerformanceReportTimeSeriesQuery, AdvAccountPerformanceReportTimeSeriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdvAccountPerformanceReportTimeSeriesQuery, AdvAccountPerformanceReportTimeSeriesQueryVariables>(AdvAccountPerformanceReportTimeSeriesDocument, options);
        }
export type AdvAccountPerformanceReportTimeSeriesQueryHookResult = ReturnType<typeof useAdvAccountPerformanceReportTimeSeriesQuery>;
export type AdvAccountPerformanceReportTimeSeriesLazyQueryHookResult = ReturnType<typeof useAdvAccountPerformanceReportTimeSeriesLazyQuery>;
export type AdvAccountPerformanceReportTimeSeriesSuspenseQueryHookResult = ReturnType<typeof useAdvAccountPerformanceReportTimeSeriesSuspenseQuery>;
export type AdvAccountPerformanceReportTimeSeriesQueryResult = Apollo.QueryResult<AdvAccountPerformanceReportTimeSeriesQuery, AdvAccountPerformanceReportTimeSeriesQueryVariables>;
export const CampaignPerformanceMetricsDocument = gql`
    query CampaignPerformanceMetrics($pagination: OffsetPaginationInput!, $order: PerformanceMetricsOrder, $input: CampaignPerformanceMetricsInput!) {
  campaignPerformanceMetrics(
    pagination: $pagination
    order: $order
    input: $input
  ) {
    nodes {
      advAccountId
      campaignId
      impressions
      reaches
      engagements
      engagementRate
      likes
      comments
      saves
      shares
      postCounts
      startedAt
      endedAt
      campaign {
        id
        name
        thumbnailUrls
      }
    }
    totalCount
  }
}
    `;

/**
 * __useCampaignPerformanceMetricsQuery__
 *
 * To run a query within a React component, call `useCampaignPerformanceMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignPerformanceMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignPerformanceMetricsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCampaignPerformanceMetricsQuery(baseOptions: Apollo.QueryHookOptions<CampaignPerformanceMetricsQuery, CampaignPerformanceMetricsQueryVariables> & ({ variables: CampaignPerformanceMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignPerformanceMetricsQuery, CampaignPerformanceMetricsQueryVariables>(CampaignPerformanceMetricsDocument, options);
      }
export function useCampaignPerformanceMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignPerformanceMetricsQuery, CampaignPerformanceMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignPerformanceMetricsQuery, CampaignPerformanceMetricsQueryVariables>(CampaignPerformanceMetricsDocument, options);
        }
export function useCampaignPerformanceMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignPerformanceMetricsQuery, CampaignPerformanceMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignPerformanceMetricsQuery, CampaignPerformanceMetricsQueryVariables>(CampaignPerformanceMetricsDocument, options);
        }
export type CampaignPerformanceMetricsQueryHookResult = ReturnType<typeof useCampaignPerformanceMetricsQuery>;
export type CampaignPerformanceMetricsLazyQueryHookResult = ReturnType<typeof useCampaignPerformanceMetricsLazyQuery>;
export type CampaignPerformanceMetricsSuspenseQueryHookResult = ReturnType<typeof useCampaignPerformanceMetricsSuspenseQuery>;
export type CampaignPerformanceMetricsQueryResult = Apollo.QueryResult<CampaignPerformanceMetricsQuery, CampaignPerformanceMetricsQueryVariables>;
export const CampaignPerformanceMetricsSummaryDocument = gql`
    query CampaignPerformanceMetricsSummary($input: CampaignPerformanceMetricsInput!) {
  campaignPerformanceMetricsSummary(input: $input) {
    impressions
    reaches
    engagements
    engagementRate
    likes
    comments
    saves
    shares
    postCounts
    startedAt
    endedAt
  }
}
    `;

/**
 * __useCampaignPerformanceMetricsSummaryQuery__
 *
 * To run a query within a React component, call `useCampaignPerformanceMetricsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignPerformanceMetricsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignPerformanceMetricsSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCampaignPerformanceMetricsSummaryQuery(baseOptions: Apollo.QueryHookOptions<CampaignPerformanceMetricsSummaryQuery, CampaignPerformanceMetricsSummaryQueryVariables> & ({ variables: CampaignPerformanceMetricsSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignPerformanceMetricsSummaryQuery, CampaignPerformanceMetricsSummaryQueryVariables>(CampaignPerformanceMetricsSummaryDocument, options);
      }
export function useCampaignPerformanceMetricsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignPerformanceMetricsSummaryQuery, CampaignPerformanceMetricsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignPerformanceMetricsSummaryQuery, CampaignPerformanceMetricsSummaryQueryVariables>(CampaignPerformanceMetricsSummaryDocument, options);
        }
export function useCampaignPerformanceMetricsSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignPerformanceMetricsSummaryQuery, CampaignPerformanceMetricsSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignPerformanceMetricsSummaryQuery, CampaignPerformanceMetricsSummaryQueryVariables>(CampaignPerformanceMetricsSummaryDocument, options);
        }
export type CampaignPerformanceMetricsSummaryQueryHookResult = ReturnType<typeof useCampaignPerformanceMetricsSummaryQuery>;
export type CampaignPerformanceMetricsSummaryLazyQueryHookResult = ReturnType<typeof useCampaignPerformanceMetricsSummaryLazyQuery>;
export type CampaignPerformanceMetricsSummarySuspenseQueryHookResult = ReturnType<typeof useCampaignPerformanceMetricsSummarySuspenseQuery>;
export type CampaignPerformanceMetricsSummaryQueryResult = Apollo.QueryResult<CampaignPerformanceMetricsSummaryQuery, CampaignPerformanceMetricsSummaryQueryVariables>;
export const CampaignPerformanceReportTimeSeriesDocument = gql`
    query CampaignPerformanceReportTimeSeries($input: CampaignPerformanceReportTimeSeriesInput!) {
  campaignPerformanceReportTimeSeries(input: $input) {
    name
    value {
      date
      value
    }
  }
}
    `;

/**
 * __useCampaignPerformanceReportTimeSeriesQuery__
 *
 * To run a query within a React component, call `useCampaignPerformanceReportTimeSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignPerformanceReportTimeSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignPerformanceReportTimeSeriesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCampaignPerformanceReportTimeSeriesQuery(baseOptions: Apollo.QueryHookOptions<CampaignPerformanceReportTimeSeriesQuery, CampaignPerformanceReportTimeSeriesQueryVariables> & ({ variables: CampaignPerformanceReportTimeSeriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignPerformanceReportTimeSeriesQuery, CampaignPerformanceReportTimeSeriesQueryVariables>(CampaignPerformanceReportTimeSeriesDocument, options);
      }
export function useCampaignPerformanceReportTimeSeriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignPerformanceReportTimeSeriesQuery, CampaignPerformanceReportTimeSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignPerformanceReportTimeSeriesQuery, CampaignPerformanceReportTimeSeriesQueryVariables>(CampaignPerformanceReportTimeSeriesDocument, options);
        }
export function useCampaignPerformanceReportTimeSeriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignPerformanceReportTimeSeriesQuery, CampaignPerformanceReportTimeSeriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignPerformanceReportTimeSeriesQuery, CampaignPerformanceReportTimeSeriesQueryVariables>(CampaignPerformanceReportTimeSeriesDocument, options);
        }
export type CampaignPerformanceReportTimeSeriesQueryHookResult = ReturnType<typeof useCampaignPerformanceReportTimeSeriesQuery>;
export type CampaignPerformanceReportTimeSeriesLazyQueryHookResult = ReturnType<typeof useCampaignPerformanceReportTimeSeriesLazyQuery>;
export type CampaignPerformanceReportTimeSeriesSuspenseQueryHookResult = ReturnType<typeof useCampaignPerformanceReportTimeSeriesSuspenseQuery>;
export type CampaignPerformanceReportTimeSeriesQueryResult = Apollo.QueryResult<CampaignPerformanceReportTimeSeriesQuery, CampaignPerformanceReportTimeSeriesQueryVariables>;
export const PostPerformanceMetricsDocument = gql`
    query PostPerformanceMetrics($pagination: OffsetPaginationInput!, $order: PerformanceMetricsOrder, $input: PostPerformanceMetricsInput!) {
  postPerformanceMetrics(pagination: $pagination, order: $order, input: $input) {
    nodes {
      snsType
      snsOriginalPostId
      advAccountId
      campaignId
      offerId
      impressions
      reaches
      engagements
      engagementRate
      likes
      comments
      saves
      shares
      startedAt
      endedAt
      postInfo {
        postUrl
        postThumbnailUrl
        userInfluencerId
        userInfluencerName
        snsConnectUid
        snsConnectName
      }
      campaign {
        id
        name
        thumbnailUrls
      }
    }
    totalCount
  }
}
    `;

/**
 * __usePostPerformanceMetricsQuery__
 *
 * To run a query within a React component, call `usePostPerformanceMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostPerformanceMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostPerformanceMetricsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePostPerformanceMetricsQuery(baseOptions: Apollo.QueryHookOptions<PostPerformanceMetricsQuery, PostPerformanceMetricsQueryVariables> & ({ variables: PostPerformanceMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostPerformanceMetricsQuery, PostPerformanceMetricsQueryVariables>(PostPerformanceMetricsDocument, options);
      }
export function usePostPerformanceMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostPerformanceMetricsQuery, PostPerformanceMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostPerformanceMetricsQuery, PostPerformanceMetricsQueryVariables>(PostPerformanceMetricsDocument, options);
        }
export function usePostPerformanceMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostPerformanceMetricsQuery, PostPerformanceMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PostPerformanceMetricsQuery, PostPerformanceMetricsQueryVariables>(PostPerformanceMetricsDocument, options);
        }
export type PostPerformanceMetricsQueryHookResult = ReturnType<typeof usePostPerformanceMetricsQuery>;
export type PostPerformanceMetricsLazyQueryHookResult = ReturnType<typeof usePostPerformanceMetricsLazyQuery>;
export type PostPerformanceMetricsSuspenseQueryHookResult = ReturnType<typeof usePostPerformanceMetricsSuspenseQuery>;
export type PostPerformanceMetricsQueryResult = Apollo.QueryResult<PostPerformanceMetricsQuery, PostPerformanceMetricsQueryVariables>;
export const PostPerformanceMetricsSummaryDocument = gql`
    query PostPerformanceMetricsSummary($input: PostPerformanceMetricsInput!) {
  postPerformanceMetricsSummary(input: $input) {
    impressions
    reaches
    engagements
    engagementRate
    likes
    comments
    saves
    shares
    startedAt
    endedAt
  }
}
    `;

/**
 * __usePostPerformanceMetricsSummaryQuery__
 *
 * To run a query within a React component, call `usePostPerformanceMetricsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostPerformanceMetricsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostPerformanceMetricsSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePostPerformanceMetricsSummaryQuery(baseOptions: Apollo.QueryHookOptions<PostPerformanceMetricsSummaryQuery, PostPerformanceMetricsSummaryQueryVariables> & ({ variables: PostPerformanceMetricsSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostPerformanceMetricsSummaryQuery, PostPerformanceMetricsSummaryQueryVariables>(PostPerformanceMetricsSummaryDocument, options);
      }
export function usePostPerformanceMetricsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostPerformanceMetricsSummaryQuery, PostPerformanceMetricsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostPerformanceMetricsSummaryQuery, PostPerformanceMetricsSummaryQueryVariables>(PostPerformanceMetricsSummaryDocument, options);
        }
export function usePostPerformanceMetricsSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostPerformanceMetricsSummaryQuery, PostPerformanceMetricsSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PostPerformanceMetricsSummaryQuery, PostPerformanceMetricsSummaryQueryVariables>(PostPerformanceMetricsSummaryDocument, options);
        }
export type PostPerformanceMetricsSummaryQueryHookResult = ReturnType<typeof usePostPerformanceMetricsSummaryQuery>;
export type PostPerformanceMetricsSummaryLazyQueryHookResult = ReturnType<typeof usePostPerformanceMetricsSummaryLazyQuery>;
export type PostPerformanceMetricsSummarySuspenseQueryHookResult = ReturnType<typeof usePostPerformanceMetricsSummarySuspenseQuery>;
export type PostPerformanceMetricsSummaryQueryResult = Apollo.QueryResult<PostPerformanceMetricsSummaryQuery, PostPerformanceMetricsSummaryQueryVariables>;
export const DeleteCompanyNotificationEmailDocument = gql`
    mutation DeleteCompanyNotificationEmail($input: DeleteCompanyNotificationEmailInput!) {
  deleteCompanyNotificationEmail(input: $input) {
    id
    notificationEmail
    activation
  }
}
    `;
export type DeleteCompanyNotificationEmailMutationFn = Apollo.MutationFunction<DeleteCompanyNotificationEmailMutation, DeleteCompanyNotificationEmailMutationVariables>;

/**
 * __useDeleteCompanyNotificationEmailMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyNotificationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyNotificationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyNotificationEmailMutation, { data, loading, error }] = useDeleteCompanyNotificationEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCompanyNotificationEmailMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompanyNotificationEmailMutation, DeleteCompanyNotificationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompanyNotificationEmailMutation, DeleteCompanyNotificationEmailMutationVariables>(DeleteCompanyNotificationEmailDocument, options);
      }
export type DeleteCompanyNotificationEmailMutationHookResult = ReturnType<typeof useDeleteCompanyNotificationEmailMutation>;
export type DeleteCompanyNotificationEmailMutationResult = Apollo.MutationResult<DeleteCompanyNotificationEmailMutation>;
export type DeleteCompanyNotificationEmailMutationOptions = Apollo.BaseMutationOptions<DeleteCompanyNotificationEmailMutation, DeleteCompanyNotificationEmailMutationVariables>;
export const ProvisionallyRegisterCompanyNotificationEmailDocument = gql`
    mutation ProvisionallyRegisterCompanyNotificationEmail($input: ProvisionallyRegisterCompanyNotificationEmailInput!) {
  provisionallyRegisterCompanyNotificationEmail(input: $input) {
    ...CompanyNotificationEmail
  }
}
    ${CompanyNotificationEmailFragmentDoc}`;
export type ProvisionallyRegisterCompanyNotificationEmailMutationFn = Apollo.MutationFunction<ProvisionallyRegisterCompanyNotificationEmailMutation, ProvisionallyRegisterCompanyNotificationEmailMutationVariables>;

/**
 * __useProvisionallyRegisterCompanyNotificationEmailMutation__
 *
 * To run a mutation, you first call `useProvisionallyRegisterCompanyNotificationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProvisionallyRegisterCompanyNotificationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [provisionallyRegisterCompanyNotificationEmailMutation, { data, loading, error }] = useProvisionallyRegisterCompanyNotificationEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProvisionallyRegisterCompanyNotificationEmailMutation(baseOptions?: Apollo.MutationHookOptions<ProvisionallyRegisterCompanyNotificationEmailMutation, ProvisionallyRegisterCompanyNotificationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProvisionallyRegisterCompanyNotificationEmailMutation, ProvisionallyRegisterCompanyNotificationEmailMutationVariables>(ProvisionallyRegisterCompanyNotificationEmailDocument, options);
      }
export type ProvisionallyRegisterCompanyNotificationEmailMutationHookResult = ReturnType<typeof useProvisionallyRegisterCompanyNotificationEmailMutation>;
export type ProvisionallyRegisterCompanyNotificationEmailMutationResult = Apollo.MutationResult<ProvisionallyRegisterCompanyNotificationEmailMutation>;
export type ProvisionallyRegisterCompanyNotificationEmailMutationOptions = Apollo.BaseMutationOptions<ProvisionallyRegisterCompanyNotificationEmailMutation, ProvisionallyRegisterCompanyNotificationEmailMutationVariables>;
export const ReSendActivateCompanyNotificationEmailDocument = gql`
    mutation ReSendActivateCompanyNotificationEmail($input: ReSendActivateCompanyNotificationEmailInput!) {
  reSendActivateCompanyNotificationEmail(input: $input) {
    id
    notificationEmail
    activation
  }
}
    `;
export type ReSendActivateCompanyNotificationEmailMutationFn = Apollo.MutationFunction<ReSendActivateCompanyNotificationEmailMutation, ReSendActivateCompanyNotificationEmailMutationVariables>;

/**
 * __useReSendActivateCompanyNotificationEmailMutation__
 *
 * To run a mutation, you first call `useReSendActivateCompanyNotificationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReSendActivateCompanyNotificationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reSendActivateCompanyNotificationEmailMutation, { data, loading, error }] = useReSendActivateCompanyNotificationEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReSendActivateCompanyNotificationEmailMutation(baseOptions?: Apollo.MutationHookOptions<ReSendActivateCompanyNotificationEmailMutation, ReSendActivateCompanyNotificationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReSendActivateCompanyNotificationEmailMutation, ReSendActivateCompanyNotificationEmailMutationVariables>(ReSendActivateCompanyNotificationEmailDocument, options);
      }
export type ReSendActivateCompanyNotificationEmailMutationHookResult = ReturnType<typeof useReSendActivateCompanyNotificationEmailMutation>;
export type ReSendActivateCompanyNotificationEmailMutationResult = Apollo.MutationResult<ReSendActivateCompanyNotificationEmailMutation>;
export type ReSendActivateCompanyNotificationEmailMutationOptions = Apollo.BaseMutationOptions<ReSendActivateCompanyNotificationEmailMutation, ReSendActivateCompanyNotificationEmailMutationVariables>;
export const CompanyNotificationEmailsDocument = gql`
    query CompanyNotificationEmails {
  viewer: viewerAsAdvertiser {
    ... on Advertiser {
      company {
        adminMembers {
          id
          email
        }
        notificationEmails {
          ...CompanyNotificationEmail
        }
      }
    }
  }
}
    ${CompanyNotificationEmailFragmentDoc}`;

/**
 * __useCompanyNotificationEmailsQuery__
 *
 * To run a query within a React component, call `useCompanyNotificationEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyNotificationEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyNotificationEmailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanyNotificationEmailsQuery(baseOptions?: Apollo.QueryHookOptions<CompanyNotificationEmailsQuery, CompanyNotificationEmailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyNotificationEmailsQuery, CompanyNotificationEmailsQueryVariables>(CompanyNotificationEmailsDocument, options);
      }
export function useCompanyNotificationEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyNotificationEmailsQuery, CompanyNotificationEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyNotificationEmailsQuery, CompanyNotificationEmailsQueryVariables>(CompanyNotificationEmailsDocument, options);
        }
export function useCompanyNotificationEmailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyNotificationEmailsQuery, CompanyNotificationEmailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyNotificationEmailsQuery, CompanyNotificationEmailsQueryVariables>(CompanyNotificationEmailsDocument, options);
        }
export type CompanyNotificationEmailsQueryHookResult = ReturnType<typeof useCompanyNotificationEmailsQuery>;
export type CompanyNotificationEmailsLazyQueryHookResult = ReturnType<typeof useCompanyNotificationEmailsLazyQuery>;
export type CompanyNotificationEmailsSuspenseQueryHookResult = ReturnType<typeof useCompanyNotificationEmailsSuspenseQuery>;
export type CompanyNotificationEmailsQueryResult = Apollo.QueryResult<CompanyNotificationEmailsQuery, CompanyNotificationEmailsQueryVariables>;
export const SavePredictedPrPostEngagementMetricsDocument = gql`
    mutation SavePredictedPrPostEngagementMetrics($input: SavePredictedPrPostEngagementInput!) {
  savePredictedPrPostEngagementMetrics(input: $input) {
    status
  }
}
    `;
export type SavePredictedPrPostEngagementMetricsMutationFn = Apollo.MutationFunction<SavePredictedPrPostEngagementMetricsMutation, SavePredictedPrPostEngagementMetricsMutationVariables>;

/**
 * __useSavePredictedPrPostEngagementMetricsMutation__
 *
 * To run a mutation, you first call `useSavePredictedPrPostEngagementMetricsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePredictedPrPostEngagementMetricsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePredictedPrPostEngagementMetricsMutation, { data, loading, error }] = useSavePredictedPrPostEngagementMetricsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSavePredictedPrPostEngagementMetricsMutation(baseOptions?: Apollo.MutationHookOptions<SavePredictedPrPostEngagementMetricsMutation, SavePredictedPrPostEngagementMetricsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePredictedPrPostEngagementMetricsMutation, SavePredictedPrPostEngagementMetricsMutationVariables>(SavePredictedPrPostEngagementMetricsDocument, options);
      }
export type SavePredictedPrPostEngagementMetricsMutationHookResult = ReturnType<typeof useSavePredictedPrPostEngagementMetricsMutation>;
export type SavePredictedPrPostEngagementMetricsMutationResult = Apollo.MutationResult<SavePredictedPrPostEngagementMetricsMutation>;
export type SavePredictedPrPostEngagementMetricsMutationOptions = Apollo.BaseMutationOptions<SavePredictedPrPostEngagementMetricsMutation, SavePredictedPrPostEngagementMetricsMutationVariables>;
export const InvoiceDocument = gql`
    query Invoice($billingMonth: DateTime!) {
  viewer {
    ... on Advertiser {
      campaigns {
        id
        name
        coverImageUrls {
          original
          small
          medium
        }
        campaignSnsRequirements {
          id
          snsType
          postFooter
          requestUrl
          tagList {
            ...CampaignSnsRequirementTagFragment
          }
        }
        gross
        offerStarted
        offerEnded
        feeReport {
          campaignId
          fixedFeeDetail(input: {reportMonth: $billingMonth}) {
            ...CampaignFeeDetail
          }
          unsettledFeeDetail(input: {reportMonth: $billingMonth}) {
            ...CampaignFeeDetail
          }
        }
      }
      ticketSubscriptionInvoiceDetails(billingMonth: $billingMonth) {
        name
        billingDate
        price
        ticketSubscription {
          ...TicketSubscription
        }
      }
    }
  }
}
    ${CampaignSnsRequirementTagFragmentFragmentDoc}
${CampaignFeeDetailFragmentDoc}
${TicketSubscriptionFragmentDoc}`;

/**
 * __useInvoiceQuery__
 *
 * To run a query within a React component, call `useInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceQuery({
 *   variables: {
 *      billingMonth: // value for 'billingMonth'
 *   },
 * });
 */
export function useInvoiceQuery(baseOptions: Apollo.QueryHookOptions<InvoiceQuery, InvoiceQueryVariables> & ({ variables: InvoiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceQuery, InvoiceQueryVariables>(InvoiceDocument, options);
      }
export function useInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceQuery, InvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceQuery, InvoiceQueryVariables>(InvoiceDocument, options);
        }
export function useInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvoiceQuery, InvoiceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvoiceQuery, InvoiceQueryVariables>(InvoiceDocument, options);
        }
export type InvoiceQueryHookResult = ReturnType<typeof useInvoiceQuery>;
export type InvoiceLazyQueryHookResult = ReturnType<typeof useInvoiceLazyQuery>;
export type InvoiceSuspenseQueryHookResult = ReturnType<typeof useInvoiceSuspenseQuery>;
export type InvoiceQueryResult = Apollo.QueryResult<InvoiceQuery, InvoiceQueryVariables>;
export const IssueOneTimeLineAuthCodeDocument = gql`
    mutation IssueOneTimeLineAuthCode {
  issueOneTimeLineAuthCode
}
    `;
export type IssueOneTimeLineAuthCodeMutationFn = Apollo.MutationFunction<IssueOneTimeLineAuthCodeMutation, IssueOneTimeLineAuthCodeMutationVariables>;

/**
 * __useIssueOneTimeLineAuthCodeMutation__
 *
 * To run a mutation, you first call `useIssueOneTimeLineAuthCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueOneTimeLineAuthCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueOneTimeLineAuthCodeMutation, { data, loading, error }] = useIssueOneTimeLineAuthCodeMutation({
 *   variables: {
 *   },
 * });
 */
export function useIssueOneTimeLineAuthCodeMutation(baseOptions?: Apollo.MutationHookOptions<IssueOneTimeLineAuthCodeMutation, IssueOneTimeLineAuthCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IssueOneTimeLineAuthCodeMutation, IssueOneTimeLineAuthCodeMutationVariables>(IssueOneTimeLineAuthCodeDocument, options);
      }
export type IssueOneTimeLineAuthCodeMutationHookResult = ReturnType<typeof useIssueOneTimeLineAuthCodeMutation>;
export type IssueOneTimeLineAuthCodeMutationResult = Apollo.MutationResult<IssueOneTimeLineAuthCodeMutation>;
export type IssueOneTimeLineAuthCodeMutationOptions = Apollo.BaseMutationOptions<IssueOneTimeLineAuthCodeMutation, IssueOneTimeLineAuthCodeMutationVariables>;
export const CreateMfkessaiCustomerDocument = gql`
    mutation CreateMfkessaiCustomer($input: CreateMfkessaiCustomerInput!) {
  createMfkessaiCustomer(input: $input) {
    id
  }
}
    `;
export type CreateMfkessaiCustomerMutationFn = Apollo.MutationFunction<CreateMfkessaiCustomerMutation, CreateMfkessaiCustomerMutationVariables>;

/**
 * __useCreateMfkessaiCustomerMutation__
 *
 * To run a mutation, you first call `useCreateMfkessaiCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMfkessaiCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMfkessaiCustomerMutation, { data, loading, error }] = useCreateMfkessaiCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMfkessaiCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateMfkessaiCustomerMutation, CreateMfkessaiCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMfkessaiCustomerMutation, CreateMfkessaiCustomerMutationVariables>(CreateMfkessaiCustomerDocument, options);
      }
export type CreateMfkessaiCustomerMutationHookResult = ReturnType<typeof useCreateMfkessaiCustomerMutation>;
export type CreateMfkessaiCustomerMutationResult = Apollo.MutationResult<CreateMfkessaiCustomerMutation>;
export type CreateMfkessaiCustomerMutationOptions = Apollo.BaseMutationOptions<CreateMfkessaiCustomerMutation, CreateMfkessaiCustomerMutationVariables>;
export const MfkessaiDestinationDocument = gql`
    query MfkessaiDestination {
  viewer: viewerAsAdvertiser {
    mfkessaiDestination {
      address1
      address2
      ccEmails
      createdAt
      customerId
      department
      email
      id
      name
      nameKana
      tel
      title
      uri
      zipCode
    }
  }
}
    `;

/**
 * __useMfkessaiDestinationQuery__
 *
 * To run a query within a React component, call `useMfkessaiDestinationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMfkessaiDestinationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMfkessaiDestinationQuery({
 *   variables: {
 *   },
 * });
 */
export function useMfkessaiDestinationQuery(baseOptions?: Apollo.QueryHookOptions<MfkessaiDestinationQuery, MfkessaiDestinationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MfkessaiDestinationQuery, MfkessaiDestinationQueryVariables>(MfkessaiDestinationDocument, options);
      }
export function useMfkessaiDestinationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MfkessaiDestinationQuery, MfkessaiDestinationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MfkessaiDestinationQuery, MfkessaiDestinationQueryVariables>(MfkessaiDestinationDocument, options);
        }
export function useMfkessaiDestinationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MfkessaiDestinationQuery, MfkessaiDestinationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MfkessaiDestinationQuery, MfkessaiDestinationQueryVariables>(MfkessaiDestinationDocument, options);
        }
export type MfkessaiDestinationQueryHookResult = ReturnType<typeof useMfkessaiDestinationQuery>;
export type MfkessaiDestinationLazyQueryHookResult = ReturnType<typeof useMfkessaiDestinationLazyQuery>;
export type MfkessaiDestinationSuspenseQueryHookResult = ReturnType<typeof useMfkessaiDestinationSuspenseQuery>;
export type MfkessaiDestinationQueryResult = Apollo.QueryResult<MfkessaiDestinationQuery, MfkessaiDestinationQueryVariables>;
export const OfferListDocument = gql`
    query OfferList($input: OffersInput, $countInput: OfferCountInput!) {
  viewer: viewerAsAdvertiser {
    offerCount(input: $countInput)
    offers(input: $input) {
      ...OfferList_Offer
    }
  }
}
    ${OfferListOfferFragmentDoc}`;

/**
 * __useOfferListQuery__
 *
 * To run a query within a React component, call `useOfferListQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferListQuery({
 *   variables: {
 *      input: // value for 'input'
 *      countInput: // value for 'countInput'
 *   },
 * });
 */
export function useOfferListQuery(baseOptions: Apollo.QueryHookOptions<OfferListQuery, OfferListQueryVariables> & ({ variables: OfferListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OfferListQuery, OfferListQueryVariables>(OfferListDocument, options);
      }
export function useOfferListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OfferListQuery, OfferListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OfferListQuery, OfferListQueryVariables>(OfferListDocument, options);
        }
export function useOfferListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OfferListQuery, OfferListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OfferListQuery, OfferListQueryVariables>(OfferListDocument, options);
        }
export type OfferListQueryHookResult = ReturnType<typeof useOfferListQuery>;
export type OfferListLazyQueryHookResult = ReturnType<typeof useOfferListLazyQuery>;
export type OfferListSuspenseQueryHookResult = ReturnType<typeof useOfferListSuspenseQuery>;
export type OfferListQueryResult = Apollo.QueryResult<OfferListQuery, OfferListQueryVariables>;
export const AssignPenaltyToOfferDocument = gql`
    mutation AssignPenaltyToOffer($input: AssignPenaltyToOfferInput!) {
  assignPenaltyToOffer(input: $input) {
    ...UserInfluencerPenaltyReport
  }
}
    ${UserInfluencerPenaltyReportFragmentDoc}`;
export type AssignPenaltyToOfferMutationFn = Apollo.MutationFunction<AssignPenaltyToOfferMutation, AssignPenaltyToOfferMutationVariables>;

/**
 * __useAssignPenaltyToOfferMutation__
 *
 * To run a mutation, you first call `useAssignPenaltyToOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignPenaltyToOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignPenaltyToOfferMutation, { data, loading, error }] = useAssignPenaltyToOfferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignPenaltyToOfferMutation(baseOptions?: Apollo.MutationHookOptions<AssignPenaltyToOfferMutation, AssignPenaltyToOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignPenaltyToOfferMutation, AssignPenaltyToOfferMutationVariables>(AssignPenaltyToOfferDocument, options);
      }
export type AssignPenaltyToOfferMutationHookResult = ReturnType<typeof useAssignPenaltyToOfferMutation>;
export type AssignPenaltyToOfferMutationResult = Apollo.MutationResult<AssignPenaltyToOfferMutation>;
export type AssignPenaltyToOfferMutationOptions = Apollo.BaseMutationOptions<AssignPenaltyToOfferMutation, AssignPenaltyToOfferMutationVariables>;
export const PenaltyReasonsDocument = gql`
    query PenaltyReasons {
  penaltyReasons {
    id
    name
  }
}
    `;

/**
 * __usePenaltyReasonsQuery__
 *
 * To run a query within a React component, call `usePenaltyReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePenaltyReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePenaltyReasonsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePenaltyReasonsQuery(baseOptions?: Apollo.QueryHookOptions<PenaltyReasonsQuery, PenaltyReasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PenaltyReasonsQuery, PenaltyReasonsQueryVariables>(PenaltyReasonsDocument, options);
      }
export function usePenaltyReasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PenaltyReasonsQuery, PenaltyReasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PenaltyReasonsQuery, PenaltyReasonsQueryVariables>(PenaltyReasonsDocument, options);
        }
export function usePenaltyReasonsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PenaltyReasonsQuery, PenaltyReasonsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PenaltyReasonsQuery, PenaltyReasonsQueryVariables>(PenaltyReasonsDocument, options);
        }
export type PenaltyReasonsQueryHookResult = ReturnType<typeof usePenaltyReasonsQuery>;
export type PenaltyReasonsLazyQueryHookResult = ReturnType<typeof usePenaltyReasonsLazyQuery>;
export type PenaltyReasonsSuspenseQueryHookResult = ReturnType<typeof usePenaltyReasonsSuspenseQuery>;
export type PenaltyReasonsQueryResult = Apollo.QueryResult<PenaltyReasonsQuery, PenaltyReasonsQueryVariables>;
export const BillingReportDocument = gql`
    query BillingReport($input: BillingReportInput!) {
  billingReport(input: $input) {
    billingMonth
    campaignsFixedFee
    campaignsUnsettledFee
    hasCampaignRecruitmentFee
    subtotal
    ticketsFee
    totalAmount
    totalTax
    expenseFixedFee
    expenseUnsettledFee
    campaignInvoiceDetails {
      campaign {
        id
        name
        coverImageUrls {
          original
          small
          medium
        }
        campaignSnsRequirements {
          id
          snsType
          postFooter
          requestUrl
          tagList {
            ...CampaignSnsRequirementTagFragment
          }
        }
        gross
        offerStarted
        offerEnded
      }
      fixedFeeDetail {
        postedReward
        recruitmentFee
        recruitmentFeeWithTax
        totalTax
      }
      unsettledFeeDetail {
        postedReward
        recruitmentFee
        recruitmentFeeWithTax
        totalTax
      }
    }
    campaignExpenseInvoiceDetails {
      campaign {
        id
        name
        coverImageUrls {
          original
          small
          medium
        }
        campaignSnsRequirements {
          id
          snsType
          snsPostTypeList
          postFooter
          requestUrl
          tagList {
            ...CampaignSnsRequirementTagFragment
          }
        }
        gross
        offerStarted
        offerEnded
      }
      expenseFixedFeeDetail {
        expenseFee
      }
      expenseUnsettledFeeDetail {
        expenseFee
      }
    }
    ticketSubscriptionInvoiceDetails {
      id
      billingDate
      name
      paymentType
      price
      status
      tax
      taxIncludedPrice
      ticketSubscription {
        ...TicketSubscription
      }
    }
  }
}
    ${CampaignSnsRequirementTagFragmentFragmentDoc}
${TicketSubscriptionFragmentDoc}`;

/**
 * __useBillingReportQuery__
 *
 * To run a query within a React component, call `useBillingReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBillingReportQuery(baseOptions: Apollo.QueryHookOptions<BillingReportQuery, BillingReportQueryVariables> & ({ variables: BillingReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingReportQuery, BillingReportQueryVariables>(BillingReportDocument, options);
      }
export function useBillingReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingReportQuery, BillingReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingReportQuery, BillingReportQueryVariables>(BillingReportDocument, options);
        }
export function useBillingReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BillingReportQuery, BillingReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BillingReportQuery, BillingReportQueryVariables>(BillingReportDocument, options);
        }
export type BillingReportQueryHookResult = ReturnType<typeof useBillingReportQuery>;
export type BillingReportLazyQueryHookResult = ReturnType<typeof useBillingReportLazyQuery>;
export type BillingReportSuspenseQueryHookResult = ReturnType<typeof useBillingReportSuspenseQuery>;
export type BillingReportQueryResult = Apollo.QueryResult<BillingReportQuery, BillingReportQueryVariables>;
export const DisableRegularlyPublishedCampaignDocument = gql`
    mutation disableRegularlyPublishedCampaign($input: DisableRegularlyPublishedCampaignInput!) {
  disableRegularlyPublishedCampaign(input: $input) {
    id
  }
}
    `;
export type DisableRegularlyPublishedCampaignMutationFn = Apollo.MutationFunction<DisableRegularlyPublishedCampaignMutation, DisableRegularlyPublishedCampaignMutationVariables>;

/**
 * __useDisableRegularlyPublishedCampaignMutation__
 *
 * To run a mutation, you first call `useDisableRegularlyPublishedCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableRegularlyPublishedCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableRegularlyPublishedCampaignMutation, { data, loading, error }] = useDisableRegularlyPublishedCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisableRegularlyPublishedCampaignMutation(baseOptions?: Apollo.MutationHookOptions<DisableRegularlyPublishedCampaignMutation, DisableRegularlyPublishedCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableRegularlyPublishedCampaignMutation, DisableRegularlyPublishedCampaignMutationVariables>(DisableRegularlyPublishedCampaignDocument, options);
      }
export type DisableRegularlyPublishedCampaignMutationHookResult = ReturnType<typeof useDisableRegularlyPublishedCampaignMutation>;
export type DisableRegularlyPublishedCampaignMutationResult = Apollo.MutationResult<DisableRegularlyPublishedCampaignMutation>;
export type DisableRegularlyPublishedCampaignMutationOptions = Apollo.BaseMutationOptions<DisableRegularlyPublishedCampaignMutation, DisableRegularlyPublishedCampaignMutationVariables>;
export const EnableRegularlyPublishedCampaignDocument = gql`
    mutation enableRegularlyPublishedCampaign($input: EnableRegularlyPublishedCampaignInput!) {
  enableRegularlyPublishedCampaign(input: $input) {
    id
  }
}
    `;
export type EnableRegularlyPublishedCampaignMutationFn = Apollo.MutationFunction<EnableRegularlyPublishedCampaignMutation, EnableRegularlyPublishedCampaignMutationVariables>;

/**
 * __useEnableRegularlyPublishedCampaignMutation__
 *
 * To run a mutation, you first call `useEnableRegularlyPublishedCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableRegularlyPublishedCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableRegularlyPublishedCampaignMutation, { data, loading, error }] = useEnableRegularlyPublishedCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnableRegularlyPublishedCampaignMutation(baseOptions?: Apollo.MutationHookOptions<EnableRegularlyPublishedCampaignMutation, EnableRegularlyPublishedCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableRegularlyPublishedCampaignMutation, EnableRegularlyPublishedCampaignMutationVariables>(EnableRegularlyPublishedCampaignDocument, options);
      }
export type EnableRegularlyPublishedCampaignMutationHookResult = ReturnType<typeof useEnableRegularlyPublishedCampaignMutation>;
export type EnableRegularlyPublishedCampaignMutationResult = Apollo.MutationResult<EnableRegularlyPublishedCampaignMutation>;
export type EnableRegularlyPublishedCampaignMutationOptions = Apollo.BaseMutationOptions<EnableRegularlyPublishedCampaignMutation, EnableRegularlyPublishedCampaignMutationVariables>;
export const CreateCompanySnsConnectionDocument = gql`
    mutation CreateCompanySnsConnection($input: CreateCompanySnsConnectionInput!) {
  createCompanySnsConnection(input: $input) {
    ...SnsConnectionInfo
  }
}
    ${SnsConnectionInfoFragmentDoc}`;
export type CreateCompanySnsConnectionMutationFn = Apollo.MutationFunction<CreateCompanySnsConnectionMutation, CreateCompanySnsConnectionMutationVariables>;

/**
 * __useCreateCompanySnsConnectionMutation__
 *
 * To run a mutation, you first call `useCreateCompanySnsConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanySnsConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanySnsConnectionMutation, { data, loading, error }] = useCreateCompanySnsConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCompanySnsConnectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanySnsConnectionMutation, CreateCompanySnsConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanySnsConnectionMutation, CreateCompanySnsConnectionMutationVariables>(CreateCompanySnsConnectionDocument, options);
      }
export type CreateCompanySnsConnectionMutationHookResult = ReturnType<typeof useCreateCompanySnsConnectionMutation>;
export type CreateCompanySnsConnectionMutationResult = Apollo.MutationResult<CreateCompanySnsConnectionMutation>;
export type CreateCompanySnsConnectionMutationOptions = Apollo.BaseMutationOptions<CreateCompanySnsConnectionMutation, CreateCompanySnsConnectionMutationVariables>;
export const RemoveCompanySnsConnectionDocument = gql`
    mutation RemoveCompanySnsConnection($input: RemoveCompanySnsConnectionInput!) {
  removeCompanySnsConnection(input: $input)
}
    `;
export type RemoveCompanySnsConnectionMutationFn = Apollo.MutationFunction<RemoveCompanySnsConnectionMutation, RemoveCompanySnsConnectionMutationVariables>;

/**
 * __useRemoveCompanySnsConnectionMutation__
 *
 * To run a mutation, you first call `useRemoveCompanySnsConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCompanySnsConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCompanySnsConnectionMutation, { data, loading, error }] = useRemoveCompanySnsConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveCompanySnsConnectionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCompanySnsConnectionMutation, RemoveCompanySnsConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCompanySnsConnectionMutation, RemoveCompanySnsConnectionMutationVariables>(RemoveCompanySnsConnectionDocument, options);
      }
export type RemoveCompanySnsConnectionMutationHookResult = ReturnType<typeof useRemoveCompanySnsConnectionMutation>;
export type RemoveCompanySnsConnectionMutationResult = Apollo.MutationResult<RemoveCompanySnsConnectionMutation>;
export type RemoveCompanySnsConnectionMutationOptions = Apollo.BaseMutationOptions<RemoveCompanySnsConnectionMutation, RemoveCompanySnsConnectionMutationVariables>;
export const UpdateAccessTokenDocument = gql`
    mutation UpdateAccessToken($input: UpdateAccessTokenInput!) {
  updateAccessToken(input: $input) {
    ...SnsConnectionInfo
  }
}
    ${SnsConnectionInfoFragmentDoc}`;
export type UpdateAccessTokenMutationFn = Apollo.MutationFunction<UpdateAccessTokenMutation, UpdateAccessTokenMutationVariables>;

/**
 * __useUpdateAccessTokenMutation__
 *
 * To run a mutation, you first call `useUpdateAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccessTokenMutation, { data, loading, error }] = useUpdateAccessTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccessTokenMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccessTokenMutation, UpdateAccessTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccessTokenMutation, UpdateAccessTokenMutationVariables>(UpdateAccessTokenDocument, options);
      }
export type UpdateAccessTokenMutationHookResult = ReturnType<typeof useUpdateAccessTokenMutation>;
export type UpdateAccessTokenMutationResult = Apollo.MutationResult<UpdateAccessTokenMutation>;
export type UpdateAccessTokenMutationOptions = Apollo.BaseMutationOptions<UpdateAccessTokenMutation, UpdateAccessTokenMutationVariables>;
export const GetLongLiveAccessTokenDocument = gql`
    query GetLongLiveAccessToken($shortLiveAccessToken: String!) {
  facebookLongLiveAccessToken(shortLiveAccessToken: $shortLiveAccessToken)
}
    `;

/**
 * __useGetLongLiveAccessTokenQuery__
 *
 * To run a query within a React component, call `useGetLongLiveAccessTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLongLiveAccessTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLongLiveAccessTokenQuery({
 *   variables: {
 *      shortLiveAccessToken: // value for 'shortLiveAccessToken'
 *   },
 * });
 */
export function useGetLongLiveAccessTokenQuery(baseOptions: Apollo.QueryHookOptions<GetLongLiveAccessTokenQuery, GetLongLiveAccessTokenQueryVariables> & ({ variables: GetLongLiveAccessTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLongLiveAccessTokenQuery, GetLongLiveAccessTokenQueryVariables>(GetLongLiveAccessTokenDocument, options);
      }
export function useGetLongLiveAccessTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLongLiveAccessTokenQuery, GetLongLiveAccessTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLongLiveAccessTokenQuery, GetLongLiveAccessTokenQueryVariables>(GetLongLiveAccessTokenDocument, options);
        }
export function useGetLongLiveAccessTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLongLiveAccessTokenQuery, GetLongLiveAccessTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLongLiveAccessTokenQuery, GetLongLiveAccessTokenQueryVariables>(GetLongLiveAccessTokenDocument, options);
        }
export type GetLongLiveAccessTokenQueryHookResult = ReturnType<typeof useGetLongLiveAccessTokenQuery>;
export type GetLongLiveAccessTokenLazyQueryHookResult = ReturnType<typeof useGetLongLiveAccessTokenLazyQuery>;
export type GetLongLiveAccessTokenSuspenseQueryHookResult = ReturnType<typeof useGetLongLiveAccessTokenSuspenseQuery>;
export type GetLongLiveAccessTokenQueryResult = Apollo.QueryResult<GetLongLiveAccessTokenQuery, GetLongLiveAccessTokenQueryVariables>;
export const ApplySubscriptionDocument = gql`
    mutation ApplySubscription($input: ApplySubscriptionInput!) {
  applySubscription(input: $input) {
    ...TicketSubscription
  }
}
    ${TicketSubscriptionFragmentDoc}`;
export type ApplySubscriptionMutationFn = Apollo.MutationFunction<ApplySubscriptionMutation, ApplySubscriptionMutationVariables>;

/**
 * __useApplySubscriptionMutation__
 *
 * To run a mutation, you first call `useApplySubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplySubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applySubscriptionMutation, { data, loading, error }] = useApplySubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplySubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<ApplySubscriptionMutation, ApplySubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplySubscriptionMutation, ApplySubscriptionMutationVariables>(ApplySubscriptionDocument, options);
      }
export type ApplySubscriptionMutationHookResult = ReturnType<typeof useApplySubscriptionMutation>;
export type ApplySubscriptionMutationResult = Apollo.MutationResult<ApplySubscriptionMutation>;
export type ApplySubscriptionMutationOptions = Apollo.BaseMutationOptions<ApplySubscriptionMutation, ApplySubscriptionMutationVariables>;
export const ApplySubscriptionByCodeDocument = gql`
    mutation ApplySubscriptionByCode($input: ApplySubscriptionByCodeInput!) {
  applySubscriptionByCode(input: $input) {
    id
  }
}
    `;
export type ApplySubscriptionByCodeMutationFn = Apollo.MutationFunction<ApplySubscriptionByCodeMutation, ApplySubscriptionByCodeMutationVariables>;

/**
 * __useApplySubscriptionByCodeMutation__
 *
 * To run a mutation, you first call `useApplySubscriptionByCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplySubscriptionByCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applySubscriptionByCodeMutation, { data, loading, error }] = useApplySubscriptionByCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplySubscriptionByCodeMutation(baseOptions?: Apollo.MutationHookOptions<ApplySubscriptionByCodeMutation, ApplySubscriptionByCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplySubscriptionByCodeMutation, ApplySubscriptionByCodeMutationVariables>(ApplySubscriptionByCodeDocument, options);
      }
export type ApplySubscriptionByCodeMutationHookResult = ReturnType<typeof useApplySubscriptionByCodeMutation>;
export type ApplySubscriptionByCodeMutationResult = Apollo.MutationResult<ApplySubscriptionByCodeMutation>;
export type ApplySubscriptionByCodeMutationOptions = Apollo.BaseMutationOptions<ApplySubscriptionByCodeMutation, ApplySubscriptionByCodeMutationVariables>;
export const RevokeSubscriptionCancellationDocument = gql`
    mutation RevokeSubscriptionCancellation($input: RevokeSubscriptionCancellationInput!) {
  revokeSubscriptionCancellation(input: $input) {
    ...TicketSubscription
  }
}
    ${TicketSubscriptionFragmentDoc}`;
export type RevokeSubscriptionCancellationMutationFn = Apollo.MutationFunction<RevokeSubscriptionCancellationMutation, RevokeSubscriptionCancellationMutationVariables>;

/**
 * __useRevokeSubscriptionCancellationMutation__
 *
 * To run a mutation, you first call `useRevokeSubscriptionCancellationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeSubscriptionCancellationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeSubscriptionCancellationMutation, { data, loading, error }] = useRevokeSubscriptionCancellationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevokeSubscriptionCancellationMutation(baseOptions?: Apollo.MutationHookOptions<RevokeSubscriptionCancellationMutation, RevokeSubscriptionCancellationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeSubscriptionCancellationMutation, RevokeSubscriptionCancellationMutationVariables>(RevokeSubscriptionCancellationDocument, options);
      }
export type RevokeSubscriptionCancellationMutationHookResult = ReturnType<typeof useRevokeSubscriptionCancellationMutation>;
export type RevokeSubscriptionCancellationMutationResult = Apollo.MutationResult<RevokeSubscriptionCancellationMutation>;
export type RevokeSubscriptionCancellationMutationOptions = Apollo.BaseMutationOptions<RevokeSubscriptionCancellationMutation, RevokeSubscriptionCancellationMutationVariables>;
export const ScheduleSubscriptionCancellationDocument = gql`
    mutation ScheduleSubscriptionCancellation($input: ScheduleSubscriptionCancellationInput!) {
  scheduleSubscriptionCancellation(input: $input) {
    ...TicketSubscription
  }
}
    ${TicketSubscriptionFragmentDoc}`;
export type ScheduleSubscriptionCancellationMutationFn = Apollo.MutationFunction<ScheduleSubscriptionCancellationMutation, ScheduleSubscriptionCancellationMutationVariables>;

/**
 * __useScheduleSubscriptionCancellationMutation__
 *
 * To run a mutation, you first call `useScheduleSubscriptionCancellationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleSubscriptionCancellationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleSubscriptionCancellationMutation, { data, loading, error }] = useScheduleSubscriptionCancellationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScheduleSubscriptionCancellationMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleSubscriptionCancellationMutation, ScheduleSubscriptionCancellationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleSubscriptionCancellationMutation, ScheduleSubscriptionCancellationMutationVariables>(ScheduleSubscriptionCancellationDocument, options);
      }
export type ScheduleSubscriptionCancellationMutationHookResult = ReturnType<typeof useScheduleSubscriptionCancellationMutation>;
export type ScheduleSubscriptionCancellationMutationResult = Apollo.MutationResult<ScheduleSubscriptionCancellationMutation>;
export type ScheduleSubscriptionCancellationMutationOptions = Apollo.BaseMutationOptions<ScheduleSubscriptionCancellationMutation, ScheduleSubscriptionCancellationMutationVariables>;
export const SubscriptionModelByCodeDocument = gql`
    query SubscriptionModelByCode($code: String!) {
  subscriptionModelByCode(code: $code) {
    ...SubscriptionModel
  }
}
    ${SubscriptionModelFragmentDoc}`;

/**
 * __useSubscriptionModelByCodeQuery__
 *
 * To run a query within a React component, call `useSubscriptionModelByCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionModelByCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionModelByCodeQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useSubscriptionModelByCodeQuery(baseOptions: Apollo.QueryHookOptions<SubscriptionModelByCodeQuery, SubscriptionModelByCodeQueryVariables> & ({ variables: SubscriptionModelByCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionModelByCodeQuery, SubscriptionModelByCodeQueryVariables>(SubscriptionModelByCodeDocument, options);
      }
export function useSubscriptionModelByCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionModelByCodeQuery, SubscriptionModelByCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionModelByCodeQuery, SubscriptionModelByCodeQueryVariables>(SubscriptionModelByCodeDocument, options);
        }
export function useSubscriptionModelByCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubscriptionModelByCodeQuery, SubscriptionModelByCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubscriptionModelByCodeQuery, SubscriptionModelByCodeQueryVariables>(SubscriptionModelByCodeDocument, options);
        }
export type SubscriptionModelByCodeQueryHookResult = ReturnType<typeof useSubscriptionModelByCodeQuery>;
export type SubscriptionModelByCodeLazyQueryHookResult = ReturnType<typeof useSubscriptionModelByCodeLazyQuery>;
export type SubscriptionModelByCodeSuspenseQueryHookResult = ReturnType<typeof useSubscriptionModelByCodeSuspenseQuery>;
export type SubscriptionModelByCodeQueryResult = Apollo.QueryResult<SubscriptionModelByCodeQuery, SubscriptionModelByCodeQueryVariables>;
export const TicketSubscriptionsDocument = gql`
    query TicketSubscriptions {
  viewer: viewerAsAdvertiser {
    ... on Advertiser {
      ticketSubscriptions {
        ...TicketSubscription
      }
      canCancelSubscription
    }
  }
}
    ${TicketSubscriptionFragmentDoc}`;

/**
 * __useTicketSubscriptionsQuery__
 *
 * To run a query within a React component, call `useTicketSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTicketSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTicketSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTicketSubscriptionsQuery(baseOptions?: Apollo.QueryHookOptions<TicketSubscriptionsQuery, TicketSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TicketSubscriptionsQuery, TicketSubscriptionsQueryVariables>(TicketSubscriptionsDocument, options);
      }
export function useTicketSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TicketSubscriptionsQuery, TicketSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TicketSubscriptionsQuery, TicketSubscriptionsQueryVariables>(TicketSubscriptionsDocument, options);
        }
export function useTicketSubscriptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TicketSubscriptionsQuery, TicketSubscriptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TicketSubscriptionsQuery, TicketSubscriptionsQueryVariables>(TicketSubscriptionsDocument, options);
        }
export type TicketSubscriptionsQueryHookResult = ReturnType<typeof useTicketSubscriptionsQuery>;
export type TicketSubscriptionsLazyQueryHookResult = ReturnType<typeof useTicketSubscriptionsLazyQuery>;
export type TicketSubscriptionsSuspenseQueryHookResult = ReturnType<typeof useTicketSubscriptionsSuspenseQuery>;
export type TicketSubscriptionsQueryResult = Apollo.QueryResult<TicketSubscriptionsQuery, TicketSubscriptionsQueryVariables>;
export const SubscriptionModelsDocument = gql`
    query SubscriptionModels {
  subscriptionModels {
    ...SubscriptionModel
  }
}
    ${SubscriptionModelFragmentDoc}`;

/**
 * __useSubscriptionModelsQuery__
 *
 * To run a query within a React component, call `useSubscriptionModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionModelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubscriptionModelsQuery(baseOptions?: Apollo.QueryHookOptions<SubscriptionModelsQuery, SubscriptionModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionModelsQuery, SubscriptionModelsQueryVariables>(SubscriptionModelsDocument, options);
      }
export function useSubscriptionModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionModelsQuery, SubscriptionModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionModelsQuery, SubscriptionModelsQueryVariables>(SubscriptionModelsDocument, options);
        }
export function useSubscriptionModelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubscriptionModelsQuery, SubscriptionModelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubscriptionModelsQuery, SubscriptionModelsQueryVariables>(SubscriptionModelsDocument, options);
        }
export type SubscriptionModelsQueryHookResult = ReturnType<typeof useSubscriptionModelsQuery>;
export type SubscriptionModelsLazyQueryHookResult = ReturnType<typeof useSubscriptionModelsLazyQuery>;
export type SubscriptionModelsSuspenseQueryHookResult = ReturnType<typeof useSubscriptionModelsSuspenseQuery>;
export type SubscriptionModelsQueryResult = Apollo.QueryResult<SubscriptionModelsQuery, SubscriptionModelsQueryVariables>;
export const AgreeAdGuidelineDocument = gql`
    mutation AgreeAdGuideline {
  agreeAdGuideline {
    ...AdGuideline
  }
}
    ${AdGuidelineFragmentDoc}`;
export type AgreeAdGuidelineMutationFn = Apollo.MutationFunction<AgreeAdGuidelineMutation, AgreeAdGuidelineMutationVariables>;

/**
 * __useAgreeAdGuidelineMutation__
 *
 * To run a mutation, you first call `useAgreeAdGuidelineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAgreeAdGuidelineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [agreeAdGuidelineMutation, { data, loading, error }] = useAgreeAdGuidelineMutation({
 *   variables: {
 *   },
 * });
 */
export function useAgreeAdGuidelineMutation(baseOptions?: Apollo.MutationHookOptions<AgreeAdGuidelineMutation, AgreeAdGuidelineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AgreeAdGuidelineMutation, AgreeAdGuidelineMutationVariables>(AgreeAdGuidelineDocument, options);
      }
export type AgreeAdGuidelineMutationHookResult = ReturnType<typeof useAgreeAdGuidelineMutation>;
export type AgreeAdGuidelineMutationResult = Apollo.MutationResult<AgreeAdGuidelineMutation>;
export type AgreeAdGuidelineMutationOptions = Apollo.BaseMutationOptions<AgreeAdGuidelineMutation, AgreeAdGuidelineMutationVariables>;
export const DeleteCompanyShopTemplateDocument = gql`
    mutation DeleteCompanyShopTemplate($input: DeleteCompanyShopTemplateInput!) {
  deleteCompanyShopTemplateMut(input: $input) {
    ...CompanyShopTemplate
  }
}
    ${CompanyShopTemplateFragmentDoc}`;
export type DeleteCompanyShopTemplateMutationFn = Apollo.MutationFunction<DeleteCompanyShopTemplateMutation, DeleteCompanyShopTemplateMutationVariables>;

/**
 * __useDeleteCompanyShopTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyShopTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyShopTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyShopTemplateMutation, { data, loading, error }] = useDeleteCompanyShopTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCompanyShopTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompanyShopTemplateMutation, DeleteCompanyShopTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompanyShopTemplateMutation, DeleteCompanyShopTemplateMutationVariables>(DeleteCompanyShopTemplateDocument, options);
      }
export type DeleteCompanyShopTemplateMutationHookResult = ReturnType<typeof useDeleteCompanyShopTemplateMutation>;
export type DeleteCompanyShopTemplateMutationResult = Apollo.MutationResult<DeleteCompanyShopTemplateMutation>;
export type DeleteCompanyShopTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteCompanyShopTemplateMutation, DeleteCompanyShopTemplateMutationVariables>;
export const AvailableAndRevisionCampaignsDocument = gql`
    query AvailableAndRevisionCampaigns($orderBy: CampaignOrder! = {direction: DESC, field: APPROVED_AT}, $excludeYouTube: Boolean = true) {
  viewer: viewerAsAdvertiser {
    ... on Advertiser {
      availableCampaigns: campaigns(
        input: {status: [APPROVED, FINISH], formatVersions: [V4_CAMPAIGN], orderBy: $orderBy, excludeYouTube: $excludeYouTube}
      ) {
        ...CopyCampaign
      }
      revisionCampaigns: campaigns(
        input: {status: [REVISION_REQUIRED], formatVersions: [V2_CAMPAIGN, V3_CAMPAIGN, V4_CAMPAIGN], orderBy: $orderBy, excludeYouTube: $excludeYouTube}
      ) {
        ...CopyCampaign
      }
      company {
        id
        availableTickets {
          ...IssuedTicket
        }
      }
    }
  }
}
    ${CopyCampaignFragmentDoc}
${IssuedTicketFragmentDoc}`;

/**
 * __useAvailableAndRevisionCampaignsQuery__
 *
 * To run a query within a React component, call `useAvailableAndRevisionCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableAndRevisionCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableAndRevisionCampaignsQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      excludeYouTube: // value for 'excludeYouTube'
 *   },
 * });
 */
export function useAvailableAndRevisionCampaignsQuery(baseOptions?: Apollo.QueryHookOptions<AvailableAndRevisionCampaignsQuery, AvailableAndRevisionCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableAndRevisionCampaignsQuery, AvailableAndRevisionCampaignsQueryVariables>(AvailableAndRevisionCampaignsDocument, options);
      }
export function useAvailableAndRevisionCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableAndRevisionCampaignsQuery, AvailableAndRevisionCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableAndRevisionCampaignsQuery, AvailableAndRevisionCampaignsQueryVariables>(AvailableAndRevisionCampaignsDocument, options);
        }
export function useAvailableAndRevisionCampaignsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailableAndRevisionCampaignsQuery, AvailableAndRevisionCampaignsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailableAndRevisionCampaignsQuery, AvailableAndRevisionCampaignsQueryVariables>(AvailableAndRevisionCampaignsDocument, options);
        }
export type AvailableAndRevisionCampaignsQueryHookResult = ReturnType<typeof useAvailableAndRevisionCampaignsQuery>;
export type AvailableAndRevisionCampaignsLazyQueryHookResult = ReturnType<typeof useAvailableAndRevisionCampaignsLazyQuery>;
export type AvailableAndRevisionCampaignsSuspenseQueryHookResult = ReturnType<typeof useAvailableAndRevisionCampaignsSuspenseQuery>;
export type AvailableAndRevisionCampaignsQueryResult = Apollo.QueryResult<AvailableAndRevisionCampaignsQuery, AvailableAndRevisionCampaignsQueryVariables>;
export const CampaignEntriesNewDocument = gql`
    query CampaignEntriesNew($id: ID!, $first: Int = 20, $offset: Int = 0, $orderby: CampaignEntriesOrder! = {direction: DESC, field: CREATED_AT}, $pinned: Pinned, $gender: Gender, $ageRange: AgeRange) {
  campaign(id: $id) {
    ...CampaignSummary
    entries(
      first: $first
      offset: $offset
      orderby: $orderby
      pinned: $pinned
      gender: $gender
      ageRange: $ageRange
    ) {
      edges {
        node {
          ...CampaignEntryDetail
        }
      }
      pageInfo {
        ...PageInfo
      }
      totalCount
    }
  }
}
    ${CampaignSummaryFragmentDoc}
${CampaignEntryDetailFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useCampaignEntriesNewQuery__
 *
 * To run a query within a React component, call `useCampaignEntriesNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignEntriesNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignEntriesNewQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      offset: // value for 'offset'
 *      orderby: // value for 'orderby'
 *      pinned: // value for 'pinned'
 *      gender: // value for 'gender'
 *      ageRange: // value for 'ageRange'
 *   },
 * });
 */
export function useCampaignEntriesNewQuery(baseOptions: Apollo.QueryHookOptions<CampaignEntriesNewQuery, CampaignEntriesNewQueryVariables> & ({ variables: CampaignEntriesNewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignEntriesNewQuery, CampaignEntriesNewQueryVariables>(CampaignEntriesNewDocument, options);
      }
export function useCampaignEntriesNewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignEntriesNewQuery, CampaignEntriesNewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignEntriesNewQuery, CampaignEntriesNewQueryVariables>(CampaignEntriesNewDocument, options);
        }
export function useCampaignEntriesNewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignEntriesNewQuery, CampaignEntriesNewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignEntriesNewQuery, CampaignEntriesNewQueryVariables>(CampaignEntriesNewDocument, options);
        }
export type CampaignEntriesNewQueryHookResult = ReturnType<typeof useCampaignEntriesNewQuery>;
export type CampaignEntriesNewLazyQueryHookResult = ReturnType<typeof useCampaignEntriesNewLazyQuery>;
export type CampaignEntriesNewSuspenseQueryHookResult = ReturnType<typeof useCampaignEntriesNewSuspenseQuery>;
export type CampaignEntriesNewQueryResult = Apollo.QueryResult<CampaignEntriesNewQuery, CampaignEntriesNewQueryVariables>;
export const ConnectedLineGroupDocument = gql`
    query ConnectedLineGroup {
  viewer: viewerAsAdvertiser {
    ... on Advertiser {
      company {
        connectedLineGroup
      }
    }
  }
}
    `;

/**
 * __useConnectedLineGroupQuery__
 *
 * To run a query within a React component, call `useConnectedLineGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectedLineGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectedLineGroupQuery({
 *   variables: {
 *   },
 * });
 */
export function useConnectedLineGroupQuery(baseOptions?: Apollo.QueryHookOptions<ConnectedLineGroupQuery, ConnectedLineGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectedLineGroupQuery, ConnectedLineGroupQueryVariables>(ConnectedLineGroupDocument, options);
      }
export function useConnectedLineGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectedLineGroupQuery, ConnectedLineGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectedLineGroupQuery, ConnectedLineGroupQueryVariables>(ConnectedLineGroupDocument, options);
        }
export function useConnectedLineGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConnectedLineGroupQuery, ConnectedLineGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConnectedLineGroupQuery, ConnectedLineGroupQueryVariables>(ConnectedLineGroupDocument, options);
        }
export type ConnectedLineGroupQueryHookResult = ReturnType<typeof useConnectedLineGroupQuery>;
export type ConnectedLineGroupLazyQueryHookResult = ReturnType<typeof useConnectedLineGroupLazyQuery>;
export type ConnectedLineGroupSuspenseQueryHookResult = ReturnType<typeof useConnectedLineGroupSuspenseQuery>;
export type ConnectedLineGroupQueryResult = Apollo.QueryResult<ConnectedLineGroupQuery, ConnectedLineGroupQueryVariables>;
export const DailyInsightDocument = gql`
    query DailyInsight($from: DateTime!, $to: DateTime!, $snsConnectId: ID!) {
  viewer: viewerAsAdvertiser {
    ... on Advertiser {
      company {
        snsConnections(snsConnectId: $snsConnectId) {
          id
          connectedAt
          dailyInstagramInsight(from: $from, to: $to) {
            ...InstagramInsight
          }
        }
      }
    }
  }
}
    ${InstagramInsightFragmentDoc}`;

/**
 * __useDailyInsightQuery__
 *
 * To run a query within a React component, call `useDailyInsightQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyInsightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDailyInsightQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      snsConnectId: // value for 'snsConnectId'
 *   },
 * });
 */
export function useDailyInsightQuery(baseOptions: Apollo.QueryHookOptions<DailyInsightQuery, DailyInsightQueryVariables> & ({ variables: DailyInsightQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DailyInsightQuery, DailyInsightQueryVariables>(DailyInsightDocument, options);
      }
export function useDailyInsightLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DailyInsightQuery, DailyInsightQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DailyInsightQuery, DailyInsightQueryVariables>(DailyInsightDocument, options);
        }
export function useDailyInsightSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DailyInsightQuery, DailyInsightQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DailyInsightQuery, DailyInsightQueryVariables>(DailyInsightDocument, options);
        }
export type DailyInsightQueryHookResult = ReturnType<typeof useDailyInsightQuery>;
export type DailyInsightLazyQueryHookResult = ReturnType<typeof useDailyInsightLazyQuery>;
export type DailyInsightSuspenseQueryHookResult = ReturnType<typeof useDailyInsightSuspenseQuery>;
export type DailyInsightQueryResult = Apollo.QueryResult<DailyInsightQuery, DailyInsightQueryVariables>;
export const CompanyShopTemplatesDocument = gql`
    query CompanyShopTemplates {
  viewer: viewerAsAdvertiser {
    ... on Advertiser {
      companyShopTemplates {
        ...CompanyShopTemplate
      }
    }
  }
}
    ${CompanyShopTemplateFragmentDoc}`;

/**
 * __useCompanyShopTemplatesQuery__
 *
 * To run a query within a React component, call `useCompanyShopTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyShopTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyShopTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanyShopTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<CompanyShopTemplatesQuery, CompanyShopTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyShopTemplatesQuery, CompanyShopTemplatesQueryVariables>(CompanyShopTemplatesDocument, options);
      }
export function useCompanyShopTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyShopTemplatesQuery, CompanyShopTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyShopTemplatesQuery, CompanyShopTemplatesQueryVariables>(CompanyShopTemplatesDocument, options);
        }
export function useCompanyShopTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyShopTemplatesQuery, CompanyShopTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyShopTemplatesQuery, CompanyShopTemplatesQueryVariables>(CompanyShopTemplatesDocument, options);
        }
export type CompanyShopTemplatesQueryHookResult = ReturnType<typeof useCompanyShopTemplatesQuery>;
export type CompanyShopTemplatesLazyQueryHookResult = ReturnType<typeof useCompanyShopTemplatesLazyQuery>;
export type CompanyShopTemplatesSuspenseQueryHookResult = ReturnType<typeof useCompanyShopTemplatesSuspenseQuery>;
export type CompanyShopTemplatesQueryResult = Apollo.QueryResult<CompanyShopTemplatesQuery, CompanyShopTemplatesQueryVariables>;
export const TodoOffersDocument = gql`
    query TodoOffers {
  viewer: viewerAsAdvertiser {
    ... on Advertiser {
      company {
        id
        todoOffers {
          ...TodoOffer_Todos
          offer {
            id
            snsType
            delivered
            influencer {
              id
              name
              imageUrl
              birthday
              gender
              activeSnsConnections {
                ...ActiveSnsConnections
              }
            }
            latestMessage {
              id
              body
              readStatus
              sender
              createdAt
            }
            latestTransition {
              id
              action
              createdAt
              deadline
            }
            campaign {
              id
              name
              thumbnailUrls
              coverImageUrls {
                ...CoverImageUrls
              }
              ...CampaignCostInfo
            }
          }
        }
      }
    }
  }
}
    ${TodoOfferTodosFragmentDoc}
${ActiveSnsConnectionsFragmentDoc}
${CoverImageUrlsFragmentDoc}
${CampaignCostInfoFragmentDoc}`;

/**
 * __useTodoOffersQuery__
 *
 * To run a query within a React component, call `useTodoOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTodoOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTodoOffersQuery({
 *   variables: {
 *   },
 * });
 */
export function useTodoOffersQuery(baseOptions?: Apollo.QueryHookOptions<TodoOffersQuery, TodoOffersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TodoOffersQuery, TodoOffersQueryVariables>(TodoOffersDocument, options);
      }
export function useTodoOffersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TodoOffersQuery, TodoOffersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TodoOffersQuery, TodoOffersQueryVariables>(TodoOffersDocument, options);
        }
export function useTodoOffersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TodoOffersQuery, TodoOffersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TodoOffersQuery, TodoOffersQueryVariables>(TodoOffersDocument, options);
        }
export type TodoOffersQueryHookResult = ReturnType<typeof useTodoOffersQuery>;
export type TodoOffersLazyQueryHookResult = ReturnType<typeof useTodoOffersLazyQuery>;
export type TodoOffersSuspenseQueryHookResult = ReturnType<typeof useTodoOffersSuspenseQuery>;
export type TodoOffersQueryResult = Apollo.QueryResult<TodoOffersQuery, TodoOffersQueryVariables>;
export const TutorialDocument = gql`
    query Tutorial {
  viewer: viewerAsAdvertiser {
    ... on Advertiser {
      company {
        id
        tutorial {
          hasBeginnerDoneCheck
          hasCampaign
          hasInstagramConnection
          hasInstagramWebsiteLink
          hasOffer
          hasTicket
        }
      }
    }
  }
}
    `;

/**
 * __useTutorialQuery__
 *
 * To run a query within a React component, call `useTutorialQuery` and pass it any options that fit your needs.
 * When your component renders, `useTutorialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTutorialQuery({
 *   variables: {
 *   },
 * });
 */
export function useTutorialQuery(baseOptions?: Apollo.QueryHookOptions<TutorialQuery, TutorialQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TutorialQuery, TutorialQueryVariables>(TutorialDocument, options);
      }
export function useTutorialLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TutorialQuery, TutorialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TutorialQuery, TutorialQueryVariables>(TutorialDocument, options);
        }
export function useTutorialSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TutorialQuery, TutorialQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TutorialQuery, TutorialQueryVariables>(TutorialDocument, options);
        }
export type TutorialQueryHookResult = ReturnType<typeof useTutorialQuery>;
export type TutorialLazyQueryHookResult = ReturnType<typeof useTutorialLazyQuery>;
export type TutorialSuspenseQueryHookResult = ReturnType<typeof useTutorialSuspenseQuery>;
export type TutorialQueryResult = Apollo.QueryResult<TutorialQuery, TutorialQueryVariables>;
export const ViewerDocument = gql`
    query Viewer {
  viewer: viewerAsAdvertiser {
    ... on Advertiser {
      adGuideline {
        ...AdGuideline
      }
      company {
        id
        paymentType
        snsConnections {
          ...SnsConnectionInfo
        }
        canCreateRewardCampaign
        showIntroduction
        connectedLineGroup
        needLineConnection
      }
    }
  }
}
    ${AdGuidelineFragmentDoc}
${SnsConnectionInfoFragmentDoc}`;

/**
 * __useViewerQuery__
 *
 * To run a query within a React component, call `useViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerQuery(baseOptions?: Apollo.QueryHookOptions<ViewerQuery, ViewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewerQuery, ViewerQueryVariables>(ViewerDocument, options);
      }
export function useViewerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewerQuery, ViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewerQuery, ViewerQueryVariables>(ViewerDocument, options);
        }
export function useViewerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewerQuery, ViewerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewerQuery, ViewerQueryVariables>(ViewerDocument, options);
        }
export type ViewerQueryHookResult = ReturnType<typeof useViewerQuery>;
export type ViewerLazyQueryHookResult = ReturnType<typeof useViewerLazyQuery>;
export type ViewerSuspenseQueryHookResult = ReturnType<typeof useViewerSuspenseQuery>;
export type ViewerQueryResult = Apollo.QueryResult<ViewerQuery, ViewerQueryVariables>;